/* eslint-disable no-control-regex, @typescript-eslint/no-explicit-any */
export const EMAIL_REGEXP =
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi;
export const DEFAULT_ERROR_MESSAGES: any = {
  required: 'This field is required.',
  email: 'This field must be an email.',
};
export const BASE_URL = 'https://www.qsncc.com';
export const LAUNCH_DATE = '2021-08-17 08:00:00';
// export const BASE_URL = 'http://qsncc-dev.4digit.co.th';
export const API_KEY =
  'XQ4CenZVzaUsYCs87KyrSHC5hV5uBj5kSEbUvCkb8mxyhTxXMc9bSYFtNJQ8Ztby4CDnD7kRjFUNrsfNTn5fCFg4LFbPE428SjTfUuUekMdsd5XEFAQMAJK29vBTFNr8TDnREbafpyDhfTesNbzqwUYnvqUfg5N86gj5GSHq2EqFE5pJ7Eu7czSWZ9JDjp9wXCBVrJPUdVyzKgF5PDbQqkvQQhDDpF8hesn7GEaLvCHfJRuzz8VDxDJhgn8jHSYv';
export const TAXIMAIL_API = {
  API_KEY: 'c9a0568fc369056a6836b2f477e110a48cafd380',
  SECRET_KEY: '440629a212702480fde90a57990ebafc2c700124',
  BASE_URL: 'https://asia-southeast1-qsncc2021.cloudfunctions.net',
  TRANSACTIONAL: '/qsncc-send-contact-email',
  LOGIN: '/qsncc-taximail-login',
  IMPORT_CONTACT: '/qsncc-taximail-subscribe',
};
export const MAIN_NAV_ITEMS = [
  // {
  //   label: '首页',
  //   link: '/'
  // },
  // {
  //   label: '场馆信息',
  //   link: '/venue-information'
  // }, {
  //   label: '酒店与周边环境',
  //   link: '/hotel-surrounding'
  // },
  {
    label: '媒体',
    link: '/media/news',
  },
  {
    label: '图片库',
    link: '/media/gallery',
  },

  {
    label: '联系我们',
    link: '/contact-us',
  },
];

export const LANGUAGE_OPTIONS = [
  { value: 'cn', label: 'CN', link: '/' },
  { value: 'en', label: 'EN', link: 'https://www.qsncc.com/en' },
  // { value: 'th', label: 'TH' },
  // { value: 'ch', label: 'CH', link: 'https://wwww.googole.com/' },
];

export const SOCIAL_ITEM_LIST = [
  {
    type: 'weixin',
    link: '/images/map/erweima2.png',
  },
  {
    type: 'facebook',
    link: 'https://www.facebook.com/QueenSirikitNationalConventionCenter',
  },
  {
    type: 'twitter',
    link: 'https://twitter.com/qsncc',
  },
  {
    type: 'instagram',
    link: 'https://www.instagram.com/qsncc/',
  },
  {
    type: 'line',
    link: 'https://lin.ee/9Nk8zIK',
  },
];

export const VIDEO_BANNERS: any = {
  sp: {
    mp4: '/videos/QSNCC_banner_480w.mp4',
    // webm: '/videos/QSNCC_banner_480w.webm',
  },
  tl: {
    mp4: '/videos/QSNCC_banner_720p.mp4',
    // webm: 'videos/QSNCC_banner_720p.webm',
  },
  pc: {
    mp4: '/videos/QSNCC_banner_1080p.mp4',
    // webm: '/videos/QSNCC_banner_1080p.webm',
  },
};

export const VIDEO_SOURCES: any = {
  sp: {
    mp4: '/videos/QSNCC_480w.mp4',
    webm: '/videos/QSNCC_480w.webm',
  },
  tl: {
    mp4: '/videos/QSNCC_720p.mp4',
    webm: '/videos/QSNCC_720p.webm',
  },
  pc: {
    mp4: '/videos/QSNCC_1080p.mp4',
    webm: '/videos/QSNCC_1080p.webm',
  },
};

export const CONSTRUCTION_END_DATE = '2022-09-01';

export const TIMEZONE = 'Asia/Bangkok';

export const HOME_GALLERY_LIST: any[] = [
  /* {
    image: '/images/home/gallery/1.-QSNCC_1600x840_@2x.jpg',
    imageSp: '/images/home/gallery/1.-QSNCC_800x420_@1x.jpg',
    imageWebp: '/images/home/gallery/1.-QSNCC_1600x840_@2x.webp',
    imageWebpSp: '/images/home/gallery/1.-QSNCC_800x420_@1x.webp',
    align: 'left',
    caption: 'QSNCC',
  }, */
  {
    image: '/images/home/gallery/PAKON-GOLDEDGE-entrance_right_KHLP-OFF-w-TREE-MAGAZINE-V03_1600x840_@2x.jpg',
    imageSp: '/images/home/gallery/PAKON-GOLDEDGE-entrance_right_KHLP-OFF-w-TREE-MAGAZINE-V03_800x420_@1x.jpg',
    imageWebp: '/images/home/gallery/PAKON-GOLDEDGE-entrance_right_KHLP-OFF-w-TREE-MAGAZINE-V03_1600x840_@2x.webp',
    imageWebpSp: '/images/home/gallery/PAKON-GOLDEDGE-entrance_right_KHLP-OFF-w-TREE-MAGAZINE-V03_800x420_@1x.webp',
    align: 'left',
    caption: '右入口',
  },
  {
    image: '/images/home/gallery/2.-Meeting-Room-Foyer-A_1600x840_@2x.jpg',
    imageSp: '/images/home/gallery/2.-Meeting-Room-Foyer-A_800x420_@1x.jpg',
    imageWebp: '/images/home/gallery/2.-Meeting-Room-Foyer-A_1600x840_@2x.webp',
    imageWebpSp: '/images/home/gallery/2.-Meeting-Room-Foyer-A_800x420_@1x.webp',
    align: 'left',
    caption: '会议室前厅A',
  },
  {
    image: '/images/home/gallery/3.-Central-Lounge_1600x840_@2x.jpg',
    imageSp: '/images/home/gallery/3.-Central-Lounge_800x420_@1x.jpg',
    imageWebp: '/images/home/gallery/3.-Central-Lounge_1600x840_@2x.webp',
    imageWebpSp: '/images/home/gallery/3.-Central-Lounge_800x420_@1x.webp',
    align: 'left',
    caption: '中央休息室',
  },
  {
    image: '/images/home/gallery/4.-Meeting-Room-Foyer-B_1600x840_@2x.jpg',
    imageSp: '/images/home/gallery/4.-Meeting-Room-Foyer-B_800x420_@1x.jpg',
    imageWebp: '/images/home/gallery/4.-Meeting-Room-Foyer-B_1600x840_@2x.webp',
    imageWebpSp: '/images/home/gallery/4.-Meeting-Room-Foyer-B_800x420_@1x.webp',
    align: 'left',
    caption: '会议室前厅B',
  },
  {
    image: '/images/home/gallery/5.-Foyer-A_1600x840_@2x.jpg',
    imageSp: '/images/home/gallery/5.-Foyer-A_800x420_@1x.jpg',
    imageWebp: '/images/home/gallery/5.-Foyer-A_1600x840_@2x.webp',
    imageWebpSp: '/images/home/gallery/5.-Foyer-A_800x420_@1x.webp',
    align: 'left',
    caption: '前厅A',
  },
  {
    image: '/images/home/gallery/6.-Main-Foyer-B_1600x840_@2x.jpg',
    imageSp: '/images/home/gallery/6.-Main-Foyer-B_800x420_@1x.jpg',
    imageWebp: '/images/home/gallery/6.-Main-Foyer-B_1600x840_@2x.webp',
    imageWebpSp: '/images/home/gallery/6.-Main-Foyer-B_800x420_@1x.webp',
    align: 'left',
    caption: '大堂B',
  },
];

export const GLANCE_HISTORY_IMG_LIST: any[] = [
  /* {
    image: '/images/home/gallery/1.-QSNCC_1600x840_@2x.jpg',
    imageSp: '/images/home/gallery/1.-QSNCC_800x420_@1x.jpg',
    imageWebp: '/images/home/gallery/1.-QSNCC_1600x840_@2x.webp',
    imageWebpSp: '/images/home/gallery/1.-QSNCC_800x420_@1x.webp',
    align: 'left',
    caption: 'QSNCC',
  }, */
  {
    image: '/images/glance/history/move-forward-01.jpg',
    imageSp: '/images/glance/history/move-forward-01.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/glance/history/move-forward-02.jpg',
    imageSp: '/images/glance/history/move-forward-02.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/glance/history/move-forward-03.jpg',
    imageSp: '/images/glance/history/move-forward-03.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/glance/history/move-forward-04.jpg',
    imageSp: '/images/glance/history/move-forward-04.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/glance/history/move-forward-05.jpg',
    imageSp: '/images/glance/history/move-forward-05.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/glance/history/move-forward-06.jpg',
    imageSp: '/images/glance/history/move-forward-06.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
];

export const GLANCE_WHYQSNCC_IMG_LIST: any[] = [
  /* {
    image: '/images/home/gallery/1.-QSNCC_1600x840_@2x.jpg',
    imageSp: '/images/home/gallery/1.-QSNCC_800x420_@1x.jpg',
    imageWebp: '/images/home/gallery/1.-QSNCC_1600x840_@2x.webp',
    imageWebpSp: '/images/home/gallery/1.-QSNCC_800x420_@1x.webp',
    align: 'left',
    caption: 'QSNCC',
  }, */
  {
    image: '/images/glance/whyqsncc/1.jpg',
    imageSp: '/images/glance/whyqsncc/1.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/glance/whyqsncc/2.jpg',
    imageSp: '/images/glance/whyqsncc/2.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/glance/whyqsncc/3.jpg',
    imageSp: '/images/glance/whyqsncc/3.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/glance/whyqsncc/4.jpg',
    imageSp: '/images/glance/whyqsncc/4.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/glance/whyqsncc/5.jpg',
    imageSp: '/images/glance/whyqsncc/5.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/glance/whyqsncc/6.jpg',
    imageSp: '/images/glance/whyqsncc/6.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
];
export const BUS_ROUTE_IMG_LIST: any[] = [
  /* {
    image: '/images/home/gallery/1.-QSNCC_1600x840_@2x.jpg',
    imageSp: '/images/home/gallery/1.-QSNCC_800x420_@1x.jpg',
    imageWebp: '/images/home/gallery/1.-QSNCC_1600x840_@2x.webp',
    imageWebpSp: '/images/home/gallery/1.-QSNCC_800x420_@1x.webp',
    align: 'left',
    caption: 'QSNCC',
  }, */
  {
    image: '/images/bus-route/mrt01.jpg',
    imageSp: '/images/bus-route/mrt01.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/bus-route/mrt02.jpg',
    imageSp: '/images/bus-route/mrt02.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/bus-route/mrt03.jpg',
    imageSp: '/images/bus-route/mrt03.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/bus-route/mrt04.jpg',
    imageSp: '/images/bus-route/mrt04.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/bus-route/mrt05.jpg',
    imageSp: '/images/bus-route/mrt05.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/bus-route/mrt06.jpg',
    imageSp: '/images/bus-route/mrt06.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
  {
    image: '/images/bus-route/mrt07.jpg',
    imageSp: '/images/bus-route/mrt07.jpg',
    imageWebp: '',
    imageWebpSp: '',
    align: 'left',
    caption: '',
  },
];

export const NEWS_LIST: any = [
  {
    slug: 'Press_Release_QSNCC_Launches_Bangkok’s_First_City-Center',
    headline: {
      cn: 'QSNCC推出曼谷首个城市中心保税仓库，助力国际展览与活动生态体系建设',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC正式推出面向国际展会的保税仓库服务,不仅使临时进口手续更加顺畅，也进一步增强了泰国作为全球会展目的地的活动生态与竞争力。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC推出曼谷首个城市中心保税仓库，助力国际展览与活动生态体系建设',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2026年6月19日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2026/6-19/Press_Release_QSNCC_Launches_Bangkok’s_First_City-Center.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心（QSNCC） 持续提升其支持国际展览与活动的能力，<strong class="addBold">正式推出面向国际展会的保税仓库服务。作为曼谷首个在市中心提供此类设施的场馆，</strong>这一里程碑标志着在强化物流基础设施和展会配套服务方面迈出了重要一步，不仅使临时进口手续更加顺畅，也进一步增强了泰国作为全球会展目的地的活动生态与竞争力。</p>
      <p><img  src="/images/media/news/2026/6-19/Bonded-Warehouse_EN.jpg" alt="QSNCC"  /></p>
      <p>保税仓库是海关监管下的设施，允许临时进口货物在国际展览和活动期间进行存储和使用。活动主办方和参展商可使用该服务，无需提供进口关税担保，也无需为临时进口准备ATA单证册文件。这有助于减少文书工作和海关手续，提高运营效率，并为来自世界各地、在QSNCC参加活动的主办方和参展商提供更大的便利。</p>
      <p>为确保保税仓库的高效运营，<strong class="addBold">QSNCC 已正式委托国际会展物流领域的领军企业— APT 会展物流集团旗下的泰国APT会展物流有限公司，承担该设施的运营管理职责</strong>。该公司是国际展览与活动行业领先的物流专家，拥有近 20 年支持泰国及海外展会的经验，在中国香港、上海、北京、广州、成都、重庆、厦门、深圳，以及新加坡、泰国、越南均设有分支机构。<strong class="addBold">作为保税仓库运营方</strong>，APT 将提供涵盖进出口处理、清关以及货物直送展区的一站式服务。</p>
      <p>作为曼谷市中心首个提供保税仓库的大型会议展览场馆，QSNCC 助力主办方和参展商高效统筹展品进口、运输和现场运营工作，同时依托场馆地处曼谷核心商圈的区位优势，可无缝衔接周边酒店、公共交通及各类商务配套。这一一体化解决方案有助于降低运营复杂性，提升国际展会的整体效率。</p>
      <div class="SpaceDay">
        <p class="SpaceDay_info"><img   src="/images/media/news/2026/6-19/Mr.Surapol_Utintu1.jpg" alt="QSNCC"  /></p>
        <p><strong class="addBold">泰国诗丽吉王后国家会议中心首席执行官Surapol Utintu </strong>表示：<br/>“保税仓库不仅仅是为主办方和参展商提供的一项新服务，更是泰国国际展览与活动生态体系中的重要一环。如今，主办方不仅看重场馆本身的质量，也关注配套基础设施的完善程度，因为那是保障展会顺畅高效运营的关键。”<br/>“我们相信，这一举措将进一步加强泰国举办国际展览和活动的能力，同时增强全球选择泰国作为会展目的地的主办方和参展商的信心。”</p>
      </div>
      <div class="SpaceDay">
        <p class="SpaceDay_info"><img  src="/images/media/news/2026/6-19/Suthichai_Techanarungroj.png" alt="QSNCC"  /></p>
        <p><strong class="addBold">APT Showfreight & Logistics Group区域总监Suthichai Techanarungroj</strong>表示：<br/>“我们很荣幸被委任为 QSNCC 的保税仓库运营管理方。凭借我们在展览和活动物流领域的丰富经验，我们深知主办方越来越看重场地品质与可靠的物流支持。”<br/>“保税仓库是提升国际展览与活动物流效率的关键组成部分。目前已有多个大型展会计划使用该服务，包括Asia Sustainable Energy Week 2026 和 Thai Water 2026 (2026年7月1日-3日), CPHI Southeast Asia 2026 (2026年7月8日-10日),Food & Hospitality Thailand 2026 (2026年8月19日-22日), Bangkok Gems & Jewelry Fair (2026年9月8日-12日), 以及 Jewellery & Gem ASEAN Bangkok 2027 (2027年5月17日-20日)。这反映出主办方对能够简化运营、提高灵活性的支持体系的需求日益增长。”</p>
      </div>
      
      <p>保税仓库的启用，标志着 QSNCC 在拓展全球展会主办方服务方面又一座重要里程碑。它通过无缝衔接场馆设施、物流服务与配套基础设施，进一步巩固了 QSNCC 在构建国际展览与活动完整生态体系中的核心作用。通过这些努力，QSNCC 持续强化泰国作为全球 MICE 产业首选目的地的领先地位。</p>
      `,
      th: ``,
    },
    image: '/images/media/news/2026/6-19/Bonded-Warehouse_EN.jpg',
    imageSp: '/images/media/news/2026/6-19/Bonded-Warehouse_EN.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'aa48D1xvIZEnjdJL_PhotoRelease_IMFMDVisitsQSNCC',
    headline: {
      cn: '泰国诗丽吉王后国家会议中心迎接IMF总裁<br>共赴2026年IMF — 世界银行集团年会筹备工作',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC执行委员会主席会见国际货币基金组织（IMF）总裁到访。旨在实地考察并讨论2026年IMF—世界银行集团年会的场馆筹备情况。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '泰国诗丽吉王后国家会议中心迎接IMF总裁<br>共赴2026年IMF — 世界银行集团年会筹备工作',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2026年3月6日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2026/3-6/aa48D1xvIZEnjdJL_PhotoRelease_IMFMDVisitsQSNCC.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心（QSNCC）执行委员会主席Mr. Panote Sirivadhanabhakdi会见国际货币基金组织（IMF）总裁Dr. Kristalina Georgieva到访。此次访问旨在实地考察并讨论2026年IMF—世界银行集团年会的场馆筹备情况。本届年会将于2026年10月12日至18日在QSNCC举行。</p>
      <p><img  src="/images/media/news/2026/3-6/IMF_MD_Visits_QSNCC1.jpg" alt="QSNCC"  /></p>
      <p>访问期间，Georgieva总裁高度评价了会议中心先进的设施与完善的运营筹备，并肯定其具备承办如此规模全球性会议的能力。她同时对泰国在筹办2026年年会方面所展现出的充分准备表示充满信心。</p>
      <p>本届年会将是QSNCC继1991年曼谷承办后，第二次获选成为这一重量级全球盛会的举办地。本次再度回归，也进一步彰显了QSNCC作为泰国领先国际会议场地的地位。</p>
      <p><img  src="/images/media/news/2026/3-6/IMF_MD_Visits_QSNCC2.jpg" alt="QSNCC"  /></p>
      <p><img  src="/images/media/news/2026/3-6/IMF_MD_Visits_QSNCC3.jpg" alt="QSNCC"  /></p>
      <p><img  src="/images/media/news/2026/3-6/IMF_MD_Visits_QSNCC4.jpg" alt="QSNCC"  /></p>
      <p><img  src="/images/media/news/2026/3-6/IMF_MD_Visits_QSNCC5.jpg" alt="QSNCC"  /></p>
      `,
      th: ``,
    },
    image: '/images/media/news/2026/3-6/IMF_MD_Visits_QSNCC1.jpg',
    imageSp: '/images/media/news/2026/3-6/IMF_MD_Visits_QSNCC1.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'CH-Thailand’s_First_Convention_Center_to_Win',
    headline: {
      cn: '泰国首家荣膺“亚洲最佳会展中心”奖项的会议中心<br>QSNCC 斩获 2025 年世界 MICE 大奖亚洲区最高荣誉，<br>并连续第三年蝉联“泰国最佳会展中心”',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC 于 2025 世界 MICE 大奖中荣获两项重要殊荣，包括“亚洲最佳会展中心”，成为首个获得该区域级别荣誉的泰国会展中心；同时连续第三年荣获“泰国最佳会展中心”称号',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '泰国首家荣膺“亚洲最佳会展中心”奖项的会议中心<br>QSNCC 斩获 2025 年世界 MICE 大奖亚洲区最高荣誉，<br>并连续第三年蝉联“泰国最佳会展中心”',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2026年1月19日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2026/1-19/CH-Thailand’s_First_Convention_Center_to_Win.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心（QSNCC）在全球舞台上取得历史性突破，于World MICE Awards 2025（2025世界MICE大奖）中荣获两项重要殊荣。该会议中心被授予“Best Convention Centre in Asia（亚洲最佳会展中心）”称号，成为首个获得该区域级别荣誉的泰国会议中心；同时，QSNCC亦连续第三年荣获“Best Convention Centre in Thailand（泰国最佳会展中心）”称号。</p>
      <p><img  src="/images/media/news/2026/1-19/2. PR-World-MICE-2025_EN.jpg" alt="QSNCC"  /></p>
      <p><strong class="addBold">世界MICE大奖</strong>是全球会议、奖励旅游、大会及展览（MICE）行业中最具声望的奖项之一。该奖项由总部设于英国的World Travel Group（世界旅游集团）主办，旨在表彰在质量、服务标准及全球竞争力方面表现卓越的机构、场馆及服务供应商。获奖者通过严格的评审流程产生，并由全球行业专业人士、活动主办方及主要利益相关方投票选出。</p>
      <p>此次成就体现了业界对QSNCC综合实力的高度认可，包括其世界一流的基础设施、卓越的服务能力以及专业管理水平。凭借这些优势，中心持续成功举办各类国家级及国际级活动，确立了QSNCC在全球MICE领域作为可信赖场馆的地位。</p>
      <div class="SpaceDay">
      <p class="SpaceDay_info"><strong class="addBold ">泰国诗丽吉王后国家会议中心首席执行官 Surapol Utintu </strong>表示：“在2025世界 MICE 大奖中荣获‘亚洲最佳会展中心’奖项，是 QSNCC 向前迈进的重要一步，意味着我们获得了超越国家层面的区域认可。同时，连续第三年被评为‘泰国最佳会展中心’，进一步彰显了我们在运营各个方面持续追求卓越的承诺。更重要的是，这一成功并非仅属于我们自身，而是整个MICE生态体系密切协作的成果，包括我们的商业合作伙伴、供应商以及所有利益相关方，共同推动泰国活动标准迈向国际认可。”</p>
      <p><img  src="/images/media/news/2026/1-19/3. Mr. Surapol Utintu.jpg" alt="QSNCC"  /></p>
      </div>
      <p>国际社会对QSNCC的信任，也进一步体现在其被选为2026年多项重要国际活动的举办场馆，其中包括<strong class="addBold">UFI Asia-Pacific Conference 2026</strong>（3月5–6日）、全球知名金融科技与金融创新大会 Money20/20 Asia（4月21–23日），以及<strong class="addBold">2026 International Monetary Fund and World Bank Group Annual Meetings</strong> （10月12–18日）。这些活动进一步巩固了QSNCC作为高规格国际会议首选平台的地位。</p>
      <p>展望未来，泰国诗丽吉王后国家会议中心将持续发展，不断提升承办世界级活动的能力，同时为推动泰国MICE产业在全球舞台上的发展作出积极贡献。</p>   
      <p><img  src="/images/media/news/2026/1-19/4. Photo - Gem jewelly.JPG" alt="QSNCC"  /></p>
      <p><img  src="/images/media/news/2026/1-19/5. Photo - Devcon.JPG" alt="QSNCC"  /></p>
      <p><img  src="/images/media/news/2026/1-19/6. Photo - Devcon2.JPG" alt="QSNCC"  /></p>
      <p><img  src="/images/media/news/2026/1-19/7. Photo - Gamecomasia.JPG" alt="QSNCC"  /></p>
      <p><img  src="/images/media/news/2026/1-19/8. Photo - Money2020.JPG" alt="QSNCC"  /></p>
      <p><img  src="/images/media/news/2026/1-19/9. Photo - SX 2025.jpg" alt="QSNCC"  /></p>
      <p><img  src="/images/media/news/2026/1-19/10. Photo - Techsauce.JPG" alt="QSNCC"  /></p>
      <p><img  src="/images/media/news/2026/1-19/11. Photo - QSNCC.jpg" alt="QSNCC"  /></p>
      `,
      th: ``,
    },
    image: '/images/media/news/2026/1-19/2. PR-World-MICE-2025_EN.jpg',
    imageSp: '/images/media/news/2026/1-19/2. PR-World-MICE-2025_EN.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'CH-QSNCC_Partners_with_SCIeco_by_SCG_EN_2',
    headline: {
      cn: '“变废为宝”<br>QSNCC携手SCG旗下SCIeco<br>共建泰国首套端到端废弃物转化能源系统<br>引领泰国MICE行业循环经济，推进迈向2050净零目标',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC与SCIeco Services Co., Ltd. 签署MOU合作备忘录，通过全面的“Waste-to-Value”模式，升级内部废弃物管理。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '“变废为宝”<br>QSNCC携手SCG旗下SCIeco<br>共建泰国首套端到端废弃物转化能源系统<br>引领泰国MICE行业循环经济，推进迈向2050净零目标',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2025年12月5日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2025/12-5/CH-QSNCC_Partners_with_SCIeco_by_SCG_EN_2.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心（QSNCC）与SCG旗下的SCIeco Services Co., Ltd. 签署MOU合作备忘录，通过全面的“Waste-to-Value”模式，升级内部废弃物管理。此次合作将引入先进技术，将一般废弃物转化为废弃物衍生燃料（Refuse-Derived Fuel, RDF），有效减少垃圾填埋量，加速QSNCC向2050 年净零排放目标迈进。</p>
      <p>此次合作在泰国环境月期间宣布，彰显了QSNCC致力于推动泰国MICE产业循环经济发展的承诺。该合作也将使<strong class="addBold">QSNCC成为泰国首个全面实施垃圾衍生燃料RDF系统</strong>的会议中心，为环保责任与可持续活动运营树立国家新标杆。</p>
      <p><strong class="addBold">N.C.C.管理发展有限公司董事总经理兼QSNCC首席执行官Surapol Utintu</strong>表示：“MICE行业的可持续发展必须建立在稳固的运营基础上，而不仅仅是活动层面的环保倡议。此次合作标志着我们从源头重新设计废弃物管理体系、降低环境影响、稳步推进‘净零’承诺的关键一步。”</p>
      <p>“我们选择SCG旗下的SCIeco作为合作伙伴，是因为他们秉持负责任、透明化且以可持续发展为核心的运营理念。作为获得认可的废弃物全面管理及垃圾衍生燃料（RDF）技术专家，SCIeco在众多行业拥有成熟的能力。凭借其先进技术、运营体系与透明报告，我们相信此次合作将提升QSNCC废弃物管理达到国际标准，加速可再生能源转型，并强化泰国的循环经济长期发展目标。”</p>
      <p><img  src="/images/media/news/2025/12-5/(MOU).jpg" alt="QSNCC"  /></p>
      <p>过去三年间，QSNCC持续加强内部与生态体系的可持续发展架构，包括取得 ISO 14064-1 及 组织碳足迹（CFO） 认证、实施“Zero Food Waste”倡议、以及打造泰国MICE行业首个实时“活动碳足迹”（CFE）仪表板。这些成果让QSNCC获得国内外多项可持续发展奖项，为其通往2050年净零目标奠定了坚实基础。</p>
      <p><strong class="addBold">SCIeco Services Co., Ltd.董事总经理Chalong Limsuntrakul</strong>补充道：“我们坚信废弃物并非负担，而是一种尚未开发价值的资源。将一般废弃物转化为替代燃料，能让这份价值重新回归循环经济。QSNCC是我们在泰国合作的首家会议中心，此次合作让我们得以优化废弃物处理的整个流程---从分类、收集、储存到全面转化为垃圾衍生燃料（RDF）。我们相信，这将成为MICE行业的一个个重要典范，并加速推动泰国向可持续的循环经济体系转型。”</p>
      <p>此次合作彰显了双方共同致力于产生可量化环境影响的承诺，也标志着泰国MICE行业在推动国家迈向低碳、可持续未来进程中的重要里程碑。</p>   
      `,
      th: ``,
    },
    image: '/images/media/news/2025/12-5/(MOU).jpg',
    imageSp: '/images/media/news/2025/12-5/(MOU).jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'aLqiwmGNHVfTOsQ6_Release_AIPCInnovationAward2025-Eng-',
    headline: {
      cn: '泰国诗丽吉王后国家会议中心凭借“Waste Not, Delight More”倡议荣获国际认可,引领会展行业迈向零食物浪费新时代',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC作为泰国会展行业的可持续发展先驱，其开创性的“Waste Not, Delight More”倡议，近日在国际舞台上斩获殊荣。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '泰国诗丽吉王后国家会议中心凭借“Waste Not, Delight More”倡议荣获国际认可,引领会展行业迈向零食物浪费新时代',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2025年9月4日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2025/9-4/aLqiwmGNHVfTOsQ6_Release_AIPCInnovationAward2025-Eng.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p><img  src="/images/media/news/2025/9-4/aLqiNm.jpg" alt="QSNCC"  /></p>
      <p>泰国诗丽吉王后国家会议中心（QSNCC）作为泰国会展行业的可持续发展先驱，近日在国际舞台上斩获殊荣。其开创性的“Waste Not, Delight More（零浪费·更美味）”倡议同时荣膺2025年国际会议中心协会创新大奖（AIPC Innovation Award 2025）“全球会员选择奖（Winner Delegate’s Choice）”，并入围2025年全球展览业协会运营与服务奖（UFI Operations & Services Award 2025）最终评选，彰显了QSNCC在可持续会展管理领域的领导地位。</p>
      <p>“Waste Not, Delight More”是QSNCC于2023年推出的一项基于循环经济原则的创新食物浪费管理计划，以实现“零食物浪费”为终极目标。该计划通过推行预点餐技术、设计注重高效利用本地食材的菜单，以及与多家机构合作将厨余垃圾转化为宝贵资源等多项举措实现这一目标。</p>
      <p>该项目不仅通过提供美味、优质且环保的餐饮服务提升与会者体验，更让参与者为保护地球的共同使命而感到自豪。每一道餐品在带来愉悦体验的同时实现零废弃物，为环境保护作出切实贡献。</p>
      <p>QSNCC的国际认可始于国际会议中心协会创新奖（AIPC Innovation Award ）——该国际权威奖项旨在表彰国际会议中心在管理、营销和服务策略方面的创新成果。备受瞩目的“全球会员选择奖（Delegate’s Choice award）”由国际会议中心协会全球会员投票产生，授予最具启发性与创新性的实践项目。</p>
      <p>此外，QSNCC还入围了2025年全球展览业协会运营与服务奖（UFI Operations & Services Award 2025）全球四强。该奖项由全球展览业协会（UFI）颁发，旨在表彰在活动中卓越的餐饮管理服务，评选标准涵盖“可持续性、参与度与适应性”三大维度，QSNCC的创新实践赢得了评审团的高度认可。</p>
      <p><strong class="addBold">QSNCC首席执行官Surapol Utintu</strong>表示：“这些国际可持续发展奖项不仅提升了QSNCC的全球声誉，更印证了我们实现零食物浪费的决心与创造力。在提供可持续的优质餐饮体验的同时，这些荣誉将激励我们朝着'净零排放'的终极目标持续迈进。”</p>
      <p>作为泰国MICE行业可持续发展的重要引领者，QSNCC持续树立行业标杆并激励同行。这一理念体现在2025年其场馆内即将举办的一系列聚焦可持续发展的活动中，包括：2025年9月22日的2025 Mae Fah Luang 基金会可持续发展论坛、9月26日至10月5日的Sustainability Expo（可持续发展博览会）、11月5日至7日的Thailand Smart City Expo（泰国智慧城市博览会），以及同期举办的International Conference on Biodiversity (IBD2025)（国际生物多样性大会）。这些活动的落地充分体现了业界对QSNCC可持续发展能力。</p>
      <p><img  src="/images/media/news/2025/9-4/aLqlAGG.jpg" alt="QSNCC"  /></p>     
      <p><img  src="/images/media/news/2025/9-4/hausajau.jpg" alt="QSNCC"  /></p>     
      <p><img  src="/images/media/news/2025/9-4/aLqjkGG.jpg" alt="QSNCC"  /></p>     
      <p><img  src="/images/media/news/2025/9-4/aLqj7m.jpg" alt="QSNCC"  /></p>     
      `,
      th: ``,
    },
    image: '/images/media/news/2025/9-4/aLqiNm.jpg',
    imageSp: '/images/media/news/2025/9-4/aLqiNm.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'Release_Carbon_Footprint_Tracking_Dashboard',
    headline: {
      cn: '泰国会展中心首创！QSNCC推出“实时碳足迹追踪仪表盘”为MICE行业树立可持续发展新标杆',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '为庆祝世界环境日，QSNCC，成为泰国首个推出MICE活动“实时碳足迹追踪仪表盘”的会展场馆。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '泰国会展中心首创！QSNCC推出“实时碳足迹追踪仪表盘”为MICE行业树立可持续发展新标杆',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2025年5月30日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2025/5-30/New_Release_Carbon_Footprint_Tracking_Dashboard.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>为庆祝世界环境日，泰国诗丽吉王后国家会议中心（QSNCC）自豪宣布，成为泰国首个推出MICE活动“实时碳足迹追踪仪表盘”的会展场馆。这一突破性创新将于今年7月举办的"Asia Sustainable Energy Week 2025"和"International Engineering Expo 2025"两大活动中试运行。</p>
      <p><img  src="/images/media/news/2025/5-30/Exterior.jpg" alt="QSNCC"  /></p>
      <p>由AltoTech Global Co., Ltd.开发的“实时碳足迹追踪仪表盘”，是泰国会展局（TCEB）支持的Winnovation计划的一部分。该智能数字平台通过实时数据，计算来自不同来源的温室气体排放量，包括能源消耗、食品消耗、包装物料及参会者交通产生的温室气体排放等。这一工具使活动主办方与参与者能够即时且透明地了解各项活动所带来的环境影响，并据此制定有效的碳减排或碳抵消策略，为实现真正的碳中和活动奠定基础。</p>
      <div class="SpaceDay">
        <p class="SpaceDay_info"><img src="/images/media/news/2025/5-30/WN-LVd7Q.jpg" alt="QSNCC"  /></p>
        <p><strong class="addBold">QSNCC 首席执行官Surapol Utintu先生</strong>“作为可持续发展的引领者，QSNCC 致力于在各方面推动绿色举措。我们率先采用ISO 14064-1和组织碳足迹（CFO）标准来衡量和报告温室气体排放。在此基础上，我们现正以更系统的方式实施针对具体活动的碳足迹评估（CFE）。此次推出的实时碳足迹追踪仪表盘，是我们在建立真正可持续、环保活动基础上的一项重要里程碑。我们希望"Asia Sustainable Energy Week 2025"和"International Engineering Expo 2025"能够成为其他提升可持续性活动的榜样，为泰国MICE行业设立全新标杆。”</p>
      </div>
      <p><img  src="/images/media/news/2025/5-30/TrackingDashboard.png" alt="QSNCC"  /></p>
      <p><strong class="addBold">泰国会展局（TCEB）执行顾问兼首席信息官Jaruwan Suwannasat女士</strong>表示：“TCEB 对QSNCC与AltoTech Global能通过MICE Winnovation计划携手合作感到非常振奋。这项合作为泰国MICE产业带来了变革性的环保责任实践，通过AltoTech Global的实时碳足迹仪表盘，能以实际可量化的成果监测和衡量会议中心活动区域的运营情况。这正契合TCEB推动创新与可持续发展的战略目标，为泰国MICE行业在全球舞台上带来竞争优势与独特价值。”</p>
      <div class="SpaceDay">
        <p class="SpaceDay_info"><img src="/images/media/news/2025/5-30/Sanchai.jpg" alt="QSNCC"  /></p>
        <p>2025亚洲可持续能源周主办方<strong class="addBold">Informa Markets Thailand泰国区总经理Sanchai Noombunnam先生</strong>补充道：“我们衷心感谢QSNCC和TCEB的大力支持与协作，使这一项目得以实现。借助实时碳足迹数据，我们能更深入地理解并体会可持续活动实践的价值，这也为我们构建系统化的碳减排与碳抵消路径提供了重要基础。这一举措与我们本届主题：‘推动可持续能源的数位转型，共创净零未来’完美契合。这不仅是迈向真正环保型活动的重要一步，也希望这一模式能够激发更多活动效仿，共同推动可持续发展。”</p>
      </div>
      <p>“展望未来，QSNCC计划将实时碳足迹追踪仪表盘纳入其会员忠诚计划的专属权益，会员可使用积分兑换该服务的使用权。这将成为推动环保型活动策划的又一方式，也将助力泰国MICE行业在可持续发展方面迈上新台阶。”Surapol先生总结道。</p>      
      `,
      th: ``,
    },
    image: '/images/media/news/2025/5-30/TrackingDashboard.png',
    imageSp: '/images/media/news/2025/5-30/TrackingDashboard.png',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'CH-Press_Relase_QSNCC_for_China_Market',
    headline: {
      cn: 'QSNCC：中国MICE活动信赖之选，以卓越服务深化双边关系，共庆泰中建交50周年',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '值此泰中建交50周年之际，QSNCC重申其作为中国会展主办方首选信赖场地的行业地位。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC：中国MICE活动信赖之选，以卓越服务深化双边关系，共庆泰中建交50周年',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2025年5月13日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2025/5-13/CH-Press_Relase_QSNCC_for_China_Market.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>值此泰中建交50周年之际，泰国诗丽吉王后国家会议中心（QSNCC）重申其作为中国会展主办方首选信赖场地的行业地位。自2022年全面升级以来，QSNCC已成功承办超过25场来自中国的会展活动。近期，QSNCC荣获<strong class="addBold">2025年TTG中国旅游大奖“最佳会议展览中心（国际）”</strong>殊荣，进一步巩固了其在中国市场的专业声誉。该奖项由中国旅游与会展行业专业人士投票评选，是业内最具影响力的荣誉之一。</p>
      <p><img  src="/images/media/news/2025/5-13/International.jpg" alt="QSNCC"  /></p>
      <p><strong class="addBold">QSNCC首席执行官Surapol Utintu</strong>表示：“我们深感荣幸能通过承办国际会展活动，为深化泰中合作贡献力量。中国主办方的信任，源于QSNCC对中国MICE市场的深刻理解。优越的地理位置、便捷交通、卓越口碑、现代化设施及定制化服务方案，正是吸引他们的重要因素。”</p>
      <p><img  src="/images/media/news/2025/5-13/aCMsMid.jpg" alt="QSNCC"  /></p>
      <p>Surapol补充道："适逢泰中建交50周年这一重要节点，QSNCC将持续积极拓展中国会展市场，积极发挥平台作用，以实际行动共庆这一里程碑时刻。我们坚信，这些活动将成为连接两国的桥梁与纽带，进一步深化经贸合作与人文交流，为泰中关系谱写更具活力的新篇章。"</p>
      <p>2025年初，QSNCC成功迎来多项重量级中国活动，包括吸引超过4,000位全球与会者的JCtrans第18届全球物流企业合作交易洽谈会（18th Freight Forwarding Conference by JCTrans），超过400人参与的博世车联特许加盟商年会（Bosch Automotive Service Franchise）。来自直销、汽车、IT、电子等多个行业的中国企业，纷纷选择在QSNCC举办国际性活动，反映出中国企业持续在亚洲拓展影响力的趋势。</p>
      <p>未来数月，QSNCC还将迎来包括5月的无<strong class="addBold">限极（中国）奖励旅游项目</strong>，以及11月的2025<strong class="addBold">年曼谷全球生物健康、人工智能与生物医药生态大会（中国）</strong>日程发布，进一步彰显其在中国MICE市场的持续吸引力。</p>
      <p>凭借一流的设施与国际化视野，QSNCC将继续发挥桥梁作用，助力泰中关系迈向更高层次，打造连接两国的多元合作平台。</p>

      
      
      `,
      th: ``,
    },
    image: '/images/media/news/2025/5-13/International.jpg',
    imageSp: '/images/media/news/2025/5-13/International.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'aBBL0PIqRLdaBsSi_PressRelease_MICEDay2025_Eng',
    headline: {
      cn: 'QSNCC 荣获三项 MICE 标准认证，稳固其世界级可持续场馆地位',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC）荣获三项备受认可的MICE行业标准认证，该荣誉于TCEB主办的“2025 MICE标准日”活动中正式颁发。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC 荣获三项 MICE 标准认证，稳固其世界级可持续场馆地位',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2025年3月25日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2025/3-25/aBBL0PIqRLdaBsSi_PressRelease_MICEDay2025_Eng.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心（QSNCC）荣获三项备受认可的MICE行业标准认证，包括东盟MICE场馆标准（AMVS）、泰国MICE场馆标准（TMVS）以及2024泰国可持续活动管理标准（TSEMS）。该荣誉于泰国会议展览局（TCEB）主办的“2025 MICE标准日”活动中正式颁发。</p>
      <p><img  src="/images/media/news/2025/3-25/MiceDayjpg.jpg" alt="QSNCC"  /></p>
      <p>这三项认证充分肯定了QSNCC作为世界级会展场馆的卓越实力，能够承办各类规模的会议与活动——从国家级论坛到国际性大会，并始终将可持续发展理念贯穿于经济、社会与环境等各个层面。</p>
      <p><strong class="addBold">东盟MICE场馆标准（AMVS）</strong>，是东南亚区域内的认证标准，旨在提升MICE场馆的质量与可信度，实现东盟统一标准；</p>
      <p><strong class="addBold">泰国MICE场馆标准（TMVS）</strong>则是已被东盟MICE产业广泛认可的国家级标准。</p>
      
      <p>
        <p>两项标准皆基于以下四大评估要素：</p>
        <ol style="list-style: decimal;margin-left: 2rem;">
          <li style="list-style: decimal;"><strong style="color:#000000">场馆条件</strong> —— 包括基础设施及会议室配套设施</li>
          <li style="list-style: decimal;"><strong style="color:#000000">技术支持</strong> —— 包括视听系统及通讯设备</li>
          <li style="list-style: decimal;"><strong style="color:#000000">服务质量</strong></li>
          <li style="list-style: decimal;"><strong style="color:#000000">可持续管理</strong> —— 涵盖环境责任、安全保障及社会责任</li>
        </ol>
      </p>
      <p><strong class="addBold">泰国可持续活动管理标准（TSEMS）</strong>表彰那些高度重视可持续运营的机构，在环保、社会责任及促进国家经济发展的多方面中，展现出综合性的可持续实践。</p>
      <p>这一次，同时获得三项MICE标准认证，体现了QSNCC在专业运营与可持续发展方面的持续投入与承诺。也进一步增强了国内外客户对其在全球标准下，提供卓越与负责任会展体验的信心。</p>
      <p>QSNCC执行董事Sutichai Bunditvorapoom（左）在TCEB主办的“2025 MICE标准日”活动中，从泰国总理办公室副部长 Dr. Nahathai Thewphaingarm（右）手中接过<strong class="addBold">2024东盟MICE场馆标准（AMVS）</strong>证书。</p>
      <p>除了AMVS，QSNCC还同时获得了泰国MICE场馆标准（TMVS）与泰国可持续活动管理标准（TSEMS）。三项认证的获得，再次印证QSNCC作为世界一流MICE场馆的地位，并彰显其在经济、社会与环境维度上坚持可持续发展原则的坚定承诺。</p>
      <p><img  src="/images/media/news/2025/3-25/MiceDayjpg.jpg" alt="QSNCC"  /></p>
      <p><img  src="/images/media/news/2025/3-25/TMVS.jpg" alt="QSNCC"  /></p>
      <p><img  src="/images/media/news/2025/3-25/TSEMS.jpg" alt="QSNCC"  /></p>
      `,
      th: ``,
    },
    image: '/images/media/news/2025/3-25/MiceDayjpg.jpg',
    imageSp: '/images/media/news/2025/3-25/MiceDayjpg.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'Z8UrRRsAHJWomCiF_OnionEarns2TIDAAwards_ENG',
    headline: {
      cn: 'Onion荣获2项TIDA奖项，以表彰QSNCC的卓越设计',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '泰国设计工作室在2月初的官方公告中，被授予泰国室内设计师协会颁发的 2 项权威设计大奖，以表彰其在QSNCC室内设计方面的卓越表现。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'Onion荣获2项TIDA奖项，以表彰QSNCC的卓越设计',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2025年2月28日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2025/2-28/Z8UrRRsAHJWomCiF_OnionEarns2TIDAAwards_ENG.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p><strong class="addBold">泰国设计工作室</strong>Onion Co., Ltd.在2月初的官方公告中，被授予泰国室内设计师协会（TIDA）颁发的 2 项权威设计大奖，以表彰其在泰国诗丽吉王后国家会议中心（QSNCC）室内设计方面的卓越表现。Onion斩获的奖项包括由TIDA评审委员会评选的“最佳设计大奖”（Best of the Best）以及“最佳文化与教育空间设计奖”（Best of Cultural and Educational Space Design）。这些奖项不仅展示了Onion出色的设计能力，也彰显了QSNCC 设计在融合泰国文化特色与当代风格方面的卓越表现。</p>
      <p><img  src="/images/media/news/2025/2-28/WomChl_QSNCC.jpg" alt="QSNCC"  /></p>
      <p>TIDA奖项自2010年设立以来，旨在推动泰国室内建筑设计的创造力，并表彰对人类、环境和社会具有价值的创意作品。2024泰国室内设计大奖（TIDA Awards 2024）评选涵盖16个奖项类别，由来自多个领域的专家评审团评选，评选标准包括创意构思、实用性、与环境及人文的连接性、空间与文化的契合度，以及对室内设计行业的启发性。今年的获奖者由泰国诗琳通公主殿下亲自授予荣誉。</p>
      <p><strong class="addBold">QSNCC首席执行官Surapol Utintu</strong>表示：“QSNCC的设计荣获两项全国性大奖，我们深感自豪。在此，我们要感谢Onion通过创意设计将泰国文化特色完美展现给国际观众。他们的设计理念与QSNCC的空间相得益彰，使其成为泰国迎接全球宾客的重要象征。”</p>
      <p><img  src="/images/media/news//2025/2-28/WomCiI_Award1.jpg" alt="QSNCC"  /></p>
      <p>Onion Co., Ltd. 作为 QSNCC 设计背后的创意推手，是泰国知名的室内设计公司，曾参与多个领先地产项目的设计，致力于满足当代社会需求。他们的设计理念强调打造“生活与商业空间相融合”的体验，以契合现代人对兼具居住舒适性和多功能性的空间需求。</p>
      <p><strong class="addBold">Onion联合创始人、建筑师 Arisara Chaktranon</strong>说道：“Onion能够获得QSNCC室内设计的国家级奖项，深感荣幸。我们很自豪能够通过设计向全球观众展现泰国艺术与文化的魅力。这些奖项不仅是对公司实力的肯定，更激励我们不断提升水平，向国际设计标准迈进。”</p>
      <p>TIDA Awards 2024奖项的认可，再次印证了 QSNCC 在设计卓越性方面的成就。在此之前，QSNCC还荣获2023年 泰国国际房地产大奖（FIABCI-Thai PRIX D’EXCELLENCE AWARDS），该奖项表彰其作为会展场馆，在建筑与设计上成功展现泰国文化特色，向国际观众传递泰国的独特魅力。</p>
      `,
      th: ``,
    },
    image: '/images/media/news/2025/2-28/WomChl_QSNCC.jpg',
    imageSp: '/images/media/news/2025/2-28/WomChl_QSNCC.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'surapol-utintu-third-from-left-ceo-of-queen-siriki',
    headline: {
      cn: 'QSNCC将使用过的 PET 塑料瓶捐赠给Mae Fa Luang Foundation基金会进行回收，以此加强其可持续发展政策，这一举措有助于减少废弃物并保护环境',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC捐赠使⽤过的 PET 塑料瓶，以此重申中⼼对可持续发展政策的承诺。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC将使用过的 PET 塑料瓶捐赠给Mae Fa Luang Foundation基金会进行回收，以此加强其可持续发展政策，这一举措有助于减少废弃物并保护环境',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2024年12月12日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2024-12-12/Photorelease_DeliveringUsedPlasticBottletoMaeFahLuangFoundation_Eng.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p><strong class="addBold">泰国诗丽吉王后国家会议中心首席执行官Surapol Utintu</strong>（左三）向由<strong class="addBold">皇室赞助的Mae Fah Luang Foundation基金会秘书长兼首席执行官M.L. Dispanadda Diskul</strong>（左四）捐赠使用过的PET塑料瓶，以此重申中心对可持续发展政策的承诺。这些塑料瓶将被回收利用，从而减少废弃物并保护环境。</p>
      <p><img  src="/images/media/news/2024-12-12/Deliverings.jpg" alt="QSNCC"  /></p>
      <p>这一PET塑料瓶捐赠活动与QSNCC的环保和可持续发展政策高度一致，旨在促进适当的垃圾分类，并通过回收最大限度地提高材料的价值。QSNCC选择Mae Fah Luang Foundation基金会作为合作伙伴，该基金会致力于可持续发展，同时推动社区的经济和改善社会福祉。</p>
      
      
      `,
      th: ``,
    },
    image: '/images/media/news/2024-12-12/Deliverings.jpg',
    imageSp: '/images/media/news/2024-12-12/Deliverings.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'DevconSEA2024toBeHostedatQSNCC-1',
    headline: {
      cn: 'Devcon SEA 2024将在QSNCC盛大举办，突显东南亚作为区块链创新领先中心的地位',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '以太坊顶级盛会Devcon SEA 2024，将于11月12日至15日在QSNCC盛大举办。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'Devcon SEA 2024将在QSNCC盛大举办，突显东南亚作为区块链创新领先中心的地位',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2024年11月06日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2024-11-06/DevconSEA2024toBeHostedatQSNCC-1.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>以太坊顶级盛会Devcon SEA 2024，将于11月12日至15日在曼谷的泰国诗丽吉王后国家会议中心（QSNCC）盛大举办。这一里程碑式盛会凸显了东南亚作为区块链技术和创新中心日益重要的地位，<strong class="addBold">预计将吸引来自世界各地的 12,000 多名参与者</strong>。通过促进协作和富有影响力的联系，Devcon SEA 旨在提升该地区开发者和企业家社区，同时创造持久的社会和经济效益。</p>
      <p><img  src="/images/media/news/2024-11-06/Devcon_sea.jpeg" alt="QSNCC"  /></p>
      <p>作为领先的可编程区块链，<strong class="addBold">以太坊</strong>引领了正在重塑行业、促进全球包容的创新应用。Devcon SEA 将展示以太坊的最新进展，强调其通过去中心化应用程序和智能合约推动各个领域的透明性、安全性和效率的能力。此次活动巩固了以太坊作为全球变革驱动力的地位，并有可能重塑行业并支持更公平的世界。</p>
      
      <p>与会者将聆听到包括<strong class="addBold">以太坊联合创始人Vitalik Buterin、以太坊基金会执行董事Aya Miyaguchi以及其他知名人士，包括Etherscan的Matthew Tan、Pendle的TN Lee和Kyber Network的Loi Luu</strong>在内的，极具影响力演讲者的见解。社区主导的会议将进一步丰富活动内容，探讨以太坊的实际应用及跨学科主题。</p>
      <p><strong class="addBold">以太坊基金会 Devcon 的负责人 Skylar Weaver </strong>表示：“我们看到泰国和东南亚拥有巨大的潜力，拥有庞大的用户群和熟练的开发者社区。在曼谷举办 Devcon SEA 将为当地开发者和企业家创造一个与国际以太坊社区建立联系的无与伦比的机会。在过去两年的努力和创新的基础上，我们致力于让这次活动成为迄今为止最具影响力的活动。”</p>
      <p>近30%的与会者将来自东南亚和南亚，泰国参会者占比约为10%。Devcon SEA将聚焦该地区充满活力的区块链生态系统，为本地开发者和创业者提供与全球以太坊社区建立联系的独特机会，并推动本地和国际增长的新项目。</p>
      <p>作为曼谷首屈一指的会议场地泰国诗丽吉王后国家会议中心 (QSNCC) 将为 Devcon SEA 提供迄今为止规模最大的会议理想场地。<strong class="addBold">Weaver 补充道</strong>“QSNCC 的现代化设施和宽敞的空间为我们的与会者提供了包括开发人员、工程师、设计师和研究人员的完美环境。”。</p>
      <p>该活动将设有六个主舞台、研讨会区域和“社区中心”，旨在促进从治理和分散科学到Layer 2网络等主题的讨论。</p>
      <p><img  src="/images/media/news/2024-11-06/FrontView-2.jpg" alt="QSNCC"  /></p>
      <p><strong class="addBold">QSNCC首席执行官Surapol Utintu</strong>表示：“举办Devcon 7进一步巩固了泰国在区域区块链创新中的领先地位，同时也展示了QSNCC举办世界级活动的能力。我们已准备好迎接来自世界各地的与会者，并通过我们先进的设施和独特的泰式款待为他们提供卓越的非凡体验。”</p>
      <p>11月11日，东南亚以太坊社区将举办EthSEA Day，这是一场为期一天的活动，门票 5 美元，旨在吸引初学者和专业人士。当天将由主要演讲者主持的研讨会、演讲和小组讨论为特色，为东南亚社区提供一个展示成就并加强本地和国际联系的平台。Devcon SEA 2024 标志着认可和庆祝东南亚对区块链发展的重大贡献的一个里程碑。通过汇集该领域的顶尖人才，激发创新，加深社区联系，并催化在该地区以外产生共鸣的相关项目。</p>
      
      `,
      th: ``,
    },
    image: '/images/media/news/2024-11-06/Devcon_sea.jpeg',
    imageSp: '/images/media/news/2024-11-06/Devcon_sea.jpeg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'Zx8SwK8jQArTz3ht_PressRelease_ThailandHostsSoutheastAsia',
    headline: {
      cn: '泰国举办2024年FNM大会——东南亚首个神经胃肠病学与动力学联盟会议于QSNCC召开，推进“医疗枢纽”国家战略”',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '泰国将主办2024年神经胃肠病学与动力学联盟科学会议（FNM 2024），汇聚全球超过1000位医生和学者，突显了泰国医学专业人员的专业能力，将泰国打造成国际医疗枢纽。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '泰国举办2024年FNM大会——东南亚首个神经胃肠病学与动力学联盟会议于QSNCC召开，推进“医疗枢纽”国家战略”',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2024年10月18日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2024-10-18/Zx8SwK8jQArTz3ht_PressRelease_ThailandHostsSoutheastAsia.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国将主办2024年神经胃肠病学与动力学联盟科学会议（FNM 2024），这将是一次重要的国际会议，汇聚全球超过1000位医生和学者。本次活动突显了泰国医学专业人员的专业能力，支持政府于2025至2034年将泰国打造成国际医疗枢纽的战略。会议将于2024年11月6日至8日在曼谷的泰国诗丽吉王后国家会议中心（QSNCC）举行。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-10-18/main.jpg" alt="QSNCC"  /></p>
      <p><strong style="color:#000000">FNM会议</strong>由神经胃肠病学和运动联合会 (FNM) 组织，旨在加强对神经系统和胃肠道的相关知识和了解，重点关注胃酸反流、功能性消化不良、肠易激综合征和慢性便秘等病症。它是功能性胃肠道疾病专家进行全球知识交流和沟通的重要平台。泰国是该联合会的主要创始成员国，已两次被选为会议主办国：第一次是在2014年（由于政局动荡而另选他处）。如今在 2024 年，这是第五届 FNM 会议，也是在东南亚第一次举办，将展示最新的医学进展并解决日益普遍的神经胃肠道疾病问题。</p>
      <div class="SpaceDay">
        <p class="SpaceDay_info"><img src="/images/media/news/2024-10-18/hw_SutepGonlachanvit.jpg" alt="QSNCC"  /></p>
        <p><strong style="color:#000000">FNM 2024主席，朱拉隆功大学神经胃肠动力学卓越中心主任兼国际康民医院胃肠动力中心主任Sutep Gonlachanvit教授</strong>表示，“泰国能够获得FNM和亚洲神经胃肠动力学协会（ANMA）代表全球顶尖专家的信任，承办FNM 2024会议，这对泰国医学界而言是极大的荣誉。这再次确认了泰国在神经胃肠动力学领域的卓越美誉。我们在学术研究方面享有世界级的美誉，有助于提升泰国的医疗枢纽地位。与泰国国家战略一致，通过知识共享和国际合作，增强我们医疗服务的竞争力并推动治疗的研发。FNM 2024的举办增强了对泰国医疗行业的信心，提升了国家的医疗体系，吸引全球专家，为开发新的医学知识和创新，创造了机会。”</p>
      </div>
      <p><strong style="color:#000000">Sutep Gonlachanvit</strong>教授还指出，泰国已为承办国际会议做好准备，拥有包括机场、住宿、适合学术会议和休闲旅游的地点以及会议场地等优秀设施。泰国诗丽吉王后国家会议中心提供先进的设施、充足的空间，适用于各种会议形式，且便于前往曼谷的旅游景点。</p>
      <p>FNM 2024将包含以下重要活动：</p>
      <p>
        <ul style="list-style: disc;margin-left: 2rem;">
          <li style="list-style: disc;"><strong style="color:#000000">研究课程：</strong>关于神经胃肠动力学相关疾病的研究课程</li>
          <li style="list-style: disc;"><strong style="color:#000000">专题讲座：</strong>由国际顶尖专家主讲的专题讲座，涵盖饮食、肠道微生物群以及肠脑互动障碍等主题</li>
          <li style="list-style: disc;"><strong style="color:#000000">研究报告：</strong>全球顶尖机构的研究者分享研究成果，于讲座和展览中展示</li>
        </ul>
      </p>
      <div class="SpaceDay">
        <p><strong style="color:#000000">泰国诗丽吉王后国家会议中心首席执行官Surapol Utintu</strong>表达了对支持泰国医学界并提升其国际声誉的自豪。他表示：“FNM 2024展示了QSNCC承办各种类型和规模活动的能力，尤其是需要多种形式和多个空间的大型国际性会议。我们致力于确保所有与会者在QSNCC度过一个舒适愉快的时光。”</p>
        <p class="SpaceDay_info"><img class="surapol" src="/images/media/news/2024-10-18/Surapol-Utintu.jpg" alt="QSNCC"  /></p>
      </div>
      
      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2024-10-18/main.jpg',
    imageSp: '/images/media/news/2024-10-18/main.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'Zvtp67VsGrYSwLae_RV4_EN_PressRelease_QSNCCWins2Int’lAwards',
    headline: {
      cn: 'QSNCC荣获两项国际大奖：“2024年泰国最佳会展中心”，推动泰国成为亚洲旅游和会奖中心',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '庆祝QSNCC在2024年荣获两项国际奖项的卓越成就：TTG旅游大奖的“泰国最佳会议与展览中心”奖和世界MICE大奖的“泰国最佳会展中心”奖。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC荣获两项国际大奖：“2024年泰国最佳会展中心”，推动泰国成为亚洲旅游和会奖中心”',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2024年9月30日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2024-09-30/Zvtp67VsGrYSwLae_RV4_EN_PressRelease_QSNCCWins2Int’lAwards.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>庆祝泰国诗丽吉王后国家会议中心（QSNCC）2024年荣获两项国际奖项的卓越成就：TTG旅游大奖（TTG Travel Awards）的“泰国最佳会议与展览中心”奖和世界MICE大奖（World MICE Awards）的“泰国最佳会展中心”奖。这些奖项由国际旅游和MICE行业的专业人士及企业投票选出，将进一步加强泰国对专业化和国际标准的承诺，推动泰国成为亚洲旅游和会议奖励旅游的中心。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-09-30/Awards.jpg" alt="QSNCC"  /></p>
      <p>2024年的获得的这两项大奖意味着QSNCC在短短两年内（2023-2024年）第三次荣获“泰国最佳会展中心”称号，此前该中心于2023年荣获世界MICE大奖的同一类别奖项，并连续两年荣获世界MICE大奖。这一卓越记录是对QSNCC一贯提供的标准服务和专业精神的肯定，从而赢得了国际组织者的信任，成为多项重要活动的举办地。</p>
      <p><strong style="color:#000000">TTG旅游大奖</strong>于1989年由<strong style="color:#000000">TTG Travel Trade Publishing</strong>公司发起，作为报道亚太地区旅游和会展行业的媒体公司，包含线上和印刷两种形式。这些奖项授予在旅游和MICE领域表现卓越的企业，评选过程由行业内的专业人士和企业投票决定。最初设有10个奖项，目前已增加到100多个奖项，主要类别包括旅游供应商、旅行社、行业有影响力人士的杰出成就奖和长期表现卓越的活动组织名人堂。</p>
      <p><strong style="color:#000000">世界MICE大奖</strong>是全球会奖行业卓越成就的象征，旨在表彰全球范围内的会奖行业机构，包括会奖目的地。该奖项由总部位于英国的World Travel Group颁发，该集团在旅游、互联网和印刷领域已有超过30年的领先地位与声誉。除了世界MICE大奖，该集团还颁发其他类别的奖项，例如世界旅游大奖、世界高尔夫球大奖和世界水疗大奖，这些奖项在全球旅游业中享有极高的声誉和认可。</p>
      <div class="SpaceDay">
        <p class="SpaceDay_info"><img src="/images/media/news/2024-09-30/Surapol Utintu.jpg" alt="QSNCC"  /></p>
        <p><strong style="color:#000000">泰国诗丽吉王后国家会议中心（QSNCC）的首席执行官Surapol Utintu先生</strong>表示：“能够获得国际知名奖项——TTG旅游大奖和世界MICE大奖中的“泰国最佳会展中心奖”，令我们在QSNCC倍感自豪。我们感谢每一位投票给我们的支持者。这些奖项不会让我们满足于此，反而会激励我们进一步提升服务，以及时满足不断变化的商业环境需求。</p>
      </div>
      <p>我们将提供最佳服务，确保客户获得最大的满意度。这两个奖项也确认了QSNCC在推动泰国旅游及其MICE行业方面的角色，提升了国家作为商务活动首选目的地的声誉，并增强了其国际竞争力。”</p>
      <p>除了获得TTG旅游大奖和世界MICE大奖的奖项，QSNCC还获得了<strong style="color:#000000">美国绿色建筑委员会（USGBC）颁发的能源与环境设计先锋银级认证（LEED）</strong>，成为东南亚首个获得该美国机构可持续发展奖项的场馆，进一步巩固了QSNCC作为<strong style="color:#000000">“泰国最佳会展中心”</strong>的地位。</p>
      
      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2024-09-30/Awards.jpg',
    imageSp: '/images/media/news/2024-09-30/Awards.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'CH-Press-Release_Space-Day_EN_FINAL',
    headline: {
      cn: 'QSNCC以泰国首个课外学习活动点燃灵感：“赋能泰国学生探索星空：2024泰国航天日”',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC很荣幸成为“赋能泰国学生探索星空：2024泰国航天日”项目的举办场地。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC以泰国首个课外学习活动点燃灵感：“赋能泰国学生探索星空：2024泰国航天日”',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2024年8月2日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2024-08-02/CH-Press-Release_Space-Day_EN_FINAL.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心 (QSNCC) 坚信，孩子们的学习应当超越课堂。为了支持无边界学习，我们很荣幸成为“赋能泰国学生探索星空：2024泰国航天日”项目的举办场地。这项计划提供了航天和工程领域的课外学习体验，为新一代提供了，在我们会议中心探索和培养创造力的独特机会。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-08-02/Group_Photo.jpg" alt="QSNCC"  /></p>
      <p>“赋能泰国学生探索星空：2024泰国航天日”项目首次在泰国举行。此次活动标志着在科学和航天领域扩大课外活动的一个重要里程碑，旨在培养技能并提高孩子们对科学和航天技术重要性的认识。参加活动的孩子们非常高兴见到了<strong style="color:#000000">Charles Sam Gemar，这位前美国国家航空航天局（NASA）的宇航员和美国陆军中校，被亲切地称为“Sam先生”</strong>。Sam先生曾完成过三次航天飞行任务（STS-38、STS-48和STS-62），绕地球飞行达385次，在太空中度过了超过581个小时，这次Sam先生来到这里分享了自己的太空飞行经历。</p>
      <div class="SpaceDay">
        <p class="SpaceDay_info"><img src="/images/media/news/2024-08-02/Surapol.jpg" alt="QSNCC"  /></p>
        <p><strong style="color:#000000">QSNCC首席执行官Surapol Utintu</strong>表示：“QSNCC很高兴能参与这个精彩的项目，支持泰国的孩子们体验课外学习。我们的场地不仅仅是一个会议中心，它是一个让人们可以参与适合自己生活方式的活动的地方。凭借我们宽敞的区域和全面的设施，我们希望孩子们在这里感到快乐、受到启发，并能够充分学习。”</p>
      </div>
      <p>在活动中，孩子们参加了各种活动，包括“建造你的航天飞机”工作坊和与Sam先生一起的“像宇航员一样训练”项目。他们还与Sam先生现场交流，并聆听他在太空工作中的经历。Sam先生向孩子们分享了许多可以将这些应用到各种情况中的，有趣的见解和观点。</p>
      <div class="SpaceDay">
        <p class="SpaceDay_info"><img src="/images/media/news/2024-08-02/girls.jpg" alt="QSNCC"  /></p>
        <p>“我们非常激动能见到Sam先生，一位真正的前宇航员，真是太棒了！Sam 先生非常友善，让我们有机会询问有关太空工作的问题。我们在与天文学和太空相关的活动中度过了有趣的时光，比如体验真正的陨石、制作我们自己的航天飞机以及使用月相计算器。我们喜欢通过小组活动学习软技能并提高了团队合作能力。”<strong style="color:#000000">来自Bodindecha (Sing Singhaseni)学校的学生Newnew Nannapas Charoenthungwittaya和Wawa Pimchanok Prueangwittayagan</strong>带着灿烂笑容地说道。</p>
      </div>
      <p>“我们希望将来会有更多这样的好项目，以及更多宽敞、便利的区域，让我们享受课外学习的乐趣，”Wawa和Newnew在参加活动前总结道。</p>
      <div class="SpaceDay">
        <p class="SpaceDay_info"><img src="/images/media/news/2024-08-02/Sam_Gemar.jpg" alt="QSNCC"  /></p>
        <p>Sam先生谈到了他的宇航员职业生涯，他说：“我小时候的梦想职业是成为一名宇航员——一名美国宇航员——有机会在太空中遨游。”他继续说道：“在成为宇航员的道路上，我面临的最大障碍是积累所有的学术资格和工作经验。这些都不是件容易的事。”<br/>此外，Sam先生还表达了对泰国诗丽吉王后国家会中心（QSNCC）的赞赏，称其为一个鼓舞人心的地方。他说：“我去过世界各地，包括去年访问的15个国家，这里是我见过的最令人印象深刻的设施。”</p>
      </div>
      <p>他继续说道：“你无法不被其建筑、设计以及会议和零售空间的结合所打动。看到人们在会议场所外进行日常生活，这种组合在其他地方很少见，非常有趣。”</p>
      <p>Sam先生补充道：“环顾会议中心，看到艺术品和往来的人们时，这是一个了解文化、结识当地人、体验这里文化和人民友好氛围的机会。泰国诗丽吉王后国家会议中心（QSNCC）是个‘鼓舞人心’的和具有‘未来感’的。”</p>
      <p>激励自我并寻求课堂外的学习体验，对于实现我们的梦想至关重要。泰国诗丽吉王后国家会议中心很高兴能提供一个激发灵感的空间，帮助泰国儿童学习并共同建设更美好的未来。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-08-02/Sam_Gemar1.jpg" alt="QSNCC"  /></p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-08-02/Sam.jpg" alt="QSNCC"  /></p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-08-02/Space_Day.jpg" alt="QSNCC"  /></p>
      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2024-08-02/Group_Photo.jpg',
    imageSp: '/images/media/news/2024-08-02/Group_Photo.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'CH_Press_Release_QSNCC_wins_World_MICE_Awards',
    headline: {
      cn: 'QSNCC 荣获世界 MICE 大奖，被评为泰国最佳会议中心',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC荣获“2023 年泰国最佳会议中心”世界会奖旅游奖（World MICE Awards）。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC 荣获世界 MICE 大奖，被评为泰国最佳会议中心',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2024年7月4日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2024-07-04/CH_Press_Release_QSNCC_wins_World_MICE_Awards.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心（QSNCC）荣获“2023 年泰国最佳会议中心”世界会奖旅游奖（World MICE Awards）。荣获该奖，是来自全球MICE和旅游业专业人士的投票结果。该奖项于 2024 年正式公布，证明了泰国 MICE 行业标准的发展和升级，已到全球水平。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-07-04/PR-World.jpg" alt="QSNCC"  /></p>
      <p><strong style="color:#000000">世界会奖旅游奖（World MICE Awards）</strong>是 MICE 行业全球卓越水平的象征。它旨在表彰在 MICE 行业多个领域取得卓越成就的企业，包括来自全球各地的目的地和表现卓越的企业。该奖项由英国世界旅游集团（World Travel Group）颁发，该集团是一家在旅游业、互联网和印刷媒体领域拥有 30 多年历史的领先机构。除了世界会奖旅游奖之外，该集团还颁发世界旅游奖、世界高尔夫大奖、世界水疗大奖，这些奖项在旅游业中都具有全球认可度。</p>
      <p>除了世界会奖之外，QSNCC还因其在可持续发展方面的举措而获得了M&C Asia Stella Awards 2023奖项，并因其具有出色建筑设计的会议而获得FIABCI-Thai PRIX D'EXCELLENCE 2023奖项。QSNCC还被选为多个世界级活动的举办地，包括世界级金融科技展“MONEY 20/20 Asia”和世界足球管理机构的年度大会“第74届国际足联大会”。 QSNCC 最新举办的大型会议是2024年国际血栓与止血大会（2024 ISTH Congress），即国际血栓与止血学会 (ISTH)第 32 届年度学术会议。这一切都证明了主办方对 QSNCC 的信心，并确立了QSNCC作为“泰国最佳会议中心”的地位。</p>
      

      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2024-07-04/PR-World.jpg',
    imageSp: '/images/media/news/2024-07-04/PR-World.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'Congress2024GlobalExpertsGatherasInternationalScientificMeetingConvenes',
    headline: {
      cn: '2024国际血栓与止血学会大会：全球专家齐聚，国际科学会议首次在泰国曼谷的泰国诗丽吉王后国家会议中心举行，时间为2024年6月22日至26日',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '第32届年度科学会议致力于血栓形成、止血和血管生物学，将于2024年6月22日至26日在诗丽吉王后国家会议中心举行。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '2024国际血栓与止血学会大会：全球专家齐聚，国际科学会议首次在泰国曼谷的泰国诗丽吉王后国家会议中心举行，时间为2024年6月22日至26日',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2024年6月17日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2024-06-22~26/Congress2024GlobalExpertsGatherasInternationalScientificMeetingConvenes.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>准备好迎接一场具有里程碑意义的活动吧，泰国将主办由国际血栓与止血学会 (ISTH) 主办的2024年国际血栓与止血大会（2024 ISTH Congress）。第32届年度科学会议致力于血栓形成、止血和血管生物学，将于2024年6月22日至26日在诗丽吉王后国家会议中心举行。预计将有数千名全球医学和科学专家出席，这将是该QSNCC有史以来规模最大的医学会议，活动将占据其70%以上的空间。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-06-22~26/024CONGRESS_Eng.png" alt="QSNCC"  /></p>
      <p><strong style="color:#000000">2024年国际血栓与止血大会（2024 ISTH Congress）</strong>是血栓形成和止血领域的顶级国际会议，展示了最新的突破和临床进展。临床医生、研究人员、教育工作者、相关医疗保健专业人员和行业领袖将齐聚一堂，交流最新创新成果，推动对血栓和出血性疾病的理解、预防、诊断和治疗。现场交流机会将比比皆是，使与会者能够促进合作并分享知识。此次国际会议标志着 ISTH 重返亚洲地区，继 2011 年在日本京都举办的大会之后，这也是泰国首次作为东道主，展示其在东南亚地区的劳动力潜力、医疗创新和领先的医疗系统。</p>
      <p><strong style="color:#000000">ISTH 主席 Flora Peyvandi 医学博士</strong>说：“我们选择了位于曼谷的泰国诗丽吉王后国家会议中心，因为其中心位置为与会者提供了最大的便利。该场馆满足我们世界级 2024年国际血栓与止血大会（2024 ISTH Congress）的多样化需求，方便进行海报展示、教育课程、最前沿的讲座、医疗行业展览以及专业的交流机会。”</p>

      <p>“泰国被指定为2024年国际血栓与止血大会（ ISTH 2024 Congress）的主办国，凸显了该地区作为医疗和科学行业创新聚集中心的地位，”<strong style="color:#000000">医学博士 Pantep Angchaisuksiri 教授</strong>表示，他是<strong style="color:#000000">国际血栓与止血大会 2024-2026年度任期的候任主席、医学教授、玛希隆大学拉玛提波迪医院止血和血栓科主任</strong>。“这次会议为亚太科学和临床界提供了一个关键机会，继续对血栓和出血性疾病的预防、诊断和治疗产生持久影响，最终塑造全球血栓和止血医疗实践的未来。”</p>
      <p><strong style="color:#000000">QSNCC 的运营管理方，N.C.C.管理与发展有限公司首席执行官Surapol Utintu先生</strong>对此表示感谢，并表示：“我们非常荣幸泰国和QSNCC被选为2024年国际血栓与止血大会（ ISTH 2024 Congress）的主办方。我们已做好充分准备，将凭借我们最先进的活动空间、一流的设施和多样化的零售选择，为与会者带来世界一流的体验。我们的目标是确保这一盛会超出预期，给与会者留下深刻印象。通过促进互动和知识交流，我们相信大会将在推进血栓治疗和促进全球医疗保健方面发挥关键作用。”</p>

      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2024-06-22~26/024CONGRESS_Eng.png',
    imageSp: '/images/media/news/2024-06-22~26/024CONGRESS_Eng.png',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'Zkvzuiol0Zci9TS8_EN_PressRelease_QSNCCJoinsForcestoReigniteThailand_sTourism',
    headline: {
      cn: 'QSNCC携手IAAPA亚洲博览会重燃泰国旅游及游乐园行业：顶级亚洲盛会时隔17年再次回归！',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '2024 IAAPA亚洲博览会（IAAPA Expo Asia 2024）时隔17年再次回到泰国。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC携手IAAPA亚洲博览会重燃泰国旅游及游乐园行业：顶级亚洲盛会时隔17年再次回归！',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2024年5月20日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2024-05-20/Zkvzuiol0Zci9TS8_EN_PressRelease_QSNCCJoinsForcestoReigniteThailand_sTourism.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>迈向创新与娱乐旅游的未来，<strong style="color:#000000">2024 IAAPA亚洲博览会（IAAPA Expo Asia 2024）</strong>是游乐园及旅游行业进步发展的首要盛会。该活动时隔17年再次回到泰国，以“<strong style="color:#000000">在IAAPA Expo Asia塑造您的进化：将您发展为领先的行业机构</strong>”为主题，旨在通过深刻的讨论、知识交流和企业家的合作，提升企业成为行业领袖。此次博览会将于2024年5月27日至30日在泰国诗丽吉王后国家会议中心（QSNCC）举行，展览会将占地面积超过7,800平方米，参会者将有机会体验来自全球的最前沿游乐设施。</p>
      
      
      <p><strong style="color:#000000">IAAPA亚洲博览会由国际游乐园及景点协会（IAAPA）</strong>主办，这是一个连接来自主题公园、动物园、家庭娱乐中心、水族馆、博物馆、科学中心和自然景点等行业成员的全球联盟。IAAPA Expo致力于在全球100多个国家促进行业发展，并以展示游乐园和旅游业的最新创新和进步而闻名。从最先进的技术和品牌授权到创新的餐饮和商品策略，IAAPA的贸易展提供了丰富的创意和见解，帮助企业保持行业领先并满足客户不断变化的需求。IAAPA Expo以举办全球100多场活动的辉煌历史，汇集顶级制造商和服务提供商，展示最新产品、服务和解决方案，包括互动游乐设施和模拟体验。</p>
      <p>主要亮点包括：</p>
      <p>
        <ul style="list-style: disc;margin-left: 2rem;">
          <li style="list-style: disc;"><strong style="color:#000000">过山车专家：</strong>如Vekoma、Intamin、Rocky Mountain Construction、Great Coaster International、Gerstlauer、Premier Rides和S&S等。</li>
          <li style="list-style: disc;"><strong style="color:#000000">游乐园设施专家：</strong>如HUSS Park Attractions、Mack Rides、Fabbri Group、Zamperla、SBF Visa、Moser Rides、Technical Park和Zierer等。</li>
          <li style="list-style: disc;"><strong style="color:#000000">水上乐园创新者：</strong>如WhiteWater West、Proslide和Polin Waterparks等。</li>
          <li style="list-style: disc;"><strong style="color:#000000">暗黑骑行和动感模拟器领导者：</strong>如DOF Robotics、Triotech、Brogent、ETF Ride Systems、Sally Darkrides和Attracktion!等。</li>
          <li style="list-style: disc;">区域展示将展示各种<strong style="color:#000000">游乐设施模型</strong>，而EduTours将提供有关旅游生态系统和泰国游乐园行业先装订深入见解。</li>
        </ul>
      </p>
      <p><strong style="color:#000000">IAAPA亚太地区（APAC）执行董事兼副总裁Jack Chan</strong>表示：“IAAPA寻找与我们访客的活跃生活方式相符的充满活力的场地。曼谷是亚洲的首选目的地，深受全球游客和活动组织者的喜爱。它融合了丰富的文化和现代化，给我们的全球同仁留下深刻印象。”</p>
      <p>“今年，我们时隔17年再次回到泰国，选择了以其举办国际会议、展览和演出的世界级声誉闻名的QSNCC。周边设施、重要位置和零售店完美契合IAAPA对场地的要求，使其不仅仅是一个‘会议中心’，而是准备满足来自世界各地参会者多样化需求的地方。完备的设施使得活动组织顺利进行，并促进全球行业领袖之间的贸易联系和合作。”</p>
      <p><strong style="color:#000000">N.C.C.管理与发展有限公司首席执行官Surapol Utintu</strong>补充道：“QSNCC非常荣幸被选为2024 IAAPA亚洲博览会的举办地。此次选择确认了我们不仅仅是‘会议中心’的成功——我们超越了生活方式和娱乐活动组织者的需求。我们期待QSNCC为参会者提供充满活力和愉快的体验，同时促进景点行业的联系并重振泰国旅游业。”</p>

      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-05-20/Technology_1_0.jpg" alt="QSNCC"  /></p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-05-20/Show_floor_4_0.jpg" alt="QSNCC" /></p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-05-20/Show_floor_3_0.jpg" alt="QSNCC" /></p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-05-20/Show_floor_2_0.jpg" alt="QSNCC" /></p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-05-20/Show_floor_1_0.jpg" alt="QSNCC"  /></p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-05-20/Education_Session_2_0.jpg" alt="QSNCC"  /></p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-05-20/Education_Session_1_0.jpg" alt="QSNCC"  /></p>

      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2024-05-20/AW_QSNCC.jpg',
    imageSp: '/images/media/news/2024-05-20/AW_QSNCC.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'ZhUwURrFxhpPBZLa_PressRelease_“Money2020Asia”_EN',
    headline: {
      cn: 'Money20/20亚洲展为全球金融科技辉煌搭建舞台QSNCC获得三年举合作保障促进泰国成为亚洲首屈一指的金融科技中心',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'Money20/20 亚洲展为全球金融科技辉煌搭建舞台QSNCC 获得三年举合作保障 促进泰国成为亚洲首屈一指的金融科技中心描述：Money 20/20是世界领先的金融科技展会，将于4月23日至25日在曼谷的QSNCC盛大开幕。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'Money20/20亚洲展为全球金融科技辉煌搭建舞台QSNCC获得三年举合作保障促进泰国成为亚洲首屈一指的金融科技中心',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2024年4月9日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2024-04-09/ZhUwURrFxhpPBZLa_PressRelease_“Money2020Asia”_EN.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p><strong style="color:#000000">Money 20/20</strong>是世界领先的金融科技展会，被视为展示货币相关业务的场所，将于4月23日至25日在曼谷的泰国诗丽吉王后国家会议中心盛大开幕。继阿姆斯特丹和拉斯维加斯之后，曼谷成为Money20/20 的第三个主办城市，每年将迎来超过20,000名金融科技和金融服务专业人士。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-04-09/main.jpg" alt="QSNCC" width="808" height="606" /></p>
      
      <p>超过250位行业领先的演讲者将在<strong style="color:#000000">Money 20/20亚洲展</strong>上的四个不同的舞台上分享精彩演讲，其中一些主旨演讲者包括Jazz(Jazz Telco and Jazz Cash)的<strong style="color:#000000">CEO Aamir Ibrahim</strong>；<strong style="color:#000000">李小加</strong>---滴灌通创始人兼董事长，作为香港当下最热金融科创公司，滴灌通得到了香港亿万富翁李嘉诚和房地产大亨<strong style="color:#000000">郑志刚</strong>的投资；泰国银行支付系统政策和金融消费者保护小组副行长<strong style="color:#000000">Daranee Saeju</strong>和Mann Deshi Mahila银行创始人兼董事长<strong style="color:#000000">Chetna Sinha</strong>。</p>
      <p>亚洲在金融科技和金融服务领域处于世界领先地位，这也是为什么Money 20/20 很高兴欢迎众多先进的企业、监管机构和支付领域的创新者，参加其在曼谷举行大会。这证明了泰国作为亚洲金融科技热点的地位不断上升，并重新定义了金融科技格局。</p>
      <p><strong style="color:#000000">Money20/20亚洲展高级副总裁Danny Levy</strong>表示：“我们认为亚洲将成为未来金融科技和金融服务的中心，而泰国正在成为一个以充满活力的投资机会和蓬勃发展创业精神为特色的杰出中心。选择在泰国诗丽吉王后会议中心举行，因为它拥有世界一流的设施，Money 20/20亚洲展旨在寻求一个能够与精通金融科技的资深观众产生共鸣的场所，而诗丽吉王后国家会议中心完美契合这一要求，为知识共享会议、监管及高层闭门会议，以及类似于著名的拉斯维加斯威尼斯度假村和阿姆斯特丹会展中心的，充满活力的零售区，提供了多种功能空间。”</p>
      <p><strong style="color:#000000">Money20/20亚洲展</strong>，展示了整个亚洲货币生态系统中最耀眼的星。这场充满活力的展会占地20,000平方米，提供大量引人入胜的活动，包括：</p>
      <p>
        <ul style="list-style: disc;margin-left: 2rem;">
          <li style="list-style: disc;"><strong style="color:#000000">行业之夜</strong>：两晚的金融科技趣玩、现场音乐表演、小食品尝以及创新的社交机会，以提升个人人脉。</li>
          <li style="list-style: disc;"><strong style="color:#000000">重要会议——金融科技的未来</strong>：让您的想象力飞扬，250多位行业内重量级人物分享见解，激发您的金融科技竞争力。</li>
          <li style="list-style: disc;"><strong style="color:#000000">初创公司畅聊</strong>：与亚洲最热门的初创公司交流，与颠覆者交流，并抓住与全球玩家的投资机会。</li>
          <li style="list-style: disc;"><strong style="color:#000000">信任峰会</strong>：与来自亚洲顶尖的开拓性企业家和行业巨头进行充满活力的讨论。</li>
          <li style="list-style: disc;"><strong style="color:#000000">Money游戏场</strong>：在我们的互动游戏区满足您的怀旧情节，并赢得大奖，获得独家奖品和赠品。</li>
          <li style="list-style: disc;"><strong style="color:#000000">全球大头照休息室</strong>：打磨完善您的专业资料，自信地踏入金融科技世界。</li>
          <li style="list-style: disc;"><strong style="color:#000000">渣打银行休息室</strong>：与渣打银行员工一起参与发人深省的讨论、观看激动人心的发布会并享用茶点。</li>
        </ul>
      </p>
      <p><strong style="color:#000000">QSNCC的运营商管理限公司，N.C.C.首席执行官Surapol Utintu</strong>感叹道：“对于QSNCC来说，能够在未来三年承办亚洲首届<strong style="color:#000000">“Money 20/20 Asia”</strong>展会，我们感到非常自豪。我们相信，我们的场馆将满足金融科技爱好者多样化的生活方式，确保提供与“拉斯维加斯威尼斯人度假村”和“阿姆斯特丹会展中心”等著名场馆同等的体验。 Money 20/20 亚洲展巩固了QSNCC作为活动行业的领导者地位，并在此过程中提升了泰国的经济和全球形象。”</p>


      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2024-04-09/main.jpg',
    imageSp: '/images/media/news/2024-04-09/main.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'Zgu9nMt2UUcvBUto_PressRelease_QSNCClaunchesQSNCCLoyaltyProgram_EN',
    headline: {
      cn: 'QSNCC推出忠诚度计划为全球活动组织者提供前所未有的特权',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC 推出忠诚度计划 为全球活动组织者提供前所未有的特权描述：QSNCC利用先进技术推出了忠诚度计划，旨在提高客户满意度，为全球活动组织者提供形式丰富且无与伦比的福利和生活需求。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC推出忠诚度计划为全球活动组织者提供前所未有的特权',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2024年4月1日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2024-04-01/Zgu9nMt2UUcvBUto_PressRelease_QSNCClaunchesQSNCCLoyaltyProgram_EN.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心（QSNCC）利用先进技术推出了忠诚度计划，旨在提高客户满意度，为全球活动组织者提供形式丰富且无与伦比的福利和生活需求。该计划旨在通过口碑传播，进一步树立QSNCC品牌的信任度，扩大其客户群。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-04-01/main.jpg" alt="QSNCC" width="808" height="606" /></p>
      
      <p>QSNCC的忠诚计划在一个安全且方便的网络门户上运作，并提供泰语和英语两个版本。会员可以实时查询消费记录、奖励积分和状态，并立即兑换所获积分，且无限制兑换奖励和特权。该系统支持智能手机、平板电脑和笔记本电脑，会员可以随时随地访问。</p>
      <p>"自2022年重新开放以来，QSNCC不断增强其举办各种规模和类型活动的能力，并赢得了本地和国际客户的信任，举办了许多国内和国际活动，" <strong style="color:#000000">QSNCC的运营商，N.C.C.首席执行官Surapol Utintu</strong>表示。</p>
      <p>“今天，我们通过积分收集系统与客户建立联系，加深与客户的关系，该系统提供各种特权和增值优惠，让客户在为下一场活动寻找完美场地时成为回头客，”<strong style="color:#000000"> Surapol </strong>补充道 。</p>
      <p>特权将涵盖所有生活方式方面，包括合作酒店的客房、数字媒体的使用以及会议中心服务和餐厅的礼品券。</p>
      <p>“忠诚度计划的实施有助于我们创造更有价值的客户体验。这使我们与众不同，并将提高客户满意度，丰富我们与所有现有客户的关系并吸引新客户，”<strong style="color:#000000"> Surapol </strong>说。</p>
      <p>忠诚度计划是QSNCC关键的客户关系管理策略之一。QSNCC不断开发和创造各种特别优惠，寻找新的合作伙伴来增强其服务内容，并倾听客户需求，以提供最佳的客户体验。</p>
      

      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2024-04-01/main.jpg',
    imageSp: '/images/media/news/2024-04-01/main.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'PressRelease_QSNCCEarnsThailandMICEVenueStandardCertification',
    headline: {
      cn: 'QSNCC获得泰国MICE场馆标准认证肯定其作为国际品质场馆的地位',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC已获得“2023年泰国会展场地标准（TMVS）认证。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC获得泰国MICE场馆标准认证肯定其作为国际品质场馆的地位',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2024年3月21日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2024-03-21/PressRelease_QSNCCEarnsThailandMICEVenueStandardCertification.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p><strong style="color:#000000">泰国诗丽吉王后国家会议中心（QSNCC）的会议室、展厅和特别活动场地已获得“2023年泰国会展场地标准（TMVS）”认证</strong>。该认证是对其能够举办各种类型、国内和国际规模的活动，并作为国际品质场馆的地位的肯定。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-03-21/main1.jpg" alt="QSNCC" width="808" height="606" /></p>
      
      <p>该认证是在泰国会展览局 (TCEB) 在曼谷拉玛花园酒店举办的2024会奖行业标准日（MICE Standards Day 2024）活动期间颁发的。</p>
      <p><strong style="color:#000000">泰国MICE场地标准（TMVS）</strong>是泰国活动场地的国家标准认证，并已被认可为东盟地区MICE场地标准的基准。该标准认证由泰国会议展览局（TCEB）根据4项标准执行。第一个是物理标准——会议室的位置和整体元素。第二个是技术方面，比如AV系统、通讯系统。第三个是服务，第四个是环境、安全、社会责任等可持续发展实践。</p>
      <p>TMVS认证是对QSNCC符合标准的保证。它可以赢得国内外客户对QSNCC作为举办国际标准活动场地的质量和能力的信心。</p>
      <p>QSNCC还获得了2HY标准（即Hygiene and Hybrid）认证。</p>
      <p>其符合卫生标准的运营以及利用创新举办混合活动时使用创新技术的做法，证明了其对健康问题和技术发展的承诺和优先考虑。因此，QSNCC能够满足组织者的各种需求，并为增强泰国会展业的竞争力提升做出贡献。</p>
      <p>QSNCC运营商管理与发展有限公司，N.C.C.的执行副总裁<strong style="color:#000000">M.R. Swasdivudh Svasti-vatana（左）</strong>，在2024年由TCEB在拉玛花园酒店组织的2024会奖行业标准日活动，从泰国会议展览局（TCEB）董事会主席Atchaka Sibunruang博士（右）手中接过Thailand MICE Venue Standard (TMVS) 2023的标志。 该标志是对QSNCC会议室、展厅和特殊活动场所标准的认证，确保QSNCC有能力举办各种类型、国内和国际规模的活动。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-03-21/second02.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-03-21/second01.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-03-21/second03.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-03-21/second04.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-03-21/second05.jpg" alt="QSNCC" width="808" height="606" /></p>

      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2024-03-21/main1.jpg',
    imageSp: '/images/media/news/2024-03-21/main1.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'ZecJ0OXgT-BdbvPH_EN_PressRelease_QSNCC',
    headline: {
      cn: 'QSNCC在三月举办了三场让年轻人兴奋不已的演唱会和粉丝见面会',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC3月举办的三场备受瞩目的活动，旨在将其客户群扩大到年轻族群，从而巩固其“终极鼓舞人心的世界级活动平台”的地位。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC在三月举办了三场让年轻人兴奋不已的演唱会和粉丝见面会',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2024年3月4日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2024-03-04/ZecJ0OXgT-BdbvPH_EN_PressRelease_QSNCC.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心(QSNCC) 计划于3月份举办的三场备受瞩目的活动，旨在将其客户群扩大到年轻族群，从而巩固其“终极鼓舞人心的世界级活动平台”的地位。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-03-04/second.jpg" alt="QSNCC" width="808" height="606" /></p>
      
      <div >
        <p style="flex:0.3">他们是韩国万人迷<strong style="color:#000000">车银优</strong>的“2024 Just One 10 Minute [Mystery Elevator]”曼谷站见面会；韩国著名男子组合GOT7<strong style="color:#000000">崔荣宰</strong>的“2024崔荣宰亚洲巡演(Inside Out)泰国站”；以及与<strong style="color:#000000">麦圣杰</strong>和众多嘉宾一起的“AssetWhite Presents PIANO & The Magic 7 Concert”音乐会。</p>
        <p>这些活动将吸引年轻人，这符合QSNCC不仅仅是会奖活动场地的使命。</p>
        <p>“我们的主要目标是使QSNCC成为“终极鼓舞人心的世界级活动平台”，该平台已准备好为所有年龄段的人群组织各种活动。 在QSNCC，我们可以组织各种生活方式活动，从音乐会、粉丝见面会到游戏锦标赛和电子竞技赛，这意味着我们的目标客户不仅限于活动组织者、研讨会参与者或是参观展览的人。所有热衷于活动或不同生活方式的年轻人也可以到访QSNCC。”<strong style="color:#000000">QSNCC的运营商N.C.C.管理发展有限公司首席执行官Surapol Utintu</strong>说道。</p>
      </div>
      <p>计划于三月举行的三项活动包括：</p>
      <p>
        <ul style="list-style: disc;margin-left: 2rem;">
          <li style="list-style: disc;"><strong style="color:#000000">车银优2024 Just One 10 Minute [Mystery Elevator]曼谷站</strong>见面会–AROHA们一定不能错过这次与才华横溢的年轻演员车银优的个人粉丝见面会，车银优也为泰国粉丝准备了一系列惊喜。三月是他的出生月份，请做好准备，迎接<strong style="color:#000000">2024年3月9日星期六19:00在G层3-4号展厅举行的更多精彩活动</strong>。</li>
          <li style="list-style: disc;"><strong style="color:#000000">2024崔荣宰亚洲巡演 (Inside Out) 泰国站</strong>会再次为泰国所有“鸟宝宝”们带来无限乐趣，GOT7成员崔荣宰正在准备他最新的亚洲巡回演唱会，计划在曼谷于<strong style="color:#000000">3月16日星期六和3月17日星期日17:00-22:00两天，举行两场演出，G层3-4号展厅</strong>。</li>
          <li style="list-style: disc;"><strong style="color:#000000">AssetWise Presents PIANO&i The Magic 7 Concert</strong>音乐会，麦圣杰将会带来令人惊叹的钢琴魔力演奏，他将演奏泰国音乐界7位优秀的艺术家的歌曲。音乐会将以“The Magic 7”为理念进行表演，一个音阶有7个音符，每个音符都有自己的魔力。将于<strong style="color:#000000">2024年3月23日星期六14:00和19:30在1层1-4号宴会厅</strong>举行两场演出。</li>
        </ul>
      </p>
      
      
      <p>自2022年9月重新开放以来，QSNCC一直是泰国和国际组织者们高度信赖的场地，他们看到了QSNCC的潜力、时刻准备就绪以及位于市中心且与地铁相连的便利位置。此外，QSNCC还拥有尖端的活动组织技术、符合国际标准的一流安全措施和优良的设施。QSNCC已被选为20多场音乐会和粉丝见面会的场地，如4EVE The 1st Concert Friends & Family、T-POP Concert Fest、EXO-SC BACK TO BACK FANCON IN BANGKOK、2023金宣虎< ONE, TWO, THREE. SMILE >亚洲巡演曼谷站和 LAUV的“The Between Albums Tour”巡演等。在QSNCC举办的这些活动推动了泰国经济，同时为泰国娱乐业创造了收入。</p>
      <p>“通过将我们举办的活动范围扩大到涵盖到娱乐行业，并将我们的目标群体扩大到年轻一代，他们作为最狂热的音乐会观众和粉丝，我们相信我们可以成为‘不仅仅只是一个会议中心’。QSNCC零售区设有餐厅、咖啡馆、便利店、体育俱乐部、水疗中心以及淋浴站，随时准备以优质的服务和难忘的体验欢迎所有来客。我们预计3月份将有大约 50,000 人参加这三场活动。”<strong style="color:#000000">Surapol</strong> 说。</p>
      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2024-03-04/main.jpg',
    imageSp: '/images/media/news/2024-03-04/main.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'qsncc-welcomes-the-month-of-love-with-4-events-to-embrace',
    headline: {
      cn: 'QSNCC以四场活动迎接爱之月拥抱爱情、购物激情和经济增长',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '泰国诗丽吉王后国家会议中心将于2024年2月举办4场激动人心的活动，诚邀大家享受购物和生活方式盛宴。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC以四场活动迎接爱之月拥抱爱情、购物激情和经济增长',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2024年1月25日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2024-01-25/CH-2024.1.25_Press Release_February 2024 Event_EN.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>根据泰国政府提振经济政策，泰国诗丽吉王后国家会议中心(QSNCC)将于2024年2月举办4场激动人心的活动，诚邀大家享受购物和生活方式盛宴。这些活动包括适合父母和孩子的<strong style="color:#000000">第54届Baby & Kids Best Buy 2024</strong>；为科技和电子产品爱好者举办的<strong style="color:#000000">2024泰国移动博览会</strong>；为运动爱好者举办的<strong style="color:#000000">阿迪达斯大型促销活动</strong>；以及为旅游爱好者举办的<strong style="color:#000000">第69届Thai Teaw Thai 2024博览会</strong>。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-01-25/main.jpg" alt="QSNCC" width="808" height="606" /></p>
      
      <div >
        <p style="flex:0.3">QSNCC的<strong style="color:#000000">运营商，N.C.C运营发展有限公司的首席执行官Surapol Utintu</strong>表示: “我们很高兴在整个二月期间，在泰国诗丽吉王后国家会议中心举办多场零售和生活方式活动。这些活动将在支持泰国政府的经济刺激政策---旨在鼓励人们在2024年初增加消费方面，发挥重要作用。预计泰国零售业的销售额将增长3.5%至4.4%，这与泰国零售商协会的预测相一致。这其中主要得益于外国游客数量的复苏，而政府的其他支持政策和私营企业的合作，也成为经济增长的催化剂。”</p>
        <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-01-17/surapol.jpg" alt="QSNCC" width="808" height="606" /></p>
      </div>
      <p>爱之月，QSNCC举办的重要活动详细信息如下：</p>
      <p>
        <ul style="list-style: disc;margin-left: 2rem;">
          <li style="list-style: disc;"><strong style="color:#000000">第54届Baby & Kids Best Buy 2024</strong>：是一场专为从婴儿到12岁儿童，举办的商贸展览，将展示丰富多彩的婴儿和儿童产品，并为孩子们提供有趣的活动。布展时间为2024年2月1日至2月4日，地点在LG层的5-6号展厅。</li>
          <li style="list-style: disc;"><strong style="color:#000000">2024泰国移动博览会：</strong>是备受期待的手机和电子配件展览之一，今年的主题为“是时候换手机了！”。本届博览会上，如去年一样，领先移动设备品牌的全系列产品将如期上市。活动还将包括Bangkok EV Expo 2024，汇集了来自领先汽车制造商的大量电动车以及电动车配件，并在曼谷市中心提供试驾车道。布展时间为2024年2月8日至2月11日，地点在LG层的5-7号展厅。</li>
          <li style="list-style: disc;"><strong style="color:#000000">阿迪达斯大型促销活动：</strong>从2024年2月8日至2月11日，在LG层的8号展厅前，可享受这家知名制造商提供的体育装备和服装的月中优惠，折扣高达3折。</li>
          <li style="list-style: disc;"><strong style="color:#000000">第 69 届Thai Teaw Thai 2024博览会：</strong>这项年度盛会以“令人惊叹的大促销”为主题，将推广泰国旅游业和当地产品。活动包括来自酒店、旅行社、水疗中心、餐厅、娱乐场所等超过800个摊位，所有摊位都提供独家的特别优惠，仅在活动期间生效。活动时间为2024年2月29日至3月3日，地点在LG层的5-6号展厅。</li>
        </ul>
      </p>
      
      
      
      
      <p><strong style="color:#000000">Surapol</strong>说：“我们相信这四个活动将会获得热烈反响，并有助于为泰国经济创造积极的动力，这要归功于QSNCC的关键优势：位于市中心的便利的地理位置、与地铁直接连接、完备的设施和高质量的服务。”</p>
      <p><strong style="color:#000000">他</strong>补充道：“所有这些特点使QSNCC不仅仅是一个会议中心。QSNCC将再次证明其‘Bangkok’s Active Lifestyle Mall’为概念的零售空间，真正满足了每个人的生活需求，包括各种餐厅、咖啡馆、便利店、运动装备店、水疗中心以及淋浴服务。”</p>
      <p>QSNCC还将于2024年2月1日至2月11日举办“2024年中国农历新年春节”活动。在此期间，客人可在QSNCC参与餐厅、咖啡馆和服务网点，每消费满500泰铢，将有资格参加金蛋幸运抽奖活动，有机会赢取来自QSNCC的红包或价值500泰铢的礼品券，用于支付中心参与商店的商品和服务费用。</p>
      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2024-01-25/main.jpg',
    imageSp: '/images/media/news/2024-01-25/main.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'queen-sirikit-national-convention-center-qsncc-isJanu',
    headline: {
      cn: 'QSNCC迎来“Prif International 2024全球大会及奖励旅游两周年”庆典以支持 2024泰国会展业',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC已做好准备，欢迎来自全球创新医疗保健电子商务企业的6,000多名领导者及成员，参加将于21日至22日举行的“Prif International 2024全球大会及奖励旅游两周年”庆典。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC迎来“Prif International 2024全球大会及奖励旅游两周年”庆典以支持 2024泰国会展业',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2024年1月17日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2024-01-17/CH-QSNCC bolsters Thai MICE industry 2024 by welcoming.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心(QSNCC)已做好准备，欢迎来自全球创新医疗保健电子商务企业的6,000多名领导者及成员，参加将于21日至22日举行的“Prif International 2024全球大会及奖励旅游两周年”庆典。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-01-17/prife.jpeg" alt="QSNCC" width="808" height="606" /></p>
      <p>该活动作为领先的会议中心使命的一部分，即在推动泰国成为世界各地活动组织者和会展企业家心中的全球顶级目的地方面，发挥了关键性作用。</p>
      
      <p><strong style="color:#000000">Prife International全球大会及奖励旅游周年庆典</strong>连续第二年举办，以表彰Prife International业务网中的工作者以及表现出色人员。Prif International是一家全球创新医疗保健电子商务企业，总部位于马来西亚吉隆坡，业务遍及全球五大洲75个国家和地区。去年，在马来西亚举办的活动取得了巨大成功，吸引超3,000名人员参会，今年的活动有望为该业务网带来更大的成功。</p>
      <p><strong style="color:#000000">Prife International Sdn. Bhd.集团总经理Victor Hew</strong>表示：“我们看到泰国在接待国际游客方面拥有的巨大潜力和充分准备，这归功于该国旅行便捷的声誉以及泰国人民的友善和热情好客。”有限公司。</p>
      <p>“我们选择QSNCC作为今年活动的举办地，因其被认为是东南亚最好的会议中心之一，宽敞的会议空间位于城市中心，国际化的服务标准以及建筑的整体美感符合所有选择条件。这个场地一定会给Prife International的员工和行业网的成员留下深刻的印象。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2024-01-17/surapol.jpg" alt="QSNCC" width="808" height="606" /></p>
      
      <p><strong style="color:#000000">QSNCC运营管理方N.C.C.管理和发展公司首席执行官Surapol Utintu</strong>表示: “我们很高兴QSNCC被选为Prife International 2024两周年全球大会及奖励旅游庆典的举办场地。奖励旅游是刺激泰国旅游业、会展业以及国家整体经济增长的重要因素。据估计2023年，参加奖励计划的国际会奖游客抵达泰国的人数为232,232人，为泰国创造了超过137.15亿泰铢的收入。”<strong style="color:#000000">（内容来源：Facebook Page MICE in Thailand）</strong></p>
      <p><strong style="color:#000000">Surapol</strong>表示：“QSNCC 的全面综合性服务使其成为一个优秀的场馆，我们提供一流的设施和技术，可举办各种符合国际安全标准的活动。独特的服务和无与伦比的热情好客，体现了泰国独特的风土人情。” 。</p>
      <p>“我们在举办了‘Liangtou集团年终庆典’和‘安利创始人’ 活动等国内和全球活动的长期经验中，获得了卓越的专业精神，使我们能够为所有参与者提供难忘的参会体验。我们的目标是继续影响世界各地的活动组织者，以便他们选择泰国作为未来举办高规格活动的首选目的地。”他补充道。</p>
      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2024-01-17/prife.jpeg',
    imageSp: '/images/media/news/2024-01-17/prife.jpeg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'queen-sirikit-national-convention-center-qsncc-isDece',
    headline: {
      cn: '亚太地区最大的胃肠病学会议将展示泰国医生的卓越能力并推动其经济发展',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC将欢迎来自60个国家的3,000多名肠胃病学和肝脏病学领域的医学专家和学者，参加亚太地区最大的胃肠病学会议。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '亚太地区最大的胃肠病学会议将展示泰国医生的卓越能力并推动其经济发展',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年12月4日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-12-03/queen-sirikit-national-convention-center-qsncc-isDece.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心（QSNCC）将欢迎来自60个国家的3,000多名肠胃病学和肝脏病学领域的医学专家和学者参加会议，此会议计划于2023年12月6日至9日在“2023年亚太消化周（APDW 2023）”期间举行。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-12-03/qsncc01.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>亚太地区最大的胃肠病学会议，APDW 2023将是一个顶级专家汇聚的国际会议，与会者提出观点，分享知识，并讨论胃肠病学和肝脏病学的最新进展。本次会议将为泰国医学专家提供一次在国际舞台展示专业知识的机会，并推动该国卫生部门的发展和经济的发展。</p>
      
      <p>2023亚太消化周（APDW 2023）是地区性的消化和胃肠病学会议，将于今年举行，主题是“取得最大化结果的优化策略”。该会议为医生和医学专家提供了一个机会，以加入和交流有关治疗胃肠道疾病和其他疾病的科学信息。注册时无论是否提交研究和创新成果可通过2种方式进行- -口头阐述及海报展示。</p>
      <p>APDW每年在亚洲和太平洋地区举行，这是第二次在泰国举办，第一次曾于2 0 1 2年举办。胃肠病学在泰国是一个日益重要的领域。</p>
      <p>泰国胃肠病学协会（GAT）主席，亚太消化周（APDW 2023）大会主席Prof. Somchai Leelakusolvong表示，“根据泰国国家癌症研究所有关泰国癌症登记处在2022年提供的信息，大多数患有癌症的泰国人是肝癌、胆管癌，其次是结肠癌和直肠癌。”</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-12-03/qsncc02.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>“这表明，胃肠道健康问题应该得到广泛的认识，公众应该更容易获得诊断和治疗。这次大会为政府提供了一个很好的机会，可以看到胃肠病学和肝脏病学的研究和创新进展，并参与支持这一关键领域的医学进步的发展和可持续性。”</p>
      <p>教授表示， “泰国很荣幸能再次主办今年的APDW会议。我们已经准备好了，包括委员会和消化系统领域的医学专家的专业知识；一个强大的国际医疗网络；我们准备组织一次大会，包括学术会议和研究成果展示。”</p>
      <p>“其他因素包括泰国的魅力和卓越的场地，可以容纳如此重要的国际会议。我们希望这次会议将给来自于全世界所有的3,000名与会者留下深刻印象，希望他们可以游览泰国各地，这也将有助于促进泰国的经济。”</p>
      <p>Somchai教授表示“QSNCC作为大会会场是最好的会场之一，因为它位于中央商务区，周围林立各类酒店和住宿设施。它还可以便利地联通所有的交通方式：汽车、轻轨和地铁，方便代表们在曼谷各处旅行。此外，QSNCC还提供了宽敞的会议室和停车场，适合举办大型活动。”</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-12-03/qsncc03.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p><strong style="color:#000000">QSNCC运营商， N.C.C.管理与发展有限公司首席执行官Surapol Utintu</strong>表示，“我们很荣幸QSNCC代表泰国被选为此次国际会议的举办地，欢迎来自世界各地的所有与会者。我们真诚地希望我们的设施和员工能给与会者留下深刻印象，并展示我们作为国际活动平台的潜力。 确保此次活动的圆满成功，并提升我们国家的声誉。”</p>
      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-12-03/qsncc01.jpg',
    imageSp: '/images/media/news/2023-12-03/qsncc01.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'queen-sirikit-national-convention-center-qsncc-is',
    headline: {
      cn: 'QSNCC将展示新的能力，为全球最大的会议行业盛会塑造成功的新高度',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '泰国诗丽吉王后国家会议中心(QSNCC)已经准备好迎接第62届ICCA年会的召开。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC将展示新的能力，为全球最大的会议行业盛会塑造成功的新高度',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年11月1日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-11-01/queen-sirikit-national-convention-center-qsncc-is.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心(QSNCC)已经准备好迎接第62届ICCA年会的召开，此会议定于2023年11月12日至15日在曼谷举办。凭借国际标准的功能空间、最先进的设施和技术、可持续的实践举措、经验丰富的员工和泰国人民的热情好客，QSNCC满足了国际大会与会议协会（ICCA）的每一个需求和要求，从而有信心将ICCA年会成功举办的形象提升到另一个高度。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-11-01/main.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>ICCA成立于1963年，是一个全球性的会议机构，目前有来自全球100个国家的约1000名成员，他们是与会议行业相关的公共和私营部门组织。泰国很荣幸地被选为第62届年度大会的主办国。这是继1985年第一次在曼谷和2007年第二次在芭堤雅之后，泰国第三次举办这项聚会。QSNCC将成为大会的一个关键合作伙伴，在全球范围内欢迎1000多名代表，就像1985年和2007年那样，帮助大会再次取得成功。</p>
      
      <p>“我们很高兴能与QSNCC合作，这是一个真正卓越的最先进的场所，将为我们的代表们带来一次完整而难忘的大会体验”， ICCA首席执行官Senthil Gopinath表示。我们正在与泰国的利益相关者和合作伙伴密切合作，以确保我们能实现超出常规预期的目标。与会者将获得宝贵的知识以及学习灿烂文化的机会。</p>
      <p>随着大会对脱碳和可持续性的关注，QSNCC可以通过其可持续实践满足这些要求的各个方面。这些措施包括以可持续性为重点的翻新版本设计、使用环保材料、安装节水卫生用品、采购当地原材料和配料用以为当地社区创造收入、减少碳排放、选择环保食品包装、回收食物垃圾和经认证的废物处理。第62届ICCA年会将为全球代表提供一个引人注目的机会，见证QSNCC提高会议可持续性标准的能力和承诺。</p>
      <p>为期四天的大会还将展示QSNCC“不仅是一个会议中心”，它满足了以“曼谷活力生活方式购物中心（BALM）”为理念发展和指导的所有类型的生活方式。与会代表将在零售区11000多平方米的楼层进行新体验，他们将在那里找到餐厅、咖啡馆、水疗中心、运动商店、书店、药店、便利店、联合办公空间和浴室。除此之外，他们还可以通过室内外建筑设计、装点室内空间的艺术品来学习和融入泰国文化，而QSNCC旁边的Benjakitti公园是一个提供许多放松活动的地方。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-11-01/main01.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p><strong style="color:#000000">QSNCC运营商， N.C.C.管理与发展有限公司首席执行官Surapol Utintu</strong>表示，“我们很荣幸被选为ICCA第62届年会的举办地。这是一个代表泰国欢迎世界各地会议行业专业人士的机会。凭借我们有潜力成为“世界一流，超凡卓越会展活动平台”，QSNCC的所有人现在都准备好欢迎所有代表，我们有信心为每一位客人提供难忘的体验，并为ICCA第62届年会成功举办贡献力量。”</p>
      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-11-01/main.jpg',
    imageSp: '/images/media/news/2023-11-01/main.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'the-queen-sirikit-national-convention-center-qsncc3',
    headline: {
      cn: 'QSNCC：泰国唯一获得 “FIABCI-Thai PRIX D’EXCELLENCE AWARDS 2023”奖项的会议中心，会议中心类别中的卓越建筑',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC)取得了非凡的成就，成为泰国第一个也是唯一一个在会议中心类别中获得知名的“FIABCI-Thai PRIX D’EXCELLENCE AWARDS 2023”奖项的会议中心。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC：泰国唯一获得 “FIABCI-Thai PRIX D’EXCELLENCE AWARDS 2023”奖项的会议中心，会议中心类别中的卓越建筑',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年10月16日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-10-16/the-queen-sirikit-national-convention-center-qsncc3.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心(QSNCC) 取得了非凡的成就，成为泰国第一个也是唯一一个在会议中心类别中获得知名的“FIABCI-Thai PRIX D’EXCELLENCE AWARDS 2023”奖项的会议中心。其迷人的建筑设计完美地概括了泰国文化的精髓，引起了全球观众的共鸣，标志着泰国活动产业登上国际舞台的一个重要里程碑。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-10-16/main.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p><strong>FIABCI-Thai PRIX D’EXCELLENCE AWARDS</strong>是由国际房地产联合会泰国分会（FIABCI Thai）颁发的一项享有盛誉的荣誉。泰国目前是FIABCI-International的成员，它是世界上最大的房地产联合会，拥有遍布全球70个国家的120多名专业组织成员。FIABCI-Thai PRIX D’EXCELLENCE AWARDS的评估过程由FIABCI内部的一个委员会进行，该委员会由来自不同国家的成员组成。该奖项表彰所有16个类别中最杰出的房地产项目。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-10-16/main2.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p><strong>QSNCC运营商， N.C.C.管理与发展有限公司执行董事Sakchai Pattarapreechakul</strong>表示“我们非常自豪的是QSNCC成为泰国第一个也是唯一一个在会议中心类别中获得知名的“FIABCI-Thai PRIX D’EXCELLENCE AWARDS 2023”的会议中心。这一成就为QSNCC提供了一个绝佳的机会。作为泰国接待国际游客的首要场地，它很好地通过建筑设计展示泰国特色的精髓。”</p>
      <p>QSNCC在2019年进行了重大的翻新，以应对不断变化的需求，并提高会议中心的国际吸引力。它以“继承、保护、继续”的原则为指导，呈现出一种现代而独特的泰式特征。重新设计包括外部建筑、内部装饰和景观美化，将丰富的泰国文化与当代全球美学无缝融合。泰国纺织品的美丽，被誉为泰国传统的突出象征，已优雅地融入室内装饰。当游客参观QSNCC时，他们可以沉浸在丰富的泰国文化中，展开无尽的探索。</p>
      <p>获得FIABCI-Thai PRIX D’EXCELLENCE AWARDS标志着QSNCC迈向FIABCI-WORLD PRIX D’EXCELLENCE AWARDS之旅的开始。QSNCC肩负着代表泰国及其人民向国际社会全面展示泰国特色的使命。这与它作为泰国第一个国家会议中心的作用相一致。</p>
      <p><strong>编辑注：图片说明</strong></p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-10-16/main.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p><strong>QSNCC运营商， N.C.C.管理与发展有限公司执行董事Sakchai Pattarapreechakul</strong>表示，我们非常自豪地凭借反映泰国特色的杰出建筑设计而获得了FIABCI-Thai PRIX D’EXCELLENCE AWARDS 2023在会议中心类别中。该奖项由财政部副部长Julapun Amornvivat（最左侧）颁发。出席仪式的还有FIABCI世界主席Budiarsa Sastrawinata（左起第三位）和FIABCI泰国主席Sopon Pornchokchai博士（左起第四位）。</p>
      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-10-16/main.jpg',
    imageSp: '/images/media/news/2023-10-16/main.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'the-creative-industry-has-consistently-exhibited-growth',
    headline: {
      cn: 'QSNCC令人鼓舞的活动平台让年轻人释放创造力，推动泰国经济向前发展',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC 4场激动人心的活动释放了年轻人的创造力',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC令人鼓舞的活动平台让年轻人释放创造力，推动泰国经济向前发展',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年10月9日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-10-09/the-creative-industry-has-consistently-exhibited-growth.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心（QSNCC）鼓励年轻人通过参与定于10月在其鼓舞人心场地举办的四场激动人心的活动来释放他们的创造力：“第28届全国书展”或“2023年泰国图书博览会”，超凡卓越流行音乐节 “百事第二届T-POP音乐节”，东南亚最大的游戏活动“2023泰国游戏展x曼谷奇迹节”， 与日本传奇的奇迹节进行了开创性的合作。“CHANG MUSIC CONNECTION Presents FATCAT音乐会”。 QSNCC仍然坚定地支持创意产业，并致力于为泰国经济做出贡献。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-10-09/1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>创意产业一直呈现出逐年增长的趋势。2021年，创意经济的价值约为1.1万亿泰铢。值得注意的是，泰国的游戏和动画产业成功创造了高达370亿泰铢的收入。此外，泰国流行音乐在音乐产业中的迅速流行扩展了其对国家收入的影响。此外，通常被视为创意来源的印刷业在新冠肺炎大流行后经历了复苏。它为创意部门的扩张做出了重大贡献，在推动泰国经济发展方面发挥了关键作用。</p>
      <p>除了年轻一代的潜力（人）和对经济有贡献的创造性活动（产品）外，平台或场所（场所）在推动泰国创意产业方面发挥着另一个重要作用。QSNCC被称为“世界一流，超凡卓越的会展活动平台”，可满足各种活动需求为年轻一代提供鼓舞人心的体验。它提供了一个在10月份举办创新活动的空间。</p>
     
      <p>
      <div style="display: flex;margin-bottom: 40px;">
        <p style="flex:1" >
          <img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-10-09/2.png" >
        </p>
        <div style="flex:1;">
          <ul style="padding-left: 25%;">
            <li line-height: 2em;">
              <strong>2023年泰国图书博览会</strong>，也被称为第28届全国书展，定于2023年10月12日至23日举行。今年，这场传奇图书活动的主题是“你梦想中要读的书是什么？”
            </li>
          </ul>
        </div>
      </div>
    </p>

    <p>
      <div style="display: flex;margin-bottom: 40px;">
        <p style="flex:1;">
          <img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-10-09/3.jpg">
        </p>
        <div style="flex:1;">
          <ul style="padding-left: 25%;">
            <li style="list-style-type: square;line-height: 2em;">
            <strong>百事第二届T-POP音乐节</strong>定于2023年10月14日至15日举行，计划在市中心举办一场大型流行音乐节。将有来自不同品牌的50多位T-POP艺术家参加，在为期2天激动人心的日子里进行表演。
            </li>
          </ul>
        </div>
      </div>
    </p>

    <p>
    <div style="display: flex;margin-bottom: 40px;">
      <p style="flex:1;">
        <img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-10-09/4.jpg">
      </p>
      <div style="flex:1;">
        <ul style="padding-left: 25%;">
          <li style="list-style-type: square;line-height: 2em;">
          <strong>2023泰国游戏展x曼谷奇迹节</strong>定于2023年10月20日至22日举行。这一开创性的合作首次将东南亚最大的游戏活动泰国游戏展与著名的日本玩具和人物收藏品活动Wonder Festival相结合。此次活动以“集合”为主题。
          </li>
        </ul>
      </div>
    </div>
  </p>

  <p>
  <div style="display: flex;margin-bottom: 40px;">
    <p style="flex:1;">
      <img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-10-09/5.jpg">
    </p>
    <div style="flex:1;">
      <ul style="padding-left: 25%;">
        <li style="list-style-type: square;line-height: 2em;">
        <strong>CHANG MUSIC CONNECTION Presents FATCAT音乐会</strong>，以20世纪90年代至21世纪初的艺术家为主角的展览定于2023年10月28日举行。期待怀旧的表演，与儿时喜爱的游戏和玩具重聚，一定会唤起珍贵的回忆。
        </li>
      </ul>
    </div>
  </div>
</p>

<p><strong>QSNCC运营商，N.C.C.管理与发展有限公司首席执行官Surapol Uthintu</strong>表示，“QSNCC很荣幸接受委托作为创意产业活动的场地平台，包括印刷、音乐、游戏和动画不同行业。它作为一个鼓舞人心的活动中心，提供机会让所有人都能拥有并展示自己的创造力。 此外，我们致力于通过强调独特的泰国人泰式习俗来突出泰国的软实力，无论是在食物、水疗还是艺术中——所有这些都可以在QSNCC场所体验到。这项努力旨在为国家创造经济价值。”</p>

<p>这四个活动强调了QSNCC不仅仅是一个“会议中心”， 它是一个多功能的场所，能够举办各种各样的活动，满足多样化的生活方式，特别关注年轻一代。在这里，他们有机会在曼谷活力生活购物中心（BALM）区域充满活力的环境中培养创造力。BALM区域包括顶级餐厅、著名咖啡馆、共享办公场所、水疗中心、书店、运动服装店、淋浴站等等，Surapol补充到。</p>
      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-10-09/1.jpg',
    imageSp: '/images/media/news/2023-10-09/1.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'qsnccs-commitment-to-sustainability-shines-through',
    headline: {
      cn: 'QSNCC可持续发展承诺闪耀2023东盟最大可持续发展博览会',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC作为可持续发展的场地先锋，再次成为SX东盟最大可持续发展博览会举办地',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC可持续发展承诺闪耀2023东盟最大可持续发展博览会',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年9月22日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-09-22/qsnccs-commitment-to-sustainability-shines-through.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心（QSNCC）是践行可持续发展理念的场地先锋，我们自豪地开门迎接东盟最重要的可持续发展博览会，2023可持续发展博览会（SX2023）. 这种可持续智慧与突破性创新的融合旨在促进打造“良好平衡，更美好世界”的理念。此博览会将使用整个QSNCC的场地，于2023年9月29日-10月8日通过为期10天的活动吸引观众参观。</p>
      <p class="center"><img src="/images/media/news/2023-09-22/1.jpg" alt="" width="800" height="413" /></p>
      <p>SX2023是东盟最大的可持续发展博览会，代表了包括政府、私营企业和社区组织在内的各部门的合作。该活动植根于“可持续的充分性”原则，激发了人们实现可持续性的集体行动。在100多个地区和全球组织的合作下，SX2023汇集了来自世界各地的300多名专家，以及1个由泰国和国际公司组成的可持续发展企业网络，共有500多个实体。该活动在8个区域举办了论坛和展览，旨在增强各类组织与公众共同创造可持续性及减少长期环境影响的能力。</p>
      <p class="center"><img src="/images/media/news/2023-09-22/2.jpg" alt="" width="800" height="413" /></p>
      <p><strong>Tongjai Thanachanan,可持续发展博览会总监（SX2023）</strong>表示，“我们组织可持续发展博览会的主要目标是推动我们的国家走向更加可持续发展的未来。我们致力于传播可持续发展领域的前沿知识和创新理念。在我们之前成功的版本中，越来越明显的是每个部门都意识到并优先考虑可持续性。随着我们今年开始的SX2023博览会，我们的承诺仍然坚定不移——一丝不苟地关注细节，全面考虑可持续性，包括经济、社会和环境层面。此外，我们的场地会严格遵守明确的可持续发展准则。QSNCC是卓越的场馆，全面展示了其满足SX2023各项要求的综合能力。这包括在可持续建筑设计、节能设施、环保材料的使用以及通过地铁系统减少温室气体排放方面的精心规划。此外，它与Benjakitti公园无缝融合，提供了一个公共空间，鼓励邻近社区参与集体活动。QSNCC是一个绿色的活动平台，连接每个人并激励他们积极参与塑造我们世界的可持续未来”。</p>
      <p class="center"><img src="/images/media/news/2023-09-22/3.jpg" alt="" width="800" height="413" /></p>
      <p><strong>QSNCC运营商， N.C.C.管理与发展有限公司首席执行官Surapol Uthintu</strong>表示，“我们很荣幸再次成为SX活动的举办地，这反映了对QSNCC各方面可持续发展的信心。SX活动是一个为所有行业所熟知的区域级的可持续发展博览会。作为其主办地，我们有机会展示QSNCC在举办国际公认的可持续活动方面的潜力，并强调我们对促进和推进可持续性的承诺。这是我们致力于提高环境质量和周围社区生活质量的一个组成部分。</p>
      <p>除了SX2023，QSNCC作为可持续发展活动的首选场地，赢得了泰国和国际组织者的信任。其中包括亚太经合组织第二十九次领导人非正式会议、2023年东盟可持续能源周和定于今年11月12日至15日举行的2023年国际大会及会议协会大会（ICCA）。</p>
      `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-09-22/1.jpg',
    imageSp: '/images/media/news/2023-09-22/1.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'the-queen-sirikit-national-convention-center-qsncc2',
    headline: {
      cn: 'QSNCC作为曼谷宝石和珠宝展的主要场地闪耀夺目，举办泰国最大的宝石和珠宝贸易活动即“Ruby Celebration”庆典',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC即将迎来“第68届曼谷宝石和珠宝博览会”，庆祝其“Ruby Celebration”周年纪念活动。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC作为曼谷宝石和珠宝展的主要场地闪耀夺目，举办泰国最大的宝石和珠宝贸易活动即“Ruby Celebration”庆典',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年8月31日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-08-31/the-queen-sirikit-national-convention-center-qsncc2.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心(QSNCC)即将迎来“第68届曼谷宝石和珠宝博览会（Bangkok Gems & Jewelry Fai）”，庆祝其“Ruby Celebration”周年纪念活动。众所周知“第68届曼谷宝石和珠宝博览会”作为世界五大宝石和珠宝贸易展览会之一久负盛名。它是泰国最大、亚洲历史最悠久的宝石和珠宝贸易展览会，足以说明了其在行业中的重要性。届时展会为期5天，即2023年9月6日至10日，涵盖QSNCC的8个展馆。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-08-31/master.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>第68届曼谷宝石珠宝展，由国际贸易促进司(DITP)和泰国宝石珠宝学院 (GIT) 联合举办，今年将庆祝其举办40周年。以“40年辉煌”为主题，这个活动体现了泰国著名的宝石和珠宝行业在全球范围内的引人注目的增长。展会的核心迷人亮点，包括展览“辉煌的40年辉煌发展历程”，展示了泰国宝石和珠宝行业的辉煌。此次活动共有 1,100多家参展商共设置2,400个展位，是一个重要的贸易平台，促进泰国企业家和国际买家之间的重要商务谈判。该活动预计将吸引超过30,000名本地和国际参与者，并产生超过30亿泰铢的收入。除了这些令人印象深刻的数字之外，展会还扩大了商机，支持出口活动，并巩固了泰国作为全球宝石和珠宝贸易中心的重要地位。</p>
      
      <p>
        <div style="display: flex;gap:1.5rem;">
          <p style="flex:1;" >
            <img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-08-31/Surapol.jpg" alt="QSNCC" width="808" height="606" />
          </p>
          <div style="flex:1;">
            <strong style="color:#000000">N.C.C. Management and Development Co., Ltd.的首席执行官，也是QSNCC的运营管理者，Surapol Utintu先生</strong>表示: “作为场馆主办方，QSNCC荣幸地扮演着推动泰国宝石和珠宝行业走向全球舞台的关键角色。这一成就是通过我们作为多功能活动平台的角色实现，我们拥有全方位的准备，特别是在我们能够同时容纳大型展览的适应性空间中展示。在第68届曼谷宝石珠宝展上，我们利用了横跨两层的广阔区域，包括 8 个展厅，总面积超过45,000平方米，横跨LG层和G层。这个多功能空间同时可以无缝承接各种类型的活动和展览。”
          </div>
        </div>
      </p>
      
      <p>凭借QSNCC广泛的空间能力，我们坚信活动组织者和参展商将发现其产品展示和进行业务洽谈时的便利。与此同时，与会者将享受到令人满意的浏览体验和做出购买的体验，所有这些的便利，都汇集于一体。</p>
      <p>体验第68届曼谷宝石珠宝展的巅峰盛况，该展览将于2023年9月6日至10日上午10点至下午6点举行。活动将在QSNCC的LG楼和G楼1-8号厅举行。该展览将于2023年9月6日至8日举办贸易日，随后于9月9日和10日举办公众日，欢迎大家参与。</p>
      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-08-31/master.jpg',
    imageSp: '/images/media/news/2023-08-31/master.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'qsncc-wins-mc-asia-stella-awards-2023-convention-center',
    headline: {
      cn: 'QSNCC凭借“最佳可持续发展倡议”荣获M&C Asia Stella 2023最佳会议中心大奖',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '诗丽吉王后国家会议中心（QSNCC）凭借最佳可持续发展倡议，荣获M&C Asia Stella 2023最佳会议中心大奖，为泰国会展业再创辉煌。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC凭借“最佳可持续发展倡议”荣获M&C Asia Stella 2023最佳会议中心大奖',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年8月24日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-08-24/qsncc-wins-mc-asia-stella-awards-2023-convention-center.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>诗丽吉王后国家会议中心（QSNCC）凭借最佳可持续发展倡议，荣获M&C Asia Stella 2023最佳会议中心大奖，为泰国会展业再创辉煌。</p>
      <p><strong>M&C Asia Stella Awards</strong>是由在会奖专业人士中享有很高知名度的会奖及旅游行业知名杂志M&C Asia颁发的年度奖项。获奖机构均展示了创新和在最佳实践中，为亚洲会展业的发展和进步做出的重大贡献。奖项共包涵6个类别29个奖项，每个类别的决赛入围者均由相应行业专业人士通过公开投票选出。</p>
      <p class="center"><img src="/images/media/news/2023-08-24/asia2.jpg" alt="" width="800" height="413" /></p>
      <p><strong>QSNCC的运营商，N.C.C.管理和发展有限公司首席执行官Surapol Utintu</strong>表示:“我们很自豪能够获得M&C Aisa颁发的奖项。我们的改造从设计初期，规划期、改造期、改造后、节能设施安装到活动和场馆管理中可持续发展的实际践行，就把可持续性放在首位。该奖项是对我们致力于行业可持续发展的荣誉认可。在此，我们要感谢M&C Asia对该地区卓越的会奖旅游行业的贡献，并感谢业界同行和会议策划者的投票和信任。</p>
      <p class="center"><img src="/images/media/news/2023-08-24/asia.jpg" alt="" width="800" height="413" /></p> 
      <p>凭借清晰的可持续实践，QSNCC将很快获得LEED-NCv4银级认证。LEED认证，是由美国绿色建筑委员会（USGBC）绿色建筑评分认证系统，所认证的领先能源与环境设计先锋。据QSNCC介绍，在这方面，QSNCC将成为泰国第一个获得此类认证的会议中心。</p>
      <p>QSNCC可持续发展倡议的主要特点是可持续建筑，包括减少用电、多种交通方式的可达性、与绿地的连接、能源效率管理、环保废物处理、本地采购和可持续会议套装。“我们的场馆已准备好为客户提供举办可持续发展的活动服务，并将泰国会展业和泰国纳入全球可持续发展版图。这肯定了场馆不仅要为行业本身做出贡献，还要为业界和社会做出贡献的决心。然而，我们清楚地意识到，仍然在可持续的道路上面临挑战。该奖项将推动QSNCC进一步改善可持续性。在这方面，QSNCC希望得到业内专业人士的建议、投入和合作，使会展业成为可持续发展的有力参与者。业界应该团结起来，为全社会树立一个好榜样。”<strong>Surapol</strong>补充道。</p>
      <p><strong>在获得2023年M&C亚洲斯特拉奖之前，该场馆已通过ISO20121:2012《大型活动可持续性管理体系要求及使用指南》认证。</stong>该奖项体现了QSNCC对可持续发展坚定不移的承诺，并将成为该场馆更好和完善其可持续举措以适应商业格局转变的平台。</p>
      `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-08-24/asia.jpg',
    imageSp: '/images/media/news/2023-08-24/asia.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'the-queen-sirikit-national-convention-center-qsncc1',
    headline: {
      cn: 'QSNCC将举办3场数字活动推动泰国成为东南亚的“数字门户”',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC今年8月将举办三场数字活动，以连接数字行业人群并支持知识交流。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC将举办3场数字活动推动泰国成为东南亚的“数字门户”',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年8月10日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-08-10/the-queen-sirikit-national-convention-center-qsncc1.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心(QSNCC)今年8月将举办三场数字活动，以连接数字行业人群并支持知识交流。</p>
      <p><img style="border-radius: 20px 0 20px 0;" src="/images/media/news/2023-08-10/master.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>旨在推动泰国数字经济的增长，首个活动是“Techsauce Global Summit 2023”，这是今年东南亚最大的技术峰会。随之而来的是首次在泰国举办的人工智能技术展览“AI Thailand Forum 2023：拥抱AI的未来”。第三个活动是题为“HACKaTHAILAND 2023：DIGITAL INFINITY”的数字技术展览。</p>
      <p>作为这些备受瞩目的活动举办地，QSNCC致力于成为“最好的活动平台”和连接公共和私营部门的中心，推动泰国成为东南亚的“数字门户”。</p>
      <p>过去三年来，越来越多的外国投资者投资东盟的数字业务。结果该行业的价值翻了一番，使得泰国和国际组织者能够更加关注数字行业。</p>
      <p>QSNCC被选为整个8月份重要数字活动的举办地，所有这些活动都旨在宣传和推动泰国成为东南亚的数字门户。</p>
      
      
      <p>今年8月在QSNCC举办的三场数字活动详情如下：</p>
      <p>
        <ul style="list-style: disc;margin-left: 2rem;">
          <li style="list-style: disc;"><strong style="color:#000000"> Techsauce Global Summit 2023，</strong>由Techsauce Media Limited举办的定于8月16日至17日，主题为“社会影响、气候技术、尖端技术”。该活动旨在通过连接投资机会并激发公共和私人组织以及泰国各级企业家和初创企业之间的合作，推动泰国的技术生态系统进一步发展。</li>
          <li style="list-style: disc;"><strong style="color:#000000">AI Thailand Forum 2023，</strong> 由泰国人工智能企业家协会 (AIEAT) 和泰国人工智能协会 (AIAT) 组织，定于8月16日至17日举行，其理念是“拥抱人工智能的未来”。此次活动的举办旨在宣传人工智能知识，为泰国人工智能技术的发展奠定基础。</li>
          <li style="list-style: disc;"><strong style="color:#000000">HACKaTHAILAND 2023，</strong> 由数字经济促进局 (DEPA)举办，定于8月25日至26日举行，以“数字无限”为概念，亮点分别五个区域，包括在当今商业、旅游内容中汇集现代数字技术的“技术展示” 和健康技术环境。</li>
        </ul>
      </p>
      
      
      <p><strong style="color:#000000">QSNCC的运营管理公司N.C.C.的首席执行官Surapol Utintu表示</strong>：“随着东盟数字经济增长的高价值，QSNCC作为具有国际标准的活动平台，已准备好满足数字活动组织者的所有要求，他们需要拥有最新技术的最先进平台。”</p>
      <p>“我们还希望帮助推广数字活动，这在泰国被认为是一个新兴产业，但它已经在全球舞台上站稳了脚跟。我们将‘泰国数字产业’视为推动泰国整体经济增长的关键，并推动泰国成为该地区的‘数字门户’。”<strong style="color:#000000">Surapol 解释道。</strong></p>
      <p>他补充道：“我们相信，通过这些领先的数字活动，公共和私营部门之间的合作将在它们之间建立强大的网络，展示泰国数字产业的良好潜力，同时也支持泰国数字经济的可持续增长。”</p>
      `,
      th: `<p><img src="/images/media/news/2023-10-09/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-08-10/master.jpg',
    imageSp: '/images/media/news/2023-08-10/master.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'cheer-for-your-favorite-team-during-the-final-round',
    headline: {
      cn: '在诗丽吉王后国家会议中心举行的VCT ASCENSION PACIFIC 2023决赛中为您最喜欢的队伍加油',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC被选做“VCT ASCENSION PACIFIC 2023”亚太区比赛举办地',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '在诗丽吉王后国家会议中心举行的VCT ASCENSION PACIFIC 2023决赛中为您最喜欢的队伍加油',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年7月，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-08-11/VCT.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心（QSNCC）将主办活动扩大至电子竞技行业，因其作为“终极鼓舞人心的世界级活动平台”地位，被选做“VCT ASCENSION PACIFIC 2023”，亚太区的比赛举办地。在促进泰国创意产业在国际舞台上发展的同时，该赛事旨在寻找一支优秀的队伍，参加2023年7月7日至9日，在QSNCC举行全球玩家都不想错过的全球锦标赛。</p>
      <p class="center"><img src="/images/media/news/2023-08-11/IMG_9656.jpg" alt="" width="800" height="413" /></p>
      <p>ASCENSION PACIFIC 2023，是多人第一人称射击类(FPS)游戏《VALORANT》的亚太区竞技锦标赛，为10个国家地区的职业选手队伍提供了机会。包含日本、韩国、大洋洲、菲律宾、印度尼西亚、泰国、越南、马来西亚、新加坡、台湾和香港以及南亚。这些队伍齐聚一堂，在比赛中展示自己的技能，他们的目标是选出VCT太平洋区的唯一获胜者，并最终登上国际竞技舞台。总奖池金额超100,000美元。这项激动人心的赛事为期10天，将于2023年在泰国曼谷举行。比赛自6月28日开始，7月9日将在QSNCC举办总决赛，参赛选手是来自亚太地区的10个国家的职业选手。</p>
      <p>“我们非常高兴能够首次将VCT Ascension Pacific带到泰国曼谷。经过一周艰苦的小组赛，我们即将在QSNCC开启季后赛。在曼谷，我们预计将有超过4,600名观众。非常感谢泰国粉丝所表现出的令人难以置信的热情和支持。我们很高兴与QSNCC和赛事运营商‘One Up’合作，将这项赛事带到曼谷。”<strong>Riot Games（拳头游戏公司）《VALORANT》游戏电子竞技亚太区负责人Jake Sin</strong>说道。</p>
      <p class="center"><div style="display:flex;width:800px;justify-content:space-between;"><div><img src="/images/media/news/2023-08-11/4Y2A0236.jpg" alt="" width="400"  /></div><div><img src="/images/media/news/2023-08-11/IMG_9797.jpg" alt="" width="400" /></div></div></p>
      <p class="center"><div style="display:flex;width:800px;justify-content:space-between;"><div><img src="/images/media/news/2023-08-11/IMG_9806.jpg" alt="" width="400"  /></div><div><img src="/images/media/news/2023-08-11/4Y2A0123.jpg" alt="" width="400" /></div></div></p>
      <p><strong>QSNCC的运营商管理发展有限公N.C.C.首席执行官Surapol Utintu先生</strong>透露：“电子竞技在泰国乃至全球范围内都是一项受欢迎的活动。它已被官方认可为职业运动，并被纳入东南亚运动会等体育赛事中。由此，泰国的电竞商业市场连年呈指数级增长。预计未来五年内玩家和观众数量将分别增加约1800万和1000万。电子竞技可被视为创意产业的软实力，吸引人们的关注，其影响力可以与其他行业相媲美。”</p>
      <p>“QSNCC非常重视成为一个鼓舞人心的世界级活动平台。我们致力于推动电子竞技成为一项培养创造力、让人们聚集在一起参加各种赛事、提高年轻一代软技能的活动。我们非常自豪能够赢得主办方的信任，选择 QSNCC作为VCT ASCENSION PACIFIC 2023的举办地，这在泰国尚属首次。我们还参与支持泰国的创意产业，使其更容易接触到更广泛的受众。我们相信，组织者、选手以及主要代表年轻一代的参与者们，在参与能够满足所有年龄段和生活方式需求的“终极鼓舞人心的世界级活动平台”时获得最佳体验。”</p>
      `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-08-11/VCT.jpg',
    imageSp: '/images/media/news/2023-08-11/VCT.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'iso201212012-qsncc-strives-to-be-a-leader-in-sustainable',
    headline: {
      cn: 'ISO20121:2012“QSNCC”致力成为可持续活动的引领者',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '诗丽吉王后国家会议中心（QSNCC）获得了世界上首屈一指的检测、检验和认证公司 SGS（Societe Generale de Surveillance）颁发的 ISO20121:2012《大型活动可持续性管理体系要求及使用指南》认证。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'ISO20121:2012“QSNCC”致力成为可持续活动的引领者',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年6月26日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-06-27/iso201212012-qsncc-strives-to-be-a-leader-in-sustainable.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>诗丽吉王后国家会议中心（QSNCC）获得了世界上首屈一指的检测、检验和认证公司SGS（Societe Generale de Surveillance）颁发的ISO20121:2012《大型活动可持续性管理体系要求及使用指南》认证。这一成就巩固了QSNCC作为可持续发展管理服务领导者的地位。</p>
      <p>ISO20121:2012大型活动可持续性管理体系标准，于2012年正式发布。它为提高大型项目相关活动的可持续性提供了指导，为可持续发展的三大支柱：经济发展、环境保护和社会进步做出了贡献。各种全球性大型活动，包括2012年伦敦奥运会和残奥会、2014年巴西世界杯、2018年第十八届亚洲运动会，都使用大型活动可持续性管理系统来管理赛事的可持续性，并控制其对社会、经济、和环境的影响。</p>
      <p>QSNCC获得ISO20121:2012标准认证，是向着建立符合泰国国家和全球可持续发展目标的活动管理服务又迈进了一步。我们在可持续发展的三个支柱：环境保护、社会进步和经济发展方面制定了相关策略并实施了举措。环境保护包括遵循优化资源效益的行动计划、利用可再生能源和使用环保产品。社会进步包括安装符合国际标准的安全系统，以便确保我们的员工和访客的安全，这也是我们的首要任务。经济发展包括企业管理中的良好管理、透明化和问责制。</p>
      <p>除了ISO20121:2012标准认证外，QSNCC还通过了ISO22000:食品安全管理体系标准认证、ISO9001:质量管理体系标准以及泰国旅游业安全与健康管理标准(SHA)的认证，该管理局负责监督游客的卫生和安全。这些认证成就和增强了国内和全球组织者的信任，将活动标准提高到国际水平，并证实了 QSNCC 致力于成为各类国内和国际活动的可持续场馆的决心。</p>
      <p class="center"><div style="display:flex;width:800px;justify-content:space-between;"><div><img src="/images/media/news/2023-06-27/sus.jpg" alt="" width="400"  /></div><div><img src="/images/media/news/2023-06-27/iso.jpg" alt="" width="400" /></div></div></p>
      <p>QSNCC运营方N.C.C.管理与发展有限公司首席执行官Suraphon Uthintu（右）荣获全球领先的测试、检验和认证公司SGS泰国有限公司---总经理Montri Tangtermsirikul（左）颁发的ISO20121：2012大型活动可持续性管理体系证书。 这一成就巩固了QSNCC作为活动可持续管理服务行业领导者的地位。</p>
      `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-06-27/iso.jpg',
    imageSp: '/images/media/news/2023-06-27/iso.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'once-again-the-queen-sirikit-national-convention-center',
    headline: {
      cn: 'QSNCC准备举办 "第十六届世界华人企业家大会"  以加强泰中商业伙伴关系及振兴世界经济',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '诗丽吉王后国家会议中心（QSNCC）再次受泰中商会委托，成为世界华商大会（WCEC）的举办地。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC准备举办 "第十六届世界华人企业家大会"  以加强泰中商业伙伴关系及振兴世界经济',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年6月19日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-06-21/once-again-the-queen-sirikit-national-convention-center.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>诗丽吉王后国家会议中心（QSNCC）再次受泰中商会委托，成为世界华商大会（WCEC）的举办地。这是继1995年QSNCC被选为同一会议的举办地之后的又一次。今年，QSNCC将迎来3000多名来自世界各地的中国企业家和高层管理人员。第十六届世界华商大会旨在促进和扩大国际投资和贸易网络，同时也提升泰国和中国商业领袖的潜力。该大会将于2023年6月24日至26日举行。</p>
      <p class="center"><img src="/images/media/news/2023-06-21/4.jpg" alt="" width="800" height="413" /></p>
      <p>世界华商大会每两年举办一次，汇集了世界各地的华商。今年，泰中商会举办该大会的目的是为了建立一个强大的经济网络，加强全球华商群体，增进泰国与各国之间的商业机会和投资。</p>
      <p>泰中商会会长、第十六届世界华商大会组委会主席Narongsak Putthapornmongkol先生透露：“中华人民共和国一直是泰国的顶级贸易伙伴之一，有超过45年的强大双边关系支持。这包括贸易、投资和旅游方面的经济合作，而泰国是中国政府允许其公民作为游客前往的第一个国家。因此，为了加强泰中商业伙伴关系，并在COVID-19引起的全球危机之后，振兴泰国经济以及世界经济，泰中商会正在组织第16届世界经济大会。大会旨在讨论贸易战略，为未来的危机做好准备，在这个数字时代探索新的投资形式，提升中国商业领袖在泰国和全球的潜力，同时也计划扩大国际商业活动的稳定性。”</p>
      <p class="center"><img src="/images/media/news/2023-06-21/1.jpg" alt="" width="800" height="413" /></p>
      <p>“尽管如此，为了热烈欢迎来自世界各地的3000多名中国商业专业人士，我们有信心选择新装修的QSNCC作为会场。我们坚信，QSNCC以其现代泰式风格的设计和最先进的设施，结合其举办全球活动的经验，无疑将给中国商业代表留下深刻印象。”</p>
      <p>QSNCC的运营方N.C.C.管理发展有限公司首席执行官Surapol Utintu先生表示：“QSNCC能够再次赢得主办方的信任，认可我们举办这一世界级会议的准备工作和能力，我们感到非常荣幸。我们坚信，凭借我们便利的设施和服务，QSNCC一定会给主办方和所有与会者留下深刻印象。被授予主办这样一个著名的国际活动的特权，将使我们对自己的地位充满信心，因为我们是‘世界一流，超凡卓越的会展活动平台’，能够容纳各种类型和规模的活动。此外，这无疑将在未来吸引更多创新的活动到泰国举办。”
      </p>
      <p class="center"><img src="/images/media/news/2023-06-21/2.jpg" alt="" width="800" height="413" /></p>
       `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-06-21/5.png',
    imageSp: '/images/media/news/2023-06-21/5.png',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'ncc-appoints-new-ceo-to-drive-event-business-forward',
    headline: {
      cn: 'NCC任命新任CEO 旨在使QSNCC成为终极鼓舞人心的世界级活动平台',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'N.C.C. 管理发展有限公司正式宣布其新任命的首席执行官Surapol Utintu先生就任',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'NCC任命新任CEO进而推动活动业务发展 旨在使QSNCC成为“面向大众的终极鼓舞人心的世界级活动平台”',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年5月，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-06-21/ncc-appoints-new-ceo-to-drive-event-business-forward.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>N.C.C. 管理发展有限公司正式宣布其新任命的首席执行官Surapol Utintu先生就任，他将带领翻新后的新诗丽吉王后国家会议中心（QSNCC）向着成为“终极鼓舞人心的世界级活动平台”的目标迈进。</p>
      <p class="center"><img src="/images/media/news/2023-06-21/ceo1.jpg" alt="" width="800" height="413" /></p>
      <p>QSNCC的管理机构N.C.C.，今日正式宣布任命<strong>Surapol先生</strong>为其新任首席执行官，接替已被任命为董事会委员会成员的<strong>Sakchai Pattarapreechaku先生</strong>。新当选的首席执行官将秉持加快公司发展，扩大其国内和国际商业合作伙伴网络的使命。与此同时，将QSNCC的形象转变为一个世界级的活动平台。并在激烈的数字竞争、经济危机和持续的全球不确定性时代和不断变化的挑战中，满足渠道客户和企业客户的需求。</p>
      <p><strong>Surapol先生</strong>有着30多年在泰国领先组织的管理经验，在管理大型零售场所、剧院以及其他多种业务领域拥有无与伦比的专业知识。凭借着其对分析和风险管理的精通，以及与商业合作伙伴建立的长期关系，他决心将自己在整个工作生涯中所学到的知识运用于推动N.C.C.成为一个独特的场所在全球声名鹊起。</p>
      <p><strong>Surapol先生</strong>说：“我们的主要目标是将QSNCC定义为不仅仅是一个会议场地，而是‘面向大众的终极鼓舞人心的世界级活动平台’”。“为了完成我们的使命，我们将推动QSNCC成为针对渠道客户以及大众客户，举办各种活动的首选场所和目的地，使QSNCC在未来能够举办更多种类的活动。我们还希望将这个会议中心，转变为一个服务于现代生活方式的地标，让更多的人们，经常在这里进行日常活动。”</p>
      <p><strong>Surapol先生</strong>补充道：“很荣幸有机会为经过改造的、现代化的，可以体现泰国的独特的QSNCC工作。我们已经做好了迎接国际游客的准备。尽管这一重大责任也带来了挑战，但我对我的团队充满信心，并相信他们的潜力、专业知识和经验将带领我们实现预期的目标。以我们无可争议的国际标准，被认可为一个出色的会议中心，自豪地代表泰国站在世界舞台上。</p>
      <p>“在架构方面，以便更好地经营管理，N.C.C.进行了重组，合并了子公司。通过这些举措，我们的活动和会议业务，现已是完整且全面的。从管理会议中心到组织会议和展览，从展位设计到搭建，并包含食品、饮料和餐饮。我们的核心使命之一是在可持续发展的基础上运营我们的业务，包括开发满足客户需求、造福社会和所有相关业者以及保护环境的产品和服务。这也涉及到使用促进可持续发展的技术。我们所有的价值观都强调我们的经营理念，即优先考虑生活质量和环境。”</p>
      `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-06-21/ceo.jpg',
    imageSp: '/images/media/news/2023-06-21/ceo.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'the-queen-sirikit-national-convention-center-qnscc',
    headline: {
      cn: 'Coex 与 QSNCC 签署谅解备忘录，推动韩国和泰国的活动产业发展',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '诗丽吉王后国家会议中心 (QSNCC) 和韩国 Coex 会展中心 (Coex) 联合签署了一份谅解备忘录 (MOU)，以提升和推动泰国和韩国之间的活动产业。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'Coex 与 QSNCC 签署谅解备忘录，推动韩国和泰国的活动产业发展',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年5月22日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-06-27/the-queen-sirikit-national-convention-center-qnscc.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>诗丽吉王后国家会议中心 (QSNCC) 和韩国 Coex 会展中心 (Coex) 联合签署了一份谅解备忘录 (MOU)，以提升和推动泰国和韩国之间的活动产业。此次合作旨在交流业务和专业知识，支持各种营销活动，并促进人员交流，以提高活动和会议管理能力。</p>
      <p class="center"><img src="/images/media/news/2023-06-27/mou.jpg" alt="" width="800" height="413" /></p>
      <p>QSNCC，泰国第一个国家会议中心，曼谷最大的会议中心；Coex，首尔最大的会展中心，二者都是领先的场馆，在各自国家的会展行业发展中发挥着重要作用。它们的物理和内部组件和谐相处。这两个会议中心都拥有覆盖场馆和零售区的宽敞空间，能够容纳各种类型的活动和生活方式。它们均位于市中心，交通便利。它们周围还有购物中心、餐馆和酒店，并拥有便利的设施和先进的技术。此外，他们都优先考虑环境的可持续性，并致力于发展活动产业，同时推动国家经济向前发展。</p>
      <p>Coex首席执行官李东基先生表示：“我们希望此次签署协议将成为一个重要的里程碑，有助于打破Coex和QSNCC的竞争力限制，实现活动和会议行业的可持续发展能力。除了两个会议中心之前经历过的合作之外，此次合作还将通过发现新的商机，为两国展览和会议行业的进步打开大门。”</p>
      <p>QSNCC 的运营商NCC 管理与发展有限公司执行副总裁 Sutichai Bunditvorapoom 先生表示：“此次合作形成的伙伴关系将增强和提升举办各种活动的能力。它将促进专业知识和新技术的交流，以支持可持续的活动管理并吸引来自韩国组织者的新形象活动，为泰国活动行业和创意产业提供成长和繁荣的机会，类似于韩国活动行业，韩国活动行业已经成功地和不断推动娱乐、演唱会、电子竞技、游戏等领域走向国际市场。”</p>
      <p>“QSNCC 认识到通过与 Coex 交流业务、专业知识和各种机会来扩大活动平台潜力的机会。此次合作旨在增强QSNCC的活动组织能力并推动国际活动行业的发展。合作涵盖三个层面，包括基础服务领域的知识交流，例如赛事行业的管理和人员交流；提供赛事竞标信息，包括过去和当前的赛事；以及联合业务开发以及开展营销活动，” Sutichai 先生总结道。</p>
 `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-06-27/mou.jpg',
    imageSp: '/images/media/news/2023-06-27/mou.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },

  {
    slug: 'money2020--one-of-the-worlds-biggest-fintech-events',
    headline: {
      cn: 'Money20/20全球金融科技创新大会–世界上最大的金融科技活动之一将于2024年4月在诗丽吉王后国家会议中心举行',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '诗丽吉王后国家会议中心（QSNCC），被选为主办世界领先的全球金融科技创新大会“Money20/20 Asia”，标志着一个新的里程碑。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'Money20/20全球金融科技创新大会–世界上最大的金融科技活动之一将于2024年4月在诗丽吉王后国家会议中心举行',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年4月28日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-06-21/money2020--one-of-the-worlds-biggest-fintech-events.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>诗丽吉王后国家会议中心（QSNCC），被选为主办世界领先的全球金融科技创新大会“Money20/20 Asia”，标志着一个新的里程碑。Money20/20 Asia 定于 2024 年 4 月 23 日至 25 日举行。曼谷成为 Money20/20 的第三个主办城市，继阿姆斯特丹和拉斯维加斯之后，将迎来全球超过 20,000 名金融科技和金融服务专业人士。</p>
      <p class="center"><img src="/images/media/news/2023-06-21/m1.jpg" alt="" width="800" height="413" /></p>
      <p>Money20/20 汇集了世界上一些最著名的金融服务和数字支付公司，例如摩根大通、VISA、万事达卡、支付宝、汇丰银行和 Airwallex 等。大会的演讲嘉宾来自各个行业和整个数字货币生态系统的数千家公司，包括世界上最大的银行、最大的数字支付公司、财富科技、保险科技、新银行、监管机构、政府机构和投资公司 。出席Money20/20的演讲者包括苹果公司联合创始人Steve Wozniak、Square和Twitter创始人兼首席执行官Jack Dorsey、全球网球明星兼Serena Ventures创始人Serena Williams、Revolut首席执行官Nikolay Storonsky以及FUBU和Shark Tank Star的创始人Daymond John。</p>
      <p>Money20/20选择在拉斯维加斯的威尼斯人酒店和阿姆斯特丹的RAI酒店等地标建筑举办全球活动。Money20/20 是全球最大的支付和金融服务创新金融科技盛会。明年选择在QSNCC举办，凸显了曼谷场馆作为亚洲世界级活动平台和泰国经济的驱动力的领先地位。</p>
      <p>“Money20/20的成立是为了帮助数字货币世界共同开展业务。我很高兴我们现在正式欢迎曼谷和整个亚洲加入我们的全球社区，在QSNCC最近进行了重大翻新后，我非常高兴能与该团队合作，为来自亚洲各地和世界各地的代表们创造世界级的活动体验。泰国、亚洲金融科技界以及我们的许多泰国地区合作伙伴给予了我们难以想象的热烈欢迎，对此我们感到非常荣幸。”Money20/20总裁Tracey Davies表示：“我们等不及明年的4月了。”</p>
      <p class="center"><img src="/images/media/news/2023-06-21/m3.jpg" alt="" width="800" height="413" /></p>
      <p>QSNCC运营商N.C.C.管理发展公司首席执行官Sakchai Pattaraprechakul表示：“我们很荣幸被选为Money20/20 Asia的举办地，并在处理金融科技事件以及将世界各地的投资者与泰国金融科技企业家建立联系方面，为泰国树立良好形象做出贡献。”</p>
      <p>“在泰国，随着越来越多的企业家进入该行业，金融科技业务不断增长，特别是支付、手机银行和电子钱包领域的服务提供商。我们相信，此次活动将为所有参与者带来启发。如果这次活动为泰国带来业务增长和扩张，我们相信这将带来更高的就业率、国内旅游业的增长，并最终促进整个泰国经济的增长。”Sakchai补充道。</p>
      <p class="center"><img src="/images/media/news/2023-06-21/m2.jpg" alt="" width="800" height="413" /></p>
      `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-06-21/feng1.jpg',
    imageSp: '/images/media/news/2023-06-21/feng1.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'showing-off-the-great-potential-of-thailands-gem-jewellery',
    headline: {
      cn: 'QSNCC 通过举办“2023 年东盟曼谷珠宝首饰展览会” 为泰国增添了新的活动概况',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '通过首次在泰国举办的世界知名珠宝展展示泰国宝石珠宝业的巨大潜力',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC 通过举办“2023 年东盟曼谷珠宝首饰展览会” 为泰国增添了新的活动概况',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年4月20日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-06-27/showing-off-the-great-potential-of-thailands-gem-jewellery.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>通过首次在泰国举办的世界知名珠宝展展示泰国宝石珠宝业的巨大潜力</p>
      <p class="center"><img src="/images/media/news/2023-06-27/bao.jpg" alt="" width="800" height="413" /></p>
      <p>诗丽吉王后国家会议中心 (QSNCC) 将于 2023 年 4 月 26 日至 29 日首次在泰国举办“2023 年曼谷珠宝与宝石东盟博览会”(JGAB)，为泰国增添新的活动内容。</p>
      <p>全球领先的贸易展览组织者之一Informa Markets泰国表示，它看到了泰国珠宝行业的巨大潜力，并准备将泰国推向全球舞台上的宝石和珠宝交易中心。</p>
      <p>“2023 年曼谷珠宝及宝石展”(JGAB)是每年在香港举办的全球最负盛名的珠宝展 Jewellery & Gem WORLD 的一部分。这是JGAB首次在泰国举办。</p>
      <p>展会云集了来自全球15个国家的400多个宝石和珠宝品牌，超过10,000件稀有宝石和珠宝藏品。JGAB除了是买家、卖家和珠宝设计师的重要国际聚会之外，也是行业内企业家聚集交流观点的场所。</p>
      <p>活动亮点包括展示来自11个国家的工具和设备的宝石和珠宝展区、“JGAB 跑道”以及“青年设计师奖”设计竞赛。此外，该活动还将展示全球服装和珠宝趋势的最新动态。</p>
      <p>“2022年，泰国珠宝业稳步增长。受疫情后国家开放、经济复苏以及泰铢贬值允许外国人在该国购物的影响，珠宝出口额达到5000亿泰铢，同比增长49.82%。”Informa Markets 活动总监 Anuchana Vichvech 在“2023 年东盟曼谷珠宝首饰展览会”(JGAB )上透露。</p>
      <p>“由于泰国是东南亚的宝石和珠宝中心，‘Informa Markets’看到了泰国宝石行业发展和增长的机遇和潜力。因此，我们将 JGAB 作为珠宝和宝石世界的一部分组织起来，成为全球买家和卖家与泰国企业家和设计师会面的交易平台。我们希望此次活动能够推动泰国成为全球范围内的宝石和珠宝交易中心。” Anchana解释道。</p>
      <p>“活动地点是给游客留下深刻印象的关键因素之一，因为‘QSNCC’是我们看到的第一个能够满足我们在曼谷市中心旅行的空间和位置便利性方面的所有需求的地方，便捷易达。除此之外，还有真正独特且现代的一流设施和泰式装饰。举办高级珠宝展的完美场所需要一个美丽而现代的场地，就像我们在 QSNCC 上看到的那样，”她补充道。</p>
      <p>QSNCC 运营商 NCC 管理与发展有限公司首席执行官 Sakchai Pattaraprechakul 表示：“QSNCC 很荣幸成为泰国企业家在国际舞台上展示潜力的平台，从而推动宝石行业的发展以及泰国经济。”</p>
      <p class="center"><img src="/images/media/news/2023-06-27/ceo.jpg" alt="" width="800" height="413" /></p>
      <p>Sakchai补充道：“这对我们来说也是一个很好的机会，能够为泰国增添新的活动概况，这不仅展示了泰国宝石和珠宝行业的潜力，也证明了我们能够成功组织像 JGAB 这样的世界级活动。它反映了泰国的会奖旅游业务如何能够与国际市场保持同等水平的增长。”</p>
      `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-06-27/bao.jpg',
    imageSp: '/images/media/news/2023-06-27/bao.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'thailand-is-hosting-the-world-congress-of-nephrology',
    headline: {
      cn: '泰国首次在 QSNCC 举办“2023 年世界肾脏病学大会”旨在让患者公平获得治疗',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '诗丽吉王后国家会议中心欢迎来自世界各地的 4,000 多名肾脏病专家参加“2023 年世界肾脏病学大会”(WCN 2023)，这是世界上最大的肾脏护理活动之一，首次在泰国举办。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '泰国首次在 QSNCC 举办“2023 年世界肾脏病学大会”旨在让患者公平获得治疗',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年3月31日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-06-27/thailand-is-hosting-the-world-congress-of-nephrology.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>诗丽吉王后国家会议中心欢迎来自世界各地的 4,000 多名肾脏病专家参加“2023 年世界肾脏病学大会”(WCN 2023)，这是世界上最大的肾脏护理活动之一，首次在泰国举办。</p>
      <p class="center"><img src="/images/media/news/2023-06-27/tai1.jpg" alt="" width="800" height="413" /></p>
      <p>此次活动得到了泰国肾脏基金会主席诗琳通公主殿下的大力支持，并主持了此次活动。该活动从3月30日持续到4月2日，并设有题为“健康肾脏的知识增强”的展览。</p>
      <p>世界肾脏病学大会 (WCN) 由国际肾脏病学会 (ISN) 主办，该协会成立于 1960 年，致力于推进全球肾脏病学教育、科学和患者护理，以实现研究和知识发展。该协会已发展成为领先的国际社区，拥有来自全球各地的 30,000 多名会员。这项一年一度的活动每年都会在世界不同国家举行，为顶级肾病专家提供了一个参与和交流知识的舞台。</p>
      <p class="center"><img src="/images/media/news/2023-06-27/tai2.jpg" alt="" width="800" height="413" /></p>
      <p>国际肾脏病学会 (ISN) 会议和活动主任 Michael Podt 先生表示：“目前，全球慢性肾病患者数量呈上升趋势，大多数患者获得治疗的机会有限。”</p>
      <p>“为了举办 2023 年 WCN，我们正在寻找一个在医疗和公共卫生方面具有强大潜力的东道国，以建立一个强大的网络，为全世界患者提供公平和可持续的治疗机会。这符合 ISN 的核心价值观，即促进患者平等和公平地获得治疗，” Podt 先生解释道。</p>
      <p>“我们选择 QSNCC 作为 2023 年 WCN 的举办地，因为它位于曼谷市中心，地理位置便利，并且与各种旅行方式都有联系。周边有很多住宿和酒店，方便与会者前来参加活动。最重要的是，我们选择 QSNCC 是因为它在世界各地广为人知的泰国待客之道中享有盛誉。” Podt 先生补充道。</p>
      <p class="center"><img src="/images/media/news/2023-06-27/tai3.jpg" alt="" width="800" height="413" /></p>
      <p>2023年世界肾脏病学大会组委会主席Surasak Kantachuvesiri副教授表示：“作为WCN 2023年的组委会主席，我很荣幸和自豪泰国被选为今年世界肾脏病学大会的主办国。这表明泰国公共卫生已获得国际认可，并体现了泰国主办国际会议的意愿。</p>
      <p>我真诚地希望本次会议除了能够交流有助于提高肾病患者治疗效率的创新知识之外，还将成为一个推动国家政策议程的论坛，以允许更多的人获得治疗。”</p>
      <p class="center"><img src="/images/media/news/2023-06-27/tai4.jpg" alt="" width="800" height="413" /></p>
      <p>QSNCC 运营方 NCC 管理与发展有限公司首席执行官 Sakchai Pattarapreechakul先生表示： “我们非常荣幸能够得到国际肾脏病学会的信任，组织国际知名的 WCN 2023。这体现了 QSNCC 的能力。举办如此盛大的活动，无论是在活动空间、人员、服务等方面。我们相信，我们的经验和专业精神将给活动的组织者和与会者留下深刻的印象。”</p>
      <p class="center"><img src="/images/media/news/2023-06-27/tai5.jpg" alt="" width="800" height="413" /></p>
       `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-06-27/tai1.jpg',
    imageSp: '/images/media/news/2023-06-27/tai1.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'qsncc-is-ready-to-host-style-bangkok-fair-2023-leading',
    headline: {
      cn: 'QSNCC已做好准备举办2023 STYLE曼谷博览会,引领泰国成为亚洲生活方式和时尚中心',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '泰国诗丽吉王后国家会议中心 (QSNCC) 已做好充分准备，在2023年3月22日至26日举办亚洲领先的生活方式产品贸易展览会STYLE BANGKOK 2023。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC已做好准备举办2023 STYLE曼谷博览会,引领泰国成为亚洲生活方式和时尚中心',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2023年3月20日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2023-06-27/qsncc-is-ready-to-host-style-bangkok-fair-2023-leading.pdf',
          th: '',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心 (QSNCC) 已做好充分准备，在2023年3月22日至26日举办亚洲领先的生活方式产品贸易展览会STYLE BANGKOK 2023，展示来自500多家参展商的各种生活方式产品，年轻的创业者们将在多达1000个展位上销售产品。</p>
      <p><strong>STYLE BANGKOK</strong>是亚洲领先的生活方式产品贸易展览会，因新冠的大流行缺席两年后，即将隆重回归。今年的概念“可持续+”，是一场不仅能满足需求，还能创造世界潮流的博览会，旨在推动泰国成为亚洲生活方式和时尚产品的贸易中心。展会坚定地致力于重新定义生活方式和时尚产业以及塑造泰国品牌未来的可持续趋势，并在QSNCC举行，以吸引更多的参与者。由于现代设计突出了独特的泰国特色，以及对可持续和环保实践的坚定承诺，该活动完美地满足了不断变化的需求。鉴于泰国已重新全面开放国际旅游，且举办活动的场馆拥有宽敞的空间和容量，预计该活动将吸引多达 40,000名参观者。</p>
      <p>QSNCC的运营公司，<strong>N.C.C.管理与发展有限公司首席执行官Sakchai Pattarapreechakul</strong>指出，QSNCC注意到泰国创业者的生活方式业务和设计作品的潜力。 </p>
      <p>“这被认为是国家软实力的一部分，可以向国际社会传达深刻且细腻的泰国文化本质。我们感到自豪和荣幸的是，泰国商务部国际贸易促进局 (DITP) 和泰国商会让我们有机会参与这一激动人心的历程，推动泰国成为亚洲生活方式和时尚设计产品的贸易中心。STYLE BANGKOK 2023体现了QSNCC举办多种生活方式活动的能力，不仅体现在提供活动场地和设施方面，还体现在我们以BALM为理念的零售空间中提供的独特产品，满足了活动中参观者的所有需求。”<strong>Sakchai </strong>说。</p>
      <p class="center"><img src="/images/media/news/2023-06-27/ceo.jpg" alt="" width="800" height="413" /></p>
      <p>届时，所有有意者都被欢迎与来自世界各地的零售商、设计师和专业买家面对面。2023年3月22日至26日，在QSNCC的G层1-4号展厅举行的STYLE BANGKOK 2023，共设有12个区域，分为 5 个类别：家具、礼品、家居装饰、家居用品和时尚。</P>
      <p>参展内部时间为3月22日至24日，公众开放日为3月25日至26日。</p>
 `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2023-06-27/style.jpg',
    imageSp: '/images/media/news/2023-06-27/style.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'apec-2022-thailand-success-proves-qsnccs-global-readiness',
    headline: {
      cn: '诗丽吉王后国家会议中心成功举办2022年APEC领导人会议',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '以“开放、连接、平衡”为主题得第29届亚太经合组织经济领导人会议（AELM）于2022年11月14日至19日在诗丽吉王后国家会议中心（QSNCC）成功举办，这对泰国来说也是一个巨大的成功。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '诗丽吉王后国家会议中心成功举办2022年APEC领导人会议',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2022年11月24日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2022-11-24/apec-2022-thailand-success-proves-qsnccs-global-readiness.pdf',
          th: '/files/press/2021-10-07/NCC-partners-FPT-Press-Release_TH_Final.pdf',
        },
      },
    ],
    description: {
      cn: `
      <p>以“开放、连接、平衡”为主题得第29届亚太经合组织经济领导人会议（AELM）于2022年11月14日至19日在诗丽吉王后国家会议中心（QSNCC）成功举办，这对泰国来说也是一个巨大的成功。会议欢迎了亚太经合组织领导人、部长、代表以及来自亚太经合组织成员经济体的媒体、主席嘉宾和国际组织的约5000名代表参加。</p>
      <p class="center"><img src="/images/media/news/2022-11-24/qsncc.jpg" alt="" width="800" height="413" /></p>
      <p>外交部亚太经合组织2022年工作组组长Thanathip Upatising大使反映，“这一成功是政府和私营部门之间协作和合作的结果。因此，我们为泰国的这一东道主年作出了不懈的努力”，“我希望向所有为这一历史性事件付出努力的人表示诚挚的感谢。泰国在举办国际会议方面的能力已经通过拥有世界一流的会议场地、设施和专业服务得到证明。”</p>
      <p class="center"><img src="/images/media/news/2022-11-24/2.jpg" alt="" width="800" height="413" /></p>
      <p>QSNCC的运营商N.C.C.管理和发展有限公司的首席执行官Sakchai Pattarapreechakul先生说：“作为AELM及相关会议的官方场地，我们强调可持续发展和生态友好型会议。我们的设施、技术和服务发挥着至关重要的作用，体现了我们的使命，即成为‘世界一流，超凡卓越的会展活动平台’。我们支持所有类型的活动，我们是所有鼓舞人心活动的平台。”</p>
      <p class="center"><img src="/images/media/news/2022-11-24/3.jpg" alt="" width="800" height="413" /></p>
      <p>除了会场，QSNCC还有幸在整个会议周期间为亚太经合组织领导人、部长和代表们提供了各种场合的服务。食品和饮料的设计以生物循环绿色经济（BCG）为理念，代表了可持续性、生态设计和零废物。</p>
      <p class="center"><img src="/images/media/news/2022-11-24/4.jpg" alt="" width="800" height="413" /></p>
      <p>在LG层——新闻中心：媒体在这里享用了泰国和国际美食。每天都有泰国甜点供应，如Bulan Dan Mek、Cho Muang、La Tiang,、Khanom Bueang和Pan Sip Nueng。媒体在用餐期间还可以体验泰国的手工艺品和纺织品之美。在G层——代表用餐区：代表们体验了用柚子、莲花、椰子和香蕉等当地著名特产制作的泰国食品和甜点。最后，在1层——亚太经合组织领导人、部长和高级官员区：为给各位代表留下深刻印象，我们制作了各种泰国特色菜肴，例如来自泰国各地的街头美食、正宗的泰国美食和泰国融合美食。</p>
      <p class="center"><img src="/images/media/news/2022-11-24/5.jpg" alt="" width="800" height="413" /></p>
      <p class="center"><img src="/images/media/news/2022-11-24/6.jpg" alt="" width="800" height="413" /></p>
      <P>N.C.C.管理和发展有限公司执行副总裁Swasdivudh Svasti-vatana先生说：“我们的骄傲之一是通过美食来展示泰国的软实力。通过这次美食之旅，我们有机会分享泰国的生活方式和文化。此外，我们为所有代表提供了100%来自可持续来源的优质本地食材。这体现了QSNCC在强调可持续社会和改善当地社区方面的使命和承诺”。</P>
      <p class="center"><img src="/images/media/news/2022-11-24/7.jpg" alt="" width="800" height="413" /></p>
      <p class="center"><img src="/images/media/news/2022-11-24/8.jpg" alt="" width="800" height="413" /></p>
      <p>如果没有与包括“QSNCC团队”在内的泰国团队的通力合作，包括但不限于来自不同行业的厨师、食品造型师、学生、艺人和工匠，会议就不会成功，他们通过这些特殊的宴会来分享他们对泰国文化的热爱。全球舞台上的泰国美食给人留下了深刻的印象，并邀请世界各地的客人来泰国参观游览。</p>
      <p>诗丽吉王后国家会议中心是泰国人民的骄傲，已经准备好成为超凡卓越的会展活动平台。</p>
      `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2022-11-24/qsncc.jpg',
    imageSp: '/images/media/news/2022-11-24/qsncc.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'the-queen-sirikit-national-convention-center-invites',
    headline: {
      cn: '诗丽吉王后国家会议中心即将举办2022年亚太经合组织会议',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '泰国诗丽吉王后国家会议中心邀请泰国人民携手举办2022年亚太经合组织（APEC）活动，在支持当地商业扩张和推动国民经济发展的同时，提升泰国在亚太地区的作用。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '诗丽吉王后国家会议中心即将举办2022年亚太经合组织会议',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2022年11月8日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2022-11-08/the-queen-sirikit-national-convention-center-invites.pdf',
          th: '/files/press/2021-10-07/NCC-partners-FPT-Press-Release_TH_Final.pdf',
        },
      },
    ],
    description: {
      cn: `
      <p>泰国诗丽吉王后国家会议中心邀请泰国人民携手举办2022年亚太经合组织（APEC）活动，在支持当地商业扩张和推动国民经济发展的同时，提升泰国在亚太地区的作用。</p>
      <p class="center"><img src="/images/media/news/2022-11-08/apec.png" alt="" width="800" height="413" /></p>
      <p>曼谷 - 2022年11月7日 - 诗丽吉王后国家会议中心（QSNCC）宣布已准备好主办2022年度亚太经济合作组织（APEC 2022）会议，会议将于11月14日至19日举行，主题为 "开放、连接、平衡"。该会议旨在促进亚太地区21个经济体之间的自由贸易和投资、经济增长和发展以及合作，从而创造包容性和可持续的经济增长，为整个地区的人民带来利益和经济繁荣。</p>
      <p>“2022年10月15日新QSNCC正式开业后，我们已经作为几个国家级和世界级活动的举办场地，成功举办了这些活动，并受到其组织者和与会者的广泛称赞。” N.C.C.管理和发展有限公司首席执行官（CEO）Sakchai Phatrapreechakul先生说。</p>
      <p>“QSNCC有幸主办即将到来的2022年亚太经合组织论坛，并欢迎来自亚太地区21个经济体的领导人和代表，我们将在成为泰国的'客厅'和全体泰国人民的代表方面发挥关键作用。QSNCC已做好各方面准备，为所有与会人员提供热情的接待，以确保2022年亚太经合组织取得令人难忘的成就，成为泰国人民和国家的骄傲，" Sakchai先生说。</p>
      <p>QSNCC的定位是 "世界一流，超凡卓越的会展活动平台"，它已确认为举办2022年亚太经合组织会议做好了充分的准备，其30万平方米的面积和用于各种活动的尖端技术，充分展现了空间容量大，设施全面，足以支持世界级活动。QSNCC还提供符合国际标准的全方位服务，包括严格的安保、卫生和清洁措施，以及高质量、有营养的现场餐饮，还有一支在组织世界级活动方面具有丰富经验的专业团队，同时向国际观众展示符合泰国文化独特之美的真正泰国好客精神。所有这些因素都将是这次世界级活动成功的关键，并给来自整个亚太地区的代表和游客留下深刻的印象。</p>
      <p>重建后的QSNCC标志着泰国通过举办2022年亚太经合组织会议翻开了成功的新篇章，这与它作为众多高级别活动举办地的显赫历史相一致。在1991年的落成典礼上，QSNCC主办了世界银行集团和国际货币基金组织理事会的第46次年会。</p>
      <p>作为2022年亚太经合组织的东道国，泰国完全有能力提升其在加强亚太经济合作方面的作用，这一新兴地区被誉为未来几十年全球经济的重要组成部分。该活动还通过从所有相关部门，包括酒店、旅游、餐饮以及其他相关服务中创收，帮助推动泰国经济的发展。</p>
      <p>QSNCC热切希望与泰国人民携手，欢迎亚太经合组织领导人和代表在2022年11月14日至19日期间前来 "世界一流，超凡卓越的会展活动平台"。</p>
         `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2022-11-08/apec.png',
    imageSp: '/images/media/news/2022-11-08/apec.png',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'qsncc-hosts-13-exciting-thai-and-international-events',
    headline: {
      cn: 'QSNCC 10月成功举办13场国家及世界级展览和活动',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '10月，QSNCC迎来了十场大家错过又期待的热门展会，以及三场必将引人入胜的全新展会。',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC 10月成功举办13场国家及世界级展览和活动',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2022-11-24/qsncc-hosts-13-exciting-thai-and-international-events.pdf',
          th: '/files/press/2021-10-07/NCC-partners-FPT-Press-Release_TH_Final.pdf',
        },
      },
    ],
    description: {
      cn: `
      <p>10月，QSNCC迎来了十场大家错过又期待的热门展会，以及三场必将引人入胜的全新展会。</p>
      <p>QSNCC运营商N.C.C.管理与发展有限公司首席执行官Sakchai Pattaraprechakul先生表示：“我们非常荣幸地欢迎十项在QSNCC这里非常受欢迎的展会再次回归，包括2022年可持续发展博览会、2022年泰国图书博览会、2022年泰国移动博览会和2022年泰国游戏展等。三个新的展览将首次在QSNCC举行，包括2022年亚太区皮革展东盟博览会、2022年泰国加密博览会和2022年曼谷艺术双年展。新老会展组织方决定选择QSNCC作为今年10月13个主要活动的举办地，证明了他们对我们作为‘世界一流，超凡卓越的会展活动平台’的潜力的信心。他们相信QSNCC可以安排好所有的活动，并满足他们在技术、可持续性和安全方面的需求”。</p>
      <p><b>可持续发展博览会 （Sustainability Expo）</b></p>
      <p><b>9月26日 – 10月2日</b></p>
      <p>在东盟最大的可持续发展博览会上，了解来自领先国家和国际组织的多媒体展览和各种倡议和可持续发展指南。</p>
      <p><b>Fi Asia 2002 与 Vitafoods Asia 同期举办</b></p>
      <p><b>10月5日 – 10月7日</b></p>
      <p>Fi Asia 2022是亚洲最大的配料行业市场盛会，全球有600家主要参展商参展。Fi Asia 2022与Vitafoods Asia 2022合署办展，承诺提供更大、更好的见解，帮助您发展业务。</p>
      <p><b>2022年泰国加密博览会 （Thailand Crypto Expo 2022）</b></p>
      <p><b>10月6日 – 10月9日</b></p>
      <p>东南亚最大的加密博览会为您提供了绝佳的网络机会，让您与来自世界各地的加密大师和爱好者见面。了解更多基于加密货币的业务，并更好地了解数字资产和区块链技术。</p>
      <p><b>2022年泰国移动博览会 （Thailand Mobile Expo 2022）</b></p>
      <p><b>10月6日 – 10月9日</b></p>
      <p>2022年泰国移动博览会展示了尖端的智能手机、平板电脑和IT小工具、技术。享受领先手机品牌和服务商提供的独家促销优惠。</p>
      <p><b>2022年泰国书展 （Book Expo Thailand 2022）</b></p>
      <p><b>10月12日 – 10月23日</b></p>
      <p>2022年泰国书展的主题是“书城：大都会读者”，其理念是阅读是创建城市的第一步。来自300家出版商的700个展位上的数千本书将让图书爱好者们欣喜不已。</p>
      <p><b>2022年亚太皮革展欧盟博览会（APLF ASEAN 2022）</b></p>
      <p><b>10月19日 – 10月21日</b></p>
      <p>APLF汇集了皮革、材料和时尚行业，来自世界各地的300多家参展商，其中包括来自东盟国家制革行业的顶级皮革产品。</p>
      <p><b>2022年泰国电玩展 （Thailand Game Show 2022 ）</b></p>
      <p><b>10月21日 – 10月23日</b></p>
      <p>2022年泰国游戏展以“回归”为主题，在为期三天的活动中开展了各种活动。这个东盟最大的游戏节是所有游戏玩家、电子竞技运动员、游戏内容创作者和游戏开发者的聚集地。参观者可享受最新游戏、游戏设备和小工具的特别优惠。</p>
      <p><b>2022曼谷艺术双年展 （Bangkok Art Biennale 2022）</b></p>
      <p><b>2022年10月22日 – 2023年2月23日</b></p>
      <p>曼谷艺术双年展是自2017年举办以来的第三届，共有来自34个国家的73位地区和国际艺术家参加。2022年曼谷艺术双年展的主题是“混乱：平静”。200多件艺术作品在曼谷的12个文化和遗产地展出。</p>
      <p><b>2022年电子商务博览会 （e-Biz Expo 2022）</b></p>
      <p><b>10月27日 – 10月29日</b></p>
      <p>2022年电子商业博览会在“下一个无缝整合”的主题下，展示了在线商业解决方案、服务和创新的所有方面。</p>
      <p><b>2022年创新教育展 （EdTeX 2022）</b></p>
      <p><b>10月27日 – 10月29日</b></p>
      <p>EdTeX 2022的主题是“通过混合教育解决方案驱动你的潜力”，重点介绍教育创新和技术。发现来自100多家参展商的各种教育相关产品和创新，所有这些都旨在提高数字时代的教育质量。亮点包括一系列发人深省的研讨会。</p>
      <p><b>2022亚洲国际关爱展 （InterCare Asia 2022）</b></p>
      <p><b>10月27日 – 10月29日</b></p>
      <p>面向老年人和有健康意识的人的国际健康与健康博览会展示了消费者和企业级的产品和服务。关于老龄化社会、医疗保健和老年健康的研讨会成为亮点。</p>
      <p><b>2022年OEM制造商博览会 （OEM Manufacturer Expo 2022）</b></p>
      <p><b>10月27日 – 10月29日</b></p>
      <p>2022年OEM制造商博览会以“成为品牌拥有者的快速通道”为主题，侧重于增强数字时代的品牌认同。该活动的特色是来自制造业和企业的各种产品，包括健康和膳食补充剂、有机产品以及食品和饮料产品。</p>
      <p><b>第42届房屋和公寓展览 （42nd House and Condo Exhibition）</b></p>
      <p><b>10月27日 – 10月30日</b></p>
      <p>第42届房屋和公寓展展示了领先房地产开发商在不同地点的最全面的房地产项目。</p>

      `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2022-11-24/pic.jpg',
    imageSp: '/images/media/news/2022-11-24/pic.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'queen-sirikit-national-convention-center-qsncc-returns',
    headline: {
      cn: '新诗丽吉王后国家会议中心闪亮登场',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: '世界一流 超凡卓越的会展活动平台在其开业的第一个月就将举办八项令人惊叹的国内和国际活动',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '新诗丽吉王后国家会议中心闪亮登场',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2022年9月12日',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2022-09-12/qsncc20220912.pdf',
          th: '/files/press/2021-10-07/NCC-partners-FPT-Press-Release_TH_Final.pdf',
        },
      },
    ],
    description: {
      cn: `
      <p>世界一流 超凡卓越的会展活动平台在其开业的第一个月就将举办八项令人惊叹的国内和国际活动。</p>
      <p>诗丽吉王后国家会议中心（QSNCC）以全新的现代设计重新回到舞台中央，同时保留了泰国的特色。诗丽吉王后国家会议中心将自己定位为 "世界一流，超凡卓越的会展活动平台"，在其运营的第一个月就将迎来八项国内和国际活动。</p>
      <p class="center"><img src="/images/media/news/2022-09-12/qsncc20220912.jpg" alt="" width="800" height="413" /></p>
      <p><strong>QSNCC的运营商N.C.C.管理与发展有限公司的首席执行官Sakchai Pattarapreechakul先生</strong>说表示：“我们很荣幸地欢迎来自世界各地的组织者和游客。QSNCC的目标不仅仅是一个为 "会展 "活动提供便利的 "会议中心"，它将吸引更多类型的活动，并带来新的活动概况，提高泰国活动行业的声誉，将泰国定位为亚洲首选的活动目的地。"</p>
      <p>9月的8个展览活动包括：</p>
      <ol>
      <li><strong>1.重启泰国：亚洲展览更新（2022年9月13日）</strong><br/>该论坛使在泰国的国际组织和泰国的展览专业人员能够进行交流，并从区域发言人那里获得第一手信息。</li>
      <li><strong>2.亚洲可持续能源周（2022年9月14日至16日）</strong><br/>东盟最全面的可再生能源、能源效率、环境和电动车技术的国际展览和会议。</li>
      <li><strong>3.2022年亚洲电动车展（EVA）（2022年9月14日至16日）</strong><br/>泰国唯一的国际电动车技术会议和展览。</li>
      <li><strong>4.Boilex亚洲（BXA）和2022年亚洲泵与价值（PVA）（2022年9月14日至16日）</strong><br/>最全面、最专业的锅炉、压力容器、泵阀技术的国际展览和会议。</li>
      <li><strong>5.2022年泰国水资源博览会（THW）（2022年9月14日至16日）</strong><br/>泰国的国际展览和会议完全致力于水和污水处理技术。展会上有来自25个国家和国际展团的技术和解决方案。</li>
      <li><strong>6.2022年曼谷纸业博览会 （2022年9月14日至16日）</strong><br/>一个令人兴奋和创新的展览和会议，专注于亚洲的纸浆、纸张、包装和卫生纸行业。</li>
      <li><strong>7.泰国食品与酒店业博览会 （2022年9月21日至24日）</strong><br/>该活动为酒店业的各种需求提供产品和服务，从食品到旅游。</li>
      <li><strong>8.可持续发展博览会：良好的平衡，更好的世界</strong><br/>在东盟最大的可持续发展博览会上，发现多媒体展览和来自领先的国家和国际组织的广泛的倡议和可持续发展准则。</li>
      </ol>
      <p>除了为组织者和参观者提供世界一流的设施和服务外，QSNCC还拥有领先的零售品牌、餐厅、咖啡馆、便利店、运动器材商店、IT商店等，以满足各种生活方式。即使在没有会议展览的日子里，每个人都可以在QSNCC获得乐趣并度过高质量的时间。 </p>
      <p>诗丽吉王后国家会议中心已准备好以 “世界一流，超凡卓越的会展活动平台”的新形象亮相。欲了解更多信息，请联系请联系 www.qsncc.com.cn。或 marina.shi@ctvgb.com.cn。</p>
         `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2022-09-12/qsncc20220912.jpg',
    imageSp: '/images/media/news/2022-09-12/qsncc20220912.jpg',
    imageWebp: '',
    imageWebpSp: '',
    gallery: [],
  },
  {
    slug: 'qsncc-launches-a-hotel-partnership-program',
    headline: {
      cn: '泰国诗丽吉王后国家会议中心为打动全球商旅客人推出“酒店合作”计划',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC与曼谷及其它旅游省份的共13家领先酒店合作',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '泰国诗丽吉王后国家会议中心为打动全球商旅客人推出“酒店合作”计划',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2022年6月20日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2022-06-20/2022.06.20_Press_Release_QSNCC_Hotel_Partnership_CN.pdf',
          th: '/files/press/2021-10-07/NCC-partners-FPT-Press-Release_TH_Final.pdf',
        },
      },
    ],
    description: {
      cn: `<p class="center"><img src="/images/media/news/2022-06-20/QSNCC.jpg" alt="QSNCC launches a “Hotel Partnership” program to enhance service and impress global business travelers" width="800" height="413" /></p>
      <p><strong>泰国诗丽吉王后国家会议中心（QSNCC）日前宣布启动“酒店合作”计划，旨在将服务全新升级。QSNCC与曼谷及其它旅游省份的共13家领先酒店合作，为会议中心的活动组织和参与者提供特殊酒店礼遇及服务。作为今年 9 月即将全新开业的 QSNCC 的庆祝活动，客人可以期待卓越的体验和最高的满意度。</strong></p>
      <p>酒店合作伙伴计划是 QSNCC 以客户为中心的积极营销策略之一，旨在提供超越场地的服务。对于与会议中心合作的组织和参与者，QSNCC 和酒店合作伙伴提供各种优惠和专享礼遇，包括 QSNCC 和酒店之间的免费交通接驳、免费地铁或轻轨票、房间至机场往返接驳特价，在QSNCC 直接办理酒店入住手续、酒店忠诚奖励计划以及提早入住和延迟退房等特权。</p>
      <p>QSNCC运营商N.C.C.管理与发展有限公司首席执行官Sakschai Pattarapreechakul先生表示：“酒店合作计划的诞生是为了满足客户在活动区域、技术、安全环境和住宿方面的各种需求。”，“在第一阶段，我们与曼谷9家领先的酒店合作，可提供3500多间客房，并与旅游省份的4家酒店合作，提供约680间客房。此外，我们还制定了特殊套餐，以满足QSNCC客户的需求，并提供卓越的体验。”</p>
      <p>这一合作得到了曼谷和旅游省份领先酒店合作伙伴的支持，包括：</p>
      <ul class="a-list">
        <li>诗丽吉王后国家会议中心方圆 5 公里范围内的9家酒店（卫星酒店），即 1) 曼谷万豪侯爵皇后公园酒店2) 曼谷素坤逸希尔顿酒店3) 曼谷雅典娜豪华精选酒店4) 曼谷 W 酒店5) 曼谷大仓新颐饭店6) 曼谷艾美酒店 7) 曼谷素坤逸希尔顿逸林酒店 8) 曼谷辉盛阁摩德纳酒店9) 曼谷沙吞智选假日酒店</li>
        <li>旅游省份的4家酒店分别是 1) 苏梅岛喜来登度假村2) 苏梅岛美利亚酒店3) 苏梅岛万娜贝尔豪华精选度假村4) 清迈美利亚酒店。</li>
      </ul>
      <p>酒店合作伙伴计划致力于提高服务效率和客户满意度，还为即将在诗丽吉王后国家会议中心组织或参加活动的大量国际游客提供协助。自5月1日起，泰国政府取消了Test & Go入境限制，对受新冠肺炎严重阻碍的会展业的发展产生了积极影响。 </p>
      <p>欲了解更多有关诗丽吉王后国家会议中心合作酒店的特别优惠，请访问 www.qsncc.com.cn。</p>
         `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2022-06-20/QSNCC@2x.jpg',
    imageSp: '/images/media/news/2022-06-20/QSNCC@1x.jpg',
    imageWebp: '/images/media/news/2022-06-20/QSNCC@2x.webp',
    imageWebpSp: '/images/media/news/2022-06-20/QSNCC@1x.webp',
    gallery: [],
  },
  {
    slug: 'qsncc-enticed-the-global-market-at-imex-frankfurt-2022',
    headline: {
      cn: 'QSNCC在2022法兰克福国际会奖旅游展上吸引全球市场目光',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC通过2022年法兰克福国际会奖旅游展，向全球会议及活动组织者发出了热情的邀请',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC在2022法兰克福国际会奖旅游展上吸引全球市场目光',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2022年6月6日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2022-06-06/2022.06.06_Press_Release_QSNCC_IMEX_Frankfurt_CN.pdf',
          th: '/files/press/2021-10-07/NCC-partners-FPT-Press-Release_TH_Final.pdf',
        },
      },
    ],
    description: {
      cn: `<p class="center"><img src="/images/media/news/2022-06-06/QSNCC1.jpg" alt="QSNCC enticed the global market at IMEX Frankfurt 2022" width="808" height="539" /></p>
      <p><strong>泰国诗丽吉王后国家会议中心（QSNCC）最近参与了欧洲最大的行业展会—2022法兰克福国际会奖旅游展，并在展会上宣布，已为欢迎全球会议组织者做好了充分的准备。</strong></p>
      <p>这是QSNCC首次正式向国际市场展示其作为“世界一流，超凡卓越的会展活动平台”的新形象。2022法兰克福国际会奖旅游展的商业配对、目标客户会议以及在向外国媒体介绍新QSNCC的新闻发布会都对此给予了积极的反馈，这也预示着新 QSNCC 将于 9 月隆重开放。</p>
      <p class="center"><img src="/images/media/news/2022-06-06/QSNCC2.jpg" alt="QSNCC enticed the global market at IMEX Frankfurt 2022" width="808" height="539" /></p>
      <p>位于德国法兰克福的国际会奖旅游展（IMEX Frankfurt）是欧洲最重要的行业会议。IMEX面向活动组织机构、公司、商务旅行和营销专业人士，并从会议、活动和更有趣的产品演示中提出新的想法。来自170多个国家/地区的约10,000名访客、目的地代表、场馆代表和供应商，汇集了规划者激发想象力和商业成功所需的所有元素。</p>
      <p class="center"><img src="/images/media/news/2022-06-06/QSNCC3.jpg" alt="QSNCC enticed the global market at IMEX Frankfurt 2022" width="808" height="539" /></p>
         `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2022-06-06/Press-20220606@2x.jpg',
    imageSp: '/images/media/news/2022-06-06/Press-20220606@1x.jpg',
    imageWebp: '/images/media/news/2022-06-06/Press-20220606@2x.webp',
    imageWebpSp: '/images/media/news/2022-06-06/Press-20220606@1x.webp',
    gallery: [],
  },
  {
    slug: 'qsncc-welcomes-the-return-of-thailand-game-show-2022',
    headline: {
      cn: 'QSNCC欢迎“2022 年泰国游戏展”回归',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC可承接从会展到生活方式的各种类型活动',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: 'QSNCC 举办“超越会奖”活动，迎接即将到来的 10 月东南亚最大游戏节',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2022年4月27日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2022-04-27/2022.04.27_Press_Release_TGS_22_MICE_version_CN.pdf',
          th: '/files/press/2021-10-07/NCC-partners-FPT-Press-Release_TH_Final.pdf',
        },
      },
    ],
    description: {
      cn: `<p class="center"><img src="/images/media/news/2022-04-27/Press-20220427-hero@2x.jpg" alt="QSNCC Welcomes the Return of Thailand Game Show 2022" width="808" height="574" /></p>
      <p><strong>泰国诗丽吉王后国家会议中心 (QSNCC) 通过即将在 2022 年 10 月 21 日至 23 日举办的以“回归”为主题的“2022 年泰国游戏展”，推动其成为“世界一流，超凡卓越的会展活动平台”。</strong></p>
      <p>由泰国游戏业巨头True Group旗下的“Online Station”和SHOW NO LIMIT 有限责任公司主办，今年的泰国游戏展将举办丰富多彩的活动，包括两个新的“NFT游戏与元宇宙”专区，开启元宇宙和NFT游戏新趋势加“商机配对”，为所有游戏相关企业创造商机。</p>
      <p class="center"><img src="/images/media/news/2022-04-27/TGS_pic1.jpg" alt="QSNCC Welcomes the Return of Thailand Game Show 2022" width="808" height="574" /></p>
      <p>负责QSNCC运营管理的<strong>N.C.C.管理发展有限公司执行副总裁 Sutichai Bunditvorapoom先生</strong>表示:“我们很高兴也很自豪地宣布泰国游戏展将在诗丽吉王后国家会议中心回归并举办。新的 QSNCC 以成为“世界一流，超凡卓越的会展活动平台”为愿景，可举办从会议奖励到生活方式的各种活动，并将给所有与会者留下不可磨灭的愉悦印象。”</p>',
      <p class="center"><img src="/images/media/news/2022-04-27/BALM01.jpg" alt="QSNCC Welcomes the Return of Thailand Game Show 2022" width="808" height="574" /></p>
      <p>新的 QSNCC 将比以前大五倍，总建筑面积约30万平方米。QSNCC的基础设施已搭建完毕，以适应高速互联网的使用，包括即将到来的5G技术。新的 QSNCC 与城市捷运连通，可轻松抵达。它还提供3,000个宽敞的室内停车位。此外，在“Bangkok’s Active Lifestyle Mall”地下还开发了一个宽敞的零售空间，参会者可以在这里消费享受包括便利店、咖啡店、餐厅和其它服务在内的100多个领先零售品牌。</p>
      <p class="center"><img src="/images/media/news/2022-04-27/NewERA_Increase01.jpg" alt="QSNCC Welcomes the Return of Thailand Game Show 2022" width="808" height="574" /></p>
      <p><strong>True Digital Group Online Station 董事总经理 Torboon Puangmaha 博士</strong>表示：“过去 17 年，True Group 旗下领先的游戏数字媒体公司和第一网络影响力Online Station 成功得举办了泰国游戏展盛会。它已发展成为东南亚最大的游戏节。今年，Online Station 与 SHOW NO LIMIT有限责任公司合作，以“回归”为主题，重振这一标志性活动。此次2022 年的展会引入了两个新区域：NFT 和元宇宙区域，它利用了加密货币的日益普及，以及连接游戏发行商、开发商、游戏相关媒体和代理商的商业配对区，以增加商机。2022年泰国电玩展 预计将吸引超过 180,000 名游戏玩家和对此感兴趣的个人，比上届活动增加 28.83%，并产生 3 亿泰铢的收入。TGS 将为力求将泰国打造为东南亚游戏中心做出重大贡献。此外，它将鼓励与游戏相关的职业和企业，如游戏玩家、电竞选手、游戏内容创作者和游戏开发者加入进来，从而提高他们的国际知名度。”</p>
      <p class="center"><img src="/images/media/news/2022-04-27/GFloor01.jpg" alt="QSNCC Welcomes the Return of Thailand Game Show 2022" width="808" height="574" /></p>
      <p><strong>SHOW NO LIMIT有限责任公司首席执行官Pongsuk Hiranprueck先生</strong>透露，“在此次活动中，与知名艺术家和影响力人士合作的泰国游戏节目NFT的第一个集合将作为“稀有物品”发布，供粉丝购买。我们打算在未来制作这些独一无二的泰国游戏节目NFT的其他版本。此外，被视为TGS核心的游戏区和生活区将继续成为此次活动的亮点。今年的设施将扩大至67个展位，以容纳来自参与开发商和公司。与会者将看到大量新游戏、游戏装备、信息技术产品，当然还有cosplayers。传统的TGS角色扮演比赛也将在活动中举行，每月进行一次试镜。杰出的cosplayers将角逐30万泰铢的现金奖励。另一个吸引人的地方是“见面会”活动，该活动将以名人玩家为主角，vTuber首次出现在主舞台上。今年，TGS选择搬迁到一个更大的场馆，以容纳大量观众，缓解活动期间的拥堵，提供更便捷的交通，并确保这场著名的演出能够正常“回归”。因此，活动将在泰国诗丽吉王后国家会议中心举行，该中心也是2022年泰国游戏展的合作伙伴。”</p>
      <p class="center"><img src="/images/media/news/2022-04-27/2ndFloor01.jpg" alt="QSNCC Welcomes the Return of Thailand Game Show 2022" width="808" height="574" /></p>
      <p>2022 年泰国电玩展为期三天，精彩不容错过。该活动将于 2022 年 10 月 21 日星期五至 2022 年 10 月 23 日星期日上午 10 点至晚上 8 点在诗丽吉王后国家会议中心的一楼3-4号展览厅举行。具体门票信息可登录Facebook “<a href="https://facebook.com/thailandgameshow" target="_blank">thailandgameshow</a>” 了解.</p>
         `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2022-04-27/Press-20220427-hero@2x.jpg',
    imageSp: '/images/media/news/2022-04-27/Press-20220427-hero@1x.jpg',
    imageWebp: '/images/media/news/2022-04-27/Press-20220427-hero@2x.webp',
    imageWebpSp: '/images/media/news/2022-04-27/Press-20220427-hero@1x.webp',
    gallery: [],
  },
  {
    slug: 'global-international-organizers-visit-the-new-qsncc',
    headline: {
      cn: '全球国际会议组织者参观诗丽吉王后国际会议中心新址',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'QSNCC迎接了专业会议组织者的代表团前来会议中心参观',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '全球国际会议组织者参观诗丽吉王后国际会议中心新址',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2022-03-29/2022.03.29_News-20Release_QSNCC-MICE-FAM-TRIP_CH.pdf',
          th: '/files/press/2021-10-07/NCC-partners-FPT-Press-Release_TH_Final.pdf',
        },
      },
    ],
    description: {
      cn: `<p class="center"><img src="/images/media/news/2022-03-29/fam-trip@2x.jpg" alt="Global International Organizers Visit the New QSNCC" width="808" height="508" /></p>
      <p>近日，N.C.C.管理发展有限公司，即泰国诗丽吉王后国家会议中心（QSNCC）管理机构，其首席执行官Sakchai Pattarapreechakul先生迎接了来自亚洲、澳大利亚、欧洲和美洲的国际协会、协会管理公司和专业会议组织者的代表团前来会议中心参观。该代表团参观了尚未完工的建筑工地，了解装修的进展情况。QSNCC的重装工作现已完成了 80% 以上，计划于 2022 年 9 月开始投入运营。</p>
      <p>全新的QSNCC以“世界一流，超凡卓越的会展活动平台”为愿景，拥有超过 300,000 平方米的建筑面积，是其前身的 5 倍。 QSNCC是一个适合举办各种活动的多功能场所。这里最先进的设施与现代的设计传递了泰式风格的真谛，旨在为当下和未来提供灵活的活动解决方案。</p>
      <p class="center"><img src="/images/media/news/2022-03-29/fam-trip-2@2x.jpg" alt="Global International Organizers Visit the New QSNCC" width="808" height="539" /></p>
      <p>今年，泰国会议展局（TCEB）组织了“2022年泰国MICE考察”，其中包括参观QSNCC项目。此行旨在鼓励感兴趣的外国组织者在泰国举办活动，令他们感到安心，并突出泰国举办国际会议的能力和一切准备就绪的情况。</p>
         `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2022-03-29/fam-trip@2x.jpg',
    imageSp: '/images/media/news/2022-03-29/fam-trip@1x.jpg',
    imageWebp: '/images/media/news/2022-03-29/fam-trip@2x.webp',
    imageWebpSp: '/images/media/news/2022-03-29/fam-trip@1x.webp',
    gallery: [],
  },
  {
    slug: 'the-revived-qsncc-is-ready-to-reopen-for-apec-in-september-2022',
    headline: {
      cn: '升级改造后的诗丽吉王后国家会议中心即将在2022年9月开放，喜迎APEC会议',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม',
    },
    topic: {
      cn: 'N.C.C管理与发展有限公司近日宣布，诗丽吉王后国家会议中心 (QSNCC) 已被选为 2022 年亚太经合组织 (APEC) 峰会和所有与 APEC 框架相关会议的全年举办地',
      th: 'อินฟอร์มา มาร์เก็ตส์ ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน',
    },
    title: {
      cn: '升级改造后的诗丽吉王后国家会议中心即将在2022年9月开放，喜迎APEC会议',
      th: 'เอ็น.ซี.ซี.ฯ ปลื้ม ยอดจองพื้นที่ล้นหลาม<br/>หลังเปิดตัวโครงการศูนย์ฯ สิริกิติ์โฉมใหม่ มั่นใจจะพร้อมให้บริการกันยายน 2565',
    },
    is_long_title: true,
    date: {
      cn: '2022年2月10日，曼谷',
      th: 'กรุงเทพฯ, 7 ตุลาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2022-02-10/2022.02.10_Press-Release-QSNCC_APEC-CN.pdf',
          th: '/files/press/2021-10-07/NCC-partners-FPT-Press-Release_TH_Final.pdf',
        },
      },
    ],
    description: {
      cn: `<p class="center"><img src="/images/media/news/2022-02-10/Press-Release-QSNCC_APEC@2x.jpg" alt="The revived QSNCC is ready to reopen for APEC in September 2022" width="808" height="522" /></p>
      <p>N.C.C管理与发展有限公司近日宣布，诗丽吉王后国家会议中心 (QSNCC) 已被选为 2022 年亚太经合组织 (APEC) 峰会和所有与 APEC 框架相关会议的全年举办地。QSNCC随时欢迎来自21个经济体及其他国家的代表访问泰国，并将支持APEC主办以“开放  连接  平衡”为主题的会议。</p>
      <p>三十多年来，QSNCC 一直提供全面的国际会议服务。它目前正在重建阶段，以提供比原来大五倍的空间和各种零售区域，以便落成后为游客提供便利。升级后的“诗丽吉王后国家会议中心”拥有独特的外观和室内设计，体现了QSNCC 传统精髓融入当今的身份概念。 作为泰国终极鼓舞人心的世界级活动平台，它确保在国际上得到进一步的了解和认可。</p>
      <p><strong>N.C.C管理与发展有限公司主席 Sakchai Pattarapreechakul 先生</strong>, 表示：“我们代表诗丽吉王后国家会议中心的管理团队，很荣幸受到泰国政府APEC组织团队的信任，选择我们为其准备全方位的会议和活动解决方案。新的QSNCC将能够无限制地举办各种类型的活动，拥有尖端的技术和完善的设施，保证与其他国家的全球顶级活动场地的标准兼容。QSNCC同时具有独特的身份，建筑和景观优美、突出，与周边区域和谐融入，展现了泰国本土文化与国际特色的完美结合。此外，凭借我们专业团队的业务知识和经验，我们确信升级后的QSNCC将为APEC 2022的会议组织者和参与者提供优质的服务。”</p>
      <p>新的QSNCC将成为泰国第一个能够突破活动举办限制的会议中心。凭借灵活的空间设计和现代施工技术，大跨度桁架结构或无柱空间有助于在室内创造更大的空间。因此，大厅面积超过22,500平方米，可无限容纳各类活动。它还旨在最大限度地提高空间的容量，包括两个总面积超过45,000平方米的主展厅，可同时举办多个会议或活动。QSNCC是泰国唯一具备这些能力的会议、研讨会和展览中心。此外，它亦是唯一位于曼谷市中心的会议中心，可直接通往大都会捷运 (MRT)。</p>
      <p>在技术和设施方面，QSNCC 已经准备好基础设施以适应泰国高速互联网的使用，包括即将到来的 6G，从而能够有效地支持虚拟和混合活动。同时QSNCC 还建立了非接触式访问系统和智能事件平台管理系统，以控制服务的提供。此外，它还采用符合国际质量标准的顶级安全技术，并考虑到参会者的生命安全。</p>
      <p><strong>Sakchai Pattarapreechakul</strong>先生补充道：“升级后的 QSNCC 作为‘为所有人提供终极鼓舞人心的世界级活动平台’，必将成为促进泰国经济增长的新活动目的地。”</p>
      <p>QSNCC是第一个也是唯一一个获得能源与环境设计领导力 (LEED) 银牌认证的会议中心。他们使用了25%的可回收产品和75%的可回收产品、太阳能电池和节能设备等建筑环保材料，构成了可持续经营。诗丽吉王后国家会议中心总活动空间达78,500平方米，设有两个超过45,000平方米的主展厅、两个近10,000平方米的大型会议厅和50间灵活的会议室。它可通往大都会捷运 (MRT) 和 2,700 个室内地下停车位，使QSNCC 成为 CBD 最便捷的中心。改造后的 QSNCC 将于 2022 年 9 月开业。</p>
         `,
      th: `<p><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC" width="808" height="606" /></p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เผยโครงการ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” โฉมใหม่ ได้รับการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าทั้งในประเทศไทยและต่างประเทศ ทำให้ปัจจุบันมียอดจองเข้าใช้พื้นที่เป็นจำนวนมาก ล่าสุด สามารถปิดดีลบริษัท อินฟอร์มา มาร์เก็ตส์ ประเทศไทย จำกัด ผู้นำธุรกิจการจัดงานระดับโลก ยืนยันจัดงานทั้งสิ้นจำนวน  6 งาน ประกอบด้วย Food Ingredient Asia, Food & Hotel Thailand, ASEAN Sustainable Energy, Pump and Valves Asia, Thai Water Expo, และ Tissue and Paper Bangkok โดยงานทั้งหมดจะจัดขึ้นในปี 2565</p>
      <p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เดินหน้าพัฒนาโครงการศูนย์การประชุมแห่งชาติสิริกิติ์ให้แล้วเสร็จตามเวลาที่กำหนด โดยได้ว่าจ้างให้ บริษัท เฟรเซอร์ส พร็อพเพอร์ตี้ (ประเทศไทย) จำกัด (มหาชน) เป็นผู้พัฒนาคอนเซ็ปต์ และบริหารงานก่อสร้างโครงการศูนย์ฯ สิริกิติ์โฉมใหม่แห่งนี้ เนื่องด้วยเล็งเห็นถึงศักยภาพและความเชี่ยวชาญในด้านการพัฒนาอสังหาริมทรัพย์ครบวงจร และมีโครงการที่ประสบความสำเร็จหลายแห่ง อาทิ “สามย่านมิตรทาวน์” ที่ทำให้สามย่านกลายเป็นจุดหมายใหม่ของกรุงเทพฯ และ “เอฟวายไอ เซ็นเตอร์” ซึ่งพลิกโฉมทำเลย่านคลองเตยอย่างสิ้นเชิง จึงมั่นใจว่าโครงการจะแล้วเสร็จตามมาตรฐานภายในกรอบเวลาที่กำหนด บริษัทฯ เชื่อมั่นว่าการปรับโฉมใหม่ในครั้งนี้ จะทำให้ศูนย์ฯ สิริกิติ์พร้อมขึ้นแท่นเป็น The Ultimate Inspiring World Class Event Platform for All ที่สามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
      <p class="center"><img src="/images/media/news/2021-10-07/NCC-President.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
      <p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “หลังจากการเผยโฉมใหม่โครงการศูนย์ฯ สิริกิติ์ในเดือนสิงหาคมที่ผ่านมา บริษัทฯ ได้รับความสนใจและการการตอบรับที่ดีเยี่ยมจากกลุ่มลูกค้าอย่างต่อเนื่อง ประกอบด้วยลูกค้าเก่าที่ต้องการกลับมาจัดงานด้วยมาตรฐานความสำเร็จของอิเวนต์ต่างๆ ที่ได้สร้างไว้ในอดีต และลูกค้าใหม่ที่ต้องการใช้บริการสถานที่จัดงานที่ได้มาตรฐานระดับสากลใจกลางกรุงเทพฯ นอกจากนี้ ยังได้ขยายขีดความสามารถในการให้บริการที่ครอบคลุมมากยิ่งขึ้น พร้อมเพิ่มความยืดหยุ่นในการตอบโจทย์ทุกความต้องการ ทำให้มีลูกค้าจำนวนมากยื่นจองพื้นที่ล่วงหน้าเพื่อจัดงานประชุมและสัมมนา โดยปัจจุบัน บริษัทฯ ได้ทยอยทำสัญญากับลูกค้าจำนวนหนึ่งเรียบร้อยแล้ว”</p>
      <p>โครงการศูนย์การประชุมแห่งชาติสิริกิติ์โฉมใหม่จะเพิ่มศักยภาพด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า คิดเป็นพื้นที่รวมกว่า 280,000 ตารางเมตร มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง เพิ่มที่จอดรถให้สามารถรองรับได้มากกว่า 2,700 คัน เปิดทางเชื่อมกับรถไฟฟ้า MRT สถานีศูนย์การประชุมแห่งชาติสิริกิติ์ เพื่ออำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน ภายใต้งบประมาณในการพัฒนาโครงการรวมกว่า 15,000 ล้านบาท ตอกย้ำการเป็นสุดยอดศูนย์การประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย</p>
      <p>สามารถสอบถามรายละเอียดพื้นที่ได้ที่ ฝ่ายขาย โทร. 0 2229 3111 หรือ อีเมล sales@qsncc.com</p>`,
    },
    image: '/images/media/news/2022-02-10/Press-20220210-hero@2x.jpg',
    imageSp: '/images/media/news/2022-02-10/Press-20220210-hero@1x.jpg',
    imageWebp: '/images/media/news/2022-02-10/Press-20220210-hero@2x.webp',
    imageWebpSp: '/images/media/news/2022-02-10/Press-20220210-hero@1x.webp',
    gallery: [],
  },
  {
    slug: 'ncc-introduces-balm-in-the-new-qsncc-targeting-health-and-fitness-enthusiasts',
    headline: {
      cn: 'NCC在新诗丽吉王后国家会议中心引入BALM，旨在吸引健康和健身爱好者',
      th: 'โฉมใหม่ศูนย์การประชุมแห่งชาติสิริกิติ์ พร้อมเปิดให้บริการกันยายนปี 65',
    },
    topic: {
      cn: '改造后的QSNCC包括一个以“曼谷活力生活方式购物中心”为概念开发的新零售购物中心“BALM”',
      th: 'บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด ประกาศรุกตลาดธุรกิจไมซ์ (MICE) ประเทศไทยครั้งใหม่',
    },
    title: {
      cn: 'NCC在新诗丽吉王后国家会议中心引入BALM — 曼谷首家活力生活方式购物中心，旨在吸引健康和健身爱好者',
      th: 'โฉมใหม่ศูนย์การประชุมแห่งชาติสิริกิติ์ พร้อมเปิดให้บริการกันยายนปี 65 ขยายพื้นที่ใหญ่กว่าเดิมถึง 5 เท่า พร้อมรับผู้เข้าร่วมงานมากกว่า 100,000 คนต่อวัน ตอกย้ำการเป็นศูนย์ประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย มุ่งเป้าสู่การเป็น The Ultimate Inspiring World Class Event Platform for All',
    },
    is_long_title: true,
    date: {
      cn: '2022年1月25日，曼谷',
      th: 'BANGKOK, 17 สิงหาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2022-01-25/2022.01.25-Press-Release_NCC-introduces-BALM-Bangkok-First-Active-Lifestyle-Mall-in-the-new-QSNCC_CN.pdf',
          th: '/files/press/2021-08-17/QSNCC Press Release_TH_19.08.2021.pdf',
        },
      },
    ],
    description: {
      cn: `<p class="center"><img src="/images/media/news/2022-01-25/Photo-QSNCC-Retail-BALM-Concept-04@2x.jpg" alt="NCC introduces BALM in the new QSNCC" width="808" height="454" /></p>
      <p><strong>N.C.C.管理与发展有限公司</strong>旨在将诗丽吉王后国家会议中心 (QSNCC) 打造为“终极鼓舞人心的世界级活动平台”。改造后的QSNCC包括一个以“曼谷活力生活方式购物中心”为概念开发的新零售购物中心“BALM”，以此吸引和服务健康和健身爱好者、城市工人和家庭。落成后的BALM拥有超过 100 家领先的零售品牌、餐厅和便利设施。</p>
      <p class="center"><img src="/images/media/news/2022-01-25/Photo-QSNCC-Retail-BALM-Concept-07@2x.jpg" alt="NCC introduces BALM in the new QSNCC" width="808" height="455" /></p>
      <p>新QSNCC以其满足活跃城市居民需求的位置和价值主张而著称。此外，通过捷运与QSNCC的连接，可以轻松到达购物中心。它还被占地720,000平方米的班佳齐蒂森林公园所环绕，这是曼谷运动爱好者经常光顾的新绿肺。</p>
      <p class="center"><img src="/images/media/news/2022-01-25/Photo-QSNCC-Retail-BALM-Concept-03@2x.jpg" alt="NCC introduces BALM in the new QSNCC" width="808" height="454" /></p>
      <p>重建后的QSNCC 零售空间从 7,200 平方米扩大到 11,000 平方米。它被划分为不同的区域，包括食品和饮料、活动支持和“积极的生活方式”等功能区。此外，泰国知名的运动配饰品牌旗舰店也将落户于此。</p>
      <p class="center"><img src="/images/media/news/2022-01-25/Mr.-Sakchai-Pattarapreechakul,-Managing-Director-of-NCC-Management-and-Development@2x.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development" width="808" height="539" /></p>
      <p><strong>N.C.C.管理与发展有限公司主席 Sakchai Pattarapreechakul 先生</strong> 表示：“凭借我们为各类活动提供过的全方位服务的经验和能力，QSNCC 将成为亚洲全新的活动平台目的地。全新开发的 QSNCC 预计在 2022 年 9 月重新开放，每年将吸引超过1300万游客。为了向游客提供更广泛的服务，我们计划将零售空间扩大 30%。</p>
      <p class="center"><img src="/images/media/news/2022-01-25/Photo-QSNCC-Retail-BALM-Concept-05@2x.jpg" alt="NCC introduces BALM in the new QSNCC" width="808" height="454" /></p>
      <p>受NCC 委托开发和租赁 QSNCC 的零售空间，Frasers地产（泰国）上市有限公司将在Thiranant Kornsritipa 女士的带领下，借助其在 Samyan Mitrtown 和 Silom Edge 零售项目上的专业知识和经验，来带动QSNCC零售空间的人气。</p>
      <p class="center"><img src="/images/media/news/2022-01-25/woman.jpg" alt="Ms. Thiranant Kornsritipa, Executive Vice President of Retail Business Development of Frasers Property Commercial (Thailand)" width="808" height="539" /></p>
      <p><strong>Frasers地产商业（泰国）零售业务发展执行副总裁Thiranant Kornsritipa女士</strong>说：“很荣幸受到NCC的信任，将我们的专业知识运用到该项目。以“曼谷活力生活方式购物中心”为概念的“BALM”零售空间将服务于现代都市人的生活。凭借其位于 QSNCC 内的便利位置，客户可以轻松从捷运和班佳齐蒂森林公园进入零售空间。这将吸引更多样化的客户——组织者、访客和那些热衷体育锻炼和健康生活方式的人。我们相信，BALM将成为曼谷城市居民的聚集地。</p>
      <p class="center"><img src="/images/media/news/2022-01-25/Photo-QSNCC-Retail-BALM-Concept-01@2x.jpg" alt="NCC introduces BALM in the new QSNCC" width="808" height="454" /></p>
      <p>该项目已收到了来自多个知名零售品牌的租赁咨询。我们正在筛选知名的餐厅和零售商潜在租户。目前已经完成了 20% 的零售空间的租赁工作，预计到今年第一季度已租赁空间将增加到 40%。</p>
      <p class="center"><img src="/images/media/news/2022-01-25/Photo-QSNCC-Retail-BALM-Concept-08@2x.jpg" alt="NCC introduces BALM in the new QSNCC" width="808" height="454" /></p>`,
      th: `<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1.jpg" alt="QSNCC" width="808" height="454" /></p>
<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด ประกาศรุกตลาดธุรกิจไมซ์ (MICE) ประเทศไทยครั้งใหม่หลังความสำเร็จในอดีตตลอดระยะเวลากว่า 30 ปี ของการเปิดให้บริการศูนย์การประชุมแห่งชาติสิริกิติ์ พร้อมทุ่มงบกว่า 15,000 ล้านบาท เดินหน้าพัฒนาสุดยอดศูนย์ประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย เพิ่มศักยภาพของโครงการด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า พร้อมเพิ่มพื้นที่รีเทลเพื่ออำนวยความสะดวกและรองรับผู้ที่เข้ามาใช้บริการ โดยรักษาชื่อ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” ซึ่งเป็นที่รู้จักและยอมรับในธุรกิจไมซ์ระดับนานาชาติ มั่นใจการพัฒนาปรับปรุงศูนย์ฯ สิริกิติ์ ครั้งนี้ จะสามารถรองรับการจัดงานประชุมหรืออิเวนต์ระดับเวิลด์คลาสได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
<p><img src="/images/media/news/2021-08-17/Mr.Panote-Sirivadhanabhakdi.jpg" alt="นายปณต สิริวัฒนภักดี กรรมการ บริษัท ทีซีซี แอสเซ็ทส์ (ประเทศไทย) จำกัด" width="808" height="454" /></p>
<p>นายปณต สิริวัฒนภักดี กรรมการ บริษัท ทีซีซี แอสเซ็ทส์ (ประเทศไทย) จำกัด กล่าวว่า “ภายใต้สถานการณ์การแพร่ระบาดของโควิด-19 ที่เกิดขึ้นทั่วโลก แต่บริษัทฯ ยังเล็งเห็นความสำคัญในการเดินหน้าพัฒนาโครงการ “ศูนย์การประชุมแห่งชาติสิริกิติ์” (Queen Sirikit National Convention Center หรือ QSNCC)  ให้เสร็จสมบูรณ์ตามแผนที่วางไว้ สอดคล้องกับแผนการลงทุนระยะยาวของบริษัทฯ ซึ่งเป็นไปตามวิสัยทัศน์และความมุ่งมั่นที่จะพัฒนาโครงการศูนย์ประชุมระดับเวิลด์คลาสแห่งใหม่ของเอเชีย บริษัทฯ เชื่อมั่นว่าด้วยศักยภาพของประเทศไทย ที่มีจุดแข็งหลายด้าน ไม่ว่าจะเป็นทำเลที่ตั้งที่เป็นศูนย์กลางทางการค้าของภูมิภาค การมีสิ่งอำนวยความสะดวกและสาธารณูปโภคที่ครบครัน พร้อมด้วยกลุ่มคู่ค้าทางธุรกิจและซัพพลายเออร์ที่มีคุณภาพ อีกทั้งยังมีศิลปวัฒนธรรมอันเป็นเอกลักษณ์ และมีการสืบสาน รักษา ต่อยอดให้เข้ากับยุคสมัยปัจจุบัน จึงทำให้บริษัทฯ มั่นใจว่า ศูนย์ฯ สิริกิติ์ จะเป็น The Ultimate Inspiring World Class Event Platform for All ที่ได้รับความสนใจจากกลุ่มลูกค้านานาชาติ และจะสามารถดึงดูดเม็ดเงินเข้ามาในประเทศไทยเพื่อขับเคลื่อนเศรษฐกิจให้เติบโตขึ้นได้อย่างแน่นอน”</p>
<p class="center"><img src="/images/media/news/2021-08-17/Panote-Sirivadhanabhakdi_1.jpg" alt="นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด" width="600" height="600" /></p>
<p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “ศูนย์การประชุมแห่งชาติสิริกิติ์ ถือเป็นหัวใจของการเริ่มต้นอุตสาหกรรมไมซ์ในประเทศไทย โดยตลอดระยะเวลากว่า 30 ปีที่ผ่านมา ศูนย์ฯ สิริกิติ์ เป็นสถานที่ที่บันทึกเรื่องราวความทรงจำของงานประชุมและอิเวนต์สำคัญๆ ทั้งในระดับชาติและนานาชาติกว่า 20,000 งาน ด้วยประสบการณ์มากกว่า 3 ทศวรรษ กอปรกับบุคลากรที่มีความรู้ความชำนาญ และมีความเป็นมืออาชีพ เราเชื่อมั่นว่าศูนย์ฯ สิริกิติ์ โฉมใหม่ จะสามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ในทุกรูปแบบได้อย่างแน่นอน” </p>
<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1-1.jpg" alt="QSNCC" width="808" height="454" /></p>
<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1-2.jpg" alt="QSNCC" width="808" height="454" /></p>
<p>ศูนย์ฯ สิริกิติ์ โฉมใหม่ มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง นอกจากนี้ศูนย์ฯ สิริกิติ์ ยังเชื่อมต่อกับสถานีรถไฟฟ้าใต้ดิน และมีที่จอดรถภายในอาคารรองรับได้มากกว่า 2,700 คัน อำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน  ขณะนี้ศูนย์ฯ สิริกิติ์ ได้เริ่มเปิดจองพื้นที่และได้รับการตอบรับที่ดีจากผู้จัดงานเป็นอย่างมาก</p>
<p><strong>เตรียมพบกับศูนย์ฯ สิริกิติ์ โฉมใหม่ ที่จะมาสร้างความคึกคักและสีสันให้กับวงการไมซ์ กันยายน 2565 นี้</strong></p>
<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1-3.jpg" alt="QSNCC" width="808" height="454" /></p>`,
    },
    image: '/images/media/news/2022-01-25/Press-20220125@2x.jpg',
    imageSp: '/images/media/news/2022-01-25/Press-20220125@1x.jpg',
    imageWebp: '/images/media/news/2022-01-25/Press-20220125@2x.webp',
    imageWebpSp: '/images/media/news/2022-01-25/Press-20220125@1x.webp',
    gallery: [],
  },
  {
    slug: 'qsncc-create-a-new-experience-with-a-unique-signature-scent',
    headline: {
      cn: 'QSNCC 和 PAÑPURI 以独特的标志性香味创造全新体验，迎接今年9月的游客',
      th: 'โฉมใหม่ศูนย์การประชุมแห่งชาติสิริกิติ์ พร้อมเปิดให้บริการกันยายนปี 65',
    },
    topic: {
      cn: 'N.C.C.管理与发展有限公司作为新诗丽吉王后国家会议中心（QSNCC）的管理方，与泰国的健康生活方式品牌PAÑPURI联手，为QSNCC创造出独特的香味',
      th: 'บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด ประกาศรุกตลาดธุรกิจไมซ์ (MICE) ประเทศไทยครั้งใหม่',
    },
    title: {
      cn: 'QSNCC 和 PAÑPURI 以独特的标志性香味创造全新体验，迎接今年9月的游客',
      th: 'โฉมใหม่ศูนย์การประชุมแห่งชาติสิริกิติ์ พร้อมเปิดให้บริการกันยายนปี 65 ขยายพื้นที่ใหญ่กว่าเดิมถึง 5 เท่า พร้อมรับผู้เข้าร่วมงานมากกว่า 100,000 คนต่อวัน ตอกย้ำการเป็นศูนย์ประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย มุ่งเป้าสู่การเป็น The Ultimate Inspiring World Class Event Platform for All',
    },
    is_long_title: true,
    date: {
      cn: '2022年1月20日，曼谷',
      th: 'BANGKOK, 17 สิงหาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2022-01-20/2022.01.20_New Release_QSNCC_PANPURI_CH.pdf',
          th: '/files/press/2021-08-17/QSNCC Press Release_TH_19.08.2021.pdf',
        },
      },
    ],
    description: {
      cn: `<p class="center"><img src="/images/media/news/2022-01-20/QSNCC_PANPURI@2x.jpg" alt="QSNCC and PAÑPURI create a new experience with a unique signature scent to welcome visitors this September" width="808" height="590" /></p>
      <p>N.C.C.管理与发展有限公司作为新诗丽吉王后国家会议中心（QSNCC）的管理方，与泰国的健康生活方式品牌PAÑPURI联手，为QSNCC创造出独特的香味：为所有人打造终极鼓舞人心的世界级活动平台。</p>
      <p class="center"><img src="/images/media/news/2022-01-20/QSNCC@2x.jpg" alt="QSNCC and PAÑPURI create a new experience with a unique signature scent to welcome visitors this September" width="808" height="539" /></p>
      <p>NCC与Puri有限公司的合作，为QSNCC创造独特的香味。该公司以最清洁的配方展示了最好的标志性泰国香水，同时努力做到完全可持续发展和环保，赢得了国际赞誉。该品牌的承诺与NCC在管理 QSNCC 时重点关注的环境保护和可持续发展的主要政策相一致。</p>
      <p class="center"><img src="/images/media/news/2022-01-20/Mr.Sutichai-Bunditvorapoom@2x.jpg" alt="Sutichai Bunditvorapoom, Executive Vice President of N.C.C. Management & Development Co., Ltd." width="808" height="590" /></p>
      <p style="text-align: center;"><small>N.C.C.管理与发展有限公司行政副总裁Sutichai Bunditvorapoom</small></p><br />
      <p>Puri公司以“感受全新QSNCC的香味”为理念，研发了一款优雅的标志性香水。泰国莲花品种 Sattabongkot 的独特香味被用来传达新QSNCC 的优雅和奢华。茉莉花的清新与活力体现了泰国人充满活力的生活方式和温柔，而玫瑰的芬芳则代表了新QSNCC的现代性和普世美感。这款标志性香水体现了新QSNCC的精神，它随时准备以泰式热情好客和一流服务欢迎游客的到来。</p>
      <p class="center"><img src="/images/media/news/2022-01-20/PANPURI@2x.jpg" alt="Vasu Surattiantra, Co-Founder of PAÑPURI" width="808" height="606" /></p>
      <p style="text-align: center;"><small>PAÑPURI公司联合创始人Vasu Surattiantra</small></p><br/>
      <p>今年 9 月在 QSNCC 上“感受全新QSNCC的香味”。</p>`,
      th: `<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1.jpg" alt="QSNCC" width="808" height="454" /></p>
<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด ประกาศรุกตลาดธุรกิจไมซ์ (MICE) ประเทศไทยครั้งใหม่หลังความสำเร็จในอดีตตลอดระยะเวลากว่า 30 ปี ของการเปิดให้บริการศูนย์การประชุมแห่งชาติสิริกิติ์ พร้อมทุ่มงบกว่า 15,000 ล้านบาท เดินหน้าพัฒนาสุดยอดศูนย์ประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย เพิ่มศักยภาพของโครงการด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า พร้อมเพิ่มพื้นที่รีเทลเพื่ออำนวยความสะดวกและรองรับผู้ที่เข้ามาใช้บริการ โดยรักษาชื่อ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” ซึ่งเป็นที่รู้จักและยอมรับในธุรกิจไมซ์ระดับนานาชาติ มั่นใจการพัฒนาปรับปรุงศูนย์ฯ สิริกิติ์ ครั้งนี้ จะสามารถรองรับการจัดงานประชุมหรืออิเวนต์ระดับเวิลด์คลาสได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
<p><img src="/images/media/news/2021-08-17/Mr.Panote-Sirivadhanabhakdi.jpg" alt="นายปณต สิริวัฒนภักดี กรรมการ บริษัท ทีซีซี แอสเซ็ทส์ (ประเทศไทย) จำกัด" width="808" height="454" /></p>
<p>นายปณต สิริวัฒนภักดี กรรมการ บริษัท ทีซีซี แอสเซ็ทส์ (ประเทศไทย) จำกัด กล่าวว่า “ภายใต้สถานการณ์การแพร่ระบาดของโควิด-19 ที่เกิดขึ้นทั่วโลก แต่บริษัทฯ ยังเล็งเห็นความสำคัญในการเดินหน้าพัฒนาโครงการ “ศูนย์การประชุมแห่งชาติสิริกิติ์” (Queen Sirikit National Convention Center หรือ QSNCC)  ให้เสร็จสมบูรณ์ตามแผนที่วางไว้ สอดคล้องกับแผนการลงทุนระยะยาวของบริษัทฯ ซึ่งเป็นไปตามวิสัยทัศน์และความมุ่งมั่นที่จะพัฒนาโครงการศูนย์ประชุมระดับเวิลด์คลาสแห่งใหม่ของเอเชีย บริษัทฯ เชื่อมั่นว่าด้วยศักยภาพของประเทศไทย ที่มีจุดแข็งหลายด้าน ไม่ว่าจะเป็นทำเลที่ตั้งที่เป็นศูนย์กลางทางการค้าของภูมิภาค การมีสิ่งอำนวยความสะดวกและสาธารณูปโภคที่ครบครัน พร้อมด้วยกลุ่มคู่ค้าทางธุรกิจและซัพพลายเออร์ที่มีคุณภาพ อีกทั้งยังมีศิลปวัฒนธรรมอันเป็นเอกลักษณ์ และมีการสืบสาน รักษา ต่อยอดให้เข้ากับยุคสมัยปัจจุบัน จึงทำให้บริษัทฯ มั่นใจว่า ศูนย์ฯ สิริกิติ์ จะเป็น The Ultimate Inspiring World Class Event Platform for All ที่ได้รับความสนใจจากกลุ่มลูกค้านานาชาติ และจะสามารถดึงดูดเม็ดเงินเข้ามาในประเทศไทยเพื่อขับเคลื่อนเศรษฐกิจให้เติบโตขึ้นได้อย่างแน่นอน”</p>
<p class="center"><img src="/images/media/news/2021-08-17/Panote-Sirivadhanabhakdi_1.jpg" alt="นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด" width="600" height="600" /></p>
<p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “ศูนย์การประชุมแห่งชาติสิริกิติ์ ถือเป็นหัวใจของการเริ่มต้นอุตสาหกรรมไมซ์ในประเทศไทย โดยตลอดระยะเวลากว่า 30 ปีที่ผ่านมา ศูนย์ฯ สิริกิติ์ เป็นสถานที่ที่บันทึกเรื่องราวความทรงจำของงานประชุมและอิเวนต์สำคัญๆ ทั้งในระดับชาติและนานาชาติกว่า 20,000 งาน ด้วยประสบการณ์มากกว่า 3 ทศวรรษ กอปรกับบุคลากรที่มีความรู้ความชำนาญ และมีความเป็นมืออาชีพ เราเชื่อมั่นว่าศูนย์ฯ สิริกิติ์ โฉมใหม่ จะสามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ในทุกรูปแบบได้อย่างแน่นอน” </p>
<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1-1.jpg" alt="QSNCC" width="808" height="454" /></p>
<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1-2.jpg" alt="QSNCC" width="808" height="454" /></p>
<p>ศูนย์ฯ สิริกิติ์ โฉมใหม่ มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง นอกจากนี้ศูนย์ฯ สิริกิติ์ ยังเชื่อมต่อกับสถานีรถไฟฟ้าใต้ดิน และมีที่จอดรถภายในอาคารรองรับได้มากกว่า 2,700 คัน อำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน  ขณะนี้ศูนย์ฯ สิริกิติ์ ได้เริ่มเปิดจองพื้นที่และได้รับการตอบรับที่ดีจากผู้จัดงานเป็นอย่างมาก</p>
<p><strong>เตรียมพบกับศูนย์ฯ สิริกิติ์ โฉมใหม่ ที่จะมาสร้างความคึกคักและสีสันให้กับวงการไมซ์ กันยายน 2565 นี้</strong></p>
<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1-3.jpg" alt="QSNCC" width="808" height="454" /></p>`,
    },
    image: '/images/media/news/2022-01-20/QSNCC_PANPURI@2x.jpg',
    imageSp: '/images/media/news/2022-01-20/QSNCC_PANPURI@1x.jpg',
    imageWebp: '/images/media/news/2022-01-20/QSNCC_PANPURI@2x.webp',
    imageWebpSp: '/images/media/news/2022-01-20/QSNCC_PANPURI@1x.webp',
    gallery: [],
  },
  {
    slug: 'fpt-achieves-over-60-percent-construction-for-the-new-qsncc',
    headline: {
      cn: '泰国 Frasers 地产在 QSNCC 重建项目中，实现 60%以上的建设里程碑',
      th: 'โฉมใหม่ศูนย์การประชุมแห่งชาติสิริกิติ์ พร้อมเปิดให้บริการกันยายนปี 65',
    },
    topic: {
      cn: '泰国 Frasers 地产推出 5 大亮点以增强新QSNCC的独特性',
      th: 'บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด ประกาศรุกตลาดธุรกิจไมซ์ (MICE) ประเทศไทยครั้งใหม่',
    },
    title: {
      cn: '泰国Frasers 地产在QSNCC重建项目中，将其空间容量扩大了五倍，达300000平方米，实现60%以上的建设里程碑',
      th: 'โฉมใหม่ศูนย์การประชุมแห่งชาติสิริกิติ์ พร้อมเปิดให้บริการกันยายนปี 65 ขยายพื้นที่ใหญ่กว่าเดิมถึง 5 เท่า พร้อมรับผู้เข้าร่วมงานมากกว่า 100,000 คนต่อวัน ตอกย้ำการเป็นศูนย์ประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย มุ่งเป้าสู่การเป็น The Ultimate Inspiring World Class Event Platform for All',
    },
    is_long_title: true,
    date: {
      cn: '2021年11月16日，曼谷',
      th: 'BANGKOK, 17 สิงหาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          cn: '/files/press/2021-11-16/QSNCC预定量激增 （新闻稿） .pdf',
          th: '/files/press/2021-08-17/QSNCC Press Release_TH_19.08.2021.pdf',
        },
      },
    ],
    description: {
      cn: `<ul class="a-list"><li>尽管疫情期间，QSNCC的规模依旧扩大了5倍，已达到了50多个足球场的规模，并计划于2022年9月将施工进展完成60%以上</li><li>推出5大亮点，将QSNCC打造成泰国一流的MICE场地，为全球各界朋友提供世界级活动平台</li></ul><br>
      <p class="center"><img src="/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg" alt="QSNCC Construction Update" width="808" height="606" srl_elementid="0" /></p>
      <p><strong>泰国Frasers地产有限公司</strong>的经验和专业知识及其国际声誉赢得了<strong>泰国N.C.C. 管理发展有限公司</strong>对新诗丽吉王后国家会议中心（QSNCC）开发项目上的信任。该项目现已完成一半，按计划将于2022年9月重新开放。泰国Frasers地产有限公司今天公布了其5大亮点，以增强QSNCC的独特性。这将有助于QSNCC完成其成为大众心中世界级极佳活动平台的愿景。</p>
      <p class="center"><img src="/images/media/news/2021-11-16/Mr-Withawat-Koottatep.jpg" alt="คุณวิทวัส คุตตะเทพ รองกรรมการผู้จัดการอาวุโส สายโครงการเชิงพาณิชยกรรม เฟรเซอร์ส พร็อพเพอร์ตี้ คอมเมอร์เชียล (ประเทศไทย)" width="600" height="600" srl_elementid="1" /></p>
      <p><strong>泰国Frasers 商业地产公司商业开发部第一执行副总裁Withawat Koottaep先生</strong>，说：“Frasers 地产很荣幸能为QSNCC的重新开发做出贡献，将其空间容量扩大五倍，达到300000平方米，相当于50多个足球场的大小。改造后的会议中心，设施先进、安保系统一流，旨在容纳从泰国乃至全球的各种类型活动，如小型会议、奖励旅游、大型会议和（MICE）展览活动。坚守的理念为通过维护和建立QSNCC的信念，从而提出发展概念，用以突出QSNCC的当代特征。除了泰国Frasers 地产公司为该项目带来的施工技术和专业知识外，我们还汇集了来自各个领域的专业人士，将QSNCC改造为亚洲新的世界级活动平台。”</p>
      <p class="center"><img src="/images/media/news/2021-11-16/QSNCC-Birdeyeview.jpg" alt="QSNCC Birdeyeview" width="909" height="606" srl_elementid="2" /></p>
      <p>“QSNCC的大规模开发改建，新增的45%的地下空间包含零售店以及3000个停车位。我们面临的主要挑战是在有限的时间下，开发这一高度复杂的建设项目，尤其在COVID-19疫情期间。根据计划，FPT有信心在商定时间内建成一流的会议中心，”Withawat先生补充道。</p>
      <p class="center"><img src="/images/media/news/2021-11-16/Foyer-A.jpg" alt="QSNCC Foyer A" width="808" height="606" srl_elementid="3" /></p>
      <p>为了支持将QSNCC升级为所有人心目中，终极鼓舞人心的世界级活动平台，此次升级的五大亮点将被重点介绍。</p>
      <p></p>
      <h3>交通可达性</h3>QSNCC位于新的Rachadapisek/Rama IV路上，连接四条主要道路：Rama IV、Sukhumvit、Rachadapiskek和Duangpitak。地铁站也与大楼直接相连。<p></p><p></p>
      <h3>安全性</h3>该项目符合国际质量标准，配备了包括生命安全在内的顶级安保系统。<p></p><p></p>
      <h3>技术</h3>通过构建6G网络支持，可保证活动组织者在组织国际规模活动时的网络便利和网络效率。包括无接触式访问系统和智能活动平台管理系统，为所有用户提供最高级别的便利和安全。<p></p><p></p>
      <h3>灵活性</h3>总活动空间300000平方米，由两个主展厅、两个大型会议厅和另外50个灵活的会议室组成。可灵活地提供从面对面活动到各种混合型以及虚拟活动的扩展服务。新QSNCC还包括零售空间，以促进曼谷居民和游客的积极生活方式。<p></p><p></p>
      <h3>持续性</h3>QSNCC是第一个也是唯一一个获得能源和环境设计（LEED）银牌认证的会议中心。使用的环保建筑材料——采用25%可回收材料以及75%可回收材料、太阳能电池以及节能设备，构成了可持续管理安排。会议中心靠近班佳齐蒂森林公园，可以享受周围广阔的绿地。<p></p>
      <p class="center"><img src="/images/media/news/2021-11-16/Central-Lounge.jpg" alt="QSNCC Central Lounge" width="808" height="606" srl_elementid="4" /></p>`,
      th: `<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1.jpg" alt="QSNCC" width="808" height="454" /></p>
<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด ประกาศรุกตลาดธุรกิจไมซ์ (MICE) ประเทศไทยครั้งใหม่หลังความสำเร็จในอดีตตลอดระยะเวลากว่า 30 ปี ของการเปิดให้บริการศูนย์การประชุมแห่งชาติสิริกิติ์ พร้อมทุ่มงบกว่า 15,000 ล้านบาท เดินหน้าพัฒนาสุดยอดศูนย์ประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย เพิ่มศักยภาพของโครงการด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า พร้อมเพิ่มพื้นที่รีเทลเพื่ออำนวยความสะดวกและรองรับผู้ที่เข้ามาใช้บริการ โดยรักษาชื่อ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” ซึ่งเป็นที่รู้จักและยอมรับในธุรกิจไมซ์ระดับนานาชาติ มั่นใจการพัฒนาปรับปรุงศูนย์ฯ สิริกิติ์ ครั้งนี้ จะสามารถรองรับการจัดงานประชุมหรืออิเวนต์ระดับเวิลด์คลาสได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
<p><img src="/images/media/news/2021-08-17/Mr.Panote-Sirivadhanabhakdi.jpg" alt="นายปณต สิริวัฒนภักดี กรรมการ บริษัท ทีซีซี แอสเซ็ทส์ (ประเทศไทย) จำกัด" width="808" height="454" /></p>
<p>นายปณต สิริวัฒนภักดี กรรมการ บริษัท ทีซีซี แอสเซ็ทส์ (ประเทศไทย) จำกัด กล่าวว่า “ภายใต้สถานการณ์การแพร่ระบาดของโควิด-19 ที่เกิดขึ้นทั่วโลก แต่บริษัทฯ ยังเล็งเห็นความสำคัญในการเดินหน้าพัฒนาโครงการ “ศูนย์การประชุมแห่งชาติสิริกิติ์” (Queen Sirikit National Convention Center หรือ QSNCC)  ให้เสร็จสมบูรณ์ตามแผนที่วางไว้ สอดคล้องกับแผนการลงทุนระยะยาวของบริษัทฯ ซึ่งเป็นไปตามวิสัยทัศน์และความมุ่งมั่นที่จะพัฒนาโครงการศูนย์ประชุมระดับเวิลด์คลาสแห่งใหม่ของเอเชีย บริษัทฯ เชื่อมั่นว่าด้วยศักยภาพของประเทศไทย ที่มีจุดแข็งหลายด้าน ไม่ว่าจะเป็นทำเลที่ตั้งที่เป็นศูนย์กลางทางการค้าของภูมิภาค การมีสิ่งอำนวยความสะดวกและสาธารณูปโภคที่ครบครัน พร้อมด้วยกลุ่มคู่ค้าทางธุรกิจและซัพพลายเออร์ที่มีคุณภาพ อีกทั้งยังมีศิลปวัฒนธรรมอันเป็นเอกลักษณ์ และมีการสืบสาน รักษา ต่อยอดให้เข้ากับยุคสมัยปัจจุบัน จึงทำให้บริษัทฯ มั่นใจว่า ศูนย์ฯ สิริกิติ์ จะเป็น The Ultimate Inspiring World Class Event Platform for All ที่ได้รับความสนใจจากกลุ่มลูกค้านานาชาติ และจะสามารถดึงดูดเม็ดเงินเข้ามาในประเทศไทยเพื่อขับเคลื่อนเศรษฐกิจให้เติบโตขึ้นได้อย่างแน่นอน”</p>
<p class="center"><img src="/images/media/news/2021-08-17/Panote-Sirivadhanabhakdi_1.jpg" alt="นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด" width="600" height="600" /></p>
<p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “ศูนย์การประชุมแห่งชาติสิริกิติ์ ถือเป็นหัวใจของการเริ่มต้นอุตสาหกรรมไมซ์ในประเทศไทย โดยตลอดระยะเวลากว่า 30 ปีที่ผ่านมา ศูนย์ฯ สิริกิติ์ เป็นสถานที่ที่บันทึกเรื่องราวความทรงจำของงานประชุมและอิเวนต์สำคัญๆ ทั้งในระดับชาติและนานาชาติกว่า 20,000 งาน ด้วยประสบการณ์มากกว่า 3 ทศวรรษ กอปรกับบุคลากรที่มีความรู้ความชำนาญ และมีความเป็นมืออาชีพ เราเชื่อมั่นว่าศูนย์ฯ สิริกิติ์ โฉมใหม่ จะสามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ในทุกรูปแบบได้อย่างแน่นอน” </p>
<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1-1.jpg" alt="QSNCC" width="808" height="454" /></p>
<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1-2.jpg" alt="QSNCC" width="808" height="454" /></p>
<p>ศูนย์ฯ สิริกิติ์ โฉมใหม่ มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง นอกจากนี้ศูนย์ฯ สิริกิติ์ ยังเชื่อมต่อกับสถานีรถไฟฟ้าใต้ดิน และมีที่จอดรถภายในอาคารรองรับได้มากกว่า 2,700 คัน อำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน  ขณะนี้ศูนย์ฯ สิริกิติ์ ได้เริ่มเปิดจองพื้นที่และได้รับการตอบรับที่ดีจากผู้จัดงานเป็นอย่างมาก</p>
<p><strong>เตรียมพบกับศูนย์ฯ สิริกิติ์ โฉมใหม่ ที่จะมาสร้างความคึกคักและสีสันให้กับวงการไมซ์ กันยายน 2565 นี้</strong></p>
<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1-3.jpg" alt="QSNCC" width="808" height="454" /></p>`,
    },
    image: '/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg',
    imageSp: '/images/media/news/2021-11-16/QSNCC-Construction-Update_1.jpg',
    imageWebp: '/images/media/news/2021-11-16/Press-20211116.webp',
    imageWebpSp: '/images/media/news/2021-11-16/Press-20211116.webp',
    gallery: [],
  },
  {
    slug: 'the-new-qsncc-to-be-open-in-2022',
    headline: {
      cn: 'QSNCC将于2022年以<br/>“世界一流、超凡卓越的会展活动平台”全新亮相',
      th: 'โฉมใหม่ศูนย์การประชุมแห่งชาติสิริกิติ์ พร้อมเปิดให้บริการกันยายนปี 65',
    },
    topic: {
      cn: 'N.C.C.管理与发展有限公司郑重宣布泰国诗丽吉王后国家会议中心（QSNCC）将以全新之姿亮相曼谷',
      th: 'บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด ประกาศรุกตลาดธุรกิจไมซ์ (MICE) ประเทศไทยครั้งใหม่',
    },
    title: {
      cn: '全新QSNCC将于2022年以<br/>“世界一流、超凡卓越的会展活动平台”的姿态亮相曼谷。新会议中心的容量是旧会议中心的5倍，日接待访客可达100,000人次以上。泰国诗丽吉王后国家会议中心（QSNCC）将进一步夯实其泰国曼谷中央商务区最大会议中心的重要地位。',
      th: 'โฉมใหม่ศูนย์การประชุมแห่งชาติสิริกิติ์ พร้อมเปิดให้บริการกันยายนปี 65 ขยายพื้นที่ใหญ่กว่าเดิมถึง 5 เท่า พร้อมรับผู้เข้าร่วมงานมากกว่า 100,000 คนต่อวัน ตอกย้ำการเป็นศูนย์ประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย มุ่งเป้าสู่การเป็น The Ultimate Inspiring World Class Event Platform for All',
    },
    is_long_title: true,
    date: {
      cn: '2021年8月17日，曼谷',
      th: 'BANGKOK, 17 สิงหาคม 2564',
    },
    downloads: [
      {
        type: 'pdf',
        file: {
          // cn: '/files/press/2021-08-17/QSNCC Press Release_EN_19.08.2021.pdf',
          cn: '/files/press/2021-08-17/Simplified Chinese 泰国诗丽吉王后国家会议中心将全新亮相.pdf',
          th: '/files/press/2021-08-17/QSNCC Press Release_TH_19.08.2021.pdf',
        },
      },
    ],
    description: {
      cn: `<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1.jpg" alt="QSNCC" width="808" height="454" /></p>
<p>N.C.C.管理与发展有限公司郑重宣布，泰国诗丽吉王后国家会议中心（QSNCC）将以全新之姿亮相曼谷。N.C.C.在会展行业深耕三十余载，致力于将QSNCC打造为世界一流、超凡卓越的会展活动平台。凭借15亿泰铢的投资价值，QSNCC将成为泰国曼谷中央商务区最大的会议中心。新会议中心的面积是旧会议中心的5倍，加之新增零售区和完善的配套技术，QSNCC将以全新之姿盛情承办各类世界级盛会。</p>
<p><img src="/images/media/news/2021-08-17/Mr.Panote-Sirivadhanabhakdi.jpg" alt="TCC资产（泰国）有限公司（TCC Assets (Thailand) Co., Ltd.）董事Panote Sirivadhanabhakdi先生" width="808" height="454" /></p>
<p>TCC资产（泰国）有限公司（TCC Assets (Thailand) Co., Ltd.）董事Panote Sirivadhanabhakdi先生表示，“尽管面临全球新冠疫情的挑战， 我们仍按照长期投资计划，成功完成了对泰国诗丽吉王后国家会议中心（QSNCC）的改造工程。这实现了我们将泰国诗丽吉王后国家会议中心（QSNCC）打造为亚洲地区世界一流会议中心的愿景和愿望。我们相信，我们所能提供的无穷的商业机遇、良好的便利性、多种类型的目的地以及热情周到的服务是一个具有很强竞争力的生态供应链系统。泰国在此方面的战略地位将会给活动主办方、参展方、客户、访客等相关合作方带来诸多益处。我们相信，这些优势将使泰国诗丽吉王后国家会议中心（QSNCC）吸引到世界领先的会议、展览和活动公司、主办者和运营商的兴趣，并成为泰国的世界一流、超凡卓越的会展活动平台。”</p>
<p class="center"><img src="/images/media/news/2021-08-17/Panote-Sirivadhanabhakdi_1.jpg" alt="Mr. Sakchai Pattarapreechakul, President of N.C.C. Management & Development Co., Ltd.," width="600" height="600" /></p>
<p>N.C.C.管理与发展有限公司总裁Sakchai Pattarapreechakul先生表示，“作为泰国会展行业30年的领导者，泰国诗丽吉王后国家会议中心（QSNCC）以其高标准的活动场地、全面而周到的服务和资源供给能力，及成功举办20,000个国内及国际高品质活动的丰富经验而闻名于世。我们相信，改造后的QSNCC将以全新之姿，服务所有客户群体，为您能想象到的所有盛会提供鼎力支持。”</p>
<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1-1.jpg" alt="QSNCC" width="808" height="454" /></p>
<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1-2.jpg" alt="QSNCC" width="808" height="454" /></p>
<p>全新的泰国诗丽吉王后国家会议中心（QSNCC）可用于举办活动的总面积为78,500平方米，2个主要展厅总面积超过45,000平方米，2个超大会议厅面积接近10,000平方米，会议中心还设有50 间可灵活间隔的分会议室和额外的零售区域，还有设备齐全的技术设施。直达地铁站的便利和2,700个室内停车位，这些都使泰国诗丽吉王后国家会议中心（QSNCC）成为了曼谷CBD商圈里最便捷到达的地点。泰国诗丽吉王后国家会议中心（QSNCC）即将于2022年9月以全新之姿亮相，中心现已开放预订，并得到了会议、展览、奖励旅游运营商、参展商以及零售区域和食品企业的积极响应。</p>
<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1-3.jpg" alt="QSNCC" width="808" height="454" /></p>`,
      th: `<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1.jpg" alt="QSNCC" width="808" height="454" /></p>
<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด ประกาศรุกตลาดธุรกิจไมซ์ (MICE) ประเทศไทยครั้งใหม่หลังความสำเร็จในอดีตตลอดระยะเวลากว่า 30 ปี ของการเปิดให้บริการศูนย์การประชุมแห่งชาติสิริกิติ์ พร้อมทุ่มงบกว่า 15,000 ล้านบาท เดินหน้าพัฒนาสุดยอดศูนย์ประชุมใจกลางเมืองที่ใหญ่ที่สุดของประเทศไทย เพิ่มศักยภาพของโครงการด้วยการขยายพื้นที่มากขึ้นถึง 5 เท่า พร้อมเพิ่มพื้นที่รีเทลเพื่ออำนวยความสะดวกและรองรับผู้ที่เข้ามาใช้บริการ โดยรักษาชื่อ “‎ศูนย์การประชุมแห่งชาติสิริกิติ์” ซึ่งเป็นที่รู้จักและยอมรับในธุรกิจไมซ์ระดับนานาชาติ มั่นใจการพัฒนาปรับปรุงศูนย์ฯ สิริกิติ์ ครั้งนี้ จะสามารถรองรับการจัดงานประชุมหรืออิเวนต์ระดับเวิลด์คลาสได้ทุกรูปแบบอย่างไร้ขีดจำกัด</p>
<p><img src="/images/media/news/2021-08-17/Mr.Panote-Sirivadhanabhakdi.jpg" alt="นายปณต สิริวัฒนภักดี กรรมการ บริษัท ทีซีซี แอสเซ็ทส์ (ประเทศไทย) จำกัด" width="808" height="454" /></p>
<p>นายปณต สิริวัฒนภักดี กรรมการ บริษัท ทีซีซี แอสเซ็ทส์ (ประเทศไทย) จำกัด กล่าวว่า “ภายใต้สถานการณ์การแพร่ระบาดของโควิด-19 ที่เกิดขึ้นทั่วโลก แต่บริษัทฯ ยังเล็งเห็นความสำคัญในการเดินหน้าพัฒนาโครงการ “ศูนย์การประชุมแห่งชาติสิริกิติ์” (Queen Sirikit National Convention Center หรือ QSNCC)  ให้เสร็จสมบูรณ์ตามแผนที่วางไว้ สอดคล้องกับแผนการลงทุนระยะยาวของบริษัทฯ ซึ่งเป็นไปตามวิสัยทัศน์และความมุ่งมั่นที่จะพัฒนาโครงการศูนย์ประชุมระดับเวิลด์คลาสแห่งใหม่ของเอเชีย บริษัทฯ เชื่อมั่นว่าด้วยศักยภาพของประเทศไทย ที่มีจุดแข็งหลายด้าน ไม่ว่าจะเป็นทำเลที่ตั้งที่เป็นศูนย์กลางทางการค้าของภูมิภาค การมีสิ่งอำนวยความสะดวกและสาธารณูปโภคที่ครบครัน พร้อมด้วยกลุ่มคู่ค้าทางธุรกิจและซัพพลายเออร์ที่มีคุณภาพ อีกทั้งยังมีศิลปวัฒนธรรมอันเป็นเอกลักษณ์ และมีการสืบสาน รักษา ต่อยอดให้เข้ากับยุคสมัยปัจจุบัน จึงทำให้บริษัทฯ มั่นใจว่า ศูนย์ฯ สิริกิติ์ จะเป็น The Ultimate Inspiring World Class Event Platform for All ที่ได้รับความสนใจจากกลุ่มลูกค้านานาชาติ และจะสามารถดึงดูดเม็ดเงินเข้ามาในประเทศไทยเพื่อขับเคลื่อนเศรษฐกิจให้เติบโตขึ้นได้อย่างแน่นอน”</p>
<p class="center"><img src="/images/media/news/2021-08-17/Panote-Sirivadhanabhakdi_1.jpg" alt="นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด" width="600" height="600" /></p>
<p>นายศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด กล่าวว่า “ศูนย์การประชุมแห่งชาติสิริกิติ์ ถือเป็นหัวใจของการเริ่มต้นอุตสาหกรรมไมซ์ในประเทศไทย โดยตลอดระยะเวลากว่า 30 ปีที่ผ่านมา ศูนย์ฯ สิริกิติ์ เป็นสถานที่ที่บันทึกเรื่องราวความทรงจำของงานประชุมและอิเวนต์สำคัญๆ ทั้งในระดับชาติและนานาชาติกว่า 20,000 งาน ด้วยประสบการณ์มากกว่า 3 ทศวรรษ กอปรกับบุคลากรที่มีความรู้ความชำนาญ และมีความเป็นมืออาชีพ เราเชื่อมั่นว่าศูนย์ฯ สิริกิติ์ โฉมใหม่ จะสามารถตอบโจทย์ทุกความต้องการของลูกค้า และรองรับการจัดงานได้ในทุกรูปแบบได้อย่างแน่นอน” </p>
<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1-1.jpg" alt="QSNCC" width="808" height="454" /></p>
<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1-2.jpg" alt="QSNCC" width="808" height="454" /></p>
<p>ศูนย์ฯ สิริกิติ์ โฉมใหม่ มีพื้นที่รองรับการจัดการประชุมและนิทรรศการมากถึง 78,500 ตารางเมตร ประกอบไปด้วยฮอลล์สำหรับการจัดนิทรรศการขนาดใหญ่ 2 ฮอลล์ พื้นที่รวมมากกว่า 45,000 ตารางเมตร ห้องสำหรับจัดประชุมสัมมนาขนาดใหญ่ 2 ห้อง พื้นที่ประมาณ 10,000 ตารางเมตร และห้องประชุมย่อยที่สามารถรองรับการประชุมได้กว่า 50 ห้อง นอกจากนี้ศูนย์ฯ สิริกิติ์ ยังเชื่อมต่อกับสถานีรถไฟฟ้าใต้ดิน และมีที่จอดรถภายในอาคารรองรับได้มากกว่า 2,700 คัน อำนวยความสะดวกให้แก่ทั้งผู้จัดงานและผู้เข้าร่วมงาน  ขณะนี้ศูนย์ฯ สิริกิติ์ ได้เริ่มเปิดจองพื้นที่และได้รับการตอบรับที่ดีจากผู้จัดงานเป็นอย่างมาก</p>
<p><strong>เตรียมพบกับศูนย์ฯ สิริกิติ์ โฉมใหม่ ที่จะมาสร้างความคึกคักและสีสันให้กับวงการไมซ์ กันยายน 2565 นี้</strong></p>
<p><img src="/images/media/news/2021-08-17/QSNCC_Exterior_1-3.jpg" alt="QSNCC" width="808" height="454" /></p>`,
    },
    image: '/images/media/news/2021-08-17/Press-20210817@2x.jpg',
    imageSp: '/images/media/news/2021-08-17/Press-20210817@1x.jpg',
    imageWebp: '/images/media/news/2021-08-17/Press-20210817@2x.webp',
    imageWebpSp: '/images/media/news/2021-08-17/Press-20210817@1x.webp',
    gallery: [],
  },
  {
    slug: 'new-years-greetings-to-siam-rath',
    headline: {
      cn: '向《暹罗早报》献上新年祝福',
      th: 'เข้าสวัสดีปีใหม่หนังสือพิมพ์สยามรัฐ',
    },
    topic: {
      // cn: 'New Year\'s greetings to "Siam Rath”',
      // th: 'เข้าสวัสดีปีใหม่หนังสือพิมพ์สยามรัฐ',
      cn: 'N.C.C集团高管拜访《暹罗早报》并献上2021新年祝福',
      th: 'ผู้บริหารเอ็น.ซี.ซี.ฯ เข้าสวัสดีปีใหม่หนังสือพิมพ์สยามรัฐ',
    },
    description: {
      cn: 'N.C.C.管理与发展有限公司总裁、泰国诗丽吉王后国家会议中心（QSNCC）经理Sakchai Pattarapreechakul亲临暹罗早报出版社（Siam Rath Publishing House）拜访暹罗早报有限公司副总裁 Kotphon Kong-udom先生，并致以新年问候。',
      th: 'คุณศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด ผู้บริหารศูนย์การประชุมแห่งชาติสิริกิติ์ เข้าสวัสดีปีใหม่ พร้อมมอบของขวัญแก่ คุณกตพล คงอุดม รองประธานกรรมการ กรรมการผู้จัดการ บริษัท สยามรัฐ จำกัด ณ สำนักพิมพ์สยามรัฐ',
    },
    image: '/images/media/news/03-เข้าสวัสดีปีใหม่-สยามรัฐ/News-3@2x.jpg',
    imageSp: '/images/media/news/03-เข้าสวัสดีปีใหม่-สยามรัฐ/News-3@1x.jpg',
    imageWebp: '/images/media/news/03-เข้าสวัสดีปีใหม่-สยามรัฐ/News-3@2x.webp',
    imageWebpSp: '/images/media/news/03-เข้าสวัสดีปีใหม่-สยามรัฐ/News-3@1x.webp',
    date: '',
    gallery: [
      {
        src: '/images/media/news/03-เข้าสวัสดีปีใหม่-สยามรัฐ/01_1616x1212_@2x.jpg',
        srcSp: '/images/media/news/03-เข้าสวัสดีปีใหม่-สยามรัฐ/01_808x606_@1x.jpg',
        srcWebp: '/images/media/news/03-เข้าสวัสดีปีใหม่-สยามรัฐ/01_1616x1212_@2x.webp',
        srcWebpSp: '/images/media/news/03-เข้าสวัสดีปีใหม่-สยามรัฐ/01_808x606_@1x.webp',
        caption: '',
      },
    ],
  },
  {
    slug: 'amarin-printing-and-publishing-welcome-ncc-executives',
    headline: {
      cn: 'Amarin印刷出版公司会见N.C.C集团高管',
      th: 'อมรินทร์พริ้นติ้ง แอนด์ พับลิชชิ่ง ต้อนรับผู้บริหาร เอ็น.ซี.ซี.ฯ',
    },
    topic: {
      cn: '2021年新年期间，Sutichai Bunditvorapoom和管理层拜访Rarin Utakapan Punjarungroj',
      th: 'คุณสุทธิชัย บัณฑิตวรภูมิ นำทีมผู้บริหาร<br/>มอบของขวัญสวัสดีปีใหม่<br/>คุณระริน อุทกะพันธุ์ ปัญจรุ่งโรจน์',
      // cn: 'Amarin Printing and Publishing welcomes NCC executives',
      // th: 'อมรินทร์พริ้นติ้ง แอนด์ พับลิชชิ่ง ต้อนรับผู้บริหาร เอ็น.ซี.ซี.ฯ',
    },
    description: {
      cn: 'N.C.C.管理与发展有限公司执行副总裁、泰国诗丽吉王后国家会议中心（QSNCC）管理层Sutichai Bunditvorapoom和N.C.C形象有限公司（N.C.C. Image Co., Ltd.）代理总经理Supasak Dulalumpa亲临Amarin印刷出版公司拜访Amarin印刷出版公司首席执行官Rarin Utakapan Punjarungroj，并致以2021年新年问候。',
      th: 'คุณสุทธิชัย บัณฑิตวรภูมิ รองกรรมการผู้จัดการ บริษัท เอ็น.ซี.ซี.แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด ผู้บริหารศูนย์การประชุมแห่งชาติสิริกิติ์ พร้อมด้วย คุณศุภศักดิ์ ดุละลัมพะ รักษาการผู้จัดการทั่วไป บริษัท เอ็น.ซี.ซี. อิมเมจ จำกัด ร่วมสวัสดีปีใหม่และมอบของขวัญแก่ คุณระริน อุทกะพันธุ์ ปัญจรุ่งโรจน์ กรรมการผู้อำนวยการใหญ่ บริษัท อมรินทร์พริ้นติ้ง แอนด์ พับลิชชิ่ง จำกัด (มหาชน) ณ บริษัท อมรินทร์พริ้นติ้ง แอนด์ พับลิชชิ่ง จำกัด (มหาชน)',
    },
    image: '/images/media/news/04-สวัสดีปีใหม่อมรินทร์/News-4@2x.jpg',
    imageSp: '/images/media/news/04-สวัสดีปีใหม่อมรินทร์/News-4@1x.jpg',
    imageWebp: '/images/media/news/04-สวัสดีปีใหม่อมรินทร์/News-4@2x.webp',
    imageWebpSp: '/images/media/news/04-สวัสดีปีใหม่อมรินทร์/News-4@1x.webp',
    date: '',
    gallery: [
      {
        src: '/images/media/news/04-สวัสดีปีใหม่อมรินทร์/01_1616x1212_@2x.jpg',
        srcSp: '/images/media/news/04-สวัสดีปีใหม่อมรินทร์/01_808x606_@1x.jpg',
        srcWebp: '/images/media/news/04-สวัสดีปีใหม่อมรินทร์/01_1616x1212_@2x.webp',
        srcWebpSp: '/images/media/news/04-สวัสดีปีใหม่อมรินทร์/01_808x606_@1x.webp',
        caption: '',
      },
    ],
  },
  {
    slug: 'ncc-executives-visit-thailand-mdes-office',
    headline: {
      cn: 'N.C.C高管拜访泰国数字经济与社会部',
      th: 'ผู้บริหารเอ็น.ซี.ซี.ฯ เยี่ยม<br/>กระทรวงดิจิทัลฯ',
    },
    topic: {
      cn: 'Sutichai Bunditvorapoom和管理层拜访泰国数字经济与社会部',
      th: 'เข้าสวัสดีปีใหม่ 2564<br/>รัฐมนตรีว่าการกระทรวงดิจิทัล<br/>เพื่อเศรษฐกิจและสังคม',
      // cn: 'NCC executives visit Thailand MDES office',
      // th: 'ผู้บริหารเอ็น.ซี.ซี.ฯ เยี่ยม<br/>กระทรวงดิจิทัลฯ',
    },
    description: {
      cn: 'N.C.C.管理与发展有限公司执行副总裁、泰国诗丽吉王后国家会议中心（QSNCC）管理层Sutichai Bunditvorapoom和管理层亲临泰国数字经济与社会部拜访泰国数字经济与社会部长Puttipong Punnakan和泰国数字经济与社会部常务书记Atcharin Pattanaphanchai，并致以新年问候。',
      th: 'คุณสุทธิชัย บัณฑิตวรภูมิ รองกรรมการผู้จัดการ พร้อมด้วยคณะผู้บริหาร บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด ผู้บริหารศูนย์การประชุมแห่งชาติสิริกิติ์ เข้าสวัสดีปีใหม่ 2564 พร้อมมอบของขวัญ แก่ คุณพุทธิพงษ์ ปุณณกันต์ รัฐมนตรีว่าการกระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม และ คุณอัจฉรินทร์ พัฒนพันธ์ชัย ปลัดกระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม ณ กระทรวงดิจิทัลเพื่อเศรษฐกิจและสังคม ศูนย์ราชการฯ แจ้งวัฒนะ',
    },
    image: '/images/media/news/02-เข้าสวัสดีปีใหม่-รัฐมนตรี/News-2@2x.jpg',
    imageSp: '/images/media/news/02-เข้าสวัสดีปีใหม่-รัฐมนตรี/News-2@1x.jpg',
    imageWebp: '/images/media/news/02-เข้าสวัสดีปีใหม่-รัฐมนตรี/News-2@2x.webp',
    imageWebpSp: '/images/media/news/02-เข้าสวัสดีปีใหม่-รัฐมนตรี/News-2@1x.webp',
    date: '',
    gallery: [
      {
        src: '/images/media/news/02-เข้าสวัสดีปีใหม่-รัฐมนตรี/01_1616x1212_@2x.jpg',
        srcSp: '/images/media/news/02-เข้าสวัสดีปีใหม่-รัฐมนตรี/01_808x606_@1x.jpg',
        srcWebp: '/images/media/news/02-เข้าสวัสดีปีใหม่-รัฐมนตรี/01_1616x1212_@2x.webp',
        srcWebpSp: '/images/media/news/02-เข้าสวัสดีปีใหม่-รัฐมนตรี/01_808x606_@1x.webp',
        caption: '',
      },
      {
        src: '/images/media/news/02-เข้าสวัสดีปีใหม่-รัฐมนตรี/02_1616x1212_@2x.jpg',
        srcSp: '/images/media/news/02-เข้าสวัสดีปีใหม่-รัฐมนตรี/02_808x606_@1x.jpg',
        srcWebp: '/images/media/news/02-เข้าสวัสดีปีใหม่-รัฐมนตรี/02_1616x1212_@2x.webp',
        srcWebpSp: '/images/media/news/02-เข้าสวัสดีปีใหม่-รัฐมนตรี/02_808x606_@1x.webp',
        caption: '',
      },
    ],
  },
  {
    slug: 'qsncc-renovation-project-site-visit',
    headline: {
      cn: '现场参观泰国诗丽吉王后国家会议中心（QSNCC）改造项目',
      th: 'เยี่ยมชมความคืบหน้าการก่อสร้างศูนย์ฯ สิริกิติ์',
    },
    topic: {
      cn: 'N.C.C管理层实地走访泰国诗丽吉王后国家会议中心（QSNCC）改造项目',
      th: 'ผู้บริหารเอ็นซี.ซี.ฯ เข้าเยี่ยมชมความคืบหน้า<br/>การก่อสร้างศูนย์ฯ สิริกิติ์',
    },
    description: {
      cn: 'N.C.C.管理与发展有限公司副董事长Phornsiri Manoharn、董事Pramook Thitathana、总裁Sakchai Pattarapreechakul和管理层实地走访泰国诗丽吉王后国家会议中心（QSNCC）改造项目。升级改造完成后的QSNCC将在2022年9月以全新之姿亮相。',
      th: 'คุณพรศิริ มโนหาญ รองประธานกรรมการบริษัท คุณประมุข ฐิตะฐาน กรรมการบริษัท คุณศักดิ์ชัย ภัทรปรีชากุล กรรมการผู้จัดการ พร้อมด้วยผู้บริหาร บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด เข้าเยี่ยมชมโครงการก่อสร้างและปรับปรุง/ดัดแปลงอาคารศูนย์การประชุมแห่งชาติสิริกิติ์ ซึ่งปัจจุบันมีความคืบหน้าในการปรับปรุงเร็วกว่าแผน ซึ่งคาดว่าจะแล้วเสร็จตามกำหนด พร้อมเปิดให้บริการรองรับการจัดงานในเดือนกันยายน พ.ศ. 2565',
    },
    image: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/News-1@2x.jpg',
    imageSp: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/News-1@1x.jpg',
    imageWebp: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/News-1@2x.webp',
    imageWebpSp: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/News-1@1x.webp',
    date: '',
    gallery: [
      {
        src: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/01_1616x1212_@2x.jpg',
        srcSp: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/01_808x606_@1x.jpg',
        srcWebp: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/01_1616x1212_@2x.webp',
        srcWebpSp: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/01_808x606_@1x.webp',
        caption: '',
      },
      {
        src: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/02_1616x1212_@2x.jpg',
        srcSp: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/02_808x606_@1x.jpg',
        srcWebp: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/02_1616x1212_@2x.webp',
        srcWebpSp: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/02_808x606_@1x.webp',
        caption: '',
      },
      {
        src: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/03_1616x1212_@2x.jpg',
        srcSp: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/03_808x606_@1x.jpg',
        srcWebp: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/03_1616x1212_@2x.webp',
        srcWebpSp: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/03_808x606_@1x.webp',
        caption: '',
      },
      {
        src: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/04_1616x1212_@2x.jpg',
        srcSp: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/04_808x606_@1x.jpg',
        srcWebp: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/04_1616x1212_@2x.webp',
        srcWebpSp: '/images/media/news/01-ผู้บริหารเยี่ยมโครงการ/04_808x606_@1x.webp',
        caption: '',
      },
    ],
  },
];
export const FLOORPLAN_LEGENDS = [
  {
    text: '所在会堂',
    color: '#9D8F3D',
  },
  {
    text: '大堂/公众区域',
    color: '#D4C9AA',
  },
  {
    text: '组织方办公室',
    color: '#A58680',
  },
  {
    text: '消防通道',
    color: '#4B577F',
  },
  {
    text: '会堂',
    color: '#D8D2C5',
    border: 'dashed',
  },
  {
    text: '零售与餐饮',
    color: '#EFC8AB',
  },
  {
    text: '客梯',
    color: '#A6B7A4',
  },
  {
    text: '美食区',
    color: '#CBD5D6',
  },
  /* {
    text: '贵宾室',
    color: '#909086',
  }, */
];
export const FLOORPLAN_OPTION_LIST = [
  {
    label: {
      cn: '地面设施',
      th: 'Floor Facilities',
    },
    value: 'floor-facilities',
  },
  {
    label: {
      cn: '布局和容量',
      th: 'Layout and Capacities',
    },
    value: 'layout-and-capacity',
  },
  {
    label: {
      cn: '图片库',
      th: 'Image Gallery',
    },
    value: 'image-gallery',
  },
  {
    label: {
      cn: '360度全方位探索',
      th: 'Explore 360°',
    },
    value: 'explore-360',
  },
];
export const FLOOR_LIST = [
  {
    level: 'LG',
    images: {
      active: {
        src: '/images/floors/floor-LG-active.png',
        srcWebp: '/images/floors/floor-LG-active.webp',
        width: 689,
        height: 313,
      },
      inactive: {
        src: '/images/floors/floor-LG.png',
        srcWebp: '/images/floors/floor-LG.webp',
        width: 542,
        height: 282,
      },
    },
    action: true,
    description: {
      cn: 'LG层直接联通到以QSNCC命名的地铁站。LG层配备了4 个大展厅，总面积达到 22,750 平方米，周围围绕着各式商店、餐厅及美食中心。',
      th: 'ชั้น LG เชื่อมต่อกับสถานีรถไฟฟ้าใต้ดิน “ศูนย์การประชุมแห่งชาติสิริกิติ์” ครอบคลุมพื้นที่ 22,750 ตารางเมตร มีฮอลล์สำหรับจัดนิทรรศการ (Exhibition Hall) 4 ห้อง และมีร้านค้าปลีก ร้านอาหาร และศูนย์อาหารครบครัน',
    },
    facility: {
      layouts: {
        description: `
        <div class="t-venue-floor__info-floor-data-description-item">
          <ul class="a-list">
            <li>立柱直径 = 1.7 m</li>
            <li>立柱间距 = 25 m</li>
            <li>楼面负荷 = 1,500 kg/m<sup>2</sup></li>
            <li>装卸区 = 55个</li>
            <li>员工电梯 = 3部（2.7 m x 1.2 m x 3 m）（长 x 宽 x 高），载重1,350 kg</li>
            <li>货梯 = 2部（8 m x 3.5 m x 3 m）（长 x 宽 x 高），载重5,000 kg</li>
          </ul>
        </div>
        `,
        options: [
          {
            label: '所有区域',
            mode: 'all',
          },
          {
            label: '展厅5+6',
            mode: 'combine',
            keys: ['lg-hall-5', 'lg-hall-6'],
          },
          {
            label: '展厅7+8',
            mode: 'combine',
            keys: ['lg-hall-7', 'lg-hall-8'],
          },
          {
            label: '展厅5+6+7+8',
            mode: 'combine',
            keys: ['lg-hall-5', 'lg-hall-6', 'lg-hall-7', 'lg-hall-8'],
          },
        ],
        total: {
          'lg-hall-5_lg-hall-6': {
            dimension: {
              title: '尺寸（初步估算）',
              items: [
                { image: 'all-floor', label: '长（米）', key: 'length', value: 108 },
                { image: 'all-floor', label: '宽（米）', key: 'width', value: 109 },
                { image: 'all-floor', label: '高（米）', key: 'height', value: 7 },
              ],
            },
            area: {
              title: '可使用总面积',
              items: [
                { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 11795 },
                { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 126960 },
              ],
            },
            capacity: {
              title: '最大容量（大约）',
              items: [
                { icon: 'theatre', label: '剧院式', key: 'theatre', value: 10000 },
                { icon: 'classroom', label: '课桌式', key: 'classroom', value: 5000 },
                { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 5000 },
                { icon: 'reception', label: '招待会', key: 'reception', value: 10000 },
                { icon: 'booth', label: '展台', key: 'booth', value: 648 },
              ],
            },
          },
          'lg-hall-7_lg-hall-8': {
            dimension: {
              title: '尺寸（初步估算）',
              items: [
                { icon: 'all-floor', label: '长（米）', key: 'length', value: 108 },
                { icon: 'all-floor', label: '宽（米）', key: 'width', value: 102 },
                { icon: 'all-floor', label: '高（米）', key: 'height', value: 7 },
              ],
            },
            area: {
              title: '可使用总面积',
              items: [
                { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 10993 },
                { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 118328 },
              ],
            },
            capacity: {
              title: '最大容量（大约）',
              items: [
                { icon: 'theatre', label: '剧院式', key: 'theatre', value: 10000 },
                { icon: 'classroom', label: '课桌式', key: 'classroom', value: 5000 },
                { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 5000 },
                { icon: 'reception', label: '招待会', key: 'reception', value: 10000 },
                { icon: 'booth', label: '展台', key: 'booth', value: 648 },
              ],
            },
          },
          'lg-hall-5_lg-hall-6_lg-hall-7_lg-hall-8': {
            dimension: {
              title: '尺寸（初步估算）',
              items: [
                { icon: 'all-floor', label: '长（米）', key: 'length', value: 211 },
                { icon: 'all-floor', label: '宽（米）', key: 'width', value: 108 },
                { icon: 'all-floor', label: '高（米）', key: 'height', value: 7 },
              ],
            },
            area: {
              title: '可使用总面积',
              items: [
                { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 22788 },
                { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 245288 },
              ],
            },
            capacity: {
              title: '最大容量（大约）',
              items: [
                { icon: 'theatre', label: '剧院式', key: 'theatre', value: 20000 },
                { icon: 'classroom', label: '课桌式', key: 'classroom', value: 10000 },
                { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 10000 },
                { icon: 'reception', label: '招待会', key: 'reception', value: 20000 },
                { icon: 'booth', label: '展台', key: 'booth', value: 1365 },
              ],
            },
          },
        },
        legends: [
          {
            text: '所在会堂',
            color: '#9D8F3D',
          },
          {
            text: '大堂/公众区域',
            color: '#D4C9AA',
          },
          {
            text: '组织方办公室',
            color: '#A58680',
          },
          {
            text: '员工电梯',
            color: '#7F5951',
          },
          {
            text: '消防通道',
            color: '#4B577F',
          },
          {
            text: '会堂',
            color: '#D8D2C5',
            border: 'dashed',
          },
          {
            text: '零售与餐饮',
            color: '#EFC8AB',
          },
          {
            text: '客梯',
            color: '#A6B7A4',
          },
          {
            text: '货梯',
            color: '#4B6856',
          },
          {
            text: '美食区',
            color: '#CBD5D6',
          },
        ],
      },
      floorplans: [
        {
          icon: 'all-floor',
          label: '所有楼层平面图',
          tabLabel: '所有楼层平面图',
          image: {
            png: '/images/floors/details/level-LG-all.png',
            webp: '/images/floors/details/level-LG-all.webp',
            pngSp: '/images/floors/details/level-LG-all-sp.png',
            webpSp: '/images/floors/details/level-LG-all-sp.webp',
          },
          showFloor: true,
          showLayout: false,
          data: {
            description: `
            <div class="t-venue-floor__info-floor-data-description-item">
              <ul class="a-list">
                <li>立柱直径 = 1.7 m</li>
                <li>立柱间距 = 25 m</li>
                <li>楼面负荷 = 1,500 kg/m<sup>2</sup></li>
                <li>装卸区 = 55个</li>
                <li>员工电梯 = 3部（2.7 m x 1.2 m x 3 m）（长 x 宽 x 高），载重1,350 kg</li>
                <li>货梯 = 2部（8 m x 3.5 m x 3 m）（长 x 宽 x 高），载重5,000 kg</li>
              </ul>
            </div>
            `,
          },
        },
        {
          icon: 'number-5',
          label: '展厅5',
          tabLabel: '展厅',
          key: 'lg-hall-5',
          image: {
            png: '/images/floors/details/level-LG-hall-5.png',
            webp: '/images/floors/details/level-LG-hall-5.webp',
            pngSp: '/images/floors/details/level-LG-hall-5-sp.png',
            webpSp: '/images/floors/details/level-LG-hall-5-sp.webp',
          },
          showFloor: true,
          showLayout: true,
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 54.82 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 7 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5921 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 63733 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5000 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 2500 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2500 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 5000 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 290 },
                ],
              },
            },
          },
        },
        {
          icon: 'number-6',
          label: '展厅6',
          tabLabel: '展厅',
          key: 'lg-hall-6',
          image: {
            png: '/images/floors/details/level-LG-hall-6.png',
            webp: '/images/floors/details/level-LG-hall-6.webp',
            pngSp: '/images/floors/details/level-LG-hall-6-sp.png',
            webpSp: '/images/floors/details/level-LG-hall-6-sp.webp',
          },
          showFloor: true,
          showLayout: true,
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 54.39 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 7 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5874 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 63227 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5000 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 2500 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2500 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 5000 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 358 },
                ],
              },
            },
          },
        },
        {
          icon: 'number-7',
          label: '展厅7',
          tabLabel: '展厅',
          key: 'lg-hall-7',
          image: {
            png: '/images/floors/details/level-LG-hall-7.png',
            webp: '/images/floors/details/level-LG-hall-7.webp',
            pngSp: '/images/floors/details/level-LG-hall-7-sp.png',
            webpSp: '/images/floors/details/level-LG-hall-7-sp.webp',
          },
          showFloor: true,
          showLayout: true,
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 54.39 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 7 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5874 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 63227 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5000 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 2500 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2500 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 5000 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 358 },
                ],
              },
            },
          },
        },
        {
          icon: 'number-8',
          label: '展厅8',
          tabLabel: '展厅',
          key: 'lg-hall-8',
          image: {
            png: '/images/floors/details/level-LG-hall-8.png',
            webp: '/images/floors/details/level-LG-hall-8.webp',
            pngSp: '/images/floors/details/level-LG-hall-8-sp.png',
            webpSp: '/images/floors/details/level-LG-hall-8-sp.webp',
          },
          showFloor: true,
          showLayout: true,
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 47.4 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 7 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5119 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 55100 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5000 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 2500 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2500 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 5000 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 290 },
                ],
              },
            },
          },
        },
        {
          label: 'LG层门厅A',
          key: 'lg-foyer-a',
          showFloor: false,
          showLayout: true,
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { icon: 'all-floor', label: '长（米）', key: 'length', value: 229.3 },
                  { icon: 'all-floor', label: '宽（米）', key: 'width', value: 24 },
                  { icon: 'all-floor', label: '高（米）', key: 'height', value: 8.5 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 3320 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 35736 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 0 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 0 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 0 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 0 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 0 },
                ],
              },
            },
          },
        },
        {
          label: 'LG层门厅B',
          key: 'lg-foyer-a',
          showFloor: false,
          showLayout: true,
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { icon: 'all-floor', label: '长（米）', key: 'length', value: 196.2 },
                  { icon: 'all-floor', label: '宽（米）', key: 'width', value: 21 },
                  { icon: 'all-floor', label: '高（米）', key: 'height', value: 8.5 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 6650 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 71580 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 0 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 0 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 0 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 0 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 0 },
                ],
              },
            },
          },
        },
      ],
      gallery: [
        {
          type: 'half',
          image: {
            src: '/images/venue/level-LG/9_Foyer-B-(3)_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-LG/9_Foyer-B-(3)_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-LG/9_Foyer-B-(3)_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-LG/9_Foyer-B-(3)_1200x630_@1x.webp',
            caption: '前厅B',
            align: 'left',
          },
        },
        {
          image: {
            src: '/images/venue/level-LG/10_Foyer-A-(2)_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-LG/10_Foyer-A-(2)_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-LG/10_Foyer-A-(2)_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-LG/10_Foyer-A-(2)_1200x630_@1x.webp',
            caption: '前厅A',
            align: 'left',
          },
        },
        {
          image: {
            src: '/images/venue/level-LG/11_Foyer-B-(2)_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-LG/11_Foyer-B-(2)_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-LG/11_Foyer-B-(2)_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-LG/11_Foyer-B-(2)_1200x630_@1x.webp',
            caption: '前厅B',
            align: 'left',
          },
        },
        {
          type: 'half',
          image: {
            src: '/images/venue/level-LG/Exhibition-Hall-5-8_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-LG/Exhibition-Hall-5-8_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-LG/Exhibition-Hall-5-8_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-LG/Exhibition-Hall-5-8_1200x630_@1x.webp',
            caption: '展厅5-8',
            align: 'left',
          },
        },
        {
          align: 'bottom',
          image: {
            src: '/images/venue/level-LG/Foyer-A_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-LG/Foyer-A_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-LG/Foyer-A_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-LG/Foyer-A_1200x630_@1x.webp',
            caption: '前厅A',
            align: 'left',
          },
        },
        {
          image: {
            src: '/images/venue/level-LG/Foyer-B_@2x.jpg',
            srcSp: '/images/venue/level-LG/Foyer-B_@1x.jpg',
            srcWebp: '/images/venue/level-LG/Foyer-B_@2x.webp',
            srcWebpSp: '/images/venue/level-LG/Foyer-B_@1x.webp',
            caption: '前厅B',
            align: 'left',
          },
        },
      ],
      explore360: [
        {
          type: 'full',
          image: {
            src: '/images/venue/level-LG/360/cover-LG_Hall@2x.jpg',
            srcSp: '/images/venue/level-LG/360/cover-LG_Hall-sp@2x.jpg',
            srcWebp: '/images/venue/level-LG/360/cover-LG_Hall@2x.webp',
            srcWebpSp: '/images/venue/level-LG/360/cover-LG_Hall-sp@2x.webp',
            caption: '展厅5-8',
            align: 'left',
          },
          image360: '/images/venue/level-LG/360/LG_Hall.jpg',
        },
        {
          image: {
            src: '/images/venue/level-LG/360/cover-LG_Hall-2@2x.jpg',
            srcSp: '/images/venue/level-LG/360/cover-LG_Hall-2-sp@2x.jpg',
            srcWebp: '/images/venue/level-LG/360/cover-LG_Hall-2@2x.webp',
            srcWebpSp: '/images/venue/level-LG/360/cover-LG_Hall-2-sp@2x.webp',
            caption: '前厅A',
            align: 'left',
          },
          image360: '/images/venue/level-LG/360/Foryer_A.jpg',
        },
        {
          image: {
            src: '/images/venue/level-LG/360/cover-LG_Hall-3@2x.jpg',
            srcSp: '/images/venue/level-LG/360/cover-LG_Hall-3-sp@2x.jpg',
            srcWebp: '/images/venue/level-LG/360/cover-LG_Hall-3@2x.webp',
            srcWebpSp: '/images/venue/level-LG/360/cover-LG_Hall-3-sp@2x.webp',
            caption: '前厅B',
            align: 'left',
          },
          image360: '/images/venue/level-LG/360/Foryer_B.jpg',
        },
      ],
    },
  },
  {
    level: 'LM',
    images: {
      active: {
        src: '/images/floors/floor-LM-active.png',
        srcWebp: '/images/floors/floor-LM-active.webp',
        width: 689,
        height: 359,
      },
      inactive: {
        src: '/images/floors/floor-LM.png',
        srcWebp: '/images/floors/floor-LM.webp',
        width: 575,
        height: 261,
      },
    },
  },
  {
    level: 'G',
    images: {
      active: {
        src: '/images/floors/floor-G-active.png',
        srcWebp: '/images/floors/floor-G-active.webp',
        width: 689,
        height: 378,
      },
      inactive: {
        src: '/images/floors/floor-G.png',
        srcWebp: '/images/floors/floor-G.webp',
        width: 531,
        height: 291,
      },
    },
    action: true,
    description: {
      cn: 'G层为主展厅，全厅无柱，面积为22,335 平方米，入口处具有宽敞的前厅及湖景。',
      th: 'ชั้น G ประกอบด้วยโถงทางเข้าขนาดใหญ่ สามารถมองเห็นทิวทัศน์อันงดงามของทะเลสาบ และมีฮอลล์สำหรับจัดนิทรรศการ (Exhibition Hall)​ แบบไร้เสาขนาดพื้นที่ 22,335 ตารางเมตร',
    },
    facility: {
      layouts: {
        description: `
        <div class="t-venue-floor__info-floor-data-description-item">
          <ul class="a-list">
            <li>多功能厅</li>
            <li>5个落客区</li>
            <li>楼面负荷 = 2,000 kg/m<sup>2</sup></li>
            <li>装卸区 = 24个</li>
            <li>员工电梯 = 2部（2.7 m x 1.2 m x 3 m）（长 x 宽 x 高），载重1,350 kg</li>
            <li>货梯 = 3部（8 m x 3.5 m x 3 m）（长 x 宽 x 高），载重5,000 kg</li>
          </ul>
        </div>
        `,
        options: [
          {
            label: '所有区域',
            mode: 'all',
          },
          {
            label: '展厅1+2',
            mode: 'combine',
            keys: ['g-hall-1', 'g-hall-2'],
          },
          {
            label: '展厅3+4',
            mode: 'combine',
            keys: ['g-hall-3', 'g-hall-4'],
          },
          {
            label: '展厅1+2+3+4',
            mode: 'combine',
            keys: ['g-hall-1', 'g-hall-2', 'g-hall-3', 'g-hall-4'],
          },
        ],
        total: {
          'g-hall-1_g-hall-2': {
            dimension: {
              title: '尺寸（初步估算）',
              items: [
                { icon: 'all-floor', label: '长（米）', key: 'length', value: 108 },
                { icon: 'all-floor', label: '宽（米）', key: 'width', value: 105.95 },
                { icon: 'all-floor', label: '高（米）', key: 'height', value: 13.5 },
              ],
            },
            area: {
              title: '可使用总面积',
              items: [
                { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 11444 },
                { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 123182 },
              ],
            },
            capacity: {
              title: '最大容量（大约）',
              items: [
                { icon: 'theatre', label: '剧院式', key: 'theatre', value: 10000 },
                { icon: 'classroom', label: '课桌式', key: 'classroom', value: 5000 },
                { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 5000 },
                { icon: 'reception', label: '招待会', key: 'reception', value: 10000 },
                { icon: 'booth', label: '展台', key: 'booth', value: 648 },
              ],
            },
          },
          'g-hall-3_g-hall-4': {
            dimension: {
              title: '尺寸（初步估算）',
              items: [
                { icon: 'all-floor', label: '长（米）', key: 'length', value: 108 },
                { icon: 'all-floor', label: '宽（米）', key: 'width', value: 101.08 },
                { icon: 'all-floor', label: '高（米）', key: 'height', value: 13.5 },
              ],
            },
            area: {
              title: '可使用总面积',
              items: [
                { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 10918 },
                { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 117520 },
              ],
            },
            capacity: {
              title: '最大容量（大约）',
              items: [
                { icon: 'theatre', label: '剧院式', key: 'theatre', value: 10000 },
                { icon: 'classroom', label: '课桌式', key: 'classroom', value: 5000 },
                { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 5000 },
                { icon: 'reception', label: '招待会', key: 'reception', value: 10000 },
                { icon: 'booth', label: '展台', key: 'booth', value: 648 },
              ],
            },
          },
          'g-hall-1_g-hall-2_g-hall-3_g-hall-4': {
            dimension: {
              title: '尺寸（初步估算）',
              items: [
                { icon: 'all-floor', label: '长（米）', key: 'length', value: 207 },
                { icon: 'all-floor', label: '宽（米）', key: 'width', value: 108 },
                { icon: 'all-floor', label: '高（米）', key: 'height', value: 13.5 },
              ],
            },
            area: {
              title: '可使用总面积',
              items: [
                { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 22326 },
                { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 240702 },
              ],
            },
            capacity: {
              title: '最大容量（大约）',
              items: [
                { icon: 'theatre', label: '剧院式', key: 'theatre', value: 20000 },
                { icon: 'classroom', label: '课桌式', key: 'classroom', value: 10000 },
                { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 10000 },
                { icon: 'reception', label: '招待会', key: 'reception', value: 20000 },
                { icon: 'booth', label: '展台', key: 'booth', value: 1365 },
              ],
            },
          },
        },
        legends: [
          {
            text: '所在会堂',
            color: '#9D8F3D',
          },
          {
            text: '大堂/公众区域',
            color: '#D4C9AA',
          },
          {
            text: '零售与餐饮',
            color: '#EFC8AB',
          },
          {
            text: '客梯',
            color: '#A6B7A4',
          },
          {
            text: '货梯',
            color: '#4B6856',
          },
          {
            text: '会堂',
            color: '#D8D2C5',
            border: 'dashed',
          },
          {
            text: '贵宾室',
            color: '#909086',
          },
          {
            text: '组织方办公室',
            color: '#A58680',
          },
          {
            text: '员工电梯',
            color: '#7F5951',
          },
          {
            text: '消防通道',
            color: '#4B577F',
          },
        ],
      },
      floorplans: [
        {
          icon: 'all-floor',
          label: '所有楼层平面图',
          tabLabel: '所有楼层平面图',
          showFloor: true,
          showLayout: false,
          image: {
            png: '/images/floors/details/level-G-all.png',
            webp: '/images/floors/details/level-G-all.webp',
            pngSp: '/images/floors/details/level-G-all-sp.png',
            webpSp: '/images/floors/details/level-G-all-sp.webp',
          },
          data: {
            description: `
            <div class="t-venue-floor__info-floor-data-description-item">
              <ul class="a-list">
                <li>多功能厅</li>
                <li>5个落客区</li>
                <li>楼面负荷 = 2,000 kg/m<sup>2</sup></li>
                <li>装卸区 = 24个</li>
                <li>员工电梯 = 2部（2.7 m x 1.2 m x 3 m）（长 x 宽 x 高），载重1,350 kg</li>
                <li>货梯 = 3部（8 m x 3.5 m x 3 m）（长 x 宽 x 高），载重5,000 kg</li>
              </ul>
            </div>
            `,
          },
        },
        {
          icon: 'number-1',
          label: '展厅1',
          tabLabel: '展厅',
          key: 'g-hall-1',
          showFloor: true,
          showLayout: true,
          image: {
            png: '/images/floors/details/level-G-hall-1.png',
            webp: '/images/floors/details/level-G-hall-1.webp',
            pngSp: '/images/floors/details/level-G-hall-1-sp.png',
            webpSp: '/images/floors/details/level-G-hall-1-sp.webp',
          },
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 53.32 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 13.5 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5651 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 60827 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5000 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 2500 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2500 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 5000 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 290 },
                ],
              },
            },
          },
        },
        {
          icon: 'number-2',
          label: '展厅2',
          tabLabel: '展厅',
          key: 'g-hall-2',
          showFloor: true,
          showLayout: true,
          image: {
            png: '/images/floors/details/level-G-hall-2.png',
            webp: '/images/floors/details/level-G-hall-2.webp',
            pngSp: '/images/floors/details/level-G-hall-2-sp.png',
            webpSp: '/images/floors/details/level-G-hall-2-sp.webp',
          },
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 53.63 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 13.5 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5793 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 62355 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5000 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 2500 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2500 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 5000 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 358 },
                ],
              },
            },
          },
        },
        {
          icon: 'number-3',
          label: '展厅3',
          tabLabel: '展厅',
          key: 'g-hall-3',
          showFloor: true,
          showLayout: true,
          image: {
            png: '/images/floors/details/level-G-hall-3.png',
            webp: '/images/floors/details/level-G-hall-3.webp',
            pngSp: '/images/floors/details/level-G-hall-3-sp.png',
            webpSp: '/images/floors/details/level-G-hall-3-sp.webp',
          },
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 53.63 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 13.5 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5793 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 62355 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5000 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 2500 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2500 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 5000 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 358 },
                ],
              },
            },
          },
        },
        {
          icon: 'number-4',
          label: '展厅4',
          tabLabel: '展厅',
          key: 'g-hall-4',
          showFloor: true,
          showLayout: true,
          image: {
            png: '/images/floors/details/level-G-hall-4.png',
            webp: '/images/floors/details/level-G-hall-4.webp',
            pngSp: '/images/floors/details/level-G-hall-4-sp.png',
            webpSp: '/images/floors/details/level-G-hall-4-sp.webp',
          },
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 47.45 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 13.5 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5125 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 55165 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5000 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 2500 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2500 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 5000 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 290 },
                ],
              },
            },
          },
        },
        {
          label: '大堂A',
          key: 'g-main-foyer-a',
          showFloor: false,
          showLayout: true,
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { icon: 'all-floor', label: '长（米）', key: 'length', value: 165 },
                  { icon: 'all-floor', label: '宽（米）', key: 'width', value: 11 },
                  { icon: 'all-floor', label: '高（米）', key: 'height', value: 5.5 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 2500 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 26910 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 0 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 0 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 0 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 0 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 0 },
                ],
              },
            },
          },
        },
        {
          label: '大堂B',
          key: 'g-main-foyer-b',
          showFloor: false,
          showLayout: true,
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { icon: 'all-floor', label: '长（米）', key: 'length', value: 187 },
                  { icon: 'all-floor', label: '宽（米）', key: 'width', value: 37.5 },
                  { icon: 'all-floor', label: '高（米）', key: 'height', value: 5.5 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 7500 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 80729 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 0 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 0 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 0 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 0 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 0 },
                ],
              },
            },
          },
        },
      ],
      gallery: [
        {
          type: 'half',
          image: {
            src: '/images/venue/level-G/5_Exhibition-Hall-1-4-(3)_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-G/5_Exhibition-Hall-1-4-(3)_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-G/5_Exhibition-Hall-1-4-(3)_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-G/5_Exhibition-Hall-1-4-(3)_1200x630_@1x.webp',
            caption: '展厅1-4',
            align: 'left',
          },
        },
        {
          image: {
            src: '/images/venue/level-G/6_Main-Foyer-A(3)_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-G/6_Main-Foyer-A(3)_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-G/6_Main-Foyer-A(3)_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-G/6_Main-Foyer-A(3)_1200x630_@1x.webp',
            caption: '大堂A',
            align: 'left',
          },
        },
        {
          image: {
            src: '/images/venue/level-G/7_Main-Foyer-B-(2)_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-G/7_Main-Foyer-B-(2)_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-G/7_Main-Foyer-B-(2)_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-G/7_Main-Foyer-B-(2)_1200x630_@1x.webp',
            caption: '大堂B',
            align: 'left',
          },
        },
        {
          type: 'full',
          align: 'bottom',
          image: {
            src: '/images/venue/level-G/8_Main-Foyer-B_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-G/8_Main-Foyer-B_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-G/8_Main-Foyer-B_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-G/8_Main-Foyer-B_1200x630_@1x.webp',
            caption: '大堂B',
            align: 'left',
          },
        },
        {
          type: 'half',
          image: {
            src: '/images/venue/level-G/Exhibition-Hall-1-4-(1)_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-G/Exhibition-Hall-1-4-(1)_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-G/Exhibition-Hall-1-4-(1)_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-G/Exhibition-Hall-1-4-(1)_1200x630_@1x.webp',
            caption: '展厅1-4',
            align: 'left',
          },
        },
        {
          image: {
            src: '/images/venue/level-G/Exhibition-Hall-1-4-(2)_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-G/Exhibition-Hall-1-4-(2)_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-G/Exhibition-Hall-1-4-(2)_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-G/Exhibition-Hall-1-4-(2)_1200x630_@1x.webp',
            caption: '展厅1-4',
            align: 'left',
          },
        },
        {
          image: {
            src: '/images/venue/level-G/Main-Foyer-A_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-G/Main-Foyer-A_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-G/Main-Foyer-A_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-G/Main-Foyer-A_1200x630_@1x.webp',
            caption: '大堂A',
            align: 'left',
          },
        },
        {
          type: 'full',
          align: 'bottom',
          image: {
            src: '/images/venue/level-G/Main-Foyer-A(2)_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-G/Main-Foyer-A(2)_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-G/Main-Foyer-A(2)_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-G/Main-Foyer-A(2)_1200x630_@1x.webp',
            caption: '大堂A',
            align: 'left',
          },
        },
      ],
      explore360: [
        {
          type: 'full',
          image: {
            src: '/images/venue/level-G/360/cover-G_Hall@2x.jpg',
            srcSp: '/images/venue/level-G/360/cover-G_Hall-sp@2x.jpg',
            srcWebp: '/images/venue/level-G/360/cover-G_Hall@2x.webp',
            srcWebpSp: '/images/venue/level-G/360/cover-G_Hall-sp@2x.webp',
            caption: '展厅1-4',
            align: 'left',
          },
          image360: '/images/venue/level-G/360/G_Exhibition-Hall.jpg',
        },
        {
          type: 'full',
          image: {
            src: '/images/venue/level-G/360/cover-G_Hall-2@2x.jpg',
            srcSp: '/images/venue/level-G/360/cover-G_Hall-2-sp@2x.jpg',
            srcWebp: '/images/venue/level-G/360/cover-G_Hall-2@2x.webp',
            srcWebpSp: '/images/venue/level-G/360/cover-G_Hall-2-sp@2x.webp',
            caption: '大堂B',
            align: 'left',
          },
          image360: '/images/venue/level-G/360/Prefunction.jpg',
        },
      ],
    },
  },
  {
    level: 'UM',
    images: {
      active: {
        src: '/images/floors/floor-UM-active.png',
        srcWebp: '/images/floors/floor-UM-active.webp',
        width: 689,
        height: 339,
      },
      inactive: {
        src: '/images/floors/floor-UM.png',
        srcWebp: '/images/floors/floor-UM.webp',
        width: 531,
        height: 261,
      },
    },
  },
  {
    level: 'L1',
    images: {
      active: {
        src: '/images/floors/floor-1-active.png',
        srcWebp: '/images/floors/floor-1-active.webp',
        width: 689,
        height: 339,
      },
      inactive: {
        src: '/images/floors/floor-1.png',
        srcWebp: '/images/floors/floor-1.webp',
        width: 531,
        height: 261,
      },
    },
    action: true,
    description: {
      cn: '宴会厅和大会堂恢宏气派，可以俯瞰湖景及公园景色。',
      th: 'ห้องบอลรูม (Ballroom) และเพลนารีฮอลล์ (Plenary Hall) หนึ่งในพื้นที่จัดแสดงงานที่มีความโดดเด่นด้วยวิวที่งดงามของทะเลสาบและสวนสาธารณะที่เขียวขจี',
    },
    facility: {
      layouts: {
        description: `
        <div class="t-venue-floor__info-floor-data-description-item">
          <strong>大会堂</strong><br/>
          <ul class="a-list">
            <li>楼面负荷 = 1,000 kg/m<sup>2</sup></li>
            <li>装卸区 = 21个</li>
            <li>货梯 = 2部（8 m x 3.5 m x 3 m）（长 x 宽 x 高），载重5,000 kg</li>
            <li>员工电梯 = 4部（2.7 m x 1.2 m x 3 m）（长 x 宽 x 高），载重1,350 kg</li>
          </ul>
        </div>
        <div class="t-venue-floor__info-floor-data-description-item">
          <strong>宴会厅</strong><br/>
          <ul class="a-list">
            <li>楼面负荷 = 1,500 kg/m<sup>2</sup></li>
            <li>装卸区 = 21个</li>
            <li>货梯 = 2部（8 m x 3.5 m x 3 m）（长 x 宽 x 高），载重5,000 kg</li>
            <li>员工电梯 = 4部（2.7 m x 1.2 m x 3 m）（长 x 宽 x 高），载重1,350 kg</li>
          </ul>
        </div>
        `,
        options: [
          {
            label: '所有区域',
            mode: 'all',
          },
          {
            label: '大会堂1+2+3',
            mode: 'combine',
            keys: ['1-plenary-hall-1', '1-plenary-hall-2', '1-plenary-hall-3'],
          },
          {
            label: '大会堂1+2+3+4',
            mode: 'combine',
            keys: ['1-plenary-hall-1', '1-plenary-hall-2', '1-plenary-hall-3', '1-plenary-hall-4'],
          },
          {
            label: '宴会厅1+2',
            mode: 'combine',
            keys: ['1-ballroom-1', '1-ballroom-2'],
          },
          {
            label: '宴会厅3+4',
            mode: 'combine',
            keys: ['1-ballroom-3', '1-ballroom-4'],
          },
          {
            label: '宴会厅1+2+3+4',
            mode: 'combine',
            keys: ['1-ballroom-1', '1-ballroom-2', '1-ballroom-3', '1-ballroom-4'],
          },
        ],
        total: {
          '1-plenary-hall-1_1-plenary-hall-2_1-plenary-hall-3': {
            dimension: {
              title: '尺寸（初步估算）',
              items: [
                { icon: 'all-floor', label: '长（米）', key: 'length', value: 42.5 },
                { icon: 'all-floor', label: '宽（米）', key: 'width', value: 77.0 },
                { icon: 'all-floor', label: '高（米）', key: 'height', value: 9 },
              ],
            },
            area: {
              title: '可使用总面积',
              items: [
                { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 3276 },
                { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 35263 },
              ],
            },
            capacity: {
              title: '最大容量（大约）',
              items: [
                { icon: 'theatre', label: '剧院式', key: 'theatre', value: 3270 },
                { icon: 'classroom', label: '课桌式', key: 'classroom', value: 1760 },
                { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 1760 },
                { icon: 'reception', label: '招待会', key: 'reception', value: 3270 },
                { icon: 'booth', label: '展台', key: 'booth', value: 165 },
              ],
            },
          },
          '1-plenary-hall-1_1-plenary-hall-2_1-plenary-hall-3_1-plenary-hall-4': {
            dimension: {
              title: '尺寸（初步估算）',
              items: [
                { icon: 'all-floor', label: '长（米）', key: 'length', value: 87.5 },
                { icon: 'all-floor', label: '宽（米）', key: 'width', value: 56.9 },
                { icon: 'all-floor', label: '高（米）', key: 'height', value: 9 },
              ],
            },
            area: {
              title: '可使用总面积',
              items: [
                { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 4540 },
                { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 48868 },
              ],
            },
            capacity: {
              title: '最大容量（大约）',
              items: [
                { icon: 'theatre', label: '剧院式', key: 'theatre', value: 4170 },
                { icon: 'classroom', label: '课桌式', key: 'classroom', value: 2370 },
                { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2160 },
                { icon: 'reception', label: '招待会', key: 'reception', value: 4170 },
                { icon: 'booth', label: '展台', key: 'booth', value: 217 },
              ],
            },
          },
          '1-ballroom-1_1-ballroom-2': {
            dimension: {
              title: '尺寸（初步估算）',
              items: [
                { icon: 'all-floor', label: '长（米）', key: 'length', value: 44.5 },
                { icon: 'all-floor', label: '宽（米）', key: 'width', value: 50.67 },
                { icon: 'all-floor', label: '高（米）', key: 'height', value: 9.5 },
              ],
            },
            area: {
              title: '可使用总面积',
              items: [
                { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 2255 },
                { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 24273 },
              ],
            },
            capacity: {
              title: '最大容量（大约）',
              items: [
                { icon: 'theatre', label: '剧院式', key: 'theatre', value: 2116 },
                { icon: 'classroom', label: '课桌式', key: 'classroom', value: 1320 },
                { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 1100 },
                { icon: 'reception', label: '招待会', key: 'reception', value: 2110 },
                { icon: 'booth', label: '展台', key: 'booth', value: 128 },
              ],
            },
          },
          '1-ballroom-3_1-ballroom-4': {
            dimension: {
              title: '尺寸（初步估算）',
              items: [
                { icon: 'all-floor', label: '长（米）', key: 'length', value: 44.5 },
                { icon: 'all-floor', label: '宽（米）', key: 'width', value: 53.33 },
                { icon: 'all-floor', label: '高（米）', key: 'height', value: 9.5 },
              ],
            },
            area: {
              title: '可使用总面积',
              items: [
                { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 2374 },
                { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 25553 },
              ],
            },
            capacity: {
              title: '最大容量（大约）',
              items: [
                { icon: 'theatre', label: '剧院式', key: 'theatre', value: 2320 },
                { icon: 'classroom', label: '课桌式', key: 'classroom', value: 1440 },
                { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 1200 },
                { icon: 'reception', label: '招待会', key: 'reception', value: 2320 },
                { icon: 'booth', label: '展台', key: 'booth', value: 140 },
              ],
            },
          },
          '1-ballroom-1_1-ballroom-2_1-ballroom-3_1-ballroom-4': {
            dimension: {
              title: '尺寸（初步估算）',
              items: [
                { icon: 'all-floor', label: '长（米）', key: 'length', value: 104 },
                { icon: 'all-floor', label: '宽（米）', key: 'width', value: 44.5 },
                { icon: 'all-floor', label: '高（米）', key: 'height', value: 9.5 },
              ],
            },
            area: {
              title: '可使用总面积',
              items: [
                { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 4629 },
                { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 49826 },
              ],
            },
            capacity: {
              title: '最大容量（大约）',
              items: [
                { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5802 },
                { icon: 'classroom', label: '课桌式', key: 'classroom', value: 3480 },
                { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2300 },
                { icon: 'reception', label: '招待会', key: 'reception', value: 5800 },
                { icon: 'booth', label: '展台', key: 'booth', value: 264 },
              ],
            },
          },
        },
        legends: [
          {
            text: '所在会堂',
            color: '#9D8F3D',
          },
          {
            text: '大堂/公众区域',
            color: '#D4C9AA',
          },
          {
            text: '会议室',
            color: '#DCDDD8',
          },
          {
            text: '客梯',
            color: '#A6B7A4',
          },
          {
            text: '货梯',
            color: '#4B6856',
          },
          {
            text: '会堂',
            color: '#D8D2C5',
            border: 'dashed',
          },
          {
            text: '贵宾室',
            color: '#909086',
          },
          {
            text: '组织方办公室',
            color: '#A58680',
          },
          {
            text: '员工电梯',
            color: '#7F5951',
          },
          {
            text: '消防通道',
            color: '#4B577F',
          },
        ],
      },
      floorplans: [
        {
          icon: 'all-floor',
          label: '所有楼层平面图',
          tabLabel: '所有楼层平面图',
          showFloor: true,
          showLayout: false,
          image: {
            png: '/images/floors/details/level-1-all.png',
            webp: '/images/floors/details/level-1-all.webp',
            pngSp: '/images/floors/details/level-1-all-sp.png',
            webpSp: '/images/floors/details/level-1-all-sp.webp',
          },
          data: {
            description: `
            <div class="t-venue-floor__info-floor-data-description-item">
              <strong>大会堂</strong><br/>
              <ul class="a-list">
                <li>楼面负荷 = 1,000 kg/m<sup>2</sup></li>
                <li>装卸区 = 21个</li>
                <li>货梯 = 2部（8 m x 3.5 m x 3 m）（长 x 宽 x 高），载重5,000 kg</li>
                <li>员工电梯 = 4部（2.7 m x 1.2 m x 3 m）（长 x 宽 x 高），载重1,350 kg</li>
              </ul>
            </div>
            <div class="t-venue-floor__info-floor-data-description-item">
              <strong>宴会厅</strong><br/>
              <ul class="a-list">
                <li>楼面负荷 = 1,500 kg/m<sup>2</sup></li>
                <li>装卸区 = 21个</li>
                <li>货梯 = 2部（8 m x 3.5 m x 3 m）（长 x 宽 x 高），载重5,000 kg</li>
                <li>员工电梯 = 4部（2.7 m x 1.2 m x 3 m）（长 x 宽 x 高），载重1,350 kg</li>
              </ul>
            </div>
            `,
          },
        },
        {
          icon: 'number-1',
          label: '大会堂1',
          tabLabel: '大会堂',
          key: '1-plenary-hall-1',
          showFloor: true,
          showLayout: true,
          image: {
            png: '/images/floors/details/level-1-plenary-hall-1.png',
            webp: '/images/floors/details/level-1-plenary-hall-1.webp',
            pngSp: '/images/floors/details/level-1-plenary-hall-1-sp.png',
            webpSp: '/images/floors/details/level-1-plenary-hall-1-sp.webp',
          },
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 42.5 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 23.3 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 9 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 990 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 10656 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 956 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 600 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 440 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 700 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 61 },
                ],
              },
            },
          },
        },
        {
          icon: 'number-2',
          label: '大会堂2',
          tabLabel: '大会堂',
          key: '1-plenary-hall-2',
          showFloor: true,
          showLayout: true,
          image: {
            png: '/images/floors/details/level-1-plenary-hall-2.png',
            webp: '/images/floors/details/level-1-plenary-hall-2.webp',
            pngSp: '/images/floors/details/level-1-plenary-hall-2-sp.png',
            webpSp: '/images/floors/details/level-1-plenary-hall-2-sp.webp',
          },
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 42.5 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 26.7 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 9 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1136 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 12228 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 1160 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 720 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 460 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 850 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 64 },
                ],
              },
            },
          },
        },
        {
          icon: 'number-3',
          label: '大会堂3',
          tabLabel: '大会堂',
          key: '1-plenary-hall-3',
          showFloor: true,
          showLayout: true,
          image: {
            png: '/images/floors/details/level-1-plenary-hall-3.png',
            webp: '/images/floors/details/level-1-plenary-hall-3.webp',
            pngSp: '/images/floors/details/level-1-plenary-hall-3-sp.png',
            webpSp: '/images/floors/details/level-1-plenary-hall-3-sp.webp',
          },
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 42.5 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 27.0 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 9 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1150 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 12378 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 1160 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 720 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 460 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 850 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 52 },
                ],
              },
            },
          },
        },
        {
          icon: 'number-4',
          label: '大会堂4',
          tabLabel: '大会堂',
          key: '1-plenary-hall-4',
          showFloor: true,
          showLayout: true,
          image: {
            png: '/images/floors/details/level-1-plenary-hall-4.png',
            webp: '/images/floors/details/level-1-plenary-hall-4.webp',
            pngSp: '/images/floors/details/level-1-plenary-hall-4-sp.png',
            webpSp: '/images/floors/details/level-1-plenary-hall-4-sp.webp',
          },
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 14.4 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 87.5 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 9 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1264 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 13606 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 900 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 610 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 400 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 900 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 40 },
                ],
              },
            },
          },
        },
        {
          icon: 'number-1',
          label: '宴会厅1',
          tabLabel: '宴会厅',
          key: '1-ballroom-1',
          showFloor: true,
          showLayout: true,
          showFloorSecondary: true,
          image: {
            png: '/images/floors/details/level-1-ballroom-1.png',
            webp: '/images/floors/details/level-1-ballroom-1.webp',
            pngSp: '/images/floors/details/level-1-ballroom-1-sp.png',
            webpSp: '/images/floors/details/level-1-ballroom-1-sp.webp',
          },
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 44.5 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 23.84 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 9.5 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1061 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 11420 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 956 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 600 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 500 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 950 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 58 },
                ],
              },
            },
          },
        },
        {
          icon: 'number-2',
          label: '宴会厅2',
          tabLabel: '宴会厅',
          key: '1-ballroom-2',
          showFloor: true,
          showLayout: true,
          showFloorSecondary: true,
          image: {
            png: '/images/floors/details/level-1-ballroom-2.png',
            webp: '/images/floors/details/level-1-ballroom-2.webp',
            pngSp: '/images/floors/details/level-1-ballroom-2-sp.png',
            webpSp: '/images/floors/details/level-1-ballroom-2-sp.webp',
          },
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 44.5 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 26.83 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 9.5 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1194 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 12852 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 1160 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 720 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 600 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 1160 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 70 },
                ],
              },
            },
          },
        },
        {
          icon: 'number-3',
          label: '宴会厅3',
          tabLabel: '宴会厅',
          key: '1-ballroom-3',
          showFloor: true,
          showLayout: true,
          showFloorSecondary: true,
          image: {
            png: '/images/floors/details/level-1-ballroom-3.png',
            webp: '/images/floors/details/level-1-ballroom-3.webp',
            pngSp: '/images/floors/details/level-1-ballroom-3-sp.png',
            webpSp: '/images/floors/details/level-1-ballroom-3-sp.webp',
          },
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 44.5 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 26.83 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 9.5 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1194 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 12852 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 1160 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 720 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 600 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 1160 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 70 },
                ],
              },
            },
          },
        },
        {
          icon: 'number-4',
          label: '宴会厅4',
          tabLabel: '宴会厅',
          key: '1-ballroom-4',
          showFloor: true,
          showLayout: true,
          showFloorSecondary: true,
          image: {
            png: '/images/floors/details/level-1-ballroom-4.png',
            webp: '/images/floors/details/level-1-ballroom-4.webp',
            pngSp: '/images/floors/details/level-1-ballroom-4-sp.png',
            webpSp: '/images/floors/details/level-1-ballroom-4-sp.webp',
          },
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 44.5 },
                  { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 26.5 },
                  { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 9.5 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1180 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 12701 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 1160 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 720 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 600 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 1160 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 70 },
                ],
              },
            },
          },
        },
        {
          label: '宴会厅门厅',
          key: '1-ballroom-foyer',
          showFloor: false,
          showLayout: true,
          data: {
            measurements: {
              dimension: {
                title: '尺寸（初步估算）',
                items: [
                  { icon: 'all-floor', label: '长（米）', key: 'length', value: 119 },
                  { icon: 'all-floor', label: '宽（米）', key: 'width', value: 10 },
                  { icon: 'all-floor', label: '高（米）', key: 'height', value: 9.5 },
                ],
              },
              area: {
                title: '可使用总面积',
                items: [
                  { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1190 },
                  { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 12809 },
                ],
              },
              capacity: {
                title: '最大容量（大约）',
                items: [
                  { icon: 'theatre', label: '剧院式', key: 'theatre', value: 0 },
                  { icon: 'classroom', label: '课桌式', key: 'classroom', value: 0 },
                  { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 0 },
                  { icon: 'reception', label: '招待会', key: 'reception', value: 0 },
                  { icon: 'booth', label: '展台', key: 'booth', value: 0 },
                ],
              },
            },
          },
        },
      ],
      gallery: [
        {
          type: 'half',
          image: {
            src: '/images/venue/level-1/1_Central-Lounge_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-1/1_Central-Lounge_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-1/1_Central-Lounge_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-1/1_Central-Lounge_1200x630_@1x.webp',
            caption: '中央休息室',
            align: 'left',
          },
        },
        {
          image: {
            src: '/images/venue/level-1/2_Meeting-Room-Foyer-B_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-1/2_Meeting-Room-Foyer-B_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-1/2_Meeting-Room-Foyer-B_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-1/2_Meeting-Room-Foyer-B_1200x630_@1x.webp',
            caption: '会议室前厅',
            align: 'left',
          },
        },
        {
          image: {
            src: '/images/venue/level-1/4_Plenary-Hall-1_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-1/4_Plenary-Hall-1_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-1/4_Plenary-Hall-1_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-1/4_Plenary-Hall-1_1200x630_@1x.webp',
            caption: '大会堂1',
            align: 'left',
          },
        },
        {
          type: 'full',
          align: 'bottom',
          image: {
            src: '/images/venue/level-1/3_Plenary-Hall-2_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-1/3_Plenary-Hall-2_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-1/3_Plenary-Hall-2_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-1/3_Plenary-Hall-2_1200x630_@1x.webp',
            caption: '大会堂2',
            align: 'left',
          },
        },
        {
          type: 'full',
          image: {
            src: '/images/venue/level-1/Ballroom-Foyer_2400x1260_@2x.jpg',
            srcSp: '/images/venue/level-1/Ballroom-Foyer_1200x630_@1x.jpg',
            srcWebp: '/images/venue/level-1/Ballroom-Foyer_2400x1260_@2x.webp',
            srcWebpSp: '/images/venue/level-1/Ballroom-Foyer_1200x630_@1x.webp',
            caption: '宴会厅门厅',
            align: 'left',
          },
        },
      ],
      explore360: [
        {
          type: 'full',
          image: {
            src: '/images/venue/level-1/360/cover-1_Hall@2x.jpg',
            srcSp: '/images/venue/level-1/360/cover-1_Hall-sp@2x.jpg',
            srcWebp: '/images/venue/level-1/360/cover-1_Hall@2x.webp',
            srcWebpSp: '/images/venue/level-1/360/cover-1_Hall-sp@2x.webp',
            caption: '会议室前厅B',
            align: 'left',
          },
          image360: '/images/venue/level-1/360/Meeting-Room.jpg',
        },
        {
          image: {
            src: '/images/venue/level-1/360/cover-1_Hall-2@2x.jpg',
            srcSp: '/images/venue/level-1/360/cover-1_Hall-2-sp@2x.jpg',
            srcWebp: '/images/venue/level-1/360/cover-1_Hall-2@2x.webp',
            srcWebpSp: '/images/venue/level-1/360/cover-1_Hall-2-sp@2x.webp',
            caption: '宴会厅',
            align: 'left',
          },
          image360: '/images/venue/level-1/360/L1_Ballroom-Hall.jpg',
        },
        {
          image: {
            src: '/images/venue/level-1/360/cover-1_Hall-3@2x.jpg',
            srcSp: '/images/venue/level-1/360/cover-1_Hall-3-sp@2x.jpg',
            srcWebp: '/images/venue/level-1/360/cover-1_Hall-3@2x.webp',
            srcWebpSp: '/images/venue/level-1/360/cover-1_Hall-3-sp@2x.webp',
            caption: '大会堂',
            align: 'left',
          },
          image360: '/images/venue/level-1/360/L1_Plenary-Hall.jpg',
        },
      ],
    },
  },
  {
    level: 'L2',
    images: {
      active: {
        src: '/images/floors/floor-2-active.png',
        srcWebp: '/images/floors/floor-2-active.webp',
        width: 689,
        height: 339,
      },
      inactive: {
        src: '/images/floors/floor-2.png',
        width: 531,
        height: 261,
      },
    },
  },
];

export const POI_LIST = {
  poiList: [
    {
      y: 86,
      x: 72,
      spY: 74,
      spX: 94,
      type: 'poi',
      image: '/images/marker-images/fyi.jpg',
      imageWebp: '/images/marker-images/fyi.webp',
      name: {
        cn: 'FIY中心',
        th: 'เอฟวายไอ เซ็นเตอร์',
      },
      value: 'fyi',
      depth: 0,
      order: 3,
      cardInfo: {
        key: 'fyi',
        logo: '/images/landmarks/logos/fyi-center.png',
        image: '/images/landmarks/FYI-Center_800x420_@2x.jpg',
        imageSP: '/images/landmarks/FYI-Center_400x210_@1x.jpg',
        logoWebp: '/images/landmarks/logos/fyi-center.webp',
        imageWebp: '/images/landmarks/FYI-Center_800x420_@2x.webp',
        imageWebpSP: '/images/landmarks/FYI-Center_400x210_@1x.webp',
        title: {
          cn: 'FIY中心',
          th: 'เอฟวายไอ เซ็นเตอร์ ',
        },
        description: {
          cn: 'FIY中心坐落于Rama IV路新商业区，以友好的环境和可灵活分配的地面空间激发灵感与创意。',
          th: 'เอฟวายไอ เซ็นเตอร์ (FIY Center) อาคารสำนักงานในย่านธุรกิจใหม่ของถนนพระราม 4 ออกแบบให้มีสภาพแวดล้อมที่เป็นมิตรและพื้นที่ใช้สอยที่ยืดหยุ่น จึงเหมาะเป็นพื้นที่สร้างแรงบันดาลใจในการสร้างสรรค์สิ่งใหม่ๆ',
        },
        // tel: '(662) 229-3000',
        // hours: '09:00 - 18:00',
        // map: 'https://goo.gl/maps/WoWt3CaPUSTT81dv5',
        // map:'https://map.baidu.com/poi/%E6%9A%B9%E7%BD%97%E4%B8%AD%E5%BF%83/@11191378.518377896,1536557.0922103387,13.18z?uid=d73b602b50d8c0b9a1acc425&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bff570fa44139d6c8708ed59572003fc23e3ea45d0bea99cf948fa729396b7809175186d8641adda90425c4d33ca66a494&querytype=detailConInfo&da_src=shareurl',
        map: 'https://map.baidu.com/poi/FYI%20CENTER/@11194371.965,1531967.58,19z?uid=1ce77ac929ebc3955fbe86ea&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&seckey=2428f0fbe21253a5a5a1ffc000c4bb522f7e4b7dc7174be4cd603cfb60b80b37fd1801e7a8f5c4ec6db3302993348960dffbfc599335faf068d3dc7eb0e3301a541c0e3b4c4ba423afe0fe49c78788cd281053fbac66429d2e78bcb12216fa8b56b62578648bd5e5172c66967933c122ff08f0f5ccd7a0580fdd1d5efa655c5e1be268a62415682ca0161bc8de1575ec9358143b9ba26d6e597c4616fc110fadd203de7108da9ce1191a8323f6692aa6759624183e42839098d47ee2ef0cff78fb886de1484b044f678c41b772a6153257d840a508a7e36b17d28fbca7c0ce4036bd2c6327457ca43409277c5a135ba7&querytype=detailConInfo&da_src=shareurl',
      },
    },
    {
      y: 78,
      x: 62,
      spY: 68,
      spX: 72.5,
      type: 'poi',
      image: '/images/marker-images/the-parq.jpg',
      imageWebp: '/images/marker-images/the-parq.webp',
      name: {
        cn: 'PARQ 综合体景观（The PARQ）',
        th: 'เดอะ ปาร์ค',
      },
      value: 'parq',
      depth: 1,
      order: 4,
      cardInfo: {
        key: 'parq',
        logo: '/images/landmarks/logos/the-parq.png',
        image: '/images/landmarks/ParQ_800x420_@2x.jpg',
        imageSP: '/images/landmarks/ParQ_400x210_@1x.jpg',
        logoWebp: '/images/landmarks/logos/the-parq.webp',
        imageWebp: '/images/landmarks/ParQ_800x420_@2x.webp',
        imageWebpSP: '/images/landmarks/ParQ_400x210_@1x.webp',
        title: {
          cn: 'PARQ 综合体景观（The PARQ）',
          th: 'เดอะปาร์ค',
        },
        description: {
          cn: 'PARQ分为PARQ办公区和PARQ生活区，实现了Rama IV路新商业区工作与生活的完美平衡。​',
          th: 'เดอะ ปาร์ค (The PARQ) ประกอบด้วยเดอะ ปาร์ค เวิร์คเพลส (The PARQ Workplace) และเดอะ ปาร์ค ไลฟ์ (The PARQ Life) นำความสมดุลระหว่างชีวิตและการทำงานมาสู่ย่านธุรกิจใหม่ของถนนพระราม 4',
        },
        tel: '(662) 080 5700',
        hours: '10:00 - 20:00',
        // map: 'https://goo.gl/maps/csUZw47GVvwcUxoG9',
        map: '/images/map/The PARQ.png',
      },
    },
    {
      y: 64,
      x: 55,
      spY: 65,
      spX: 62,
      type: 'poi',
      image: '/images/marker-images/medpark.jpg',
      imageWebp: '/images/marker-images/medpark.webp',
      name: {
        cn: 'MedPark医院',
        th: 'โรงพยาบาลเมดพาร์ค',
      },
      value: 'medpark',
      depth: 2,
      order: 5,
      cardInfo: {
        key: 'medpark',
        logo: '/images/landmarks/logos/med-park.png',
        image: '/images/landmarks/Med-park_800x420_@2x.jpg',
        imageSP: '/images/landmarks/Med-park_400x210_@1x.jpg',
        logoWebp: '/images/landmarks/logos/med-park.webp',
        imageWebp: '/images/landmarks/Med-park_800x420_@2x.webp',
        imageWebpSP: '/images/landmarks/Med-park_400x210_@1x.webp',
        title: {
          cn: 'MedPark医院',
          th: 'โรงพยาบาลเมดพาร์ค',
        },
        description: {
          cn: 'MedPark医院坐落于Rama IV路，是泰国医疗健康行业的新标杆。医院提供高敏感性和复杂疾病综合治疗与护理服务。​',
          th: 'โรงพยาบาลเมดพาร์ค (MedPark Hospital) บนถนนพระราม 4 มาตรฐานใหม่ของอุตสาหกรรมการดูแลสุขภาพในประเทศไทย ให้การดูแลรักษาที่ครอบคลุมโรคที่ซับซ้อนและรุนแรง',
        },
        tel: '(662) 023 3333',
        hours: '24小时',
        // map: 'https://goo.gl/maps/LY1hKckwxWyTse9Z6',
        map: '/images/map/MedPark Hospital.png',
      },
    },
    {
      y: 57,
      x: 82,
      spY: 44,
      spX: 80.5,
      type: 'poi',
      image: '/images/marker-images/benjakitti.jpg',
      imageWebp: '/images/marker-images/benjakitti.webp',
      name: {
        cn: '班佳齐蒂森林公园（Benjakitti Forest Park）',
        th: 'สวนป่าเบญจกิติ',
      },
      value: 'benjakitti',
      depth: 3,
      order: 2,
      cardInfo: {
        key: 'benjakitti',
        image: '/images/landmarks/Benjakitti_800x420_@2x.jpg',
        imageSP: '/images/landmarks/Benjakitti_400x210_@1x.jpg',
        imageWebp: '/images/landmarks/Benjakitti_800x420_@2x.webp',
        imageWebpSP: '/images/landmarks/Benjakitti_400x210_@1x.webp',
        title: {
          cn: '班佳⻬蒂森林公园（Benjakitti Forest Park）',
          th: 'สวนป่าเบญจกิติ',
        },
        description: {
          cn: '曼⾕第四⼤公园，毗邻泰国诗丽吉王后国家会议中⼼（QSNCC）与隆⽐尼公园相连，形成130 公顷的户外场地。它以⽣态湿地、⾃然森林、复育动植物栖息地的⽅式，给予曼⾕更⼴⼤的绿⾊开放空间，并提供崭新的健康⽣活⽅式。',
          th: 'สวนสาธารณะขนาดใหญ่อันดับสี่ของกรุงเทพฯ ตั้งอยู่ติดกับศูนย์ฯ  สิริกิติ์ ซึ่งจะพลิกโฉมเป็น "สวนป่าเบญจกิติ" สวนป่าขนาดใหญ่พร้อมทางเดินลอยฟ้าและศูนย์รวมกิจกรรมสันทนาการต่างๆ ที่จะเกิดขึ้นในปี 2565',
        },
        tel: '(662) 254 1263',
        hours: '05:00 - 21:00',
        // map: 'https://goo.gl/maps/sQhkuGfAYc3vtATn6',
        map: 'https://map.baidu.com/poi/%E7%8F%AD%E5%98%89%E7%90%A6%E7%BC%87%E7%9A%87%E5%90%8E%E5%85%AC%E5%9B%AD/@11194363.395,1533057.68,19z?uid=3de6883695be8a4e2cb17ec1&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bfd0f989b5232ec3e698eba11b2f31b6f8eab4b6aa9a5a0c2f373740a402f081598f6792e81eac97039bb84b85fbac29e5&querytype=detailConInfo&da_src=shareurl',
      },
    },
    {
      y: 62,
      x: 68,
      spY: 59.5,
      spX: 80.5,
      type: 'poi',
      image: '/images/marker-images/qsncc.jpg',
      imageWebp: '/images/marker-images/qsncc.webp',
      name: {
        cn: '泰国诗丽吉王后国家会议中心（QSNCC）',
        th: 'ศูนย์การประชุมแห่งชาติสิริกิติ์',
      },
      value: 'qsncc',
      depth: 4,
      order: 1,
      cardInfo: {
        key: 'qsncc',
        logo: '/images/landmarks/logos/qsncc.svg',
        image: '/images/landmarks/QSNCC_800x420_@2x.jpg',
        imageSP: '/images/landmarks/QSNCC_400x210_@1x.jpg',
        logoWebp: '/images/landmarks/logos/qsncc.webp',
        imageWebp: '/images/landmarks/QSNCC_800x420_@2x.webp',
        imageWebpSP: '/images/landmarks/QSNCC_400x210_@1x.webp',
        title: {
          cn: '泰国诗丽吉王后国家会议中心（QSNCC）',
          th: 'ศูนย์การประชุมแห่งชาติสิริกิติ์',
        },
        description: {
          cn: '泰国诗丽吉王后国家会议中心（QSNCC）位于曼谷繁华商业区的心脏地带，是曼谷市中心的标志性建筑。QSNCC配备世界顶级设施与设备，可承接一系列世界级展览与会议，灵活满足现在与未来的各种需求。同时，交通便捷、四通八达，QSNCC地铁站直通场馆，从曼谷每一个角落均可轻松抵达。',
          th: 'ศูนย์ฯ สิริกิติ์ แลนด์มาร์กที่โดดเด่นใจกลางกรุงเทพฯ รองรับการจัดงานทุกประเภท ออกแบบด้วยดีไซน์ล้ำทันสมัยเพื่อตอบโจทย์ทุกความต้องการทั้งในปัจจุบันและอนาคต<br/><br/>การเดินทางมาศูนย์ฯ สิริกิติ์ สะดวกสบายด้วยบริการรถไฟฟ้าใต้ดิน สถานี “ศูนย์การประชุมแห่งชาติสิริกิติ์” เชื่อมต่อโดยตรงกับตัวอาคาร สะดวกทุกการเดินทางจากทุกที่ในกรุงเทพมหานคร',
        },
        tel: '(662) 229 3000',
        hours: '09:00 - 18:00',
        // map: 'https://goo.gl/maps/3jeHYayVXc6e8yxVA',
        map: 'https://map.baidu.com/poi/%E8%AF%97%E4%B8%BD%E5%90%89%E7%8E%8B%E5%90%8E%E5%9B%BD%E5%AE%B6%E4%BC%9A%E8%AE%AE%E4%B8%AD%E5%BF%83/@11194278.005,1532374.74,19z?uid=0680a0e4b7af2058d12dd697&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bf30830c114f1f5116d9c06b16acffc66049dba771f02df6367f896ed3256872e623ba2e08a5860e8c1b6eaab42aed8f15&querytype=detailConInfo&da_src=shareurl',
      },
    },
    {
      y: 45,
      x: 39,
      spY: 57,
      spX: 42,
      type: 'poi',
      image: '/images/marker-images/one-bangkok.jpg',
      imageWebp: '/images/marker-images/one-bangkok.webp',
      name: {
        cn: 'One Bangkok项目',
        th: 'วัน แบงค็อก',
      },
      value: 'onebkk',
      depth: 4,
      order: 6,
      cardInfo: {
        key: 'onebkk',
        logo: '/images/landmarks/logos/one-bangkok.png',
        image: '/images/landmarks/One-bangkok_800x420_@2x.jpg',
        imageSP: '/images/landmarks/One-bangkok_400x210_@1x.jpg',
        logoWebp: '/images/landmarks/logos/one-bangkok.webp',
        imageWebp: '/images/landmarks/One-bangkok_800x420_@2x.webp',
        imageWebpSP: '/images/landmarks/One-bangkok_400x210_@1x.webp',
        title: {
          cn: 'One Bangkok项目',
          th: 'วัน แบงค็อก',
        },
        description: {
          cn: 'One Bangkok是曼谷中心城区新的全球性地标目的地。项目秉承可持续城市和社区的发展理念，重塑曼谷城市生活方式。',
          th: 'วัน แบงค็อก (One Bangkok) แลนด์มาร์กแห่งใหม่ใจกลางกรุงเทพฯ ได้รับการออกแบบโดยคำนึงถึงเมืองและชุมชนที่ยั่งยืน วัน แบงค็อกปรับเปลี่ยนการใช้ชีวิตในเมืองใหญ่อย่างกรุงเทพฯ ให้เป็นมิตรกับผู้อยู่อาศัยมากขึ้น',
        },
        tel: '(662) 081 3700',
        hours: '09:00 - 18:00',
        // map: 'https://goo.gl/maps/YzZYU5N6tcoWJBiw6',
        map: 'https://map.baidu.com/poi/ONE%20BANGKOK/@11192819.885,1532796.75,19z?uid=809c9597ce4c4917b03c8119&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bf30830c114f1f5116d9c06b16acffc66049dba771f02df6367f896ed3256872e623ba2e08a5860e8c1b6eaab42aed8f15&querytype=detailConInfo&da_src=shareurl',
      },
    },
    {
      y: 22,
      x: 12,
      spY: 49,
      spX: 9,
      type: 'poi',
      image: '/images/marker-images/samyan.jpg',
      imageWebp: '/images/marker-images/samyan.webp',
      name: {
        cn: '泰国山燕商场（Samyan Mitrtown）',
        th: 'สามย่านมิตรทาวน์',
      },
      value: 'sym',
      depth: 4,
      order: 7,
      cardInfo: {
        key: 'sym',
        logo: '/images/landmarks/logos/samyan-mitrtown.png',
        image: '/images/landmarks/Samyan_800x420_@2x.jpg',
        imageSP: '/images/landmarks/Samyan_400x210_@1x.jpg',
        logoWebp: '/images/landmarks/logos/samyan-mitrtown.webp',
        imageWebp: '/images/landmarks/Samyan_800x420_@2x.webp',
        imageWebpSP: '/images/landmarks/Samyan_400x210_@1x.webp',
        title: {
          cn: '泰国山燕商场（Samyan Mitrtown）',
          th: 'สามย่านมิตรทาวน์',
        },
        description: {
          cn: '泰国山燕商场位于朱拉隆功大学附近（Chulalongkorn University），是一座现代化多功能综合体。秉承“共享”的设计理念，泰国山燕商场将百货商店与现代生活方式住宅和办公区完美结合，实现和谐平衡。​',
          th: 'สามย่านมิตรทาวน์ อาคารมิกซ์ยูสที่ทันสมัยติดกับจุฬาลงกรณ์มหาวิทยาลัยได้รับการออกแบบจากจิตวิญญาณแห่งการแบ่งปัน โดยผสมผสานห้างสรรพสินค้า อาคารที่พักอาศัยที่สวยงามทันสมัย และสำนักงานเข้าด้วยกัน',
        },
        // tel: '电话: (662) 229 3000',
        // hours: '09:00 - 18:00',
        // map: 'https://goo.gl/maps/CXQxWSThrktyqne28',
        map: 'https://map.baidu.com/poi/%E4%B8%89%E6%B4%8B%E4%B8%AD%E5%BF%83/@11190880.835,1533557.66,19z?uid=9d43949ac4b2b3b83e9a5e1b&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bf30830c114f1f5116d9c06b16acffc66049dba771f02df6367f896ed3256872e623ba2e08a5860e8c1b6eaab42aed8f15&querytype=detailConInfo&da_src=shareurl',
      },
    },
  ],
  transportList: [
    { y: 37, x: 91, type: 'bts' },
    { y: 25, x: 80, type: 'bts' },
    { y: 14, x: 70, type: 'bts' },
    { y: 4, x: 61, type: 'bts' },
    { y: 42, x: 95, type: 'mrt' },
    { y: 64, x: 77, type: 'mrt-2' },
    { y: 73, x: 50, type: 'mrt' },
    { y: 56, x: 34, type: 'mrt' },
    { y: 44, x: 23, type: 'mrt' },
    { y: 29, x: 9, type: 'mrt' },
    // SP
    { x: 78, y: 21, type: 'bts', spOnly: true },
    // MRT
    { x: 86, y: 22, type: 'mrt-circle', spOnly: true },
    { x: 88, y: 65, type: 'mrt-circle', spOnly: true },
    { x: 67, y: 76, type: 'mrt-circle', spOnly: true },
    { x: 38, y: 70, type: 'mrt-circle', spOnly: true },
    { x: 21, y: 65, type: 'mrt-circle', spOnly: true },
    { x: 5, y: 60, type: 'mrt-circle', spOnly: true },
  ],
};

export const HOTEL_LIST = [
  {
    slug: 'modena-by-fraser-bangkok',
    title: {
      cn: '曼谷名致酒店式服务公寓<br/>（Modena By Fraser Bangkok）',
      th: 'โรงแรม โมเดน่า บาย เฟรเซอร์ กรุงเทพฯ',
    },
    image: '/images/hotels/2-Modena/Hotel-2@2x.jpg',
    imageSp: '/images/hotels/2-Modena/Hotel-2@1x.jpg',
    imageWebp: '/images/hotels/2-Modena/Hotel-2@2x.webp',
    imageWebpSp: '/images/hotels/2-Modena/Hotel-2@1x.webp',
    distance: {
      value: 0.6,
      unit: '公里',
      // link: 'https://g.page/Modenabangkok?share',
      link: 'https://map.baidu.com/poi/%E6%9B%BC%E8%B0%B7%E5%90%8D%E8%87%B4%E9%85%92%E5%BA%97%E5%BC%8F%E6%9C%8D%E5%8A%A1%E5%85%AC%E5%AF%93/@11194401.795,1532052.06,19z?uid=b1709d786a82e35a9603195d&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bfa7b30cf02691255c21d6b91f5776856a3107678826753cdd0d584000c9f7acd5bd45a237ed16732e94ee8466e06789bf&querytype=detailConInfo&da_src=shareurl',
    },
    description: {
      cn: '酒店紧邻泰国诗丽吉王后国家会议中心（QSNCC），通过地下廊道与之紧密相连。',
      th: 'โรงแรม โมเดน่า บาย เฟรเซอร์ กรุงเทพฯ อยู่ติดกับสถานีรถไฟฟ้าใต้ดิน “ศูนย์การประชุมแห่งชาติสิริกิติ์” มีทางเดินใต้ดินเชื่อมต่อกัน',
    },
    excerpt: {
      title: {
        cn: `酒店紧邻泰国诗丽吉王后国家会议中心（QSNCC），通过地下廊道与之紧密相连。`,
        th: `โรงแรม โมเดน่า บาย เฟรเซอร์ กรุงเทพฯ (Modena by Fraser Bangkok) อยู่ติดกับสถานีรถไฟฟ้าใต้ดิน “ศูนย์การประชุมแห่งชาติสิริกิติ์” มีทางเดินใต้ดินเชื่อมต่อกัน แวดล้อมไปด้วยความคึกคักของตลาดสดคลองเตย และย่านธุรกิจอย่างสุขุมวิท ซึ่งสามารถเดินทางด้วยรถไฟฟ้าใต้ดินเพียง 2 นาที`,
      },
      subtitle: {
        cn: `酒店坐落于曼谷新商业区Rama IV路，设计新颖时尚，波光粼粼的现代化玻璃立面后，巧妙布设238间专为商务或休闲人士量身打造的现代客房。FYI中心与酒店近在咫尺，是宾客品鉴美食、畅享购物乐趣的不二之选。
          <br/><br/>
          酒店周围布设当地织物、涂鸦等精致艺术品，为宾客呈现丰富多彩的当地特色元素。酒店设有大堂酒吧、Bistro@M餐厅以及咖啡苹果酒吧（Coffee & Cider Bar），并特设商务会议中心、健身房和洗衣房，为宾客提供宾至如归的极致体验。`,
        th: `โมเดน่า บาย เฟรเซอร์ กรุงเทพฯ เป็นส่วนหนึ่งของย่านธุรกิจใหม่บนถนนพระราม 4 เบื้องหลังอาคารกระจกอันทันสมัยมีห้องพัก 238 ห้อง ที่ออกแบบสำหรับแขกที่เดินทางเพื่อธุรกิจและพักผ่อน โรงแรมอยู่ติดกับ FYI Center แหล่งรวมร้านอาหารและร้านค้าที่เหมาะที่สุดสำหรับเปิดประสบการณ์การรับประทานอาหารและการช้อปปิ้งที่ยอดเยี่ยม
        <br/><br/>
        คุณจะได้สัมผัสถึงวัฒนธรรมท้องถิ่นผ่านงานศิลปะหลากหลายในโรงแรม ตั้งแต่ผ้าจากท้องถิ่นไปจนถึงลวดลายกราฟฟิตี้ ร้านอาหารรสเลิศ ล็อบบี้บาร์ ร้านอาหาร “บริสโทร แอท เอ็ม” (Bistro@M) และ “คอฟฟี่ แอนด์ ไซเดอร์ บาร์” (Coffee & Cider Bar) นอกจากนั้นยังมีศูนย์บริการธุรกิจ (Business Center) ห้องออกกำลังกาย และห้องบริการเครื่องซักผ้า เพื่อให้ผู้เข้าพักทุกท่านได้รับความสะดวกสบายเหมือนอยู่บ้านของตัวเอง`,
      },
    },
    locations: [
      {
        type: 'address',
        text: {
          cn: '2527 Rama 4 Road, FYI Center（与 Ratchadaphisek Road交界处）Khlong Toey District, Bangkok 10110',
          th: '2527 ถนนพระราม 4 เอฟวายไอเซ็นเตอร์ (บริเวณแยกรัชดาภิเษก) เขตคลองเตย กรุงเทพฯ 10110',
        },
      },
      {
        type: 'hours',
        text: {
          cn: '8:00 - 17:00',
          th: '8.00 น. - 17.00 น.',
        },
      },
      {
        type: 'phone',
        text: {
          cn: '电话: (662) 033 0888',
          th: 'โทรศัพท์: (662) 033 0888',
        },
        value: 'tel:(662) 033 0888',
      },
      {
        type: 'website',
        text: {
          cn: 'https://bangkok.modenabyfraser.com/en',
          th: 'https://bangkok.modenabyfraser.com/en',
        },
        value: 'https://bangkok.modenabyfraser.com/en',
      },
    ],
    gallery: [
      {
        imageSp: '/images/hotels/2-Modena/Modena01_808x606_@1x.jpg',
        image: '/images/hotels/2-Modena/Modena01_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/2-Modena/Modena01_808x606_@1x.webp',
        imageWebp: '/images/hotels/2-Modena/Modena01_1616x1212_@2x.webp',
        caption: '曼谷名致酒店式服务公寓（Modena By Fraser Bangkok）',
      },
      {
        imageSp: '/images/hotels/2-Modena/Modena02_808x606_@1x.jpg',
        image: '/images/hotels/2-Modena/Modena02_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/2-Modena/Modena02_808x606_@1x.webp',
        imageWebp: '/images/hotels/2-Modena/Modena02_1616x1212_@2x.webp',
        caption: '曼谷名致酒店式服务公寓（Modena By Fraser Bangkok）',
      },
      {
        imageSp: '/images/hotels/2-Modena/Modena03_808x606_@1x.jpg',
        image: '/images/hotels/2-Modena/Modena03_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/2-Modena/Modena03_808x606_@1x.webp',
        imageWebp: '/images/hotels/2-Modena/Modena03_1616x1212_@2x.webp',
        caption: '曼谷名致酒店式服务公寓（Modena By Fraser Bangkok）',
      },
      {
        imageSp: '/images/hotels/2-Modena/Modena04_808x606_@1x.jpg',
        image: '/images/hotels/2-Modena/Modena04_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/2-Modena/Modena04_808x606_@1x.webp',
        imageWebp: '/images/hotels/2-Modena/Modena04_1616x1212_@2x.webp',
        caption: '曼谷名致酒店式服务公寓（Modena By Fraser Bangkok）',
      },
    ],
  },
  {
    slug: 'bangkok-marriott-marquis-queens-park',
    title: {
      cn: '曼谷皇后公园万豪侯爵酒店<br/>（Bangkok Marriott Marquis<br/>Queen’s Park）',
      th: 'โรงแรม แบงค็อก แมริออท มาร์คีส์ ควีนส์ปาร์ค',
    },
    image: '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Hotel-1@2x.jpg',
    imageSp: '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Hotel-1@1x.jpg',
    imageWebp: '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Hotel-1@2x.webp',
    imageWebpSp: '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Hotel-1@1x.webp',
    distance: {
      value: 2.1,
      unit: '公里',
      // link: 'https://goo.gl/maps/jHwdZVD9vM3po52S6',
      link: 'https://map.baidu.com/search/%E6%9B%BC%E8%B0%B7%E7%9A%87%E5%90%8E%E5%85%AC%E5%9B%AD%E4%B8%87%E8%B1%AA%E4%BE%AF%E7%88%B5%E9%85%92%E5%BA%97/@11195046.795,1533090.48,19z?querytype=s&da_src=shareurl&wd=%E6%9B%BC%E8%B0%B7%E7%9A%87%E5%90%8E%E5%85%AC%E5%9B%AD%E4%B8%87%E8%B1%AA%E4%BE%AF%E7%88%B5%E9%85%92%E5%BA%97&c=20508&src=0&pn=0&sug=0&l=19&b=(11193981.795,1531822.06;11194821.795,1532282.06)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bfa7b30cf02691255c21d6b91f5776856a3107678826753cdd0d584000c9f7acd5bd45a237ed16732e94ee8466e06789bf&device_ratio=1',
    },
    description: {
      cn: '酒店交通便捷、四通八达，与曼谷繁华的素坤逸（Sukhumvit）紧密连接，是商务或休闲旅客的首选之地。',
      th: 'โรงแรมย่านใจกลางกรุงเทพฯ บนถนนสุขุมวิท<br/>พร้อมต้อนรับนักเดินทางเพื่อธุรกิจและเพื่อการพักผ่อน',
    },
    excerpt: {
      title: {
        cn: '酒店交通便捷、四通八达，与曼谷繁华的素坤逸（Sukhumvit）紧密连接，是商务或休闲旅客的首选之地。',
        th: `โรงแรมย่านใจกลางกรุงเทพฯ บนถนนสุขุมวิท พร้อมต้อนรับนักเดินทางเพื่อธุรกิจและเพื่อการพักผ่อน เชื่อมต่อผู้เข้าพักเข้ากับความพลุกพล่านบนถนนสุขุมวิทใจกลางกรุงเทพฯ พบปะกับคู่ค้าทางธุรกิจ เดินเล่นในสวนสาธารณะหรือเที่ยวชมกรุงเทพฯได้ง่ายๆ ด้วยการเดินเท้าหรือใช้บริการรถไฟฟ้าบีทีเอสและรถไฟฟ้าใต้ดิน`,
      },
      subtitle: {
        cn: `曼谷皇后公园万豪侯爵酒店是曼谷最大的酒店，设有1,388间客房和套房。斑斓的色调、柔和的灯光以及现代化的装饰，给予宾客极致舒适的入住体验。
        <br/><br/>
        酒店为宾客提供品类多样的精致餐食。贡厨餐厅与酒吧（Goji Kitchen + Bar）让地道美食与真情陪伴完美结合，而宝塔餐厅（ Pagoda ）为宾客奉上正宗的广东美食。暹罗餐厅（Siam Tea Room）则用地道的泰国美食挑拨您的味蕾。`,
        th: `โรงแรม แบงค็อก แมริออท มาร์คีส์ ควีนส์ปาร์ค โรงแรมที่ใหญ่ที่สุดในเมือง เพียบพร้อมด้วยห้องพักและห้องสวีท 1,388 ห้อง ตกแต่งแบบร่วมสมัยเพื่อมอบความสะดวกสบายสูงสุดให้ผู้เข้าพัก
        <br/><br/>
        โรงแรม แบงค็อก แมริออท มาร์คีส์ ควีนส์ปาร์ค มีร้านอาหารให้เลือกมากมาย ร้านอาหาร “โกจิ คิทเช่น + บาร์” (Goji Kitchen + Bar) ผสานอาหารเลิศรสและการพบปะสังสรรค์เข้าด้วยกัน ร้านอาหาร “เดอะ พาโกด้า” (The Pagoda) ให้บริการอาหารจีนกวางตุ้ง และร้าน “สยาม ที รูม” (Siam Tea Room) ปลุกรสสัมผัสด้วยอาหารไทยต้นตำรับ`,
      },
    },
    locations: [
      {
        type: 'address',
        text: {
          cn: '199 Sukhumvit Soi 22, Khlong Ton, Khlong Toei, Bangkok 10110',
          th: '199 สุขุมวิท ซอย 22 แขวงคลองตัน เขตคลองเตย กรุงเทพฯ 10110',
        },
      },
      {
        type: 'hours',
        text: {
          cn: '24小时',
          th: '24 ชั่วโมง',
        },
      },
      {
        type: 'phone',
        text: {
          cn: '电话: (662) 059 5555',
          th: 'โทรศัพท์: (662) 059 5555',
        },
        value: 'tel:(662) 059 5555',
      },
      {
        type: 'website',
        text: {
          cn: 'www.bangkokmarriottmarquisqueenspark.com',
          th: 'www.bangkokmarriottmarquisqueenspark.com',
        },
        value: 'https://www.bangkokmarriottmarquisqueenspark.com/',
      },
    ],
    gallery: [
      {
        imageSp:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park01_1616x1212_@2x.jpg',
        image:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park01_808x606_@1x.jpg',
        imageWebpSp:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park01_1616x1212_@2x.webp',
        imageWebp:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park01_808x606_@1x.webp',
        caption: '曼谷皇后公园万豪侯爵酒店（Bangkok Marriott Marquis Queen’s Park）',
      },
      {
        imageSp:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park02_1616x1212_@2x.jpg',
        image:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park02_808x606_@1x.jpg',
        imageWebpSp:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park02_1616x1212_@2x.webp',
        imageWebp:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park02_808x606_@1x.webp',
        caption: '曼谷皇后公园万豪侯爵酒店（Bangkok Marriott Marquis Queen’s Park）',
      },
      {
        imageSp:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park03_1616x1212_@2x.jpg',
        image:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park03_808x606_@1x.jpg',
        imageWebpSp:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park03_1616x1212_@2x.webp',
        imageWebp:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park03_808x606_@1x.webp',
        caption: '曼谷皇后公园万豪侯爵酒店（Bangkok Marriott Marquis Queen’s Park）',
      },
      {
        imageSp:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park04_1616x1212_@2x.jpg',
        image:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park04_808x606_@1x.jpg',
        imageWebpSp:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park04_1616x1212_@2x.webp',
        imageWebp:
          '/images/hotels/1-Bangkok-Marriott-Marquis-Queens-Park/Bangkok-Marriott-Marquis-Queen-s-Park04_808x606_@1x.webp',
        caption: '曼谷皇后公园万豪侯爵酒店（Bangkok Marriott Marquis Queen’s Park）',
      },
    ],
  },
  {
    slug: 'the-athenee-hotel',
    title: {
      cn: '曼谷雅典娜广场豪华精选酒店<br/>（The Athenee Hotel, a Luxury Collection Hotel, Bangkok）',
      th: 'โรงแรม ดิ แอทธินี โฮเทล แบงค็อก,<br/>อะลักซ์ชูรี คอลเลคชั่น โฮเทล กรุงเทพฯ',
    },
    image: '/images/hotels/3-The-Athenee-Hotel/Hotel-3@2x.jpg',
    imageSp: '/images/hotels/3-The-Athenee-Hotel/Hotel-3@1x.jpg',
    imageWebp: '/images/hotels/3-The-Athenee-Hotel/Hotel-3@2x.webp',
    imageWebpSp: '/images/hotels/3-The-Athenee-Hotel/Hotel-3@1x.webp',
    distance: {
      value: 4,
      unit: '公里',
      // link: 'https://g.page/theatheneehotel?share',
      link: 'https://map.baidu.com/search/%E6%9B%BC%E8%B0%B7%E9%9B%85%E5%85%B8%E5%A8%9C%E5%B9%BF%E5%9C%BA%E8%B1%AA%E5%8D%8E%E7%B2%BE%E9%80%89%E9%85%92%E5%BA%97/@11193039.455,1534341.29,19z?querytype=s&da_src=shareurl&wd=%E6%9B%BC%E8%B0%B7%E9%9B%85%E5%85%B8%E5%A8%9C%E5%B9%BF%E5%9C%BA%E8%B1%AA%E5%8D%8E%E7%B2%BE%E9%80%89%E9%85%92%E5%BA%97&c=20508&src=0&pn=0&sug=0&l=19&b=(11194626.795,1532860.48;11195466.795,1533320.48)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bfa7b30cf02691255c21d6b91f5776856a3107678826753cdd0d584000c9f7acd5bd45a237ed16732e94ee8466e06789bf&device_ratio=1',
    },
    description: {
      cn: '酒店坐落于原皇家行宫庭院内，是您在繁忙会议后放松身心的绝佳去处。',
      th: 'โรงแรม ดิ แอทธินี โฮเทล ตั้งอยู่บนพื้นที่ซึ่งเดิมเป็นวังของราชนิกุล เหมาะสำหรับการพักผ่อนหลังจากใช้เวลาทั้งวันในศูนย์การประชุม',
    },
    excerpt: {
      title: {
        cn: '酒店坐落于原皇家行宫庭院内，是您在繁忙会议后放松身心的绝佳去处。',
        th: `โรงแรม ดิ แอทธินี โฮเทล ตั้งอยู่บนพื้นที่ซึ่งเดิมเป็นวังของราชนิกุล เหมาะสำหรับการพักผ่อนหลังจากใช้เวลาทั้งวันในศูนย์การประชุม เพียบพร้อมด้วยห้องพักที่สะดวกสบายและการตกแต่งภายในที่หรูหราพร้อมให้การต้อนรับอย่างอบอุ่นแบบไทยแท้และมอบประสบการณ์การรับประทานอาหารที่ยอดเยี่ยม`,
      },
      subtitle: {
        cn: `酒店位于绿树成荫的Wireless路，步行即可到达购物广场、商务中心和城市公园等场所。坐落在Kandhavas行宫内，宾客可亲身体验与现代设施交相辉映的永恒奢华。
        <br/><br/>
        酒店共设374间客房。客房内装饰高雅奢华，源自宫殿的皇家图案、精致的东方风韵地毯与精美的木工艺品，给人以极致奢享体验。铺上全棉床单的豪华大床，轻柔的羽毛枕头和羽绒被，一洗宾客沉乏。酒店四个奢华餐厅，是美食品鉴家们的美食天堂。`,
        th: `โรงแรม ดิ แอทธินี โฮเทล อยู่บนถนนวิทยุที่ขนาบด้วยต้นไม้ใหญ่เป็นแถวเรียงราย ไม่ไกลจากแหล่งช้อปปิ้ง ศูนย์ธุรกิจ และสวนสาธารณะของเมือง โรงแรมตั้งอยู่บนพื้นที่ซึ่งเดิมเป็นวังคันธวาส โรงแรม ดิ แอทธินี โฮเทล ยินดีต้อนรับแขกทุกท่านสู่ประสบการณ์ความหรูหราเหนือกาลเวลาที่ผสมผสานกับสิ่งอำนวยความสะดวกที่ทันสมัยอย่างลงตัว
        <br/><br/>
        ห้องพักทั้งหมด 374 ห้องตกแต่งอย่างหรูหราด้วยลวดลายที่ถอดแบบมาจากวัง พรมสไตล์ตะวันออกและงานไม้ที่งดงาม ผู้เข้าพักสามารถผ่อนคลายบนเตียง “ลักซ์ชูรี คอลเลคชั่น” (Luxury Collection) พร้อมผ้าปูที่นอนและผ้าคลุมเตียงผ้าฝ้าย 100% หมอนขนนกและผ้านวมนุ่มเบา ร้านอาหารเลิศรสสี่แห่งของโรงแรมเป็นสวรรค์ของคนรักอาหารอย่างแท้จริง`,
      },
    },
    locations: [
      {
        type: 'address',
        text: {
          cn: '61 Wireless Road (Witthayu), Lumpini, Pathumwan, Bangkok 10330',
          th: '61 ถนนวิทยุ แขวงลุมพินี เขตปทุมวัน กรุงเทพมหานคร 10330',
        },
      },
      {
        type: 'hours',
        text: {
          cn: '8:30 - 18:30',
          th: '8.30 น. - 18.30 น.',
        },
      },
      {
        type: 'phone',
        text: {
          cn: '电话: (662) 650 8800',
          th: 'โทรศัพท์: (662) 650 8800',
        },
        value: 'tel:(662) 650 8800',
      },
      {
        type: 'website',
        text: {
          cn: 'www.theatheneehotel.com',
          th: 'www.theatheneehotel.com',
        },
        value: 'http://www.theatheneehotel.com/',
      },
    ],
    gallery: [
      {
        imageSp: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel01_808x606_@1x.jpg',
        image: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel01_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel01_808x606_@1x.webp',
        imageWebp: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel01_1616x1212_@2x.webp',
        caption: '曼谷雅典娜广场豪华精选酒店（The Athenee Hotel, a Luxury Collection Hotel, Bangkok）',
      },
      {
        imageSp: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel02_808x606_@1x.jpg',
        image: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel02_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel02_808x606_@1x.webp',
        imageWebp: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel02_1616x1212_@2x.webp',
        caption: '曼谷雅典娜广场豪华精选酒店（The Athenee Hotel, a Luxury Collection Hotel, Bangkok）',
      },
      {
        imageSp: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel03_808x606_@1x.jpg',
        image: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel03_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel03_808x606_@1x.webp',
        imageWebp: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel03_1616x1212_@2x.webp',
        caption: '曼谷雅典娜广场豪华精选酒店（The Athenee Hotel, a Luxury Collection Hotel, Bangkok）',
      },
      {
        imageSp: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel04_808x606_@1x.jpg',
        image: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel04_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel04_808x606_@1x.webp',
        imageWebp: '/images/hotels/3-The-Athenee-Hotel/The-Athenee-Hotel04_1616x1212_@2x.webp',
        caption: '曼谷雅典娜广场豪华精选酒店（The Athenee Hotel, a Luxury Collection Hotel, Bangkok）',
      },
    ],
  },
  {
    slug: 'the-okura-prestige-bangkok',
    title: {
      cn: '曼谷大仓新颐饭店<br/>（The Okura Prestige Bangkok）',
      th: 'โรงแรม ดิ โอกุระ เพรสทีจ กรุงเทพฯ',
    },
    image: '/images/hotels/4-The-Okura-Prestige-Bangkok/Hotel-4@2x.jpg',
    imageSp: '/images/hotels/4-The-Okura-Prestige-Bangkok/Hotel-4@1x.jpg',
    imageWebp: '/images/hotels/4-The-Okura-Prestige-Bangkok/Hotel-4@2x.webp',
    imageWebpSp: '/images/hotels/4-The-Okura-Prestige-Bangkok/Hotel-4@1x.webp',
    distance: {
      value: 4.2,
      unit: '公里',
      // link: 'https://goo.gl/maps/vkbqAcqmGuiN1MyLA',
      link: 'https://map.baidu.com/search/%E6%9B%BC%E8%B0%B7%E5%A4%A7%E4%BB%93%E6%96%B0%E9%A2%90%E9%A5%AD%E5%BA%97/@11193065.225,1534507.12,19z?querytype=s&da_src=shareurl&wd=%E6%9B%BC%E8%B0%B7%E5%A4%A7%E4%BB%93%E6%96%B0%E9%A2%90%E9%A5%AD%E5%BA%97&c=20508&src=0&pn=0&sug=0&l=19&b=(11192619.455,1534111.29;11193459.455,1534571.29)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bfa7b30cf02691255c21d6b91f5776856a3107678826753cdd0d584000c9f7acd5bd45a237ed16732e94ee8466e06789bf&device_ratio=1',
    },
    description: {
      cn: '曼谷大仓新颐饭店是在外宾客的第二个家！',
      th: 'โรงแรม ดิ โอกุระ เพรสทีจ กรุงเทพฯ บ้านหลังที่สองที่สมบูรณ์แบบของนักเดินทาง',
    },
    excerpt: {
      title: {
        cn: '曼谷大仓新颐饭店是在外宾客的第二个家！',
        th: `ดิ โอกุระ เพรสทีจ กรุงเทพฯ บ้านหลังที่สองที่สมบูรณ์แบบของนักเดินทาง โรงแรมหรูในทำเลชั้นเยี่ยมสำหรับนักธุรกิจและนักท่องเที่ยวบนถนนวิทยุ
        <br/><br/>
        ดิ โอกุระดึงดูดนักท่องเที่ยวด้วยการต้อนรับแบบไทยและความสมบูรณ์แบบสไตล์ญี่ปุ่น โรงแรมเชื่อมต่อกับสถานีรถไฟฟ้าบีทีเอส`,
      },
      subtitle: {
        cn: `酒店恢宏优雅，为宾客提供舒适体验。酒店外饰精致，三层隔音隔热的彩色玻璃全景窗户，使之成为一道亮丽的风景线。240间客房与套房内，曼谷绝美的天际线一览无余。酒店贴心地为客户提供10种不同风格的下榻体验，从豪华套房到皇家套房，应有尽有。
        <br/><br/>
        酒店是《米其林指南》和众多美食品鉴家公认的曼谷美食打卡必到之地。山形餐厅为宾客倾情呈现源自日本百年品牌怀石料理（Kaiseki Ryori ）的精美日式料理。米其林星级餐厅 Elements则为您奉献融合日式料理精髓的精美法国美食。`,
        th: `ดิ โอกุระ เพรสทีจ กรุงเทพฯ นำเสนอความสง่างาม และความสะดวกสบาย ห้องพัก และห้องสวีททั้งหมด 240 ห้อง งดงามด้วยทัศนียภาพเส้นขอบฟ้าของกรุงเทพฯ ผ่านหน้าต่างกระจก 3 ชั้น แบบพาโนรามาที่ป้องกันความร้อน และเสียงรบกวน โรงแรมมีห้องพัก 10 ประเภท ตั้งแต่ห้องดีลักซ์สวีทไปจนถึงห้องอิมพีเรียลสวีท
        <br/><br/>
        โรงแรมแห่งนี้ได้รับการยอมรับจากมิชลินไกด์ (Michelin Guide) และผู้ที่หลงใหลอาหารว่าเป็นจุดหมายการรับประทานอาหารชั้นเลิศในกรุงเทพฯ ร้านอาหารยามาซาโตะให้บริการอาหารญี่ปุ่นชั้นเยี่ยมโดยอิงจาก “ไคเซกิ เรียวริ” (Kaiseki Ryori) อาหารชั้นสูงของญี่ปุ่นที่สืบทอดมาหลายศตวรรษ ในขณะที่ห้องอาหาร “เอเลเมนท์” (Elements) ที่ได้รับดาวมิชลินให้บริการอาหารฝรั่งเศสที่มีกลิ่นอายญี่ปุ่น`,
      },
    },
    locations: [
      {
        type: 'address',
        text: {
          cn: '57/1 Wireless Road, Lumpini, Pathumwan, Bangkok 10330',
          th: '57/1 ถนนวิทยุ แขวงลุมพินี เขตปทุมวัน กรุงเทพมหานคร 10330',
        },
      },
      {
        type: 'hours',
        text: {
          cn: '24小时',
          th: '24 ชั่วโมง',
        },
      },
      {
        type: 'phone',
        text: {
          cn: '电话: (662) 687 9000',
          th: 'โทรศัพท์: (662) 687 9000',
        },
        value: 'tel:(662) 687 9000',
      },
      {
        type: 'website',
        text: {
          cn: 'www.okurabangkok.com',
          th: 'www.okurabangkok.com',
        },
        value: 'http://www.okurabangkok.com/',
      },
    ],
    gallery: [
      {
        imageSp: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok01_808x606_@1x.jpg',
        image: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok01_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok01_808x606_@1x.webp',
        imageWebp: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok01_1616x1212_@2x.webp',
        caption: '曼谷大仓新颐饭店（The Okura Prestige Bangkok）',
      },
      {
        imageSp: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok02_808x606_@1x.jpg',
        image: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok02_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok02_808x606_@1x.webp',
        imageWebp: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok02_1616x1212_@2x.webp',
        caption: '曼谷大仓新颐饭店（The Okura Prestige Bangkok）',
      },
      {
        imageSp: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok03_808x606_@1x.jpg',
        image: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok03_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok03_808x606_@1x.webp',
        imageWebp: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok03_1616x1212_@2x.webp',
        caption: '曼谷大仓新颐饭店（The Okura Prestige Bangkok）',
      },
      {
        imageSp: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok04_808x606_@1x.jpg',
        image: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok04_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok04_808x606_@1x.webp',
        imageWebp: '/images/hotels/4-The-Okura-Prestige-Bangkok/The-Okura-Prestige-Bangkok04_1616x1212_@2x.webp',
        caption: '曼谷大仓新颐饭店（The Okura Prestige Bangkok）',
      },
    ],
  },
  {
    slug: 'w-bangkok',
    title: {
      cn: '曼谷W酒店<br/>（W Bangkok）',
      th: 'โรงแรม ดับเบิ้ลยู กรุงเทพฯ',
    },
    image: '/images/hotels/5-W-Hotel-Bangkok/Hotel-5@2x.jpg',
    imageSp: '/images/hotels/5-W-Hotel-Bangkok/Hotel-5@1x.jpg',
    imageWebp: '/images/hotels/5-W-Hotel-Bangkok/Hotel-5@2x.webp',
    imageWebpSp: '/images/hotels/5-W-Hotel-Bangkok/Hotel-5@1x.webp',
    distance: {
      value: 4.6,
      unit: '公里',
      // link: 'https://goo.gl/maps/RZhcrECFGb164Ugu9',
      link: 'https://map.baidu.com/search/%E6%9B%BC%E8%B0%B7w%E9%85%92%E5%BA%97/@11190920.685,1532139.17,19z?querytype=s&da_src=shareurl&wd=%E6%9B%BC%E8%B0%B7W%E9%85%92%E5%BA%97&c=20508&src=0&pn=0&sug=0&l=19&b=(11192645.225,1534277.12;11193485.225,1534737.12)&from=webmap&biz_forward=%7B%22scaler%22:1,%22styles%22:%22pl%22%7D&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bfa7b30cf02691255c21d6b91f5776856a3107678826753cdd0d584000c9f7acd5bd45a237ed16732e94ee8466e06789bf&device_ratio=1',
    },
    description: {
      cn: '曼谷W酒店位于曼谷商业区，是一家设计前卫的优质酒店。',
      th: 'โรงแรม ดับเบิ้ลยู กรุงเทพฯ โรงแรมดีไซน์ล้ำสมัยตั้งอยู่ในย่านการค้าของกรุงเทพฯ',
    },
    excerpt: {
      title: {
        cn: '曼谷W酒店位于曼谷商业区，是一家设计前卫的优质酒店。',
        th: `โรงแรม ดับเบิ้ลยู กรุงเทพฯ โรงแรมดีไซน์ล้ำสมัยตั้งอยู่ในย่านการค้าของกรุงเทพฯ มีหอคอยกระจกอันทันสมัยและอาคารเก่าแก่ที่ได้รับอิทธิพลจากยุโรป โรงแรมอยู่ใกล้กับสถานีรถไฟฟ้าบีทีเอสและรถไฟฟ้าใต้ดิน ผู้เข้าพักสามารถเดินทางไปยังส่วนอื่นๆ ของกรุงเทพฯ ได้อย่างง่ายดาย`,
      },
      subtitle: {
        cn: `酒店共设403间客房和套房，面积29平方米至425平方米不等，配置极富创意的精美设计、意蕴丰富的图案、饶有趣味的织物和风格迥异的定制家具。房内办公桌设计时尚，无线网络连接畅快无阻，宾客可在专心工作或准备会议内容的同时，一睹曼谷旖旎的风景。
        <br/><br/>
        若您想在一天繁忙会议后放松身心，酒店为您精心打造独一无二的烹饪体验。“沙吞之屋”（The House on Sathorn）内设餐厅（亚洲最佳餐厅50强），以及专供特制时令鸡尾酒、清酒和独特烈酒的专属酒吧。`,
        th: `ห้องพักและห้องสวีททั้งหมด 403 ห้อง มีพื้นที่ตั้งแต่ 29 ถึง 425 ตารางเมตร ตกแต่งด้วยการออกแบบที่สร้างแรงบันดาลใจ ตั้งแต่ลวดลายผ้าและเครื่องเรือนที่สั่งทำเป็นพิเศษ แขกสามารถเชื่อมต่อกับอินเทอร์เน็ต Wi-Fi ความเร็วสูงเพื่อทำงานหรือเตรียมการประชุมพร้อมๆ ไปกับการชมวิวกรุงเทพฯ
        <br/><br/>
        สำหรับผู้ที่ต้องการผ่อนคลายหลังจากประชุมมาทั้งวัน โรงแรม ดับเบิ้ลยู กรุงเทพฯ นำเสนอประสบการณ์ด้านอาหารที่ไม่เหมือนใครที่ “เดอะ เฮ้าส์ ออน สาทร” (The House on Sathorn) อิ่มเอมกับอาหารรสเลิศที่ “เดอะ ไดนิ่ง รูม” (The Dining Room) (ติดอันดับ 50 ร้านอาหารยอดเยี่ยมแห่งเอเชีย) และ “เดอะบาร์” (The Bar) บาร์สุดพิเศษที่ให้บริการเครื่องดื่มหลากหลายที่มีเอกลักษณ์เฉพาะตัว`,
      },
    },
    locations: [
      {
        type: 'address',
        text: {
          cn: '106 North Sathorn Road, Silom, Bangrak, Bangkok 10500',
          th: '106 ถนนสาทรเหนือ แขวงสีลม เขตบางรัก กรุงเทพฯ 10500',
        },
      },
      {
        type: 'hours',
        text: {
          cn: '8:30 - 18:30',
          th: '8.30 น. - 18.30 น.',
        },
      },
      {
        type: 'phone',
        text: {
          cn: '电话: (662) 344 4000',
          th: 'โทรศัพท์: (662) 344 4000',
        },
        value: 'tel:(662) 344 4000',
      },
      {
        type: 'website',
        text: {
          cn: 'www.wbangkok.com',
          th: 'www.wbangkok.com',
        },
        value: 'http://www.wbangkok.com/',
      },
    ],
    gallery: [
      {
        imageSp: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok01_808x606_@1x.jpg',
        image: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok01_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok01_808x606_@1x.webp',
        imageWebp: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok01_1616x1212_@2x.webp',
        caption: '曼谷W酒店（W Bangkok）',
      },
      {
        imageSp: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok02_808x606_@1x.jpg',
        image: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok02_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok02_808x606_@1x.webp',
        imageWebp: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok02_1616x1212_@2x.webp',
        caption: '曼谷W酒店（W Bangkok）',
      },
      {
        imageSp: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok03_808x606_@1x.jpg',
        image: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok03_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok03_808x606_@1x.webp',
        imageWebp: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok03_1616x1212_@2x.webp',
        caption: '曼谷W酒店（W Bangkok）',
      },
      {
        imageSp: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok04_808x606_@1x.jpg',
        image: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok04_1616x1212_@2x.jpg',
        imageWebpSp: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok04_808x606_@1x.webp',
        imageWebp: '/images/hotels/5-W-Hotel-Bangkok/W-Hotel-Bangkok04_1616x1212_@2x.webp',
        caption: '曼谷W酒店（W Bangkok）',
      },
    ],
  },
];

export const SURROUNDING_LIST = [
  {
    slug: 'the-parq',
    type: 'surrounding',
    title: {
      cn: 'PARQ 综合体景观<br/>（The PARQ）',
      th: 'เดอะ ปาร์ค',
    },
    image: '/images/surroundings/2-The-PARQ/Surrounding-2@2x.jpg',
    imageSp: '/images/surroundings/2-The-PARQ/Surrounding-2@1x.jpg',
    imageWebp: '/images/surroundings/2-The-PARQ/Surrounding-2@2x.webp',
    imageWebpSp: '/images/surroundings/2-The-PARQ/Surrounding-2@1x.webp',
    distance: {
      value: 0.75,
      unit: '公里',
      link: '/images/map/The PARQ.png',
    },
    description: {
      cn: 'PARQ毗邻泰国诗丽吉王后国家会议中心（QSNCC），是一座多用途综合体，为居民、游客和社区提供集办公和零售商业等为一体的综合服务。PARQ致力于优化环境、提高所有人的生活质量，实现繁忙工作与日常生活的完美平衡。',
      th: 'เดอะ ปาร์ค (The PARQ) โครงการมิกซ์ยูสที่ประกอบด้วยสำนักงานแบบผสมผสาน และหลากหลายร้านค้าสำหรับพนักงาน ผู้มาเยือน และชุมชนต่างๆ เดอะ ปาร์ค นำความสมดุลมาสู่ชีวิตการทำงานที่วุ่นวายผ่านสภาพแวดล้อมที่ปรับให้เหมาะสม เพื่อยกระดับคุณภาพชีวิตของทุกคน เดอะ ปาร์คตั้งอยู่ติดกับศูนย์ฯ สิริกิติ์',
    },
    excerpt: {
      title: {
        cn: 'PARQ毗邻泰国诗丽吉王后国家会议中心（QSNCC），是一座多用途综合体，为居民、游客和社区提供集办公和零售商业等为一体的综合服务。PARQ致力于优化环境、提高所有人的生活质量，实现繁忙工作与日常生活的完美平衡。',
        th: `เดอะ ปาร์ค (The PARQ) โครงการมิกซ์ยูสที่ประกอบด้วยสำนักงานแบบผสมผสาน และหลากหลายร้านค้าสำหรับพนักงาน ผู้มาเยือน และชุมชนต่างๆ เดอะ ปาร์ค นำความสมดุลมาสู่ชีวิตการทำงานที่วุ่นวายผ่านสภาพแวดล้อมที่ปรับให้เหมาะสม เพื่อยกระดับคุณภาพชีวิตของทุกคน เดอะ ปาร์คตั้งอยู่ติดกับศูนย์ฯ สิริกิติ์`,
      },
      subtitle: {
        cn: 'PARQ毗邻泰国诗丽吉王后国家会议中心（QSNCC），是一座多用途综合体，为居民、游客和社区提供集办公和零售商业等为一体的综合服务。PARQ致力于优化环境、提高所有人的生活质量，实现繁忙工作与日常生活的完美平衡。',
        th: `เดอะ ปาร์ค (The PARQ) โครงการมิกซ์ยูสที่ประกอบด้วยสำนักงานแบบผสมผสาน และหลากหลายร้านค้าสำหรับพนักงาน ผู้มาเยือน และชุมชนต่างๆ เดอะ ปาร์ค นำความสมดุลมาสู่ชีวิตการทำงานที่วุ่นวายผ่านสภาพแวดล้อมที่ปรับให้เหมาะสม เพื่อยกระดับคุณภาพชีวิตของทุกคน เดอะ ปาร์คตั้งอยู่ติดกับศูนย์ฯ สิริกิติ์`,
      },
    },
    locations: [
      {
        type: 'hours',
        text: {
          cn: '10:00 - 22:00',
          th: '10.00 น. - 22.00 น.',
        },
      },
      {
        type: 'phone',
        text: {
          cn: '电话: (662) 081 3500',
          th: 'โทรศัพท์: (662) 081 3500',
        },
        value: 'tel:(662) 081 3500',
      },
      {
        type: 'website',
        text: {
          cn: 'www.theparq.com',
          th: 'www.theparq.com',
        },
        value: 'http://www.theparq.com/',
      },
    ],
    gallery: [
      {
        image: '/images/surroundings/2-The-PARQ/The-PARQ01_1616x1212_@2x.jpg',
        imageSp: '/images/surroundings/2-The-PARQ/The-PARQ01_808x606_@1x.jpg',
        imageWebp: '/images/surroundings/2-The-PARQ/The-PARQ01_1616x1212_@2x.webp',
        imageWebpSp: '/images/surroundings/2-The-PARQ/The-PARQ01_808x606_@1x.webp',
        caption: 'PARQ 综合体景观（The PARQ）',
      },
      {
        image: '/images/surroundings/2-The-PARQ/The-PARQ02_1616x1212_@2x.jpg',
        imageSp: '/images/surroundings/2-The-PARQ/The-PARQ02_808x606_@1x.jpg',
        imageWebp: '/images/surroundings/2-The-PARQ/The-PARQ02_1616x1212_@2x.webp',
        imageWebpSp: '/images/surroundings/2-The-PARQ/The-PARQ02_808x606_@1x.webp',
        caption: 'PARQ 综合体景观（The PARQ）',
      },
      {
        image: '/images/surroundings/2-The-PARQ/The-PARQ03_1616x1212_@2x.jpg',
        imageSp: '/images/surroundings/2-The-PARQ/The-PARQ03_808x606_@1x.jpg',
        imageWebp: '/images/surroundings/2-The-PARQ/The-PARQ03_1616x1212_@2x.webp',
        imageWebpSp: '/images/surroundings/2-The-PARQ/The-PARQ03_808x606_@1x.webp',
        caption: 'PARQ 综合体景观（The PARQ）',
      },
      {
        image: '/images/surroundings/2-The-PARQ/The-PARQ04_1616x1212_@2x.jpg',
        imageSp: '/images/surroundings/2-The-PARQ/The-PARQ04_808x606_@1x.jpg',
        imageWebp: '/images/surroundings/2-The-PARQ/The-PARQ04_1616x1212_@2x.webp',
        imageWebpSp: '/images/surroundings/2-The-PARQ/The-PARQ04_808x606_@1x.webp',
        caption: 'PARQ 综合体景观（The PARQ）',
      },
    ],
  },
  {
    slug: 'benjakitti-forest-park',
    type: 'surrounding',
    title: {
      cn: '班佳齐蒂森林公园<br/>（Benjakitti Forest Park）',
      th: 'สวนป่าเบญจกิติ',
    },
    image: '/images/surroundings/4-Benjakitit-Forest-Park/Surrounding-4@2x.jpg',
    imageSp: '/images/surroundings/4-Benjakitit-Forest-Park/Surrounding-4@1x.jpg',
    imageWebp: '/images/surroundings/4-Benjakitit-Forest-Park/Surrounding-4@2x.webp',
    imageWebpSp: '/images/surroundings/4-Benjakitit-Forest-Park/Surrounding-4@1x.webp',
    distance: {
      value: 0.8,
      unit: '公里',
      // link: 'https://goo.gl/maps/Xp9oqhBUVtra3mLs6',
      link: 'https://map.baidu.com/poi/%E7%8F%AD%E5%98%89%E7%90%A6%E7%BC%87%E7%9A%87%E5%90%8E%E5%85%AC%E5%9B%AD/@11194363.523684211,1533093.8998421053,17.86z?uid=3de6883695be8a4e2cb17ec1&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bfa7b30cf02691255c21d6b91f5776856a3107678826753cdd0d584000c9f7acd5bd45a237ed16732e94ee8466e06789bf&querytype=detailConInfo&da_src=shareurl',
    },
    description: {
      cn: '班佳齐蒂森林公园专为纪念诗丽吉王后（即王太后）72岁寿辰而建。目前，公园正在扩建、改造，将升级为森林公园，总占地面积430奈（约172英亩）。扩建后，公园将成为曼谷最大的绿地空间。班佳齐蒂森林公园毗邻泰国诗丽吉王后国家会议中心（QSNCC），主打稀有植物、空中廊道、运河、池塘及室内和室外运动与活动区。项目预计于2022年完工。',
      th: 'สวนเบญจกิติ สร้างขึ้นเพื่อเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ พระบรมราชชนนีพันปีหลวง เนื่องในโอกาสเฉลิมพระชนมพรรษา 72 พรรษา ปัจจุบันอยู่ในระหว่างการปรับปรุงเพื่อให้เป็น “สวนป่า” ขนาดใหญ่มีพื้นที่รวมทั้งหมด 430 ไร่ (172 เอเคอร์) สวนป่าที่อยู่ติดศูนย์ฯ สิริกิติ์ แห่งนี้จะเป็นพื้นที่สีเขียวใหญ่ที่สุดแห่งหนึ่งของกรุงเทพฯ สวนป่าเบญจกิติประกอบไปด้วยพันธุ์ไม้หายาก ทางเดินลอยฟ้า ลำคลอง สระน้ำ รวมถึงพื้นที่ในร่มและกลางแจ้งสำหรับเล่นกีฬาและกิจกรรมต่างๆ โดยโครงการจะแล้วเสร็จในปี 2565',
    },
    excerpt: {
      title: {
        cn: `班佳齐蒂森林公园专为纪念诗丽吉王后（即王太后）72岁寿辰而建。目前，公园正在扩建、改造，将升级为森林公园，总占地面积430奈（约172英亩）。扩建后，公园将成为曼谷最大的绿地空间。班佳齐蒂森林公园毗邻泰国诗丽吉王后国家会议中心（QSNCC），主打稀有植物、空中廊道、运河、池塘及室内和室外运动与活动区。项目预计于2022年完工。`,
        th: `สวนเบญจกิติ สร้างขึ้นเพื่อเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ พระบรมราชชนนีพันปีหลวง เนื่องในโอกาสเฉลิมพระชนมพรรษา 72 พรรษา ปัจจุบันอยู่ในระหว่างการปรับปรุงเพื่อให้เป็น “สวนป่า” ขนาดใหญ่มีพื้นที่รวมทั้งหมด 430 ไร่ (172 เอเคอร์) สวนป่าที่อยู่ติดศูนย์ฯ สิริกิติ์ แห่งนี้จะเป็นพื้นที่สีเขียวใหญ่ที่สุดแห่งหนึ่งของกรุงเทพฯ สวนป่าเบญจกิติประกอบไปด้วยพันธุ์ไม้หายาก ทางเดินลอยฟ้า ลำคลอง สระน้ำ รวมถึงพื้นที่ในร่มและกลางแจ้งสำหรับเล่นกีฬาและกิจกรรมต่างๆ โดยโครงการจะแล้วเสร็จในปี 2565`,
      },
      subtitle: {
        cn: `班佳齐蒂森林公园专为纪念诗丽吉王后（即王太后）72岁寿辰而建。目前，公园正在扩建、改造，将升级为森林公园，总占地面积430奈（约172英亩）。扩建后，公园将成为曼谷最大的绿地空间。班佳齐蒂森林公园毗邻泰国诗丽吉王后国家会议中心（QSNCC），主打稀有植物、空中廊道、运河、池塘及室内和室外运动与活动区。项目预计于2022年完工。`,
        th: `สวนเบญจกิติ สร้างขึ้นเพื่อเฉลิมพระเกียรติสมเด็จพระนางเจ้าสิริกิติ์ พระบรมราชินีนาถ พระบรมราชชนนีพันปีหลวง เนื่องในโอกาสเฉลิมพระชนมพรรษา 72 พรรษา ปัจจุบันอยู่ในระหว่างการปรับปรุงเพื่อให้เป็น “สวนป่า” ขนาดใหญ่มีพื้นที่รวมทั้งหมด 430 ไร่ (172 เอเคอร์) สวนป่าที่อยู่ติดศูนย์ฯ สิริกิติ์ แห่งนี้จะเป็นพื้นที่สีเขียวใหญ่ที่สุดแห่งหนึ่งของกรุงเทพฯ สวนป่าเบญจกิติประกอบไปด้วยพันธุ์ไม้หายาก ทางเดินลอยฟ้า ลำคลอง สระน้ำ รวมถึงพื้นที่ในร่มและกลางแจ้งสำหรับเล่นกีฬาและกิจกรรมต่างๆ โดยโครงการจะแล้วเสร็จในปี 2565`,
      },
    },
    locations: [],
    gallery: [
      {
        image: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park01_1616x1212_@2x.jpg',
        imageSp: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park01_808x606_@1x.jpg',
        imageWebp: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park01_1616x1212_@2x.webp',
        imageWebpSp: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park01_808x606_@1x.webp',
        caption: '班佳齐蒂森林公园（Benjakitti Forest Park）',
      },
      {
        imageSp: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park02_808x606_@1x.jpg',
        image: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park02_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park02_808x606_@1x.webp',
        imageWebp: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park02_1616x1212_@2x.webp',
        caption: '班佳齐蒂森林公园（Benjakitti Forest Park）',
      },
      {
        imageSp: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park03_808x606_@1x.jpg',
        image: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park03_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park03_808x606_@1x.webp',
        imageWebp: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park03_1616x1212_@2x.webp',
        caption: '班佳齐蒂森林公园（Benjakitti Forest Park）',
      },
      {
        imageSp: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park04_808x606_@1x.jpg',
        image: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park04_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park04_808x606_@1x.webp',
        imageWebp: '/images/surroundings/4-Benjakitit-Forest-Park/Benjakitit-Forest-Park04_1616x1212_@2x.webp',
        caption: '班佳齐蒂森林公园（Benjakitti Forest Park）',
      },
    ],
  },
  {
    slug: 'medpark-hospital',
    type: 'surrounding',
    title: {
      cn: 'MedPark 医院<br/>（MedPark Hospital）',
      th: 'โรงพยาบาลเมดพาร์ค',
    },
    image: '/images/surroundings/3-MedPark/Surrounding-3@2x.jpg',
    imageSp: '/images/surroundings/3-MedPark/Surrounding-3@1x.jpg',
    imageWebp: '/images/surroundings/3-MedPark/Surrounding-3@2x.webp',
    imageWebpSp: '/images/surroundings/3-MedPark/Surrounding-3@1x.webp',
    distance: {
      value: 1,
      unit: '公里',
      link: '/images/map/MedPark Hospital.png',
    },
    description: {
      cn: 'MedPark医院位于Rama IV路，是泰国医疗健康行业的新标杆。作为东南亚地区的医疗中心，医院拥有一支由不同医疗领域经验丰富的医生组建的庞大医疗团队。医院提供高敏感性和复杂疾病综合治疗与护理服务。医院大楼共有25层，设有300间门诊诊室，住院部设有550张全科和专科病床。',
      th: 'โรงพยาบาลเมดพาร์ค (MedPark Hospital) บนถนนพระราม 4 โรงพยาบาลที่กำหนดมาตรฐานใหม่ให้กับอุตสาหกรรมการดูแลสุขภาพในประเทศไทย เมดพาร์คตั้งเป้าในการก้าวเป็นศูนย์กลางทางการแพทย์ในเอเชียตะวันออกเฉียงใต้ โดยมีทีมแพทย์มากประสบการณ์ในสาขาการแพทย์ที่หลากหลาย พร้อมให้การดูแลที่ครอบคลุมโรคที่รุนแรงและซับซ้อน ด้วยอาคารสูง 25 ชั้น มีห้องตรวจผู้ป่วยนอก 300 ห้อง และห้องสำหรับผู้ป่วยในจำนวน 550 เตียงสำหรับการรักษาทั่วไปและการรักษาเฉพาะทาง',
    },
    excerpt: {
      title: {
        cn: 'MedPark医院位于Rama IV路，是泰国医疗健康行业的新标杆。作为东南亚地区的医疗中心，医院拥有一支由不同医疗领域经验丰富的医生组建的庞大医疗团队。医院提供高敏感性和复杂疾病综合治疗与护理服务。医院大楼共有25层，设有300间门诊诊室，住院部设有550张全科和专科病床。',
        th: `โรงพยาบาลเมดพาร์ค (MedPark Hospital) บนถนนพระราม 4 โรงพยาบาลที่กำหนดมาตรฐานใหม่ให้กับอุตสาหกรรมการดูแลสุขภาพในประเทศไทย เมดพาร์คตั้งเป้าในการก้าวเป็นศูนย์กลางทางการแพทย์ในเอเชียตะวันออกเฉียงใต้ โดยมีทีมแพทย์มากประสบการณ์ในสาขาการแพทย์ที่หลากหลาย พร้อมให้การดูแลที่ครอบคลุมโรคที่รุนแรงและซับซ้อน ด้วยอาคารสูง 25 ชั้น มีห้องตรวจผู้ป่วยนอก 300 ห้อง และห้องสำหรับผู้ป่วยในจำนวน 550 เตียงสำหรับการรักษาทั่วไปและการรักษาเฉพาะทาง`,
      },
      subtitle: {
        cn: 'MedPark医院位于Rama IV路，是泰国医疗健康行业的新标杆。作为东南亚地区的医疗中心，医院拥有一支由不同医疗领域经验丰富的医生组建的庞大医疗团队。医院提供高敏感性和复杂疾病综合治疗与护理服务。医院大楼共有25层，设有300间门诊诊室，住院部设有550张全科和专科病床。',
        th: `โรงพยาบาลเมดพาร์ค (MedPark Hospital) บนถนนพระราม 4 โรงพยาบาลที่กำหนดมาตรฐานใหม่ให้กับอุตสาหกรรมการดูแลสุขภาพในประเทศไทย เมดพาร์คตั้งเป้าในการก้าวเป็นศูนย์กลางทางการแพทย์ในเอเชียตะวันออกเฉียงใต้ โดยมีทีมแพทย์มากประสบการณ์ในสาขาการแพทย์ที่หลากหลาย พร้อมให้การดูแลที่ครอบคลุมโรคที่รุนแรงและซับซ้อน ด้วยอาคารสูง 25 ชั้น มีห้องตรวจผู้ป่วยนอก 300 ห้อง และห้องสำหรับผู้ป่วยในจำนวน 550 เตียงสำหรับการรักษาทั่วไปและการรักษาเฉพาะทาง`,
      },
    },
    locations: [
      {
        type: 'hours',
        text: {
          cn: '24 Hours',
          th: '24 ชั่วโมง',
        },
      },
      {
        type: 'phone',
        text: {
          cn: '电话: (662) 023 3333',
          th: 'โทรศัพท์: (662) 023 3333',
        },
        value: 'tel:(662) 023 3333',
      },
      {
        type: 'website',
        text: {
          cn: 'www.medparkhospital.com',
          th: 'www.medparkhospital.com',
        },
        value: 'http://www.medparkhospital.com/',
      },
    ],
    gallery: [
      {
        imageSp: '/images/surroundings/3-MedPark/MedPark01_808x606_@1x.jpg',
        image: '/images/surroundings/3-MedPark/MedPark01_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/3-MedPark/MedPark01_808x606_@1x.webp',
        imageWebp: '/images/surroundings/3-MedPark/MedPark01_1616x1212_@2x.webp',
        caption: 'MedPark 医院（MedPark Hospital）',
      },
      {
        image: '/images/surroundings/3-MedPark/MedPark02_808x606_@1x.jpg',
        imageSp: '/images/surroundings/3-MedPark/MedPark02_1616x1212_@2x.jpg',
        imageWebp: '/images/surroundings/3-MedPark/MedPark02_808x606_@1x.webp',
        imageWebpSp: '/images/surroundings/3-MedPark/MedPark02_1616x1212_@2x.webp',
        caption: 'MedPark 医院（MedPark Hospital）',
      },
      {
        imageSp: '/images/surroundings/3-MedPark/MedPark03_808x606_@1x.jpg',
        image: '/images/surroundings/3-MedPark/MedPark03_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/3-MedPark/MedPark03_808x606_@1x.webp',
        imageWebp: '/images/surroundings/3-MedPark/MedPark03_1616x1212_@2x.webp',
        caption: 'MedPark 医院（MedPark Hospital）',
      },
      {
        imageSp: '/images/surroundings/3-MedPark/MedPark04_808x606_@1x.jpg',
        image: '/images/surroundings/3-MedPark/MedPark04_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/3-MedPark/MedPark04_808x606_@1x.webp',
        imageWebp: '/images/surroundings/3-MedPark/MedPark04_1616x1212_@2x.webp',
        caption: 'MedPark 医院（MedPark Hospital）',
      },
      {
        imageSp: '/images/surroundings/3-MedPark/MedPark05_808x606_@1x.jpg',
        image: '/images/surroundings/3-MedPark/MedPark05_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/3-MedPark/MedPark05_808x606_@1x.webp',
        imageWebp: '/images/surroundings/3-MedPark/MedPark05_1616x1212_@2x.webp',
        caption: 'MedPark 医院（MedPark Hospital）',
      },
    ],
  },
  {
    slug: 'one-bangkok',
    type: 'surrounding',
    title: {
      cn: 'One Bangkok项目',
      th: 'วัน แบงค็อก',
    },
    image: '/images/surroundings/1-One-Bangkok/Surrounding-1@2x.jpg',
    imageSp: '/images/surroundings/1-One-Bangkok/Surrounding-1@1x.jpg',
    imageWebp: '/images/surroundings/1-One-Bangkok/Surrounding-1@2x.webp',
    imageWebpSp: '/images/surroundings/1-One-Bangkok/Surrounding-1@1x.webp',
    distance: {
      value: 2.2,
      unit: '公里',
      // link: 'https://goo.gl/maps/q6zUytPN6678Mirr7',
      link: 'https://map.baidu.com/poi/ONE%20BANGKOK/@11192819.885,1532796.75,19z?uid=809c9597ce4c4917b03c8119&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bf30830c114f1f5116d9c06b16acffc66049dba771f02df6367f896ed3256872e623ba2e08a5860e8c1b6eaab42aed8f15&querytype=detailConInfo&da_src=shareurl',
    },
    description: {
      cn: 'One Bangkok项目位于Wireless路和Rama IV路转角处，旨在打造新的全球性地标目的地。项目以可持续发展城市和社区为引导，经过精心设计与开发，旨在丰富和改善曼谷城市生活。项目由新一代办公楼、奢华生活方式酒店、零售休闲商店、超奢住宅楼和一系列城市区域及文化艺术设施组成。One Bangkok堪称城中之城，将于2022年正式对外开放。',
      th: 'โครงการวัน แบงค็อก (One Bangkok) บนหัวมุมถนนวิทยุและถนนพระราม 4 ออกแบบเพื่อให้เป็นสถานที่สำคัญระดับโลกแห่งใหม่ โดยคำนึงถึงเมืองและชุมชนที่ยั่งยืน โครงการได้รับการออกแบบและพัฒนาอย่างพิถีพิถัน เพื่อปรับเปลี่ยนการใช้ชีวิตเมืองในกรุงเทพฯ ให้เป็นมิตรกับผู้อยู่อาศัยมากขึ้น โครงการประกอบด้วยอาคารสำนักงานสุดล้ำสมัย โรงแรมหรู และโรงแรมไลฟ์สไตล์ ร้านค้าปลีกและสถานบันเทิงครบวงจร อาคารพักอาศัยสุดหรู พร้อมพื้นที่ส่วนกลางที่หลากหลาย พร้อมเปิดอย่างเป็นทางการในปี 2565',
    },
    excerpt: {
      title: {
        cn: 'One Bangkok项目位于Wireless路和Rama IV路转角处，旨在打造新的全球性地标目的地。项目以可持续发展城市和社区为引导，经过精心设计与开发，旨在丰富和改善曼谷城市生活。项目由新一代办公楼、奢华生活方式酒店、零售休闲商店、超奢住宅楼和一系列城市区域及文化艺术设施组成。One Bangkok堪称城中之城，将于2022年正式对外开放。',
        th: 'วัน แบงค็อก (One Bangkok) ตั้งอยู่ที่หัวมุมถนนวิทยุและถนนพระราม 4 โครงการวัน แบงค็อก ออกแบบเพื่อให้เป็นสถานที่สำคัญระดับโลกแห่งใหม่ โดยคำนึงถึงเมืองและชุมชนที่ยั่งยืน โครงการได้รับการออกแบบและพัฒนาอย่างพิถีพิถัน เพื่อปรับเปลี่ยนการใช้ชีวิตเมืองในกรุงเทพฯ ให้เป็นมิตรกับผู้อยู่อาศัยมากขึ้น โครงการประกอบด้วยอาคารสำนักงานสุดล้ำสมัย โรงแรมหรู และโรงแรมไลฟ์สไตล์ ร้านค้าปลีกและสถานบันเทิงครบวงจร อาคารพักอาศัยสุดหรู พร้อมพื้นที่ส่วนกลางที่หลากหลาย พร้อมเปิดอย่างเป็นทางการในปี 2565',
      },
      subtitle: {
        cn: 'One Bangkok项目位于Wireless路和Rama IV路转角处，旨在打造新的全球性地标目的地。项目以可持续发展城市和社区为引导，经过精心设计与开发，旨在丰富和改善曼谷城市生活。项目由新一代办公楼、奢华生活方式酒店、零售休闲商店、超奢住宅楼和一系列城市区域及文化艺术设施组成。One Bangkok堪称城中之城，将于2022年正式对外开放。',
        th: 'โครงการวัน แบงค็อก (One Bangkok) บนหัวมุมถนนวิทยุและถนนพระราม 4 ออกแบบเพื่อให้เป็นสถานที่สำคัญระดับโลกแห่งใหม่ โดยคำนึงถึงเมืองและชุมชนที่ยั่งยืน โครงการได้รับการออกแบบและพัฒนาอย่างพิถีพิถัน เพื่อปรับเปลี่ยนการใช้ชีวิตเมืองในกรุงเทพฯ ให้เป็นมิตรกับผู้อยู่อาศัยมากขึ้น โครงการประกอบด้วยอาคารสำนักงานสุดล้ำสมัย โรงแรมหรู และโรงแรมไลฟ์สไตล์ ร้านค้าปลีกและสถานบันเทิงครบวงจร อาคารพักอาศัยสุดหรู พร้อมพื้นที่ส่วนกลางที่หลากหลาย พร้อมเปิดอย่างเป็นทางการในปี 2565',
      },
    },
    locations: [
      {
        type: 'hours',
        text: {
          cn: '9:00 - 18:00',
          th: '9.00 น. - 18.00 น.',
        },
      },
      {
        type: 'phone',
        text: {
          cn: '电话: (662) 081 3700',
          th: 'โทรศัพท์: (662) 081 3700',
        },
        value: 'tel:(662) 081 3700',
      },
      {
        type: 'website',
        text: {
          cn: 'onebangkok.com​',
          th: 'onebangkok.com​',
        },
        value: 'https://onebangkok.com​/',
      },
    ],
    gallery: [
      {
        image: '/images/surroundings/1-One-Bangkok/One-Bangkok01_1616x1212_@2x.jpg',
        imageSp: '/images/surroundings/1-One-Bangkok/One-Bangkok01_808x606_@1x.jpg',
        imageWebp: '/images/surroundings/1-One-Bangkok/One-Bangkok01_1616x1212_@2x.webp',
        imageWebpSp: '/images/surroundings/1-One-Bangkok/One-Bangkok01_808x606_@1x.webp',
        caption: 'One Bangkok项目',
      },
      {
        image: '/images/surroundings/1-One-Bangkok/One-Bangkok02_1616x1212_@2x.jpg',
        imageSp: '/images/surroundings/1-One-Bangkok/One-Bangkok02_808x606_@1x.jpg',
        imageWebp: '/images/surroundings/1-One-Bangkok/One-Bangkok02_1616x1212_@2x.webp',
        imageWebpSp: '/images/surroundings/1-One-Bangkok/One-Bangkok02_808x606_@1x.webp',
        caption: 'One Bangkok项目',
      },
      {
        image: '/images/surroundings/1-One-Bangkok/One-Bangkok03_1616x1212_@2x.jpg',
        imageSp: '/images/surroundings/1-One-Bangkok/One-Bangkok03_808x606_@1x.jpg',
        imageWebp: '/images/surroundings/1-One-Bangkok/One-Bangkok03_1616x1212_@2x.webp',
        imageWebpSp: '/images/surroundings/1-One-Bangkok/One-Bangkok03_808x606_@1x.webp',
        caption: 'One Bangkok项目',
      },
      {
        image: '/images/surroundings/1-One-Bangkok/One-Bangkok04_1616x1212_@2x.jpg',
        imageSp: '/images/surroundings/1-One-Bangkok/One-Bangkok04_808x606_@1x.jpg',
        imageWebp: '/images/surroundings/1-One-Bangkok/One-Bangkok04_1616x1212_@2x.webp',
        imageWebpSp: '/images/surroundings/1-One-Bangkok/One-Bangkok04_808x606_@1x.webp',
        caption: 'One Bangkok项目',
      },
    ],
  },
  {
    slug: 'terminal21-asok',
    type: 'surrounding',
    title: {
      cn: 'Terminal21 Asok购物中心',
      th: 'เทอร์มินอล21 อโศก',
    },
    image: '/images/surroundings/6-Terminal-21-Bangkok/Surrounding-6@2x.jpg',
    imageSp: '/images/surroundings/6-Terminal-21-Bangkok/Surrounding-6@1x.jpg',
    imageWebp: '/images/surroundings/6-Terminal-21-Bangkok/Surrounding-6@2x.webp',
    imageWebpSp: '/images/surroundings/6-Terminal-21-Bangkok/Surrounding-6@1x.webp',
    distance: {
      value: 2.5,
      unit: '公里',
      // link: 'https://goo.gl/maps/q4ZGZqDtci4dLEw19',
      link: 'https://map.baidu.com/poi/21%E8%88%AA%E7%AB%99%E6%A5%BC%E5%95%86%E5%9C%BA/@11194452.34656579,1533961.5150000001,19z?uid=78289125b66e3574c8c3db22&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bfa7b30cf02691255c21d6b91f5776856a3107678826753cdd0d584000c9f7acd5bd45a237ed16732e94ee8466e06789bf&querytype=detailConInfo&da_src=shareurl',
    },
    description: {
      cn: 'Terminal21 Asok 购物中心充满青春活力，曼谷大众运输系统和地铁在此交汇。购物中心共有9层，是设计师品牌、国际美食、美食超市和精品商店的战略首选地。地下一层为“机场”，游客可乘坐自动扶梯，上行至“巴黎”、“东京”和以其他城市为主题的各楼层。Pier 21美食汇（Pier 21 Food Court）美食品类繁多、干净卫生、价格实惠，是许多游客的必到之处。',
      th: `ศูนย์การค้าเทอร์มินอล21 อโศก เต็มเปี่ยมไปด้วยพลังและความคึกคักเพราะอยู่ใจกลางเมืองที่เป็นจุดเชื่อมการเดินทางระหว่างรถไฟฟ้าบีทีเอสและรถไฟฟ้าใต้ดิน ศูนย์การค้าฯ สูง 9 ชั้นแห่งนี้เป็นแหล่งรวมสินค้าแบรนด์เนม อาหารนานาชาติ ซูเปอร์มาร์เก็ตระดับกูร์เมต์ และร้านบูติก ที่ตกแต่งในธีม ‘สนามบิน’ คุณจะมีโอกาสได้ไปเยือน 'ปารีส' 'โตเกียว' และชั้นอื่นๆ ในธีมเมืองต่างๆ ไฮไลต์ที่ดึงดูดใจคนกรุงเทพและนักท่องเที่ยว คือ ศูนย์อาหาร “เพียร์ 21” (Pier 21) แหล่งรวมอาหารอร่อย สะอาด และราคาไม่แพง`,
    },
    excerpt: {
      title: {
        cn: 'Terminal21 Asok 购物中心充满青春活力，曼谷大众运输系统和地铁在此交汇。购物中心共有9层，是设计师品牌、国际美食、美食超市和精品商店的战略首选地。地下一层为“机场”，游客可乘坐自动扶梯，上行至“巴黎”、“东京”和以其他城市为主题的各楼层。Pier 21美食汇（Pier 21 Food Court）美食品类繁多、干净卫生、价格实惠，是许多游客的必到之处。',
        th: `ศูนย์การค้าเทอร์มินอล21 อโศก เต็มเปี่ยมไปด้วยพลังและความคึกคักเพราะอยู่ใจกลางเมืองที่เป็นจุดเชื่อมการเดินทางระหว่างรถไฟฟ้าบีทีเอสและรถไฟฟ้าใต้ดิน ศูนย์การค้าฯ สูง 9 ชั้นแห่งนี้เป็นแหล่งรวมสินค้าแบรนด์เนม อาหารนานาชาติ ซูเปอร์มาร์เก็ตระดับกูร์เมต์ และร้านบูติก ที่ตกแต่งในธีม ‘สนามบิน’ คุณจะมีโอกาสได้ไปเยือน 'ปารีส' 'โตเกียว' และชั้นอื่นๆ ในธีมเมืองต่างๆ ไฮไลต์ที่ดึงดูดใจคนกรุงเทพและนักท่องเที่ยว คือ ศูนย์อาหาร “เพียร์ 21” (Pier 21) แหล่งรวมอาหารอร่อย สะอาด และราคาไม่แพง`,
      },
      subtitle: {
        cn: 'Terminal21 Asok 购物中心充满青春活力，曼谷大众运输系统和地铁在此交汇。购物中心共有9层，是设计师品牌、国际美食、美食超市和精品商店的战略首选地。地下一层为“机场”，游客可乘坐自动扶梯，上行至“巴黎”、“东京”和以其他城市为主题的各楼层。Pier 21美食汇（Pier 21 Food Court）美食品类繁多、干净卫生、价格实惠，是许多游客的必到之处。',
        th: `ศูนย์การค้าเทอร์มินอล21 อโศก เต็มเปี่ยมไปด้วยพลังและความคึกคักเพราะอยู่ใจกลางเมืองที่เป็นจุดเชื่อมการเดินทางระหว่างรถไฟฟ้าบีทีเอสและรถไฟฟ้าใต้ดิน ศูนย์การค้าฯ สูง 9 ชั้นแห่งนี้เป็นแหล่งรวมสินค้าแบรนด์เนม อาหารนานาชาติ ซูเปอร์มาร์เก็ตระดับกูร์เมต์ และร้านบูติก ที่ตกแต่งในธีม ‘สนามบิน’ คุณจะมีโอกาสได้ไปเยือน 'ปารีส' 'โตเกียว' และชั้นอื่นๆ ในธีมเมืองต่างๆ ไฮไลต์ที่ดึงดูดใจคนกรุงเทพและนักท่องเที่ยว คือ ศูนย์อาหาร “เพียร์ 21” (Pier 21) แหล่งรวมอาหารอร่อย สะอาด และราคาไม่แพง`,
      },
    },
    locations: [
      {
        type: 'hours',
        text: {
          cn: '10:00 - 22:00',
          th: '10.00 น. - 22.00 น.',
        },
      },
      {
        type: 'phone',
        text: {
          cn: '电话: (662) 108 0888',
          th: 'โทรศัพท์: (662) 108 0888',
        },
        value: 'tel:(662) 108 0888',
      },
      {
        type: 'website',
        text: {
          cn: 'www.terminal21.co.th/asok',
          th: 'www.terminal21.co.th/asok',
        },
        value: 'http://www.terminal21.co.th/asok',
      },
    ],
    gallery: [
      {
        imageSp: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok01_808x606_@1x.jpg',
        image: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok01_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok01_808x606_@1x.webp',
        imageWebp: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok01_1616x1212_@2x.webp',
        caption: 'Terminal21 Asok购物中心',
      },
      {
        imageSp: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok02_808x606_@1x.jpg',
        image: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok02_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok02_808x606_@1x.webp',
        imageWebp: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok02_1616x1212_@2x.webp',
        caption: 'Terminal21 Asok购物中心',
      },
      {
        imageSp: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok03_808x606_@1x.jpg',
        image: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok03_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok03_808x606_@1x.webp',
        imageWebp: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok03_1616x1212_@2x.webp',
        caption: 'Terminal21 Asok购物中心',
      },
      {
        imageSp: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok04_808x606_@1x.jpg',
        image: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok04_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok04_808x606_@1x.webp',
        imageWebp: '/images/surroundings/6-Terminal-21-Bangkok/Terminal-21-Bangkok04_1616x1212_@2x.webp',
        caption: 'Terminal21 Asok购物中心',
      },
    ],
  },
  {
    slug: 'siam-paragon',
    type: 'surrounding',
    title: {
      cn: ' 暹罗百丽宫<br/>（Siam Paragon）',
      th: 'สยามพารากอน',
    },
    image: '/images/surroundings/7-Siam-Paragon/Surrounding-7@2x.jpg',
    imageSp: '/images/surroundings/7-Siam-Paragon/Surrounding-7@1x.jpg',
    imageWebp: '/images/surroundings/7-Siam-Paragon/Surrounding-7@2x.webp',
    imageWebpSp: '/images/surroundings/7-Siam-Paragon/Surrounding-7@1x.webp',
    distance: {
      value: 4.4,
      unit: '公里',
      // link: 'https://goo.gl/maps/nDuda3WFjiYXyfK57',
      link: 'https://map.baidu.com/poi/%E6%9A%B9%E7%BD%97%E7%99%BE%E4%B8%BD%E5%AE%AB/@11191589.641302591,1534880.68955455,19.24z?uid=7c6d9fe47101d6ad39e4a647&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bfa7b30cf02691255c21d6b91f5776856a3107678826753cdd0d584000c9f7acd5bd45a237ed16732e94ee8466e06789bf&querytype=detailConInfo&da_src=shareurl',
    },
    description: {
      cn: '暹罗百丽宫与暹罗广场轻轨终点站连接，是曼谷最大的购物中心之一。购物综合体共有十层，恢宏大气，布设诸多让人心情愉悦的休闲娱乐设施。这里汇集了曼谷海洋世界、零售店、展厅、泰国美术馆及15个大银幕影院和歌剧音乐厅，让您眼花缭乱、流连忘返。',
      th: 'สยามพารากอน ศูนย์การค้าที่ใหญ่ที่สุดใจกลางกรุงเทพฯ มีทางเข้าเชื่อมต่อตรงกับสถานีรถไฟฟ้าบีทีเอส ที่สยามสแควร์ แหล่งรวมความบันเทิงและสันทนาการเหนือระดับ ทั้งพิพิธภัณฑ์สัตว์น้ำ “ซีไลฟ์ แบงคอก โอเชี่ยน เวิลด์” (Sea Life Bangkok Ocean World) พื้นที่ค้าปลีก ห้องนิทรรศการ หอศิลป์ไทย โรงภาพยนตร์จอใหญ่ 15 โรง และ “สยาม โอเปร่า เธียเตอร์” (Siam Opera 剧院式)',
    },
    excerpt: {
      title: {
        cn: '暹罗百丽宫与暹罗广场轻轨终点站连接，是曼谷最大的购物中心之一。购物综合体共有十层，恢宏大气，布设诸多让人心情愉悦的休闲娱乐设施。这里汇集了曼谷海洋世界、零售店、展厅、泰国美术馆及15个大银幕影院和歌剧音乐厅，让您眼花缭乱、流连忘返。',
        th: `สยามพารากอน ศูนย์การค้าที่ใหญ่ที่สุดใจกลางกรุงเทพฯ มีทางเข้าเชื่อมต่อตรงกับสถานีรถไฟฟ้าบีทีเอส ที่สยามสแควร์ แหล่งรวมความบันเทิงและสันทนาการเหนือระดับ ทั้งพิพิธภัณฑ์สัตว์น้ำ “ซีไลฟ์ แบงคอก โอเชี่ยน เวิลด์” (Sea Life Bangkok Ocean World) พื้นที่ค้าปลีก ห้องนิทรรศการ หอศิลป์ไทย โรงภาพยนตร์จอใหญ่ 15 โรง และ “สยาม โอเปร่า เธียเตอร์” (Siam Opera 剧院式)`,
      },
      subtitle: {
        cn: '暹罗百丽宫与暹罗广场轻轨终点站连接，是曼谷最大的购物中心之一。购物综合体共有十层，恢宏大气，布设诸多让人心情愉悦的休闲娱乐设施。这里汇集了曼谷海洋世界、零售店、展厅、泰国美术馆及15个大银幕影院和歌剧音乐厅，让您眼花缭乱、流连忘返。',
        th: `สยามพารากอน ศูนย์การค้าที่ใหญ่ที่สุดใจกลางกรุงเทพฯ มีทางเข้าเชื่อมต่อตรงกับสถานีรถไฟฟ้าบีทีเอส ที่สยามสแควร์ แหล่งรวมความบันเทิงและสันทนาการเหนือระดับ ทั้งพิพิธภัณฑ์สัตว์น้ำ “ซีไลฟ์ แบงคอก โอเชี่ยน เวิลด์” (Sea Life Bangkok Ocean World) พื้นที่ค้าปลีก ห้องนิทรรศการ หอศิลป์ไทย โรงภาพยนตร์จอใหญ่ 15 โรง และ “สยาม โอเปร่า เธียเตอร์” (Siam Opera 剧院式)`,
      },
    },
    locations: [
      {
        type: 'hours',
        text: {
          cn: '10:00 - 22:00',
          th: '10.00 น. - 22.00 น.',
        },
      },
      {
        type: 'phone',
        text: {
          cn: '电话: (662) 610 8000',
          th: 'โทรศัพท์: (662) 610 8000',
        },
        value: 'tel:(662) 610 8000',
      },
      {
        type: 'website',
        text: {
          cn: 'www.siamparagon.co.th',
          th: 'www.siamparagon.co.th',
        },
        value: 'http://www.siamparagon.co.th/',
      },
    ],
    gallery: [
      {
        imageSp: '/images/surroundings/7-Siam-Paragon/Siam-Paragon01_808x606_@1x.jpg',
        image: '/images/surroundings/7-Siam-Paragon/Siam-Paragon01_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/7-Siam-Paragon/Siam-Paragon01_808x606_@1x.webp',
        imageWebp: '/images/surroundings/7-Siam-Paragon/Siam-Paragon01_1616x1212_@2x.webp',
        caption: ' 暹罗百丽宫（Siam Paragon）',
      },
      {
        imageSp: '/images/surroundings/7-Siam-Paragon/Siam-Paragon02_808x606_@1x.jpg',
        image: '/images/surroundings/7-Siam-Paragon/Siam-Paragon02_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/7-Siam-Paragon/Siam-Paragon02_808x606_@1x.webp',
        imageWebp: '/images/surroundings/7-Siam-Paragon/Siam-Paragon02_1616x1212_@2x.webp',
        caption: ' 暹罗百丽宫（Siam Paragon）',
      },
      {
        imageSp: '/images/surroundings/7-Siam-Paragon/Siam-Paragon03_808x606_@1x.jpg',
        image: '/images/surroundings/7-Siam-Paragon/Siam-Paragon03_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/7-Siam-Paragon/Siam-Paragon03_808x606_@1x.webp',
        imageWebp: '/images/surroundings/7-Siam-Paragon/Siam-Paragon03_1616x1212_@2x.webp',
        caption: ' 暹罗百丽宫（Siam Paragon）',
      },
      {
        imageSp: '/images/surroundings/7-Siam-Paragon/Siam-Paragon04_808x606_@1x.jpg',
        image: '/images/surroundings/7-Siam-Paragon/Siam-Paragon04_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/7-Siam-Paragon/Siam-Paragon04_808x606_@1x.webp',
        imageWebp: '/images/surroundings/7-Siam-Paragon/Siam-Paragon04_1616x1212_@2x.webp',
        caption: ' 暹罗百丽宫（Siam Paragon）',
      },
    ],
  },
  {
    slug: 'bangkok-art-and-culture-centre',
    type: 'surrounding',
    title: {
      cn: '曼谷文化艺术中心<br/>（Bangkok Art and Culture Centre）',
      th: 'หอศิลปวัฒนธรรม<br/>แห่งกรุงเทพมหานคร',
    },
    image: '/images/surroundings/8-Bangkok-Art-and-Culture/Surrounding-8@2x.jpg',
    imageSp: '/images/surroundings/8-Bangkok-Art-and-Culture/Surrounding-8@1x.jpg',
    imageWebp: '/images/surroundings/8-Bangkok-Art-and-Culture/Surrounding-8@2x.webp',
    imageWebpSp: '/images/surroundings/8-Bangkok-Art-and-Culture/Surrounding-8@1x.webp',
    distance: {
      value: 4.9,
      unit: '公里',
      // link: 'https://goo.gl/maps/Dcfmq9YEsBKrBD8q7',
      link: 'https://map.baidu.com/poi/%E6%9B%BC%E8%B0%B7%E6%96%87%E5%8C%96%E8%89%BA%E6%9C%AF%E4%B8%AD%E5%BF%83/@11191097.135,1534963.59,19z?uid=24210d0d92b68e5dffa77851&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bfa7b30cf02691255c21d6b91f5776856a3107678826753cdd0d584000c9f7acd5bd45a237ed16732e94ee8466e06789bf&querytype=detailConInfo&da_src=shareurl',
    },
    description: {
      cn: '暹罗广场周围流行文化盛行，青春气息浓郁，曼谷文化艺术中心（BACC）则是曼谷的当代艺术中心。在这里，艺术鉴赏家可以饱览泰国和地区艺术家的精湛作品，尽享视觉饕餮盛宴。音乐家、剧作家、独立电影人、设计师、摄影师争相恐后，纷纷在此展示他们的佳作。此外，咖啡厅、美术馆、艺术图书馆、书店和工艺品商店亦为艺术中心增色不少。',
      th: 'หอศิลปวัฒนธรรมแห่งกรุงเทพมหานคร หอศิลปะร่วมสมัยในกรุงเทพฯ ที่ได้แรงบันดาลใจจากวัฒนธรรมสมัยนิยมและจิตวิญญาณของวัยรุ่นรอบๆ สยามสแควร์ ผู้ที่ชื่นชอบศิลปะสามารถดื่มด่ำกับความรุ่มรวยทางทัศนศิลป์ของศิลปินไทยและศิลปินในภูมิภาค นักดนตรี นักเขียนบทละคร ผู้สร้างภาพยนตร์อิสระ นักออกแบบ และช่างภาพผลัดกันมาแสดงผลงานและความคิดสร้างสรรค์ นอกจากนั้นยังมีคาเฟ่  ห้องแสดงศิลปะ ห้องสมุดศิลปะ ร้านหนังสือ และร้านงานฝีมือต่างๆ ให้ได้เก็บเกี่ยวแรงบันดาลใจได้อย่างเต็มที่ ',
    },
    excerpt: {
      title: {
        cn: '暹罗广场周围流行文化盛行，青春气息浓郁，曼谷文化艺术中心（BACC）则是曼谷的当代艺术中心。在这里，艺术鉴赏家可以饱览泰国和地区艺术家的精湛作品，尽享视觉饕餮盛宴。音乐家、剧作家、独立电影人、设计师、摄影师争相恐后，纷纷在此展示他们的佳作。此外，咖啡厅、美术馆、艺术图书馆、书店和工艺品商店亦为艺术中心增色不少。',
        th: `หอศิลปวัฒนธรรมแห่งกรุงเทพมหานคร หอศิลปะร่วมสมัยในกรุงเทพฯ ที่ได้แรงบันดาลใจจากวัฒนธรรมสมัยนิยมและจิตวิญญาณของวัยรุ่นรอบๆ สยามสแควร์ ผู้ที่ชื่นชอบศิลปะสามารถดื่มด่ำกับความรุ่มรวยทางทัศนศิลป์ของศิลปินไทยและศิลปินในภูมิภาค นักดนตรี นักเขียนบทละคร ผู้สร้างภาพยนตร์อิสระ นักออกแบบ และช่างภาพผลัดกันมาแสดงผลงานและความคิดสร้างสรรค์ นอกจากนั้นยังมีคาเฟ่  ห้องแสดงศิลปะ ห้องสมุดศิลปะ ร้านหนังสือ และร้านงานฝีมือต่างๆ ให้ได้เก็บเกี่ยวแรงบันดาลใจได้อย่างเต็มที่ `,
      },
      subtitle: {
        cn: '暹罗广场周围流行文化盛行，青春气息浓郁，曼谷文化艺术中心（BACC）则是曼谷的当代艺术中心。在这里，艺术鉴赏家可以饱览泰国和地区艺术家的精湛作品，尽享视觉饕餮盛宴。音乐家、剧作家、独立电影人、设计师、摄影师争相恐后，纷纷在此展示他们的佳作。此外，咖啡厅、美术馆、艺术图书馆、书店和工艺品商店亦为艺术中心增色不少。',
        th: `หอศิลปวัฒนธรรมแห่งกรุงเทพมหานคร หอศิลปะร่วมสมัยในกรุงเทพฯ ที่ได้แรงบันดาลใจจากวัฒนธรรมสมัยนิยมและจิตวิญญาณของวัยรุ่นรอบๆ สยามสแควร์ ผู้ที่ชื่นชอบศิลปะสามารถดื่มด่ำกับความรุ่มรวยทางทัศนศิลป์ของศิลปินไทยและศิลปินในภูมิภาค นักดนตรี นักเขียนบทละคร ผู้สร้างภาพยนตร์อิสระ นักออกแบบ และช่างภาพผลัดกันมาแสดงผลงานและความคิดสร้างสรรค์ นอกจากนั้นยังมีคาเฟ่  ห้องแสดงศิลปะ ห้องสมุดศิลปะ ร้านหนังสือ และร้านงานฝีมือต่างๆ ให้ได้เก็บเกี่ยวแรงบันดาลใจได้อย่างเต็มที่ `,
      },
    },
    locations: [
      {
        type: 'hours',
        text: {
          cn: '10:00 - 21:00',
          th: '10.00 น. - 21.00 น.',
        },
      },
      {
        type: 'phone',
        text: {
          cn: '电话: (662) 214 6639',
          th: 'โทรศัพท์: (662) 214 6639',
        },
        value: 'tel:(662) 214 6639',
      },
      {
        type: 'website',
        text: {
          cn: 'www.bacc.or.th',
          th: 'www.bacc.or.th',
        },
        value: 'http://www.bacc.or.th/',
      },
    ],
    gallery: [
      {
        imageSp: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture01_808x606_@1x.jpg',
        image: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture01_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture01_808x606_@1x.webp',
        imageWebp: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture01_1616x1212_@2x.webp',
        caption: '曼谷文化艺术中心（Bangkok Art and Culture Centre）',
      },
      {
        imageSp: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture02_808x606_@1x.jpg',
        image: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture02_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture02_808x606_@1x.webp',
        imageWebp: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture02_1616x1212_@2x.webp',
        caption: '曼谷文化艺术中心（Bangkok Art and Culture Centre）',
      },
      {
        imageSp: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture03_808x606_@1x.jpg',
        image: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture03_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture03_808x606_@1x.webp',
        imageWebp: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture03_1616x1212_@2x.webp',
        caption: '曼谷文化艺术中心（Bangkok Art and Culture Centre）',
      },
      {
        imageSp: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture04_808x606_@1x.jpg',
        image: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture04_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture04_808x606_@1x.webp',
        imageWebp: '/images/surroundings/8-Bangkok-Art-and-Culture/Bangkok-Art-and-Culture04_1616x1212_@2x.webp',
        caption: '曼谷文化艺术中心（Bangkok Art and Culture Centre）',
      },
    ],
  },
  {
    slug: 'samyan-mitrtown',
    type: 'surrounding',
    title: {
      cn: '泰国山燕商场<br/>（Samyan Mitrtown）',
      th: 'สามย่านมิตรทาวน์',
    },
    image: '/images/surroundings/9-Samyan-Mitrtown/Surrounding-9@2x.jpg',
    imageSp: '/images/surroundings/9-Samyan-Mitrtown/Surrounding-9@1x.jpg',
    imageWebp: '/images/surroundings/9-Samyan-Mitrtown/Surrounding-9@2x.webp',
    imageWebpSp: '/images/surroundings/9-Samyan-Mitrtown/Surrounding-9@1x.webp',
    distance: {
      value: 7.8,
      unit: '公里',
      // link: 'https://goo.gl/maps/dGyHpuVGhBHw1nAH7',
      link: 'https://map.baidu.com/poi/%E4%B8%89%E6%B4%8B%E4%B8%AD%E5%BF%83/@11190880.835,1533557.66,19z?uid=9d43949ac4b2b3b83e9a5e1b&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bfa7b30cf02691255c21d6b91f5776856a3107678826753cdd0d584000c9f7acd5bd45a237ed16732e94ee8466e06789bf&querytype=detailConInfo&da_src=shareurl',
    },
    description: {
      cn: '泰国山燕商场位于朱拉隆功大学（Chulalongkorn University）附近，与Samyan地铁站连接。建设之初，泰国山燕商场就已将共享经济牢记于心，同时举办丰富多姿的活动，打造轻松愉悦的生活方式。综合体由Triple Y 酒店、住宅区、办公区和零售区组成。其中，零售区提供集餐饮、购物、餐厅、超市和协同工作为一体的全方位服务。',
      th: 'สามย่านมิตรทาวน์ ตั้งอยู่ใกล้จุฬาลงกรณ์มหาวิทยาลัยและเชื่อมต่อกับสถานีรถไฟฟ้าใต้ดิน “สามย่าน” สร้างขึ้นโดยคำนึงถึงเศรษฐกิจแบบแบ่งปัน เต็มไปด้วยกิจกรรมและไลฟ์สไตล์ที่มีความสุข สามย่านมิตรทาวน์ ประกอบด้วยโรงแรมทริปเปิ้ล วาย (Triple Y) อาคารที่อยู่อาศัย สำนักงาน และโซนพื้นที่ค้าปลีก ที่ให้บริการครบวงจรทั้งร้านอาหาร แหล่งช้อปปิ้ง ซูเปอร์มาร์เก็ต และโคเวิร์คกิ้งสเปซ (Co-working Space)',
    },
    excerpt: {
      title: {
        cn: '泰国山燕商场位于朱拉隆功大学（Chulalongkorn University）附近，与Samyan地铁站连接。建设之初，泰国山燕商场就已将共享经济牢记于心，同时举办丰富多姿的活动，打造轻松愉悦的生活方式。综合体由Triple Y 酒店、住宅区、办公区和零售区组成。其中，零售区提供集餐饮、购物、餐厅、超市和协同工作为一体的全方位服务。',
        th: 'สามย่านมิตรทาวน์ ตั้งอยู่ใกล้จุฬาลงกรณ์มหาวิทยาลัยและเชื่อมต่อกับสถานีรถไฟฟ้าใต้ดิน “สามย่าน” สร้างขึ้นโดยคำนึงถึงเศรษฐกิจแบบแบ่งปัน เต็มไปด้วยกิจกรรมและไลฟ์สไตล์ที่มีความสุข สามย่านมิตรทาวน์ ประกอบด้วยโรงแรมทริปเปิ้ล วาย (Triple Y) อาคารที่อยู่อาศัย สำนักงาน และโซนพื้นที่ค้าปลีก ที่ให้บริการครบวงจรทั้งร้านอาหาร แหล่งช้อปปิ้ง ซูเปอร์มาร์เก็ต และโคเวิร์คกิ้งสเปซ (Co-working Space)',
      },
      subtitle: {
        cn: '泰国山燕商场位于朱拉隆功大学（Chulalongkorn University）附近，与Samyan地铁站连接。建设之初，泰国山燕商场就已将共享经济牢记于心，同时举办丰富多姿的活动，打造轻松愉悦的生活方式。综合体由Triple Y 酒店、住宅区、办公区和零售区组成。其中，零售区提供集餐饮、购物、餐厅、超市和协同工作为一体的全方位服务。​',
        th: 'สามย่านมิตรทาวน์ ตั้งอยู่ใกล้จุฬาลงกรณ์มหาวิทยาลัยและเชื่อมต่อกับสถานีรถไฟฟ้าใต้ดิน “สามย่าน” สร้างขึ้นโดยคำนึงถึงเศรษฐกิจแบบแบ่งปัน เต็มไปด้วยกิจกรรมและไลฟ์สไตล์ที่มีความสุข สามย่านมิตรทาวน์ ประกอบด้วยโรงแรมทริปเปิ้ล วาย (Triple Y) อาคารที่อยู่อาศัย สำนักงาน และโซนพื้นที่ค้าปลีก ที่ให้บริการครบวงจรทั้งร้านอาหาร แหล่งช้อปปิ้ง ซูเปอร์มาร์เก็ต และโคเวิร์คกิ้งสเปซ (Co-working Space)',
      },
    },
    locations: [
      {
        type: 'hours',
        text: {
          cn: '10:00 - 22:00',
          th: '10.00 น. - 22.00 น.',
        },
      },
      {
        type: 'phone',
        text: {
          cn: '电话: (662) 033 8900',
          th: 'โทรศัพท์: (662) 033 8900',
        },
        value: 'tel:(662) 033 8900',
      },
      {
        type: 'website',
        text: {
          cn: 'www.samyan-mitrtown.com',
          th: 'www.samyan-mitrtown.com',
        },
        value: 'http://www.samyan-mitrtown.com/',
      },
    ],
    gallery: [
      {
        imageSp: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown01_808x606_@1x.jpg',
        image: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown01_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown01_808x606_@1x.webp',
        imageWebp: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown01_1616x1212_@2x.webp',
        caption: '泰国山燕商场（Samyan Mitrtown）',
      },
      {
        imageSp: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown02_808x606_@1x.jpg',
        image: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown02_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown02_808x606_@1x.webp',
        imageWebp: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown02_1616x1212_@2x.webp',
        caption: '泰国山燕商场（Samyan Mitrtown）',
      },
      {
        imageSp: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown03_808x606_@1x.jpg',
        image: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown03_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown03_808x606_@1x.webp',
        imageWebp: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown03_1616x1212_@2x.webp',
        caption: '泰国山燕商场（Samyan Mitrtown）',
      },
      {
        imageSp: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown04_808x606_@1x.jpg',
        image: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown04_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown04_808x606_@1x.webp',
        imageWebp: '/images/surroundings/9-Samyan-Mitrtown/Samyan-Mitrtown04_1616x1212_@2x.webp',
        caption: '泰国山燕商场（Samyan Mitrtown）',
      },
    ],
  },
  {
    slug: 'bangkok-chinatown',
    type: 'surrounding',
    title: {
      cn: '唐人街',
      th: 'เยาวราช',
    },
    image: '/images/surroundings/5-Bangkok_s-Chinatown/Surrounding-5@2x.jpg',
    imageSp: '/images/surroundings/5-Bangkok_s-Chinatown/Surrounding-5@1x.jpg',
    imageWebp: '/images/surroundings/5-Bangkok_s-Chinatown/Surrounding-5@2x.webp',
    imageWebpSp: '/images/surroundings/5-Bangkok_s-Chinatown/Surrounding-5@1x.webp',
    distance: {
      value: 8.1,
      unit: '公里',
      // link: 'https://goo.gl/maps/85eGrFFt8FJpVKJ88',
      link: 'https://map.baidu.com/poi/%E5%94%90%E4%BA%BA%E8%A1%97/@11188666.665,1534332.07,19z?uid=87317850b905a6d4770269a2&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&seckey=2e2a0a47bdcac477b497b3756246e88116d753808397929acaaf5a201554f1f535a8951ab937d219eff0ffe9855708944f6bcd8db2619f964c6113bb03b0ac033fbbfcc5712807b274dbe0e1865bdfc3ac1c147617dd3facfaffdc23745bf492f44a37ad8ff147baadfcdafc303c1e8b7aa6ae7514562d49f3062bb4f8ddaefb399d0e95f6244068788dd72c38a8aae1afd106f7b02075ee6b8117f672f5f14d905e5cee9816e18b2b72ab4f9f3b78d954b93ae3e18eacdfb16abf365586c7bfa7b30cf02691255c21d6b91f5776856a3107678826753cdd0d584000c9f7acd5bd45a237ed16732e94ee8466e06789bf&querytype=detailConInfo&da_src=shareurl',
    },
    description: {
      cn: '曼谷唐人街，即耀华力路（Yaowarat Road），自1782年以来一直是华人定居中心点。这里，历史街区由Wat Mangkon地铁站向四面八方延伸。唐人街以其美食和娱乐项目而闻名。游客可在耀华力路闲庭信步，这里的泰国炒面、海鲜汤、烤鸡和热带水果金字塔，让您垂涎三尺。一些传统商店一改古朴风格，摇身变成时尚咖啡厅或高级餐厅。更有趣的是，各色美食诱人的香气萦绕鼻尖，让您迷失在繁华街巷。​',
      th: 'เยาวราช ศูนย์กลางของการตั้งถิ่นฐานของชาวจีนตั้งแต่ปี 2325 ย่านประวัติศาสตร์แห่งนี้ทอดยาวตั้งแต่สถานีรถไฟฟ้าใต้ดินวัดมังกรแผ่ไปในทุกทิศทาง เยาวราชขึ้นชื่อในเรื่องอาหารที่หลากหลายและสีสันของความสนุกสนาน ให้คุณได้สัมผัสและเพลิดเพลินไปกับการเลือกชิมอาหารเมนูต่างๆ ไม่ว่าจะเป็นก๋วยเตี๋ยวผัดไทย ต้มยำทะเล ไก่ย่าง และผลไม้ต่างๆ นอกจากนี้ยังมีอาคารพาณิชย์เก่าแก่ที่ปรับเปลี่ยนเป็นร้านกาแฟเก๋ๆ หรือร้านอาหารชั้นเลิศ เสน่ห์ของการไปเยือนเยาวราช คือการเดินหลงในตรอกเล็กๆ เพราะตามกลิ่นหอมยั่วยวนใจของอาหารนั่นเอง',
    },
    excerpt: {
      title: {
        cn: '曼谷唐人街，即耀华力路（Yaowarat Road），自1782年以来一直是华人定居中心点。这里，历史街区由Wat Mangkon地铁站向四面八方延伸。唐人街以其美食和娱乐项目而闻名。游客可在耀华力路闲庭信步，这里的泰国炒面、海鲜汤、烤鸡和热带水果金字塔，让您垂涎三尺。一些传统商店一改古朴风格，摇身变成时尚咖啡厅或高级餐厅。更有趣的是，各色美食诱人的香气萦绕鼻尖，让您迷失在繁华街巷。',
        th: `เยาวราช ศูนย์กลางของการตั้งถิ่นฐานของชาวจีนตั้งแต่ปี 2325 ย่านประวัติศาสตร์แห่งนี้ทอดยาวตั้งแต่สถานีรถไฟฟ้าใต้ดินวัดมังกรแผ่ไปในทุกทิศทาง เยาวราชขึ้นชื่อในเรื่องอาหารที่หลากหลายและสีสันของความสนุกสนาน ให้คุณได้สัมผัสและเพลิดเพลินไปกับการเลือกชิมอาหารเมนูต่างๆ ไม่ว่าจะเป็นก๋วยเตี๋ยวผัดไทย ต้มยำทะเล ไก่ย่าง และผลไม้ต่างๆ นอกจากนี้ยังมีอาคารพาณิชย์เก่าแก่ที่ปรับเปลี่ยนเป็นร้านกาแฟเก๋ๆ หรือร้านอาหารชั้นเลิศ เสน่ห์ของการไปเยือนเยาวราช คือการเดินหลงในตรอกเล็กๆ เพราะตามกลิ่นหอมยั่วยวนใจของอาหารนั่นเอง`,
      },
      subtitle: {
        cn: '曼谷唐人街，即耀华力路（Yaowarat Road），自1782年以来一直是华人定居中心点。这里，历史街区由Wat Mangkon地铁站向四面八方延伸。唐人街以其美食和娱乐项目而闻名。游客可在耀华力路闲庭信步，这里的泰国炒面、海鲜汤、烤鸡和热带水果金字塔，让您垂涎三尺。一些传统商店一改古朴风格，摇身变成时尚咖啡厅或高级餐厅。更有趣的是，各色美食诱人的香气萦绕鼻尖，让您迷失在繁华街巷。​',
        th: `เยาวราช ศูนย์กลางของการตั้งถิ่นฐานของชาวจีนตั้งแต่ปี 2325 ย่านประวัติศาสตร์แห่งนี้ทอดยาวตั้งแต่สถานีรถไฟฟ้าใต้ดินวัดมังกรแผ่ไปในทุกทิศทาง เยาวราชขึ้นชื่อในเรื่องอาหารที่หลากหลายและสีสันของความสนุกสนาน ให้คุณได้สัมผัสและเพลิดเพลินไปกับการเลือกชิมอาหารเมนูต่างๆ ไม่ว่าจะเป็นก๋วยเตี๋ยวผัดไทย ต้มยำทะเล ไก่ย่าง และผลไม้ต่างๆ นอกจากนี้ยังมีอาคารพาณิชย์เก่าแก่ที่ปรับเปลี่ยนเป็นร้านกาแฟเก๋ๆ หรือร้านอาหารชั้นเลิศ เสน่ห์ของการไปเยือนเยาวราช คือการเดินหลงในตรอกเล็กๆ เพราะตามกลิ่นหอมยั่วยวนใจของอาหารนั่นเอง`,
      },
    },
    locations: [],
    gallery: [
      {
        imageSp: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown01_808x606_@1x.jpg',
        image: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown01_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown01_808x606_@1x.webp',
        imageWebp: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown01_1616x1212_@2x.webp',
        caption: '曼谷唐人街',
      },
      {
        imageSp: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown02_808x606_@1x.jpg',
        image: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown02_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown02_808x606_@1x.webp',
        imageWebp: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown02_1616x1212_@2x.webp',
        caption: '曼谷唐人街',
      },
      {
        imageSp: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown03_808x606_@1x.jpg',
        image: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown03_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown03_808x606_@1x.webp',
        imageWebp: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown03_1616x1212_@2x.webp',
        caption: '曼谷唐人街',
      },
      {
        imageSp: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown04_808x606_@1x.jpg',
        image: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown04_1616x1212_@2x.jpg',
        imageWebpSp: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown04_808x606_@1x.webp',
        imageWebp: '/images/surroundings/5-Bangkok_s-Chinatown/Bangkok_s-Chinatown04_1616x1212_@2x.webp',
        caption: '曼谷唐人街',
      },
    ],
  },
];

export const HOTEL_SURROUNDING_OPTION_LIST = [
  {
    label: '酒店',
    value: 'hotel',
    link: '/hotel-surrounding/hotel/',
  },
  {
    label: '周边环境',
    value: 'surrounding',
    link: '/hotel-surrounding/surrounding/',
  },
];

export const MEDIA_OPTION_LIST = [
  {
    label: {
      cn: '新闻',
      th: 'News',
    },
    value: 'news',
    link: '/media/news/',
  },
  {
    label: {
      cn: '图片库',
      th: 'Gallery',
    },
    value: 'gallery',
    link: '/media/gallery/',
  },
  {
    label: {
      cn: 'N.C.C集团',
      th: 'NCC Group',
    },
    value: 'ncc-group',
    link: '/media/ncc-group/',
  },
];
export const SUSTAIN_OPTION_LIST = [
  {
    label: {
      cn: '可持续性',
      th: 'Sustainability',
    },
    value: 'sustainability',
    link: '/privacy-policy/sustainability/',
  },
  {
    label: {
      cn: '证书',
      th: 'Certificates',
    },
    value: 'certificates',
    link: '/privacy-policy/certificates/',
  },
  {
    label: {
      cn: '合作伙伴',
      th: 'Partnership',
    },
    value: 'partnership',
    link: '/privacy-policy/partnership/',
  },
];

export const VENUN_OPTION_LIST = [
  {
    label: {
      cn: '场地服务',
      th: 'VenueService',
    },
    value: 'venue-service',
    link: '/service/venue-service/',
  },
  {
    label: {
      cn: '品牌广告',
      th: 'BrandAdvertising',
    },
    value: 'brandadvertising',
    link: '/service/brandadvertising/',
  },
];
export const EVENT_PROMOTION_LIST = [
  {
    label: {
      cn: '活动促销',
      th: 'EventPromotion',
    },
    value: 'venue-service',
    link: 'https://qsncc.com/en/visit/food-and-retail/',
  },
];
export const VIRTUAL_TOUR_LIST = [
  {
    label: {
      cn: '虚拟导览',
      th: 'VirtualTour',
    },
    value: 'virtualtour',
    link: '/virtual/virtualtour/',
  },
];

export const GLANCE_OPTION_LIST = [
  {
    label: {
      cn: '愿景',
      th: 'News',
    },
    value: 'vision',
    link: '/glance/vision/',
  },
  {
    label: {
      cn: '历史',
      th: 'Gallery',
    },
    value: 'history',
    link: '/glance/history/',
  },
  {
    label: {
      cn: '选择QSNCC的理由',
      th: 'NCC Group',
    },
    value: 'whyqsncc',
    link: '/glance/whyqsncc/',
  },
];
export const BUS_ROUTE_LIST = [
  {
    label: {
      cn: '乘车路线',
      th: 'BusRoute',
    },
    value: 'busroute',
    link: '/bus-route/busroute/',
  },
  {
    label: {
      cn: 'MRT换乘',
      th: 'MRT',
    },
    value: 'mrt',
    link: '/bus-route/mrt/',
  },
  {
    label: {
      cn: '停车场',
      th: 'Parking',
    },
    value: 'parking',
    link: '/bus-route/parking/',
  },
  {
    label: {
      cn: '交通方式',
      th: 'Transportation',
    },
    value: 'transportation',
    link: '/bus-route/transportation/',
  },
];

export const GALLERY_LIST = [
  // Exterior
  {
    label: {
      cn: '外部',
      th: 'ภายนอกอาคาร',
    },
    items: [
      {
        type: 'half',
        image: {
          src: '/images/media/gallery/exterior/210420-Birdeyeview_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/exterior/210420-Birdeyeview_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/exterior/210420-Birdeyeview_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/exterior/210420-Birdeyeview_1200x630_@1x.webp',
          caption: '俯瞰图',
          align: 'left',
        },
      },
      {
        image: {
          src: '/images/media/gallery/exterior/cam009-03-ren-day-Magazine-V03_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/exterior/cam009-03-ren-day-Magazine-V03_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/exterior/cam009-03-ren-day-Magazine-V03_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/exterior/cam009-03-ren-day-Magazine-V03_1200x630_@1x.webp',
          caption: '俯瞰图',
          align: 'left',
        },
      },
      {
        image: {
          src: '/images/media/gallery/exterior/PAKON-GOLDEDGE-entrance_right_KHLP-OFF-w-TREE-MAGAZINE-V03_2400x1260_@2x.jpg',
          srcSp:
            '/images/media/gallery/exterior/PAKON-GOLDEDGE-entrance_right_KHLP-OFF-w-TREE-MAGAZINE-V03_1200x630_@1x.jpg',
          srcWebp:
            '/images/media/gallery/exterior/PAKON-GOLDEDGE-entrance_right_KHLP-OFF-w-TREE-MAGAZINE-V03_2400x1260_@2x.webp',
          srcWebpSp:
            '/images/media/gallery/exterior/PAKON-GOLDEDGE-entrance_right_KHLP-OFF-w-TREE-MAGAZINE-V03_1200x630_@1x.webp',
          caption: '右入口',
          align: 'left',
        },
      },
      {
        type: 'full',
        align: 'bottom',
        image: {
          src: '/images/media/gallery/exterior/qsncc_front_perspective_day_A_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/exterior/qsncc_front_perspective_day_A_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/exterior/qsncc_front_perspective_day_A_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/exterior/qsncc_front_perspective_day_A_1200x630_@1x.webp',
          caption: '正面',
          align: 'left',
        },
      },
    ],
  },
  {
    label: {
      cn: '内部',
      th: 'ภายในอาคาร',
    },
    items: [
      // Level 1
      {
        type: 'half',
        image: {
          src: '/images/media/gallery/interior/level-1/Ballroom-Foyer_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-1/Ballroom-Foyer_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-1/Ballroom-Foyer_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-1/Ballroom-Foyer_1200x630_@1x.webp',
          caption: 'L1层 - 宴会厅门厅',
          align: 'left',
        },
      },
      {
        image: {
          src: '/images/media/gallery/interior/level-1/Central-Lounge_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-1/Central-Lounge_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-1/Central-Lounge_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-1/Central-Lounge_1200x630_@1x.webp',
          caption: 'L1层 - 中央休息室',
          align: 'left',
        },
      },
      {
        image: {
          src: '/images/media/gallery/interior/level-1/Meeting-Room-Foyer-B_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-1/Meeting-Room-Foyer-B_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-1/Meeting-Room-Foyer-B_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-1/Meeting-Room-Foyer-B_1200x630_@1x.webp',
          caption: 'L1层 - 会议室前厅B',
          align: 'left',
        },
      },
      {
        type: 'full',
        align: 'bottom',
        image: {
          src: '/images/media/gallery/interior/level-1/Plenary-Hall-1_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-1/Plenary-Hall-1_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-1/Plenary-Hall-1_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-1/Plenary-Hall-1_1200x630_@1x.webp',
          caption: 'L1层 - 大会堂2',
          align: 'left',
        },
      },
      {
        type: 'full',
        align: 'bottom',
        image: {
          src: '/images/media/gallery/interior/level-1/Plenary-Hall-2_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-1/Plenary-Hall-2_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-1/Plenary-Hall-2_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-1/Plenary-Hall-2_1200x630_@1x.webp',
          caption: 'L1层 - 大会堂2',
          align: 'left',
        },
      },
      // Level 2
      {
        type: 'half',
        image: {
          src: '/images/media/gallery/interior/level-2/Meeting-Room-Foyer-A_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-2/Meeting-Room-Foyer-A_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-2/Meeting-Room-Foyer-A_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-2/Meeting-Room-Foyer-A_1200x630_@1x.webp',
          caption: 'L2层 - 会议室前厅A',
          align: 'left',
        },
      },
      // Level B1
      {
        image: {
          src: '/images/media/gallery/interior/level-B1/Meeting-Room-Foyer-A_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-B1/Meeting-Room-Foyer-A_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-B1/Meeting-Room-Foyer-A_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-B1/Meeting-Room-Foyer-A_1200x630_@1x.webp',
          caption: 'B1层 - 会议室前厅A',
          align: 'left',
        },
      },
      // Level G
      {
        image: {
          src: '/images/media/gallery/interior/level-G/Exhibition-Hall-1-4-(1)_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-G/Exhibition-Hall-1-4-(1)_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-G/Exhibition-Hall-1-4-(1)_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-G/Exhibition-Hall-1-4-(1)_1200x630_@1x.webp',
          caption: 'G层 - 展厅1-4',
          align: 'left',
        },
      },
      {
        type: 'full',
        align: 'bottom',
        image: {
          src: '/images/media/gallery/interior/level-G/Exhibition-Hall-1-4-(2)_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-G/Exhibition-Hall-1-4-(2)_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-G/Exhibition-Hall-1-4-(2)_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-G/Exhibition-Hall-1-4-(2)_1200x630_@1x.webp',
          caption: 'G层 - 展厅1-4',
          align: 'left',
        },
      },
      {
        type: 'half',
        image: {
          src: '/images/media/gallery/interior/level-G/Exhibition-Hall-1-4-(3)_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-G/Exhibition-Hall-1-4-(3)_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-G/Exhibition-Hall-1-4-(3)_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-G/Exhibition-Hall-1-4-(3)_1200x630_@1x.webp',
          caption: 'G层 - 展厅1-4',
          align: 'left',
        },
      },
      {
        image: {
          src: '/images/media/gallery/interior/level-G/Main-Foyer-A_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-G/Main-Foyer-A_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-G/Main-Foyer-A_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-G/Main-Foyer-A_1200x630_@1x.webp',
          caption: 'G层 - 大堂A',
          align: 'left',
        },
      },
      {
        image: {
          src: '/images/media/gallery/interior/level-G/Main-Foyer-A(2)_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-G/Main-Foyer-A(2)_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-G/Main-Foyer-A(2)_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-G/Main-Foyer-A(2)_1200x630_@1x.webp',
          caption: 'G层 - 大堂A',
          align: 'left',
        },
      },
      {
        type: 'half',
        image: {
          src: '/images/media/gallery/interior/level-G/Main-Foyer-A(3)_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-G/Main-Foyer-A(3)_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-G/Main-Foyer-A(3)_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-G/Main-Foyer-A(3)_1200x630_@1x.webp',
          caption: 'G层 - 大堂B',
          align: 'left',
        },
      },
      {
        image: {
          src: '/images/media/gallery/interior/level-G/Main-Foyer-B_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-G/Main-Foyer-B_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-G/Main-Foyer-B_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-G/Main-Foyer-B_1200x630_@1x.webp',
          caption: 'G层 - 大堂B',
          align: 'left',
        },
      },
      // Level LG
      {
        image: {
          src: '/images/media/gallery/interior/level-LG/Exhibition-Hall-5-8_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-LG/Exhibition-Hall-5-8_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-LG/Exhibition-Hall-5-8_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-LG/Exhibition-Hall-5-8_1200x630_@1x.webp',
          caption: 'LG层 - 展厅5-8',
          align: 'left',
        },
      },
      {
        type: 'full',
        align: 'bottom',
        image: {
          src: '/images/media/gallery/interior/level-LG/Foyer-A-(2)_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-LG/Foyer-A-(2)_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-LG/Foyer-A-(2)_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-LG/Foyer-A-(2)_1200x630_@1x.webp',
          caption: 'LG层 - 前厅A',
          align: 'left',
        },
      },
      {
        type: 'half',
        image: {
          src: '/images/media/gallery/interior/level-LG/Foyer-A_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-LG/Foyer-A_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-LG/Foyer-A_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-LG/Foyer-A_1200x630_@1x.webp',
          caption: 'LG层 - 前厅A',
          align: 'left',
        },
      },
      {
        image: {
          src: '/images/media/gallery/interior/level-LG/Foyer-B-(2)_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-LG/Foyer-B-(2)_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-LG/Foyer-B-(2)_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-LG/Foyer-B-(2)_1200x630_@1x.webp',
          caption: 'LG层 - 前厅B',
          align: 'left',
        },
      },
      {
        align: 'bottom',
        image: {
          src: '/images/media/gallery/interior/level-LG/Foyer-B_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-LG/Foyer-B_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-LG/Foyer-B_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-LG/Foyer-B_@1x.webp',
          caption: 'LG层 - 前厅B',
          align: 'left',
        },
      },
      {
        type: 'full',
        image: {
          src: '/images/media/gallery/interior/level-LG/Foyer-B-(3)_2400x1260_@2x.jpg',
          srcSp: '/images/media/gallery/interior/level-LG/Foyer-B-(3)_1200x630_@1x.jpg',
          srcWebp: '/images/media/gallery/interior/level-LG/Foyer-B-(3)_2400x1260_@2x.webp',
          srcWebpSp: '/images/media/gallery/interior/level-LG/Foyer-B-(3)_1200x630_@1x.webp',
          caption: 'LG层 - 前厅B',
          align: 'left',
        },
      },
    ],
  },
];

export const PRIVACY_POLICY_LIST = [
  {
    default: true,
    title: {
      cn: '京ICP备16033182号-2',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `<p style="text-align: center;font-size: 19px;padding: 0 0 10px 0;">泰国诗丽吉王后国家会议中心（QSNCC）拥有最先进的建筑设计，是泰国首屈一指的活动平台。在规划时考虑到各种活动的需要，因其环保设计和使用了最新的创新技术，使其处于可持续发展的前沿。</P>
      
      <div style="display: flex;align-items: start;padding-bottom: 80px;">
        <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;flex: 1;gap: 25px;">
          <img src="/images/sustainability/route.png"><span style="font-size: 20px;">地理位置&交通</span>
          <img src="/images/sustainability/state.png"><span style="font-size: 20px;">可持续场地</span>
          <img src="/images/sustainability/water.png"><span style="font-size: 20px;">节水</span>
        </div>
        <div style="display: flex;align-items: center;justify-content: center;flex-direction: column;flex: 1;">
          <img style="border-radius: 0 50px 0 50px;width:90%;height:60%"  src="/images/sustainability/sustainability-01.jpg" >
          <p style="padding: 20px 0 0 20px;text-indent: 32px;line-height: 1.8em;font-size: 17px;width: 46em;">QSNCC 位于曼谷商业区的中心，拥有优越的地理位置，交通也十分便利，前往会议中心的旅程不会留下过多的碳排放。一条人行道连接 MRT、诗丽吉王后国家会议中心站及会议中心的地下一层，会议场馆附近还设有公交车站。会议中心还提供诸如停车场、电动汽车充电器、自行车架和淋浴间等现代化设施，以支持那些选择其他可持续交通方式的人。</p>
        </div>
      </div>

      <div style="display: flex;align-items: center;justify-content: center;padding-bottom: 80px;">
          <p><img style="border-radius: 0 50px 0 50px;" width="100%" height="60%" src="/images/sustainability/sustainability-02.jpg" ></p>
          <div style="width: 45em;padding: 3em;line-height: 1.8em;font-size: 17px;width: 46em;">
            QSNCC 致⼒于成为可持续发展领域的⾏业领导者，并关注对环境的影响。所有系统（如照明、⽔、暖通空调、室内空⽓质量和清洁）的设计都反映了我们的政策与绿⾊运营实践。
            <ul>
              <li style="list-style-type: disc;">通过在⼈⾏道和屋顶表⾯使⽤浅⾊，最⼤限度地减少阳光反射。</li>
              <li style="list-style-type: disc;">向上照明和光侵⼊也被最⼩化，以限制天空辉光和对周围区域的⼲扰。</li>
              <li style="list-style-type: disc;">整个设施最⼤限度地利⽤⾃然光和通⻛换⽓系统。</li>
            </ul>
          </div>
      </div>
      <div style="display: flex;align-items: center;justify-content: center;">
        <p style="width: 45em;padding: 3em;line-height: 1.8em;font-size: 17px;width: 46em;">QSNCC 安装了节⽔装置，以减少⽤⽔量，并在整个建筑内使⽤低流量⽔装置，以最⼤限度减少⽤⽔量。该场馆旨在通过使⽤滴灌系统和⽔循环，来最⼤限度地减少绿地的供⽔需求。外部景观还利⽤滴灌线，最⼤限度地提⾼浇灌效率，并最⼤限度地减少⽤⽔量。
        </p>
        <p><img style="border-radius: 50px 0 50px 0;" width="100%" height="60%" src="/images/sustainability/sustainability-03.jpg" ></p>
          
      </div>
      `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
  {
    title: {
      cn: 'What Personal Data we collect',
      th: 'ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม',
    },
    content: {
      cn: `<p style="letter-spacing: 8px;text-align:center;font-size: 40px;padding: 4% 0;color: #827800;"><strong>能源效率</strong></p>
        <div style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 80px;">
          <ol style="width: 34em;padding: 0 20px 0 0;font-size: 17px;line-height: 1.7em;">
            <li style="font-size: 17px;">整个建筑是一个非常节能的设施，具备实施节能测量和验证 (M&V)的能力，以促进和保持资源效率并满足环境目标。在实时测量和跟踪能源使用的帮助下，使用 BAS 和智能建筑控制计量和监控为环境可持续性做出重大贡献。</li>
            <li style="font-size: 17px;">屋顶安装了 6,207 平方米的太阳能电池板，作为会展中心的可再生能源。</li>
            <li style="font-size: 17px;">所有展厅均安装了感应式 LED 照明，降低了能耗。</li>
            <li style="font-size: 17px;">不同场所配备不同的照明场景，最大限度地利用自然光</li>
          </ol>
          <p><img style="border-radius: 50px 0 50px 0;"  width="100%" height="60%" src="/images/sustainability/energy-efficiency-pc.jpg" ></p>
        </div>
        
        <p style="letter-spacing: 8px;text-align:center;font-size: 40px;padding: 4% 0;color: #827800;"><strong>绿色施工实践</strong></p>
        <div style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 80px;">
          <p><img style="border-radius: 50px 0 50px 0;" src="/images/sustainability/green-pc.jpg" width="90%" height="60%"></p>
          <div>
              <div style="font-size: 23px;"><strong>施工</strong></div><br>
              <div style="font-size: 27px;color: #007aff;"><strong>污染控制</strong></div>
              <ul>
                <li style="list-style-type: square;line-height: 4em;">防止施工现场产生污染物</li>
              </ul>
              <div style="font-size: 23px;"><strong>建筑</strong></div><br>
              <div style="font-size: 27px;color: #007aff;"><strong>垃圾管理</strong></div><br>
              
              <ul>
                <li style="list-style-type: square;line-height: 2em;">超过75%的建筑垃圾从垃圾填埋场转出</li>
                <li style="list-style-type: square;line-height: 2em;">考虑空气质量管理</li>
                <li style="list-style-type: square;line-height: 2em;">防止施工期间建筑内部灰尘和化学物质造成的空气污</li>
              </ul>
          </div>
        </div>

        <div style="margin-bottom: 80px;">
          <p style="letter-spacing: 8px;text-align:center;font-size: 40px;padding: 4% 0;color: #827800;"><strong>“WELL”建筑标准</strong></p>
          <div style="display: flex;align-items: center;position: relative;">
            <div style="padding: 0 20px 0 0;">
                <div style="font-size: 23px;text-align:center;"><strong>美丽与用心的设计</strong></div><br>
                <ul>
                  <li style="list-style-type: square;line-height: 3em;font-size: 17px;">室内设计和装饰体现了泰国文化特色，体现了泰国公共艺术和历史</li>
                  <li style="list-style-type: square;line-height: 3em;font-size: 17px;">通过景观美化实现与 Benjakitti 公园的视觉联系</li>
                  <li style="list-style-type: square;line-height: 3em;font-size: 17px;">露天剧场打造优质公共聚会空间</li>
                </ul>
            </div>
            <p style="width:100%;margin-left: 1em;">
              <img style="border-radius: 50px 0 50px 0;" width="100%" height="60%" src="/images/sustainability/building-standard-01.jpg" >
            </p>
            <div style="display: flex;padding: 10px 0 3px 10px;position: absolute;bottom: 2%;left: 39em;background-color: #fff;border-radius:30px 0 0 0">
                <img src="/images/sustainability/building-standard-01.jpg" width="35%" style="border-radius:30px 0 30px 0;padding-right: 10px;">
                <img src="/images/sustainability/building-standard-02.jpg" width="35%" style="border-radius:30px 0 30px 0;padding-right: 10px;">
                <img src="/images/sustainability/building-standard-03.jpg" width="35%" style="border-radius: 30px 0 30px 0;">
            </div>

          </div>
        </div>
        
        
         `,
      th: `<p><strong>1.	ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม</strong></p>
      <p>“ข้อมูลส่วนบุคคล” (Personal Data) หมายถึง ข้อมูลใด ๆ ที่เกี่ยวข้องกับท่านหรือที่ทำให้สามารถระบุถึงตัวตนของท่านได้ ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรม </p>
      <p>เพื่อที่เราจะเสนอผลิตภัณฑ์หรือบริการแก่ท่าน เราอาจเก็บข้อมูลส่วนบุคคลของท่านทางตรง (เช่น ผ่านทางตัวแทน, พนักงาน, ศูนย์บริการข้อมูลลูกค้า, แอพพลิเคชั่น) หรือทางอ้อม จากท่านหรือแหล่งข้อมูลอื่น (เช่น โซเชียลมีเดีย, แพลตฟอร์มออนไลน์ของบุคคลภายนอก, และ แหล่งข้อมูลสาธารณะอื่นๆ) หรือผ่านทางบริษัทแม่ของเรา, บริษัทในเครือ, บริษัทย่อย, พันธมิตรทางธุรกิจ, เจ้าหน้าที่รัฐ หรือบุคคลภายนอกอื่นๆ  โดยประเภทของข้อมูลที่เราเก็บรวบรวมนั้นจะขึ้นอยู่กับบริบทของการติดต่อสื่อสารระหว่างท่านกับเรา รวมถึงบริการหรือผลิตภัณฑ์ที่ท่านต้องการจากเราและจากบริษัทในเครือ NCC Group </p>
      <p>“ข้อมูลที่ละเอียดอ่อน” (Sensitive Data) ข้อมูลส่วนบุคคลที่กฎหมายจำแนกว่าเป็นข้อมูลที่ละเอียดอ่อน เราจะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลที่ละเอียดอ่อน ก็ต่อเมื่อได้รับความยินยอมโดยชัดแจ้งจากท่าน หรือเป็นกรณีที่กฎหมายอนุญาตให้ดำเนินการได้ </p>
      <p>เราอาจมีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน ดังต่อไปนี้</p>
      <ol>
        <li>ข้อมูลส่วนตัว (Personal details) เช่น คำนำหน้าชื่อ ชื่อเต็ม เพศ อายุ อาชีพ วุฒิการศึกษา ตำแหน่งงาน สถานที่ทำงาน ตำแหน่งหรือฐานะ สัญชาติ ประเทศที่พำนัก วันเกิด ข้อมูลบนบัตรที่ออกโดยรัฐบาล (เช่น เลขที่บัตรประจำตัวประชาชน เลขประกันสังคม เลขที่หนังสือเดินทาง เลขประจำตัวผู้เสียภาษีอากร ข้อมูลใบอนุญาตขับขี่รถยนต์ หรือสิ่งที่ระบุตัวตนอันมีลักษณะคล้ายคลึงกัน เป็นต้น) ข้อมูลบนสำเนาทะเบียนบ้าน รายละเอียดการเข้าเมือง ได้แก่ วันที่เดินทางมาถึงและเดินทางออกประเทศ ลายมือชื่อ เสียง เสียงที่บันทึก รูปถ่าย ภาพจากกล้องวงจรปิด ข้อมูลประกันภัย ป้ายทะเบียนรถ งานอดิเรก และสิ่งที่ท่านสนใจ เป็นต้น</li>
        <li>ข้อมูลเพื่อการติดต่อ เช่น ที่อยู่ทางไปรษณีย์ ข้อมูลการจัดส่ง ที่อยู่สำหรับส่งใบแจ้งหนี้ หมายเลขโทรศัพท์ หมายเลขโทรสาร ที่อยู่อีเมล์ LINE ID) Facebook account Google ID Twitter ID Instagram account WhatsApp ID  WeChat ID และบัญชีผู้ใช้ในเว็บไซต์โซเชียลมีเดียอื่น ๆ </li>
        <li>ข้อมูลทางการเงิน เช่น รายได้ เงินเดือน ข้อมูลบัตรเครดิต/เดบิตหรือข้อมูลทางธนาคาร หมายเลขบัตรเครดิต/เดบิต ประเภทของบัตรเครดิต รอบบิล รายละเอียดบัญชีธนาคาร รายละเอียดและประวัติการชำระเงิน </li>
        <li>ข้อมูลการทำธุรกรรม (Transaction details) เช่น ข้อมูลเกี่ยวกับการชำระเงินไปยังและจากท่าน วันที่และ/หรือเวลาที่ชำระเงิน ยอดชำระเงิน ข้อมูลเกี่ยวกับการขอเงินคืน ยอดเงินคืน คะแนนสะสม วันที่และสถานที่ที่ซื้อ หมายเลขการซื้อหรือคำสั่งซื้อ วันนัดหมายเข้ารับบริการ ที่อยู่/วันที่และเวลาในการรับหรือจัดส่ง ข้อความตอบรับของผู้รับ ข้อความลงท้ายในอีเมล์ของผู้รับ ข้อมูลการรับประกันสินค้า คำร้องเรียนและข้อเรียกร้อง ข้อมูลการจอง ข้อมูลการเช่า ธุรกรรม ประวัติการทำธุรกรรม สถานที่ สถานะของธุรกรรม ธุรกรรมทางการขายในอดีต สถานะ สถานะการทำธุรกรรม ข้อมูลอื่น ๆ ของผลิตภัณฑ์และบริการที่ท่านซื้อ</li>
        <li>ข้อมูลทางเทคนิค (Technical details) เช่น เลขที่อยู่ไอพี (IP address) ที่อยู่ Media Access Control (MAC address) คุกกี้ เว็บบีคอน (web beacon) ล็อก (Log)  รหัสอุปกรณ์ (Device ID) รุ่นอุปกรณ์และประเภทของอุปกรณ์ เครือข่าย ข้อมูลการเชื่อมต่อ ข้อมูลการเข้าถึง ข้อมูลการเข้าใช้งานแบบ single sign-on (SSO) การเข้าสู่ระบบ (Login log) ระยะเวลาและสถานที่ที่เข้าถึง ระยะเวลาที่ใช้บนหน้าเพจของเรา ข้อมูลการเข้าสู่ระบบ ประวัติการค้นหา ข้อมูลการเรียกดู ประเภทและเวอร์ชันของเบราว์เซอร์ การตั้งค่าเขตเวลา (Time zone setting) และสถานที่ตั้ง ประเภทและเวอร์ชันของปลั๊กอินเบราว์เซอร์ ระบบปฏิบัติการและแพลตฟอร์ม เทคโนโลยีอื่นๆ บนอุปกรณ์ที่ท่านใช้ในการเข้าถึงแพลตฟอร์มของเรา</li>
        <li>ข้อมูลเกี่ยวกับพฤติกรรม (Behaviour details) เช่น ข้อมูลเกี่ยวกับพฤติกรรมการซื้อของท่าน ข้อมูลที่ได้รับจากการใช้ผลิตภัณฑ์และบริการของเรา งานอดิเรก ความสนใจ ทัศนคติ ความเชื่อมั่น ข้อมูลปฏิกิริยา</li>
        <li>ข้อมูลประวัติ (Profile details) เช่น หมายเลขสมาชิกแอพพลิเคชั่น ชื่อผู้ใช้และรหัสผ่านของท่าน รายละเอียดและรูปภาพข้อมูลส่วนตัว การซื้อ ประวัติคำสั่งซื้อ คำสั่งซื้อในอดีต ประวัติการซื้อ สินค้าที่ซื้อ จำนวนสินค้า คำสั่งซื้อหรือคำสั่งเรียกคืนสินค้าโดยท่าน คำสั่งซื้อผ่านทางเว็บไซต์ รายละเอียดการเก็บเงินปลายทาง (Cash on Delivery) ไอดีคำสั่งซื้อ (order ID) บันทึกข้อมูลทางการเงิน เลขรหัสลับส่วนตัว (PIN) ความสนใจของท่าน ความชอบ การตอบรับและผลสำรวจ การสำรวจความพึงพอใจ การใช้โซเชียลมีเดีย ข้อมูลการเข้าร่วม ข้อมูลโปรแกรมการเป็นลูกค้าอย่างต่อเนื่อง (Loyalty programs) รหัสส่วนลดและโปรโมชั่นที่ท่านใช้ รายละเอียดคำสั่งซื้อของลูกค้า การบริการลูกค้า การเข้าร่วมนิทรรศการการค้าและกิจกรรม นิทรรศการการค้า การดำเนินคดี การทดสอบและทดลองใช้งาน</li>
        <li>ข้อมูลทางการตลาดและการติดต่อสื่อสาร เช่น ความต้องการของท่านในการรับข้อมูลทางการตลาดจากเรา บริษัทในเครือของเรา บริษัทย่อย บุคคลภายนอก พันธมิตรทางธุรกิจ รูปแบบการติดต่อสื่อสารที่ต้องการ และ/หรือ</li>
        <li>ข้อมูลที่ละเอียดอ่อน เช่น เชื้อชาติ เผ่าพันธุ์ ความคิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนาหรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพหรือสภาพทางร่างกายหรือจิตใจ ความพิการ ภาวะทุพพลภาพ ข้อมูลสหภาพแรงงาน ข้อมูลทางพันธุกรรม ข้อมูลชีวภาพ ประวัติทางการแพทย์ ลายนิ้วมือ ระบบจดจำใบหน้า</li>
      </ol>
      <p>หากท่านได้ให้ข้อมูลส่วนบุคคลของบุคคลที่สามแก่เรา เช่น ชื่อ นามสกุล ที่อยู่ และหมายเลขโทรศัพท์เพื่อติดต่อในกรณีฉุกเฉิน รายได้ของบุคคลในครอบครัว กรุณาแจ้งบุคคลเหล่านั้นให้ทราบถึงนโยบายความเป็นส่วนตัวฉบับนี้ และ/หรือขอความยินยอมจากบุคคลเหล่านั้น </p>
      <p>ในกรณีที่จำเป็นต้องได้รับความยินยอม เราจะเก็บรวบรวมข้อมูลของผู้เยาว์ คนเสมือนไร้ความสามารถ คนไร้ความสามารถต่อเมื่อได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์ หรือผู้อนุบาล เท่านั้น เราจะไม่เก็บรวบรวมข้อมูลจากลูกค้าที่เรารู้โดยแจ้งชัดว่าอายุต่ำกว่ายี่สิบปี หรือจากคนเสมือนไร้ความสามารถและคนไร้ความสามารถหากไม่ได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์ หรือผู้อนุบาล ในกรณีที่เราทราบว่า เราได้เก็บรวบรวมข้อมูลส่วนบุคคลโดยไม่มีเจตนาจากบุคคลใด ๆ ที่อายุต่ำกว่ายี่สิบปี คนเสมือนไร้ความสามารถ หรือคนไร้ความสามารถโดยไม่ได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์ หรือผู้อนุบาล เราจะดำเนินการลบข้อมูลดังกล่าวทันที หรือประมวลผลเฉพาะในส่วนของข้อมูลที่เราสามารถกระทำได้บนฐานทางกฎหมายอื่น ๆ นอกเหนือจากการขอความยินยอม</p>`,
    },
  },
];
export const CERTIFICATE_LIST = [
  {
    title: {
      cn: '证书',
      th: 'ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม',
    },
    content: {
      cn: `
        <div style="text-align:center;margin-bottom: 80px;">
          <p style="font-size:40px;line-height: 1.3;letter-spacing: 8px;color: #827800;"><strong>证书</strong></p>
          <p >我们超越我们的极限，让每一场活动都尽可能做到最好。这些著名的行业荣誉和认证证明了“世界一流，超凡卓越，会展活动平台”的含义。</p>
          <p style="padding: 10px 0;"><img src="/images/sustainability/certificate.png" width=100%></p>
          
        </div>

        
        
         `,
      th: `<p><strong>1.	ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม</strong></p>
      <p>“ข้อมูลส่วนบุคคล” (Personal Data) หมายถึง ข้อมูลใด ๆ ที่เกี่ยวข้องกับท่านหรือที่ทำให้สามารถระบุถึงตัวตนของท่านได้ ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรม </p>
      <p>เพื่อที่เราจะเสนอผลิตภัณฑ์หรือบริการแก่ท่าน เราอาจเก็บข้อมูลส่วนบุคคลของท่านทางตรง (เช่น ผ่านทางตัวแทน, พนักงาน, ศูนย์บริการข้อมูลลูกค้า, แอพพลิเคชั่น) หรือทางอ้อม จากท่านหรือแหล่งข้อมูลอื่น (เช่น โซเชียลมีเดีย, แพลตฟอร์มออนไลน์ของบุคคลภายนอก, และ แหล่งข้อมูลสาธารณะอื่นๆ) หรือผ่านทางบริษัทแม่ของเรา, บริษัทในเครือ, บริษัทย่อย, พันธมิตรทางธุรกิจ, เจ้าหน้าที่รัฐ หรือบุคคลภายนอกอื่นๆ  โดยประเภทของข้อมูลที่เราเก็บรวบรวมนั้นจะขึ้นอยู่กับบริบทของการติดต่อสื่อสารระหว่างท่านกับเรา รวมถึงบริการหรือผลิตภัณฑ์ที่ท่านต้องการจากเราและจากบริษัทในเครือ NCC Group </p>
      <p>“ข้อมูลที่ละเอียดอ่อน” (Sensitive Data) ข้อมูลส่วนบุคคลที่กฎหมายจำแนกว่าเป็นข้อมูลที่ละเอียดอ่อน เราจะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลที่ละเอียดอ่อน ก็ต่อเมื่อได้รับความยินยอมโดยชัดแจ้งจากท่าน หรือเป็นกรณีที่กฎหมายอนุญาตให้ดำเนินการได้ </p>
      <p>เราอาจมีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน ดังต่อไปนี้</p>
      <ol>
        <li>ข้อมูลส่วนตัว (Personal details) เช่น คำนำหน้าชื่อ ชื่อเต็ม เพศ อายุ อาชีพ วุฒิการศึกษา ตำแหน่งงาน สถานที่ทำงาน ตำแหน่งหรือฐานะ สัญชาติ ประเทศที่พำนัก วันเกิด ข้อมูลบนบัตรที่ออกโดยรัฐบาล (เช่น เลขที่บัตรประจำตัวประชาชน เลขประกันสังคม เลขที่หนังสือเดินทาง เลขประจำตัวผู้เสียภาษีอากร ข้อมูลใบอนุญาตขับขี่รถยนต์ หรือสิ่งที่ระบุตัวตนอันมีลักษณะคล้ายคลึงกัน เป็นต้น) ข้อมูลบนสำเนาทะเบียนบ้าน รายละเอียดการเข้าเมือง ได้แก่ วันที่เดินทางมาถึงและเดินทางออกประเทศ ลายมือชื่อ เสียง เสียงที่บันทึก รูปถ่าย ภาพจากกล้องวงจรปิด ข้อมูลประกันภัย ป้ายทะเบียนรถ งานอดิเรก และสิ่งที่ท่านสนใจ เป็นต้น</li>
        <li>ข้อมูลเพื่อการติดต่อ เช่น ที่อยู่ทางไปรษณีย์ ข้อมูลการจัดส่ง ที่อยู่สำหรับส่งใบแจ้งหนี้ หมายเลขโทรศัพท์ หมายเลขโทรสาร ที่อยู่อีเมล์ LINE ID) Facebook account Google ID Twitter ID Instagram account WhatsApp ID  WeChat ID และบัญชีผู้ใช้ในเว็บไซต์โซเชียลมีเดียอื่น ๆ </li>
        <li>ข้อมูลทางการเงิน เช่น รายได้ เงินเดือน ข้อมูลบัตรเครดิต/เดบิตหรือข้อมูลทางธนาคาร หมายเลขบัตรเครดิต/เดบิต ประเภทของบัตรเครดิต รอบบิล รายละเอียดบัญชีธนาคาร รายละเอียดและประวัติการชำระเงิน </li>
        <li>ข้อมูลการทำธุรกรรม (Transaction details) เช่น ข้อมูลเกี่ยวกับการชำระเงินไปยังและจากท่าน วันที่และ/หรือเวลาที่ชำระเงิน ยอดชำระเงิน ข้อมูลเกี่ยวกับการขอเงินคืน ยอดเงินคืน คะแนนสะสม วันที่และสถานที่ที่ซื้อ หมายเลขการซื้อหรือคำสั่งซื้อ วันนัดหมายเข้ารับบริการ ที่อยู่/วันที่และเวลาในการรับหรือจัดส่ง ข้อความตอบรับของผู้รับ ข้อความลงท้ายในอีเมล์ของผู้รับ ข้อมูลการรับประกันสินค้า คำร้องเรียนและข้อเรียกร้อง ข้อมูลการจอง ข้อมูลการเช่า ธุรกรรม ประวัติการทำธุรกรรม สถานที่ สถานะของธุรกรรม ธุรกรรมทางการขายในอดีต สถานะ สถานะการทำธุรกรรม ข้อมูลอื่น ๆ ของผลิตภัณฑ์และบริการที่ท่านซื้อ</li>
        <li>ข้อมูลทางเทคนิค (Technical details) เช่น เลขที่อยู่ไอพี (IP address) ที่อยู่ Media Access Control (MAC address) คุกกี้ เว็บบีคอน (web beacon) ล็อก (Log)  รหัสอุปกรณ์ (Device ID) รุ่นอุปกรณ์และประเภทของอุปกรณ์ เครือข่าย ข้อมูลการเชื่อมต่อ ข้อมูลการเข้าถึง ข้อมูลการเข้าใช้งานแบบ single sign-on (SSO) การเข้าสู่ระบบ (Login log) ระยะเวลาและสถานที่ที่เข้าถึง ระยะเวลาที่ใช้บนหน้าเพจของเรา ข้อมูลการเข้าสู่ระบบ ประวัติการค้นหา ข้อมูลการเรียกดู ประเภทและเวอร์ชันของเบราว์เซอร์ การตั้งค่าเขตเวลา (Time zone setting) และสถานที่ตั้ง ประเภทและเวอร์ชันของปลั๊กอินเบราว์เซอร์ ระบบปฏิบัติการและแพลตฟอร์ม เทคโนโลยีอื่นๆ บนอุปกรณ์ที่ท่านใช้ในการเข้าถึงแพลตฟอร์มของเรา</li>
        <li>ข้อมูลเกี่ยวกับพฤติกรรม (Behaviour details) เช่น ข้อมูลเกี่ยวกับพฤติกรรมการซื้อของท่าน ข้อมูลที่ได้รับจากการใช้ผลิตภัณฑ์และบริการของเรา งานอดิเรก ความสนใจ ทัศนคติ ความเชื่อมั่น ข้อมูลปฏิกิริยา</li>
        <li>ข้อมูลประวัติ (Profile details) เช่น หมายเลขสมาชิกแอพพลิเคชั่น ชื่อผู้ใช้และรหัสผ่านของท่าน รายละเอียดและรูปภาพข้อมูลส่วนตัว การซื้อ ประวัติคำสั่งซื้อ คำสั่งซื้อในอดีต ประวัติการซื้อ สินค้าที่ซื้อ จำนวนสินค้า คำสั่งซื้อหรือคำสั่งเรียกคืนสินค้าโดยท่าน คำสั่งซื้อผ่านทางเว็บไซต์ รายละเอียดการเก็บเงินปลายทาง (Cash on Delivery) ไอดีคำสั่งซื้อ (order ID) บันทึกข้อมูลทางการเงิน เลขรหัสลับส่วนตัว (PIN) ความสนใจของท่าน ความชอบ การตอบรับและผลสำรวจ การสำรวจความพึงพอใจ การใช้โซเชียลมีเดีย ข้อมูลการเข้าร่วม ข้อมูลโปรแกรมการเป็นลูกค้าอย่างต่อเนื่อง (Loyalty programs) รหัสส่วนลดและโปรโมชั่นที่ท่านใช้ รายละเอียดคำสั่งซื้อของลูกค้า การบริการลูกค้า การเข้าร่วมนิทรรศการการค้าและกิจกรรม นิทรรศการการค้า การดำเนินคดี การทดสอบและทดลองใช้งาน</li>
        <li>ข้อมูลทางการตลาดและการติดต่อสื่อสาร เช่น ความต้องการของท่านในการรับข้อมูลทางการตลาดจากเรา บริษัทในเครือของเรา บริษัทย่อย บุคคลภายนอก พันธมิตรทางธุรกิจ รูปแบบการติดต่อสื่อสารที่ต้องการ และ/หรือ</li>
        <li>ข้อมูลที่ละเอียดอ่อน เช่น เชื้อชาติ เผ่าพันธุ์ ความคิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนาหรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพหรือสภาพทางร่างกายหรือจิตใจ ความพิการ ภาวะทุพพลภาพ ข้อมูลสหภาพแรงงาน ข้อมูลทางพันธุกรรม ข้อมูลชีวภาพ ประวัติทางการแพทย์ ลายนิ้วมือ ระบบจดจำใบหน้า</li>
      </ol>
      <p>หากท่านได้ให้ข้อมูลส่วนบุคคลของบุคคลที่สามแก่เรา เช่น ชื่อ นามสกุล ที่อยู่ และหมายเลขโทรศัพท์เพื่อติดต่อในกรณีฉุกเฉิน รายได้ของบุคคลในครอบครัว กรุณาแจ้งบุคคลเหล่านั้นให้ทราบถึงนโยบายความเป็นส่วนตัวฉบับนี้ และ/หรือขอความยินยอมจากบุคคลเหล่านั้น </p>
      <p>ในกรณีที่จำเป็นต้องได้รับความยินยอม เราจะเก็บรวบรวมข้อมูลของผู้เยาว์ คนเสมือนไร้ความสามารถ คนไร้ความสามารถต่อเมื่อได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์ หรือผู้อนุบาล เท่านั้น เราจะไม่เก็บรวบรวมข้อมูลจากลูกค้าที่เรารู้โดยแจ้งชัดว่าอายุต่ำกว่ายี่สิบปี หรือจากคนเสมือนไร้ความสามารถและคนไร้ความสามารถหากไม่ได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์ หรือผู้อนุบาล ในกรณีที่เราทราบว่า เราได้เก็บรวบรวมข้อมูลส่วนบุคคลโดยไม่มีเจตนาจากบุคคลใด ๆ ที่อายุต่ำกว่ายี่สิบปี คนเสมือนไร้ความสามารถ หรือคนไร้ความสามารถโดยไม่ได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์ หรือผู้อนุบาล เราจะดำเนินการลบข้อมูลดังกล่าวทันที หรือประมวลผลเฉพาะในส่วนของข้อมูลที่เราสามารถกระทำได้บนฐานทางกฎหมายอื่น ๆ นอกเหนือจากการขอความยินยอม</p>`,
    },
  },
];
export const PARTNERSHIP_LIST = [
  {
    title: {
      cn: '合作伙伴',
      th: 'ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม',
    },
    content: {
      cn: `

        <div style="text-align:center;margin-bottom: 80px;">
            <p style="font-size:40px;line-height: 1.3;letter-spacing: 8px;color: #827800;"><strong>合作伙伴</strong></p>
            <p>QSNCC与各种优秀组织合作，使我们的会场达到全球标准，并将客户满意度提升至新高度。</p>
            <p style="padding: 10px 0;"><img src="/images/sustainability/partnership.png" width=100%></p>
        </div>
        
         `,
      th: `<p><strong>1.	ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม</strong></p>
      <p>“ข้อมูลส่วนบุคคล” (Personal Data) หมายถึง ข้อมูลใด ๆ ที่เกี่ยวข้องกับท่านหรือที่ทำให้สามารถระบุถึงตัวตนของท่านได้ ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรม </p>
      <p>เพื่อที่เราจะเสนอผลิตภัณฑ์หรือบริการแก่ท่าน เราอาจเก็บข้อมูลส่วนบุคคลของท่านทางตรง (เช่น ผ่านทางตัวแทน, พนักงาน, ศูนย์บริการข้อมูลลูกค้า, แอพพลิเคชั่น) หรือทางอ้อม จากท่านหรือแหล่งข้อมูลอื่น (เช่น โซเชียลมีเดีย, แพลตฟอร์มออนไลน์ของบุคคลภายนอก, และ แหล่งข้อมูลสาธารณะอื่นๆ) หรือผ่านทางบริษัทแม่ของเรา, บริษัทในเครือ, บริษัทย่อย, พันธมิตรทางธุรกิจ, เจ้าหน้าที่รัฐ หรือบุคคลภายนอกอื่นๆ  โดยประเภทของข้อมูลที่เราเก็บรวบรวมนั้นจะขึ้นอยู่กับบริบทของการติดต่อสื่อสารระหว่างท่านกับเรา รวมถึงบริการหรือผลิตภัณฑ์ที่ท่านต้องการจากเราและจากบริษัทในเครือ NCC Group </p>
      <p>“ข้อมูลที่ละเอียดอ่อน” (Sensitive Data) ข้อมูลส่วนบุคคลที่กฎหมายจำแนกว่าเป็นข้อมูลที่ละเอียดอ่อน เราจะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลที่ละเอียดอ่อน ก็ต่อเมื่อได้รับความยินยอมโดยชัดแจ้งจากท่าน หรือเป็นกรณีที่กฎหมายอนุญาตให้ดำเนินการได้ </p>
      <p>เราอาจมีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน ดังต่อไปนี้</p>
      <ol>
        <li>ข้อมูลส่วนตัว (Personal details) เช่น คำนำหน้าชื่อ ชื่อเต็ม เพศ อายุ อาชีพ วุฒิการศึกษา ตำแหน่งงาน สถานที่ทำงาน ตำแหน่งหรือฐานะ สัญชาติ ประเทศที่พำนัก วันเกิด ข้อมูลบนบัตรที่ออกโดยรัฐบาล (เช่น เลขที่บัตรประจำตัวประชาชน เลขประกันสังคม เลขที่หนังสือเดินทาง เลขประจำตัวผู้เสียภาษีอากร ข้อมูลใบอนุญาตขับขี่รถยนต์ หรือสิ่งที่ระบุตัวตนอันมีลักษณะคล้ายคลึงกัน เป็นต้น) ข้อมูลบนสำเนาทะเบียนบ้าน รายละเอียดการเข้าเมือง ได้แก่ วันที่เดินทางมาถึงและเดินทางออกประเทศ ลายมือชื่อ เสียง เสียงที่บันทึก รูปถ่าย ภาพจากกล้องวงจรปิด ข้อมูลประกันภัย ป้ายทะเบียนรถ งานอดิเรก และสิ่งที่ท่านสนใจ เป็นต้น</li>
        <li>ข้อมูลเพื่อการติดต่อ เช่น ที่อยู่ทางไปรษณีย์ ข้อมูลการจัดส่ง ที่อยู่สำหรับส่งใบแจ้งหนี้ หมายเลขโทรศัพท์ หมายเลขโทรสาร ที่อยู่อีเมล์ LINE ID) Facebook account Google ID Twitter ID Instagram account WhatsApp ID  WeChat ID และบัญชีผู้ใช้ในเว็บไซต์โซเชียลมีเดียอื่น ๆ </li>
        <li>ข้อมูลทางการเงิน เช่น รายได้ เงินเดือน ข้อมูลบัตรเครดิต/เดบิตหรือข้อมูลทางธนาคาร หมายเลขบัตรเครดิต/เดบิต ประเภทของบัตรเครดิต รอบบิล รายละเอียดบัญชีธนาคาร รายละเอียดและประวัติการชำระเงิน </li>
        <li>ข้อมูลการทำธุรกรรม (Transaction details) เช่น ข้อมูลเกี่ยวกับการชำระเงินไปยังและจากท่าน วันที่และ/หรือเวลาที่ชำระเงิน ยอดชำระเงิน ข้อมูลเกี่ยวกับการขอเงินคืน ยอดเงินคืน คะแนนสะสม วันที่และสถานที่ที่ซื้อ หมายเลขการซื้อหรือคำสั่งซื้อ วันนัดหมายเข้ารับบริการ ที่อยู่/วันที่และเวลาในการรับหรือจัดส่ง ข้อความตอบรับของผู้รับ ข้อความลงท้ายในอีเมล์ของผู้รับ ข้อมูลการรับประกันสินค้า คำร้องเรียนและข้อเรียกร้อง ข้อมูลการจอง ข้อมูลการเช่า ธุรกรรม ประวัติการทำธุรกรรม สถานที่ สถานะของธุรกรรม ธุรกรรมทางการขายในอดีต สถานะ สถานะการทำธุรกรรม ข้อมูลอื่น ๆ ของผลิตภัณฑ์และบริการที่ท่านซื้อ</li>
        <li>ข้อมูลทางเทคนิค (Technical details) เช่น เลขที่อยู่ไอพี (IP address) ที่อยู่ Media Access Control (MAC address) คุกกี้ เว็บบีคอน (web beacon) ล็อก (Log)  รหัสอุปกรณ์ (Device ID) รุ่นอุปกรณ์และประเภทของอุปกรณ์ เครือข่าย ข้อมูลการเชื่อมต่อ ข้อมูลการเข้าถึง ข้อมูลการเข้าใช้งานแบบ single sign-on (SSO) การเข้าสู่ระบบ (Login log) ระยะเวลาและสถานที่ที่เข้าถึง ระยะเวลาที่ใช้บนหน้าเพจของเรา ข้อมูลการเข้าสู่ระบบ ประวัติการค้นหา ข้อมูลการเรียกดู ประเภทและเวอร์ชันของเบราว์เซอร์ การตั้งค่าเขตเวลา (Time zone setting) และสถานที่ตั้ง ประเภทและเวอร์ชันของปลั๊กอินเบราว์เซอร์ ระบบปฏิบัติการและแพลตฟอร์ม เทคโนโลยีอื่นๆ บนอุปกรณ์ที่ท่านใช้ในการเข้าถึงแพลตฟอร์มของเรา</li>
        <li>ข้อมูลเกี่ยวกับพฤติกรรม (Behaviour details) เช่น ข้อมูลเกี่ยวกับพฤติกรรมการซื้อของท่าน ข้อมูลที่ได้รับจากการใช้ผลิตภัณฑ์และบริการของเรา งานอดิเรก ความสนใจ ทัศนคติ ความเชื่อมั่น ข้อมูลปฏิกิริยา</li>
        <li>ข้อมูลประวัติ (Profile details) เช่น หมายเลขสมาชิกแอพพลิเคชั่น ชื่อผู้ใช้และรหัสผ่านของท่าน รายละเอียดและรูปภาพข้อมูลส่วนตัว การซื้อ ประวัติคำสั่งซื้อ คำสั่งซื้อในอดีต ประวัติการซื้อ สินค้าที่ซื้อ จำนวนสินค้า คำสั่งซื้อหรือคำสั่งเรียกคืนสินค้าโดยท่าน คำสั่งซื้อผ่านทางเว็บไซต์ รายละเอียดการเก็บเงินปลายทาง (Cash on Delivery) ไอดีคำสั่งซื้อ (order ID) บันทึกข้อมูลทางการเงิน เลขรหัสลับส่วนตัว (PIN) ความสนใจของท่าน ความชอบ การตอบรับและผลสำรวจ การสำรวจความพึงพอใจ การใช้โซเชียลมีเดีย ข้อมูลการเข้าร่วม ข้อมูลโปรแกรมการเป็นลูกค้าอย่างต่อเนื่อง (Loyalty programs) รหัสส่วนลดและโปรโมชั่นที่ท่านใช้ รายละเอียดคำสั่งซื้อของลูกค้า การบริการลูกค้า การเข้าร่วมนิทรรศการการค้าและกิจกรรม นิทรรศการการค้า การดำเนินคดี การทดสอบและทดลองใช้งาน</li>
        <li>ข้อมูลทางการตลาดและการติดต่อสื่อสาร เช่น ความต้องการของท่านในการรับข้อมูลทางการตลาดจากเรา บริษัทในเครือของเรา บริษัทย่อย บุคคลภายนอก พันธมิตรทางธุรกิจ รูปแบบการติดต่อสื่อสารที่ต้องการ และ/หรือ</li>
        <li>ข้อมูลที่ละเอียดอ่อน เช่น เชื้อชาติ เผ่าพันธุ์ ความคิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนาหรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพหรือสภาพทางร่างกายหรือจิตใจ ความพิการ ภาวะทุพพลภาพ ข้อมูลสหภาพแรงงาน ข้อมูลทางพันธุกรรม ข้อมูลชีวภาพ ประวัติทางการแพทย์ ลายนิ้วมือ ระบบจดจำใบหน้า</li>
      </ol>
      <p>หากท่านได้ให้ข้อมูลส่วนบุคคลของบุคคลที่สามแก่เรา เช่น ชื่อ นามสกุล ที่อยู่ และหมายเลขโทรศัพท์เพื่อติดต่อในกรณีฉุกเฉิน รายได้ของบุคคลในครอบครัว กรุณาแจ้งบุคคลเหล่านั้นให้ทราบถึงนโยบายความเป็นส่วนตัวฉบับนี้ และ/หรือขอความยินยอมจากบุคคลเหล่านั้น </p>
      <p>ในกรณีที่จำเป็นต้องได้รับความยินยอม เราจะเก็บรวบรวมข้อมูลของผู้เยาว์ คนเสมือนไร้ความสามารถ คนไร้ความสามารถต่อเมื่อได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์ หรือผู้อนุบาล เท่านั้น เราจะไม่เก็บรวบรวมข้อมูลจากลูกค้าที่เรารู้โดยแจ้งชัดว่าอายุต่ำกว่ายี่สิบปี หรือจากคนเสมือนไร้ความสามารถและคนไร้ความสามารถหากไม่ได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์ หรือผู้อนุบาล ในกรณีที่เราทราบว่า เราได้เก็บรวบรวมข้อมูลส่วนบุคคลโดยไม่มีเจตนาจากบุคคลใด ๆ ที่อายุต่ำกว่ายี่สิบปี คนเสมือนไร้ความสามารถ หรือคนไร้ความสามารถโดยไม่ได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์ หรือผู้อนุบาล เราจะดำเนินการลบข้อมูลดังกล่าวทันที หรือประมวลผลเฉพาะในส่วนของข้อมูลที่เราสามารถกระทำได้บนฐานทางกฎหมายอื่น ๆ นอกเหนือจากการขอความยินยอม</p>`,
    },
  },
];
export const VENUE_SERVICE_LIST = [
  {
    default: true,
    title: {
      cn: '场地服务',
      th: 'ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม',
    },
    content: {
      cn: `
      <p style="font-size:40px;line-height: 1.3;letter-spacing: 8px;color: #827800;text-align: center;"><strong>场地服务</strong></p>
      <p style="text-align: center;font-size: 19px;padding-bottom: 2em;">你会想在诗丽吉皇后国家会议中心举办下一个活动。你将得到专业的服务。我们的专业服务团队将使您的活动圆满成功。</P>
      <div style="text-align:center;margin-bottom: 80px;">
        <ul style="display: flex; ">
          <li style="position: relative;margin-right: 2em;" class="venue-img">
            <img  src="/images/service/vip-room.jpg" style="width: 100%;border-radius: 30px 0 30px 0;"  >
            <p style="padding-top:1em;font-size:20px;font-weight: 700;">贵宾室</p>
            <p style="position: absolute;bottom:6em;left: 0;text-align: justify;padding:20px;" class="text_hover">贵宾室利用我们的VIP空间为您的客人提供真正的享受。贵宾室非常适合招待知名企业家或世界权威人士。让尊贵的客人受到妥帖的照顾并感到舒适。贵宾室拥有现代设计，并切设计时关注灵活的适应性，可根据客人需求量身定制。</p>
          </li>
          <li style="position: relative;margin-right: 2em;"  class="venue-img">
            <img src="/images/service/dock-leveler.jpg"style="width: 100%;border-radius: 30px 0 30px 0;" >
            <p style="padding: 1em;font-size:20px;font-weight: 700;">装卸平台</p>
            <p style="position: absolute;bottom:6em;left: 0;text-align: justify;padding:20px" class="text_hover">装卸平台旨在与物流仓库和工厂配合使用，可直接通往展厅，并通过附近的货运电梯通往其他楼层。</p>
          </li>
          <li  class="venue-img" style="position: relative;">
            <img src="/images/service/rigging.jpg" style="width: 100%;border-radius: 30px 0 30px 0;" >
            <p style="padding: 1em;font-size:20px;font-weight: 700;">索具</p>
            <p style="position: absolute;bottom:6em;left: 0;text-align: justify;padding:20px" class="text_hover">您是否需要大型安装，或者只是想悬挂横幅？QSNCC拥有全面的索具系统，可以满足您的需求。每个点的最大负载范围为300至500公斤。QSNCC仅使用经过评级和批准的索具硬件，并遵循行业中最佳的索具实践规则。</p>
          </li>
        </ul>
        <ul style="display: flex; ">
          <li  class="venue-img" style="position: relative;margin-right: 2em;" >
            <img src="/images/service/freight-elevator.jpg" style="width: 100%;border-radius: 30px 0 30px 0;" >
            <p style="padding: 1em;font-size:20px;font-weight: 700;">载货电梯</p>
            <p style="position: absolute;bottom:6em;left: 0;text-align: justify;padding:20px" class="text_hover">QSNCC提供从地下一层可搭乘的货运电梯。最大负载为5,000公斤。装卸区的货梯可直达G层和一层展厅。</p>
          </li>
          <li  class="venue-img" style="position: relative;margin-right: 2em;">
            <img src="/images/service/cleaning.jpg"style="width: 100%;border-radius: 30px 0 30px 0;" >
            <p style="padding: 1em;font-size:20px;font-weight: 700;">清洁服务</p>
            <p style="position: absolute;bottom:6em;left: 0;text-align: justify;padding:20px" class="text_hover">QSNCC提供高效、快速的清洁服务。我们确保高标准的清洁和卫生。我们可以分配额外的人员和服务，以使整个活动期间的一切保持新鲜和完美。</p>
          </li>
          <li  class="venue-img" style="position: relative;">
            <img src="/images/service/security.jpg" style="width: 100%;border-radius: 30px 0 30px 0;" >
            <p style="padding: 1em;font-size:20px;font-weight: 700;">安全</p>
            <p style="position: absolute;bottom:6em;left: 0;text-align: justify;padding:20px" class="text_hover">QSNCC将安全和安保国际标准视为首要任务。我们使用智能系统来控制区域访问并管理建筑物内的设施。QSNCC 采用尖端的安全技术、24 小时监控和训练有素的安保人员，为您的安全保驾护航。</p>
          </li>
        </ul>
        <ul style="display: flex; ">
          <li  class="venue-img" style="position: relative;margin-right: 2em;">
            <img src="/images/service/internet-service.jpg" style="width: 100%;border-radius: 30px 0 30px 0;" >
            <p style="padding: 1em;font-size:20px;font-weight: 700;">网络服务</p>
            <p style="position: absolute;bottom:6em;left: 0;text-align: justify;padding:20px" class="text_hover">QSNCC配备5G技术和光纤，开启Web 3.0时代，实现更全面、无死角的覆盖。这确保了线上及线下活动能够满负荷运行，为活动组织者和参观者提供无与伦比的便利。</p>
          </li>
          <li  class="venue-img" style="position: relative;margin-right: 2em;">
            <img src="/images/service/telecom-communication.jpg" style="width: 100%;border-radius: 30px 0 30px 0;" >
            <p style="padding: 1em;font-size:20px;font-weight: 700;">实用设施</p>
            <p style="position: absolute;bottom:6em;left: 0;text-align: justify;padding:20px" class="text_hover">无论大小，您的展位都需要适当的公用设施基础来支持活动。QSNCC提供符合最佳安全标准的公用设施服务，包括电力、水和高速互联网连接，以确保活动期间一切顺利进行。尽早咨询我们的团队了解您的要求。</p>
          </li>
          <li  class="venue-img" style="position: relative;">
            <img src="/images/service/audio-visual-service.jpg" style="width: 100%;border-radius: 30px 0 30px 0;" >
            <p style="padding: 1em;font-size:20px;font-weight: 700;">视听服务</p>
            <p style="position: absolute;bottom:6em;left: 0;text-align: justify;padding:20px" class="text_hover">凭借尖端的视听设备，我们的音频和视频技术服务让您的场地焕发活力。 音视频团队拥有多年的会议经验，可以提供从标准到高端音视频设备的解决方案。因此，请安心将您场地的技术需求交给我们团队的专业团队。</p>
            </li>
        </ul>
        <ul style="display: flex; ">
          <li  class="venue-img" style="position: relative;margin-right: 2em;">
            <img src="/images/service/stagelight-sound.jpg" style="width: 100%;border-radius: 30px 0 30px 0;" >
            <p style="padding: 1em;font-size:20px;font-weight: 700;">舞台灯光服务</p>
            <p style="position: absolute;bottom:6em;left: 0;text-align: justify;padding:20px" class="text_hover">让光线充足，为您的品牌声誉创造兴奋和吸引力。 QSNCC 提供专业的舞台灯光，帮助为您的活动定下基调。 凭借尖端的照明技术，吸引所有人的目光到您的品牌和产品上。 QSNCC 为各种规模的活动和观众类型提供照明解决方案。</p>
          </li>
          <li  class="venue-img" style="position: relative;margin-right: 2em;">
            <img src="/images/service/flower-landscape.jpg"style="width: 100%;border-radius: 30px 0 30px 0;" >
            <p style="padding: 1em;font-size:20px;font-weight: 700;">花卉景观服务</p>
            <p style="position: absolute;bottom:6em;left: 0;text-align: justify;padding:20px" class="text_hover">没有什么比新鲜、异国情调的鲜花更能为您的活动增添一抹档次了。 借助我们多功能的花卉和景观服务，以各种方式装饰和设计您的展位和空间。</p>
          </li>
          <li  class="venue-img" style="position: relative;">
            <img src="/images/service/other-service.jpg" style="width: 100%;border-radius: 30px 0 30px 0;" >
            <p style="padding: 1em;font-size:20px;font-weight: 700;">笔译和口译</p>
            <p style="position: absolute;bottom:6em;left: 0;text-align: justify;padding:20px" class="text_hover">QSNCC让举办多语言会议变得简单。我们的会议笔译员和口译员（根据要求）用语言将您会场的人员和远程参与者联系起来。我们在商务会议、研讨会和消费者活动中拥有先进技能的口译员，帮助打破沟通障碍。</p>
          </li>
        </ul>
      </div>
        
         `,
      th: `<p><strong>1.	ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม</strong></p>
      <p>“ข้อมูลส่วนบุคคล” (Personal Data) หมายถึง ข้อมูลใด ๆ ที่เกี่ยวข้องกับท่านหรือที่ทำให้สามารถระบุถึงตัวตนของท่านได้ ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรม </p>
      <p>เพื่อที่เราจะเสนอผลิตภัณฑ์หรือบริการแก่ท่าน เราอาจเก็บข้อมูลส่วนบุคคลของท่านทางตรง (เช่น ผ่านทางตัวแทน, พนักงาน, ศูนย์บริการข้อมูลลูกค้า, แอพพลิเคชั่น) หรือทางอ้อม จากท่านหรือแหล่งข้อมูลอื่น (เช่น โซเชียลมีเดีย, แพลตฟอร์มออนไลน์ของบุคคลภายนอก, และ แหล่งข้อมูลสาธารณะอื่นๆ) หรือผ่านทางบริษัทแม่ของเรา, บริษัทในเครือ, บริษัทย่อย, พันธมิตรทางธุรกิจ, เจ้าหน้าที่รัฐ หรือบุคคลภายนอกอื่นๆ  โดยประเภทของข้อมูลที่เราเก็บรวบรวมนั้นจะขึ้นอยู่กับบริบทของการติดต่อสื่อสารระหว่างท่านกับเรา รวมถึงบริการหรือผลิตภัณฑ์ที่ท่านต้องการจากเราและจากบริษัทในเครือ NCC Group </p>
      <p>“ข้อมูลที่ละเอียดอ่อน” (Sensitive Data) ข้อมูลส่วนบุคคลที่กฎหมายจำแนกว่าเป็นข้อมูลที่ละเอียดอ่อน เราจะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลที่ละเอียดอ่อน ก็ต่อเมื่อได้รับความยินยอมโดยชัดแจ้งจากท่าน หรือเป็นกรณีที่กฎหมายอนุญาตให้ดำเนินการได้ </p>
      <p>เราอาจมีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน ดังต่อไปนี้</p>
      <ol>
        <li>ข้อมูลส่วนตัว (Personal details) เช่น คำนำหน้าชื่อ ชื่อเต็ม เพศ อายุ อาชีพ วุฒิการศึกษา ตำแหน่งงาน สถานที่ทำงาน ตำแหน่งหรือฐานะ สัญชาติ ประเทศที่พำนัก วันเกิด ข้อมูลบนบัตรที่ออกโดยรัฐบาล (เช่น เลขที่บัตรประจำตัวประชาชน เลขประกันสังคม เลขที่หนังสือเดินทาง เลขประจำตัวผู้เสียภาษีอากร ข้อมูลใบอนุญาตขับขี่รถยนต์ หรือสิ่งที่ระบุตัวตนอันมีลักษณะคล้ายคลึงกัน เป็นต้น) ข้อมูลบนสำเนาทะเบียนบ้าน รายละเอียดการเข้าเมือง ได้แก่ วันที่เดินทางมาถึงและเดินทางออกประเทศ ลายมือชื่อ เสียง เสียงที่บันทึก รูปถ่าย ภาพจากกล้องวงจรปิด ข้อมูลประกันภัย ป้ายทะเบียนรถ งานอดิเรก และสิ่งที่ท่านสนใจ เป็นต้น</li>
        <li>ข้อมูลเพื่อการติดต่อ เช่น ที่อยู่ทางไปรษณีย์ ข้อมูลการจัดส่ง ที่อยู่สำหรับส่งใบแจ้งหนี้ หมายเลขโทรศัพท์ หมายเลขโทรสาร ที่อยู่อีเมล์ LINE ID) Facebook account Google ID Twitter ID Instagram account WhatsApp ID  WeChat ID และบัญชีผู้ใช้ในเว็บไซต์โซเชียลมีเดียอื่น ๆ </li>
        <li>ข้อมูลทางการเงิน เช่น รายได้ เงินเดือน ข้อมูลบัตรเครดิต/เดบิตหรือข้อมูลทางธนาคาร หมายเลขบัตรเครดิต/เดบิต ประเภทของบัตรเครดิต รอบบิล รายละเอียดบัญชีธนาคาร รายละเอียดและประวัติการชำระเงิน </li>
        <li>ข้อมูลการทำธุรกรรม (Transaction details) เช่น ข้อมูลเกี่ยวกับการชำระเงินไปยังและจากท่าน วันที่และ/หรือเวลาที่ชำระเงิน ยอดชำระเงิน ข้อมูลเกี่ยวกับการขอเงินคืน ยอดเงินคืน คะแนนสะสม วันที่และสถานที่ที่ซื้อ หมายเลขการซื้อหรือคำสั่งซื้อ วันนัดหมายเข้ารับบริการ ที่อยู่/วันที่และเวลาในการรับหรือจัดส่ง ข้อความตอบรับของผู้รับ ข้อความลงท้ายในอีเมล์ของผู้รับ ข้อมูลการรับประกันสินค้า คำร้องเรียนและข้อเรียกร้อง ข้อมูลการจอง ข้อมูลการเช่า ธุรกรรม ประวัติการทำธุรกรรม สถานที่ สถานะของธุรกรรม ธุรกรรมทางการขายในอดีต สถานะ สถานะการทำธุรกรรม ข้อมูลอื่น ๆ ของผลิตภัณฑ์และบริการที่ท่านซื้อ</li>
        <li>ข้อมูลทางเทคนิค (Technical details) เช่น เลขที่อยู่ไอพี (IP address) ที่อยู่ Media Access Control (MAC address) คุกกี้ เว็บบีคอน (web beacon) ล็อก (Log)  รหัสอุปกรณ์ (Device ID) รุ่นอุปกรณ์และประเภทของอุปกรณ์ เครือข่าย ข้อมูลการเชื่อมต่อ ข้อมูลการเข้าถึง ข้อมูลการเข้าใช้งานแบบ single sign-on (SSO) การเข้าสู่ระบบ (Login log) ระยะเวลาและสถานที่ที่เข้าถึง ระยะเวลาที่ใช้บนหน้าเพจของเรา ข้อมูลการเข้าสู่ระบบ ประวัติการค้นหา ข้อมูลการเรียกดู ประเภทและเวอร์ชันของเบราว์เซอร์ การตั้งค่าเขตเวลา (Time zone setting) และสถานที่ตั้ง ประเภทและเวอร์ชันของปลั๊กอินเบราว์เซอร์ ระบบปฏิบัติการและแพลตฟอร์ม เทคโนโลยีอื่นๆ บนอุปกรณ์ที่ท่านใช้ในการเข้าถึงแพลตฟอร์มของเรา</li>
        <li>ข้อมูลเกี่ยวกับพฤติกรรม (Behaviour details) เช่น ข้อมูลเกี่ยวกับพฤติกรรมการซื้อของท่าน ข้อมูลที่ได้รับจากการใช้ผลิตภัณฑ์และบริการของเรา งานอดิเรก ความสนใจ ทัศนคติ ความเชื่อมั่น ข้อมูลปฏิกิริยา</li>
        <li>ข้อมูลประวัติ (Profile details) เช่น หมายเลขสมาชิกแอพพลิเคชั่น ชื่อผู้ใช้และรหัสผ่านของท่าน รายละเอียดและรูปภาพข้อมูลส่วนตัว การซื้อ ประวัติคำสั่งซื้อ คำสั่งซื้อในอดีต ประวัติการซื้อ สินค้าที่ซื้อ จำนวนสินค้า คำสั่งซื้อหรือคำสั่งเรียกคืนสินค้าโดยท่าน คำสั่งซื้อผ่านทางเว็บไซต์ รายละเอียดการเก็บเงินปลายทาง (Cash on Delivery) ไอดีคำสั่งซื้อ (order ID) บันทึกข้อมูลทางการเงิน เลขรหัสลับส่วนตัว (PIN) ความสนใจของท่าน ความชอบ การตอบรับและผลสำรวจ การสำรวจความพึงพอใจ การใช้โซเชียลมีเดีย ข้อมูลการเข้าร่วม ข้อมูลโปรแกรมการเป็นลูกค้าอย่างต่อเนื่อง (Loyalty programs) รหัสส่วนลดและโปรโมชั่นที่ท่านใช้ รายละเอียดคำสั่งซื้อของลูกค้า การบริการลูกค้า การเข้าร่วมนิทรรศการการค้าและกิจกรรม นิทรรศการการค้า การดำเนินคดี การทดสอบและทดลองใช้งาน</li>
        <li>ข้อมูลทางการตลาดและการติดต่อสื่อสาร เช่น ความต้องการของท่านในการรับข้อมูลทางการตลาดจากเรา บริษัทในเครือของเรา บริษัทย่อย บุคคลภายนอก พันธมิตรทางธุรกิจ รูปแบบการติดต่อสื่อสารที่ต้องการ และ/หรือ</li>
        <li>ข้อมูลที่ละเอียดอ่อน เช่น เชื้อชาติ เผ่าพันธุ์ ความคิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนาหรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพหรือสภาพทางร่างกายหรือจิตใจ ความพิการ ภาวะทุพพลภาพ ข้อมูลสหภาพแรงงาน ข้อมูลทางพันธุกรรม ข้อมูลชีวภาพ ประวัติทางการแพทย์ ลายนิ้วมือ ระบบจดจำใบหน้า</li>
      </ol>
      <p>หากท่านได้ให้ข้อมูลส่วนบุคคลของบุคคลที่สามแก่เรา เช่น ชื่อ นามสกุล ที่อยู่ และหมายเลขโทรศัพท์เพื่อติดต่อในกรณีฉุกเฉิน รายได้ของบุคคลในครอบครัว กรุณาแจ้งบุคคลเหล่านั้นให้ทราบถึงนโยบายความเป็นส่วนตัวฉบับนี้ และ/หรือขอความยินยอมจากบุคคลเหล่านั้น </p>
      <p>ในกรณีที่จำเป็นต้องได้รับความยินยอม เราจะเก็บรวบรวมข้อมูลของผู้เยาว์ คนเสมือนไร้ความสามารถ คนไร้ความสามารถต่อเมื่อได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์ หรือผู้อนุบาล เท่านั้น เราจะไม่เก็บรวบรวมข้อมูลจากลูกค้าที่เรารู้โดยแจ้งชัดว่าอายุต่ำกว่ายี่สิบปี หรือจากคนเสมือนไร้ความสามารถและคนไร้ความสามารถหากไม่ได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์ หรือผู้อนุบาล ในกรณีที่เราทราบว่า เราได้เก็บรวบรวมข้อมูลส่วนบุคคลโดยไม่มีเจตนาจากบุคคลใด ๆ ที่อายุต่ำกว่ายี่สิบปี คนเสมือนไร้ความสามารถ หรือคนไร้ความสามารถโดยไม่ได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์ หรือผู้อนุบาล เราจะดำเนินการลบข้อมูลดังกล่าวทันที หรือประมวลผลเฉพาะในส่วนของข้อมูลที่เราสามารถกระทำได้บนฐานทางกฎหมายอื่น ๆ นอกเหนือจากการขอความยินยอม</p>`,
    },
  },
];

export const GLANCE_VISION_LIST = [
  {
    default: true,
    title: {
      cn: '概率愿景',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `<p><div style="text-align:center;font-size:56px;line-height:56px;color: #827800;">世界一流 · 超凡卓越</div></p>
      <p><div style="text-align:center;font-size:26px;line-height:26px;color: #827800;">会展活动平台</div></p>
      <p><div style="text-align:center;">泰国诗丽吉王后国家会议中⼼（QSNCC）为每个活动提供灵活的解决⽅案。拥抱新体验并启发灵感。</div></P>
      <p><img src="/images/glance/history/vision.png" alt="" width="1250" height="191" />`,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];

export const GLANCE_HISTORY_INFO = [
  {
    default: true,
    title: {
      cn: '概览历史',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `<p style="font-size:32px;text-align:center;color: #288cff;margin-bottom: 2em;"><strong>历史</strong></p>
      <div style="padding-bottom: 5em;">
        <p style="text-align:center;position: relative;z-index: 10;"><img  style="border-radius: 20px 0 20px 0;width: 600px;" src="/images/glance/history/est-1988-01.jpg" alt=""  /></p>
        <div>
          <img  style="border-radius: 20px 0 20px 0;position: absolute;top: 3em;left: 5em;" src="/images/glance/history/est-1988-02.jpg" alt="" width="288"  />
          <img style="border-radius: 20px 0 20px 0;position: absolute;right: 2em;top: 14em;" src="/images/glance/history/est-1988-03.jpg" alt="" width="288" />
          <img style="border-radius: 20px 0 20px 0;position: absolute;left: 4em;bottom: 15em;" src="/images/glance/history/est-1988-04.jpg" alt="" width="288" />
        </div>
      </div>
      
    <p>QSNCC始建于1989年，旨在承接第46届世界银行集团与国际货币基金组织理事会年会，并为来自泰国以及世界各地的客人提供专业且创新的宾客休息区。QSNCC作为泰国第一个国际化会议中心，已举办超过20,000场国内、国际会议、奖励旅游、展览 (MICE)等 活动，并在30年来成功推动泰国的会奖行业发展。<br/><br/></p>
    <p style="font-size:32px;text-align:center;color: #288cff;margin-top:40px;"><strong>突破提升</strong></p> 
    <p style="text-align:center;">为了最大限度地发挥潜力，QSNCC于2019年关闭并进行了重大改造，并开启了“泰国之光”和“终极鼓舞人心的世界级活动平台”的新篇章。</p>
    `,
      th: ``,
    },
  },
];

export const GLANCE_NEW_NEWCHAPTER = [
  {
    default: true,
    title: {
      cn: '概率愿景--新篇章',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `
      <p>QSNCC旨在成为终极鼓舞人心的世界级活动平台和新的世界级活动目的地，采用现代、优雅的设计理念，充分体现了泰国的可持续发展和文化特色。QSNCC旨在满足全面的会议和活动需求，提供灵活的空间和最先进的技术和设施。自成立以来，因四通八达的多种交通方式的便利性，使得QSNCC一直是举办大型活动的首选。</p>
      `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];
export const GLANCE_HISTORY_NEWCHAPTER = [
  {
    default: true,
    title: {
      cn: '概率愿景--文化遗产的传承',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `
      <p style="font-size:32px;text-align:center;color: #288cff;margin-top:40px;"><strong>文化遗产的传承</strong></p>
      <p>
      <div style="display: flex;margin-bottom: 40px;align-items: center;">
        <p style="flex:1" >
          <img style="border-radius: 20px 0 20px 0;" src="/images/glance/history/chuancheng.png" >
        </p>
        <div style="flex:1">
          
          <ul>
            <li style="line-height: 2em;display: flex;justify-content: center;align-items: center;">
              <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;margin: 2em;gap:25px">
                <img src="/images/home/gallery/inherit.png" ><span style="font-size: 22px;color: #288cff;font-weight: 600;">传承</span>
              </div>
              自1989年为第46届世界银行集团与国际货币基金组织理事会承接举办年会奠下第一块基石以来，QSNCC一直决心作为一个优雅和创新的场所获得国际认可，这是泰国无愧于诗丽吉王后之名的骄傲。 凭借全新设计和尖端技术，我们已准备好征服更多挑战并超越我们的极限。
            </li>
            <li style="line-height: 2em;display: flex;justify-content: center;align-items: center;">
              <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;margin: 2em;gap:25px">
              <img src="/images/home/gallery/preserve.png" ><span style="font-size: 22px;color: #288cff;font-weight: 600;">坚守</span>
              </div>
              追随诗丽吉王后保护泰国传统知识和文化的远见脚步，QSNCC被赋予了新的生命，以便能够融入在现代世界中。泰国的工艺、智慧、艺术和文化都充满生机和繁荣，并以新的光芒散发着它们的精髓。
            </li>
            <li style="line-height: 2em;display: flex;justify-content: center;align-items: center;">
              <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;margin: 2em;gap:25px">
                <img src="/images/home/gallery/continue.png" ><span style="font-size: 22px;color: #288cff;font-weight: 600;">延续</span>
              </div>
              想要跟上新时代永不停歇的变革浪潮，需要新方法、新思维、新知识。 凭借我们对于保持终身学习的坚定信念和知识储备，鼓舞激励不断开拓新天地，找到生活中的灵感和激情。
            </li>
          </ul>
          
        </div>
      </div>
    </p>


      `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];

export const GLANCE_WHYQSNCC = [
  {
    default: true,
    title: {
      cn: '概率愿景---选择QSNCC的理由',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `
      <p>新的QSNCC扩建为改造升级前的五倍，是一个总面积达300,000平方米的多功能场馆。新的QSNCC设有8个展厅、4 个会议厅、4 个全体会议厅、50个会议室和一个零售区。 它拥有世界一流的设施和最先进的技术，可以举办从现场音乐会到全球峰会的任何活动。将您的想象，变成现实。</p>
      <p style="font-size:32px;text-align:center;color:#FFFFFF;;margin-top:140px;"><strong>QSNCC：让成功发生</strong></p>
      <p style="text-align:center;color:#FFFFFF;">配备一流的设施。QSNCC为您提供无与伦比的服务。这个“终极鼓舞人心的世界级活动平台”让一切成为可能。</p>



      `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];

export const GLANCE_WHYQSNCC_LOCATION = [
  {
    default: true,
    title: {
      cn: '概率愿景---选择QSNCC的理由--地理位置',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `
      <p>
      <div style="display: flex;margin-bottom: 40px;align-items: center;">
        <p style="flex:1" >
          <img style="border-radius: 20px 0 20px 0;" src="/images/glance/location/content-media-01.jpg" >
        </p>
        <div style="flex:1;">
          <ul style="    padding-left: 25%;display: flex;flex-direction: column;justify-content: space-between;">
            <li style="line-height: 2em; padding-bottom:2em; color: #343434;">
            <h2>地点</h2>
            </li>
            <li style="line-height: 2em; padding-bottom:3em">
            QSNCC位于曼谷市中心，可通过多种交通方式到达，自成立以来一直是举办大型活动的主要场所。为游客提供多达3000个停车位。搭乘地铁QSNCC站可直达会场。游客可以欣赏湖泊和公园的景色，也可以在附近的班佳齐蒂森林公园（Benjakitti Forest Park）散步。
            </li>
            
          </ul>
        </div>
      </div>
    </p>

    <p>
    <div style="display: flex;margin-bottom: 40px;align-items: center;">
    <div style="flex:1;">
    <ul style="padding-right: 25%;display: flex;flex-direction: column;justify-content: space-between;">
      <li style="line-height: 2em; padding-bottom:2em; color: #343434;">
      <h2>灵活性</h2>
      </li>
      <li style="line-height: 2em; padding-bottom:3em">
      QSNCC拥有一流的设施和无与伦比的服务，可举办各种活动，在设计时考虑到了灵活性，无论是官方正式活动还是与生活方式相关的活动。78,500平方米的活动空间，另外还有50间会议室和一个大型零售空间。先进的设施由一支敬业的专业团队管理，他们总是可以做到超预期。
       </li>
      
    </ul>
  </div>
      <p style="flex:1" >
        <img style="border-radius: 20px 0 20px 0;" src="/images/glance/location/content-media-02.jpg" >
      </p>

    </div>
  </p>

  <p>
  <div style="display: flex;margin-bottom: 40px;align-items: center;">
    <p style="flex:1" >
      <img style="border-radius: 20px 0 20px 0;" src="/images/glance/location/content-media-03.jpg" >
    </p>
    <div style="flex:1;">
      <ul style="    padding-left: 25%;display: flex;flex-direction: column;justify-content: space-between;">
        <li style="line-height: 2em; padding-bottom:2em; color: #343434;">
        <h2>可持续发展性</h2>
        </li>
        <li style="line-height: 2em; padding-bottom:3em">
        QSNCC 是泰国首个获得LEED银级认证的会议中心，确保其设计、施工和运营均环保。其在所有相关环境领域均按照全球最高标准运作。为了成为绿色场馆，QSNCC实施了可再生能源和减少碳排放等可持续实践。
        </li>
        
      </ul>
    </div>
  </div>
</p>

<p>
<div style="display: flex;margin-bottom: 40px;align-items: center;">
<div style="flex:1;">
<ul style="padding-right: 25%;display: flex;flex-direction: column;justify-content: space-between;">
  <li style="line-height: 2em; padding-bottom:2em; color: #343434;">
  <h2>安全保障</h2>
  </li>
  <li style="line-height: 2em; padding-bottom:3em">
  QSNCC提供全球安全标准，涵盖生命和资产安全、身体卫生、食品安全和数字安全。非接触式访问和智能活动平台管理系统解决方案改善了该地区的服务，使其平稳、安全地运行。此外，整个地区都安装了监控。
  </li>
  
</ul>
</div>
  <p style="flex:1" >
    <img style="border-radius: 20px 0 20px 0;" src="/images/glance/location/content-media-04.jpg" >
  </p>

</div>
</p>

<p>
<div style="display: flex;margin-bottom: 40px;align-items: center;">
  <p style="flex:1" >
    <img style="border-radius: 20px 0 20px 0;" src="/images/glance/location/content-media-05.jpg" >
  </p>
  <div style="flex:1;">
    <ul style="    padding-left: 25%;display: flex;flex-direction: column;justify-content: space-between;">
      <li style="line-height: 2em; padding-bottom:2em; color: #343434;">
      <h2>技术</h2>
      </li>
      <li style="line-height: 2em; padding-bottom:3em">
      QSNCC已为数字技术的下一个十年做好了准备，投资了尖端基础设施以适应高科技的活动。光纤和WiFi网络覆盖了QSNCC的每个角落，确保线上和线下活动能够满负荷运行。我们知识丰富的IT团队可确保组织者和参观者在我们的场馆感到轻松并享受愉快的体验。
      </li>
      
    </ul>
  </div>
</div>
</p>

      `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];
export const BRAND_ADVERTISIONG_LIST = [
  {
    title: {
      cn: '品牌&广告',
      th: 'ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม',
    },
    content: {
      cn: `
      <p style="font-size:40px;line-height: 1.3;letter-spacing: 8px;color: #827800;text-align: center;"><strong>品牌&广告</strong></p>
      <p style="text-align: center;font-size: 19px;padding-bottom: 2em;">通过我们的现场广告解决方案传播您的活动信息，并为您的品牌增加曝光。QSNCC提供从横幅、悬挂标牌到数字屏幕等，以及现场数字媒体解决方案，帮助您将信息传达给正确的目标群体。</P>
        <div style="margin-bottom: 80px;">
            <p style="font-size:30px;line-height: 1.3;letter-spacing: 8px;text-align:center;"><strong>非数字化</strong></p>
            <ul>
              <li><img src="/images/service/brand01.jpg" style="width:100%"><p>G门厅 - 悬挂横幅</p></li>
              <li>
                <div style="display:flex">
                  <div style="margin-right:20px">
                    <img src="/images/service/brand02.jpg" style="width: 48em;height: 29em;object-fit: cover;"><p>LAKESIDE入口 - 玻璃板</p>
                  </div>
                  <div>
                    <img src="/images/service/brand03.jpg" style="width:100%"><p>零售步行街 - 立柱</p>
                    <img src="/images/service/brand04.jpg" style="width:100%;"><p>中庭扶梯 - 玻璃板</p>
                  </div>
                </div>
              </li>
              <li>
                <div style="display:flex">
                  <div style="margin-right:20px"><img src="/images/service/brand05.jpg" style="width:100%"><p>室外 - JFLAP</p></div>
                  <div><img src="/images/service/brand06.jpg" style="width:100%"><p>玻璃围栏 - 玻璃板</p></div>
                </div>
              </li>
              <li><img src="/images/service/brand07.jpg" style="width:100%"><p>GALLERY WALK - 悬挂横幅</p></li>
              <li>
                  <div style="display:flex">
                    <div style="margin-right:20px"><img src="/images/service/brand08.jpg" style=" width: 28em;height: 31em;"><p>宴会厅门厅 - 立柱</p></div>
                    <div><img src="/images/service/brand09.jpg" style="width:100%;height: 31em;"><p>宴会厅门厅 - 玻璃板</p></div>
                  </div>
              </li>
            </ul>
            <p style="font-size:30px;line-height: 1.3;letter-spacing: 8px;text-align:center;"><strong>数字化</strong></p>
            <ul>
              <li><img src="/images/service/brand10.jpg" style="width:100%"><p>MRT通道 - LED 屏幕</p></li>
              <li>
                <div style="display:flex">
                  <div style="margin-right:20px">
                    <img src="/images/service/brand11.jpg" style="width: 48em;height: 33.8em;"><p>主服务台 - LED 屏幕</p>
                  </div>
                  <div>
                    <img src="/images/service/brand12.jpg" style="width:100%"><p>2 号馆 - LED 屏幕</p>
                    <img src="/images/service/brand17.jpg" style="width:100%;height: 15.4em;"><p>1、3、4号馆 - LED屏幕</p>
                  </div>
                </div>
              </li>
              <li><img src="/images/service/brand13.jpg" style="width:100%"><p>导览标牌 - 互动板</p></li>
              <li>
                <div style="display:flex">
                  <div style="margin-right:20px"><img src="/images/service/brand14.jpg" style="width: 25em;height: 30.9em;"><p>自动扶梯 - 互动板</p></div>
                  <div><img src="/images/service/brand15.jpg" style="width:100%"><p>5 号厅 - 互动板</p></div>l
                </div>
              </li>
              <li><img src="/images/service/brand16.jpg" style="width:100%"><p>5 号厅 - 互动板</p></li>
            </ul>
        </div>
        
         `,
      th: `<p><strong>1.	ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม</strong></p>
      <p>“ข้อมูลส่วนบุคคล” (Personal Data) หมายถึง ข้อมูลใด ๆ ที่เกี่ยวข้องกับท่านหรือที่ทำให้สามารถระบุถึงตัวตนของท่านได้ ไม่ว่าทางตรงหรือทางอ้อม แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรม </p>
      <p>เพื่อที่เราจะเสนอผลิตภัณฑ์หรือบริการแก่ท่าน เราอาจเก็บข้อมูลส่วนบุคคลของท่านทางตรง (เช่น ผ่านทางตัวแทน, พนักงาน, ศูนย์บริการข้อมูลลูกค้า, แอพพลิเคชั่น) หรือทางอ้อม จากท่านหรือแหล่งข้อมูลอื่น (เช่น โซเชียลมีเดีย, แพลตฟอร์มออนไลน์ของบุคคลภายนอก, และ แหล่งข้อมูลสาธารณะอื่นๆ) หรือผ่านทางบริษัทแม่ของเรา, บริษัทในเครือ, บริษัทย่อย, พันธมิตรทางธุรกิจ, เจ้าหน้าที่รัฐ หรือบุคคลภายนอกอื่นๆ  โดยประเภทของข้อมูลที่เราเก็บรวบรวมนั้นจะขึ้นอยู่กับบริบทของการติดต่อสื่อสารระหว่างท่านกับเรา รวมถึงบริการหรือผลิตภัณฑ์ที่ท่านต้องการจากเราและจากบริษัทในเครือ NCC Group </p>
      <p>“ข้อมูลที่ละเอียดอ่อน” (Sensitive Data) ข้อมูลส่วนบุคคลที่กฎหมายจำแนกว่าเป็นข้อมูลที่ละเอียดอ่อน เราจะเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลที่ละเอียดอ่อน ก็ต่อเมื่อได้รับความยินยอมโดยชัดแจ้งจากท่าน หรือเป็นกรณีที่กฎหมายอนุญาตให้ดำเนินการได้ </p>
      <p>เราอาจมีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน ดังต่อไปนี้</p>
      <ol>
        <li>ข้อมูลส่วนตัว (Personal details) เช่น คำนำหน้าชื่อ ชื่อเต็ม เพศ อายุ อาชีพ วุฒิการศึกษา ตำแหน่งงาน สถานที่ทำงาน ตำแหน่งหรือฐานะ สัญชาติ ประเทศที่พำนัก วันเกิด ข้อมูลบนบัตรที่ออกโดยรัฐบาล (เช่น เลขที่บัตรประจำตัวประชาชน เลขประกันสังคม เลขที่หนังสือเดินทาง เลขประจำตัวผู้เสียภาษีอากร ข้อมูลใบอนุญาตขับขี่รถยนต์ หรือสิ่งที่ระบุตัวตนอันมีลักษณะคล้ายคลึงกัน เป็นต้น) ข้อมูลบนสำเนาทะเบียนบ้าน รายละเอียดการเข้าเมือง ได้แก่ วันที่เดินทางมาถึงและเดินทางออกประเทศ ลายมือชื่อ เสียง เสียงที่บันทึก รูปถ่าย ภาพจากกล้องวงจรปิด ข้อมูลประกันภัย ป้ายทะเบียนรถ งานอดิเรก และสิ่งที่ท่านสนใจ เป็นต้น</li>
        <li>ข้อมูลเพื่อการติดต่อ เช่น ที่อยู่ทางไปรษณีย์ ข้อมูลการจัดส่ง ที่อยู่สำหรับส่งใบแจ้งหนี้ หมายเลขโทรศัพท์ หมายเลขโทรสาร ที่อยู่อีเมล์ LINE ID) Facebook account Google ID Twitter ID Instagram account WhatsApp ID  WeChat ID และบัญชีผู้ใช้ในเว็บไซต์โซเชียลมีเดียอื่น ๆ </li>
        <li>ข้อมูลทางการเงิน เช่น รายได้ เงินเดือน ข้อมูลบัตรเครดิต/เดบิตหรือข้อมูลทางธนาคาร หมายเลขบัตรเครดิต/เดบิต ประเภทของบัตรเครดิต รอบบิล รายละเอียดบัญชีธนาคาร รายละเอียดและประวัติการชำระเงิน </li>
        <li>ข้อมูลการทำธุรกรรม (Transaction details) เช่น ข้อมูลเกี่ยวกับการชำระเงินไปยังและจากท่าน วันที่และ/หรือเวลาที่ชำระเงิน ยอดชำระเงิน ข้อมูลเกี่ยวกับการขอเงินคืน ยอดเงินคืน คะแนนสะสม วันที่และสถานที่ที่ซื้อ หมายเลขการซื้อหรือคำสั่งซื้อ วันนัดหมายเข้ารับบริการ ที่อยู่/วันที่และเวลาในการรับหรือจัดส่ง ข้อความตอบรับของผู้รับ ข้อความลงท้ายในอีเมล์ของผู้รับ ข้อมูลการรับประกันสินค้า คำร้องเรียนและข้อเรียกร้อง ข้อมูลการจอง ข้อมูลการเช่า ธุรกรรม ประวัติการทำธุรกรรม สถานที่ สถานะของธุรกรรม ธุรกรรมทางการขายในอดีต สถานะ สถานะการทำธุรกรรม ข้อมูลอื่น ๆ ของผลิตภัณฑ์และบริการที่ท่านซื้อ</li>
        <li>ข้อมูลทางเทคนิค (Technical details) เช่น เลขที่อยู่ไอพี (IP address) ที่อยู่ Media Access Control (MAC address) คุกกี้ เว็บบีคอน (web beacon) ล็อก (Log)  รหัสอุปกรณ์ (Device ID) รุ่นอุปกรณ์และประเภทของอุปกรณ์ เครือข่าย ข้อมูลการเชื่อมต่อ ข้อมูลการเข้าถึง ข้อมูลการเข้าใช้งานแบบ single sign-on (SSO) การเข้าสู่ระบบ (Login log) ระยะเวลาและสถานที่ที่เข้าถึง ระยะเวลาที่ใช้บนหน้าเพจของเรา ข้อมูลการเข้าสู่ระบบ ประวัติการค้นหา ข้อมูลการเรียกดู ประเภทและเวอร์ชันของเบราว์เซอร์ การตั้งค่าเขตเวลา (Time zone setting) และสถานที่ตั้ง ประเภทและเวอร์ชันของปลั๊กอินเบราว์เซอร์ ระบบปฏิบัติการและแพลตฟอร์ม เทคโนโลยีอื่นๆ บนอุปกรณ์ที่ท่านใช้ในการเข้าถึงแพลตฟอร์มของเรา</li>
        <li>ข้อมูลเกี่ยวกับพฤติกรรม (Behaviour details) เช่น ข้อมูลเกี่ยวกับพฤติกรรมการซื้อของท่าน ข้อมูลที่ได้รับจากการใช้ผลิตภัณฑ์และบริการของเรา งานอดิเรก ความสนใจ ทัศนคติ ความเชื่อมั่น ข้อมูลปฏิกิริยา</li>
        <li>ข้อมูลประวัติ (Profile details) เช่น หมายเลขสมาชิกแอพพลิเคชั่น ชื่อผู้ใช้และรหัสผ่านของท่าน รายละเอียดและรูปภาพข้อมูลส่วนตัว การซื้อ ประวัติคำสั่งซื้อ คำสั่งซื้อในอดีต ประวัติการซื้อ สินค้าที่ซื้อ จำนวนสินค้า คำสั่งซื้อหรือคำสั่งเรียกคืนสินค้าโดยท่าน คำสั่งซื้อผ่านทางเว็บไซต์ รายละเอียดการเก็บเงินปลายทาง (Cash on Delivery) ไอดีคำสั่งซื้อ (order ID) บันทึกข้อมูลทางการเงิน เลขรหัสลับส่วนตัว (PIN) ความสนใจของท่าน ความชอบ การตอบรับและผลสำรวจ การสำรวจความพึงพอใจ การใช้โซเชียลมีเดีย ข้อมูลการเข้าร่วม ข้อมูลโปรแกรมการเป็นลูกค้าอย่างต่อเนื่อง (Loyalty programs) รหัสส่วนลดและโปรโมชั่นที่ท่านใช้ รายละเอียดคำสั่งซื้อของลูกค้า การบริการลูกค้า การเข้าร่วมนิทรรศการการค้าและกิจกรรม นิทรรศการการค้า การดำเนินคดี การทดสอบและทดลองใช้งาน</li>
        <li>ข้อมูลทางการตลาดและการติดต่อสื่อสาร เช่น ความต้องการของท่านในการรับข้อมูลทางการตลาดจากเรา บริษัทในเครือของเรา บริษัทย่อย บุคคลภายนอก พันธมิตรทางธุรกิจ รูปแบบการติดต่อสื่อสารที่ต้องการ และ/หรือ</li>
        <li>ข้อมูลที่ละเอียดอ่อน เช่น เชื้อชาติ เผ่าพันธุ์ ความคิดเห็นทางการเมือง ความเชื่อในลัทธิ ศาสนาหรือปรัชญา พฤติกรรมทางเพศ ประวัติอาชญากรรม ข้อมูลสุขภาพหรือสภาพทางร่างกายหรือจิตใจ ความพิการ ภาวะทุพพลภาพ ข้อมูลสหภาพแรงงาน ข้อมูลทางพันธุกรรม ข้อมูลชีวภาพ ประวัติทางการแพทย์ ลายนิ้วมือ ระบบจดจำใบหน้า</li>
      </ol>
      <p>หากท่านได้ให้ข้อมูลส่วนบุคคลของบุคคลที่สามแก่เรา เช่น ชื่อ นามสกุล ที่อยู่ และหมายเลขโทรศัพท์เพื่อติดต่อในกรณีฉุกเฉิน รายได้ของบุคคลในครอบครัว กรุณาแจ้งบุคคลเหล่านั้นให้ทราบถึงนโยบายความเป็นส่วนตัวฉบับนี้ และ/หรือขอความยินยอมจากบุคคลเหล่านั้น </p>
      <p>ในกรณีที่จำเป็นต้องได้รับความยินยอม เราจะเก็บรวบรวมข้อมูลของผู้เยาว์ คนเสมือนไร้ความสามารถ คนไร้ความสามารถต่อเมื่อได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์ หรือผู้อนุบาล เท่านั้น เราจะไม่เก็บรวบรวมข้อมูลจากลูกค้าที่เรารู้โดยแจ้งชัดว่าอายุต่ำกว่ายี่สิบปี หรือจากคนเสมือนไร้ความสามารถและคนไร้ความสามารถหากไม่ได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์ หรือผู้อนุบาล ในกรณีที่เราทราบว่า เราได้เก็บรวบรวมข้อมูลส่วนบุคคลโดยไม่มีเจตนาจากบุคคลใด ๆ ที่อายุต่ำกว่ายี่สิบปี คนเสมือนไร้ความสามารถ หรือคนไร้ความสามารถโดยไม่ได้รับความยินยอมจากผู้ใช้อำนาจปกครองที่มีอำนาจกระทำการแทนผู้เยาว์ ผู้พิทักษ์ หรือผู้อนุบาล เราจะดำเนินการลบข้อมูลดังกล่าวทันที หรือประมวลผลเฉพาะในส่วนของข้อมูลที่เราสามารถกระทำได้บนฐานทางกฎหมายอื่น ๆ นอกเหนือจากการขอความยินยอม</p>`,
    },
  },
];

export const VENUE_ROOM_OPTION_LIST = [
  {
    label: {
      cn: 'B2层',
      th: 'News',
    },
    value: 'B2',
    link: '/venue-room/B2/',
  },
  {
    label: {
      cn: 'B1层',
      th: 'Gallery',
    },
    value: 'B1',
    link: '/venue-room/B1/',
  },
  {
    label: {
      cn: 'LG层',
      th: 'NCC Group',
    },
    value: 'LG',
    link: '/venue-room/LG/',
  },
  {
    label: {
      cn: 'LM层',
      th: 'NCC Group',
    },
    value: 'LM',
    link: '/venue-room/LM/',
  },
  {
    label: {
      cn: 'G层',
      th: 'NCC Group',
    },
    value: 'G',
    link: '/venue-room/G/',
  },
  {
    label: {
      cn: '1层',
      th: 'NCC Group',
    },
    value: '1',
    link: '/venue-room/1/',
  },
  {
    label: {
      cn: '2层',
      th: 'NCC Group',
    },
    value: '2',
    link: '/venue-room/2/',
  },
];

export const VENUE_ROOM_B2 = [
  {
    default: true,
    title: {
      cn: 'B2层介绍',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `
      <p><img src="/images/venueroom/B2/B2.png" alt="" width="90%" /></p>
      <p><img src="/images/venueroom/B2/B2_icon.png" alt="" width="956" height="112" /></p>
      <p>停车场设有无障碍停车位，开放时间为5:00至24:00。在同一楼层，还有一个1,850.00平方米的大厅。活动大厅设有登记处和一个单独的组织方工作房间，可用于举办特别活动。</p>
      <p ><h2 style="font-size:40px;color: #343434;font-weight: 700;line-height: 1.4;text-align:center;">图片库</h2></p>
      <p>
      <ul>
        <li>
           <div style="display:flex">
             <div style="margin-right:20px"><img src="/images/venueroom/B2/1.jpg" style=" width: 28em;height: 31em;"></div>
             <div><img src="/images/venueroom/B2/2.jpg" style="width:100%;height: 31em;"></div>
           </div>
       </li>
  </ul>
      </p> 
      `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];

export const VENUE_ROOM_B1 = [
  {
    default: true,
    title: {
      cn: 'B1层',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `<p><img src="/images/venueroom/B1/B1.png" alt="" width="90%" /></p>
      <p><img src="/images/venueroom/B1/B1_icon.png" alt="" width="966" height="104" /></p>
      <p>停车场包括无障碍停车场和女士专用停车场，开放时间为5:00至24:00。还提供电动汽车充电桩。美食街的营业时间为7:00至20:00，美食爱好者可以在这里满足自己的口腹之欲。</p>
      <p ><h2 style="font-size:40px;color: #343434;font-weight: 700;line-height: 1.4;text-align:center;">虚拟导览</h2></p>
      <div style="margin-bottom: 80px;position: relative;">
        <img src="/images/venueroom/B1/Thumbnail_Level_B1.jpg" style="width:100%">
        <a href="https://www.qsncc.com/vr/index.html/?floor=B1&scene=Food_Street" target="_block">
          <div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);font-size: 17px;background-color: #827800;color:#fffefe;padding: 17px 24px;font-weight: 600;border-radius: 20px 0 20px 0;">开始虚拟导览</div>
        </a>
       </div>
      <p ><h2 style="font-size:40px;color: #343434;font-weight: 700;line-height: 1.4;text-align:center;">图片库</h2></p>
      <p><img src="/images/venueroom/B1/1.jpg" alt="" width="100%" /></p>
      <p>
      <ul>
        <li>
           <div style="display:flex">
             <div style="margin-right:20px"><img src="/images/venueroom/B1/2.jpg" style=" width: 28em;height: 31em;"></div>
             <div><img src="/images/venueroom/B1/3.jpg" style="width:100%;height: 31em;"></div>
           </div>
       </li>
  </ul>
      </p> 
         `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];

export const VENUE_ROOM_LM = [
  {
    default: true,
    title: {
      cn: 'B1层',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `<p><img src="/images/venueroom/LM/LM.png" alt="" width="90%" /></p>
      <p><img src="/images/venueroom/LM/LM_icon.png" alt="" width="970" height="128" /></p>
      <p>在LM层，会议组织方和参观者都可以探索令人兴奋、难忘的体验，因为这里有各种商店和服务可以满足您的所有需求。探索QSNCC的另一面，它不仅仅是一个会议中心。</p>
      
      <p ><h2 style="font-size:40px;color: #343434;font-weight: 700;line-height: 1.4;text-align:center;">图片库</h2></p>
      <p><img src="/images/venueroom/LM/1.jpg" alt="" width="100%" /></p>
      <p>
      <ul>
        <li>
           <div style="display:flex">
             <div style="margin-right:20px"><img src="/images/venueroom/LM/2.jpg" style=" width: 28em;height: 31em;"></div>
             <div><img src="/images/venueroom/LM/3.jpg" style="width:100%;height: 31em;"></div>
           </div>
       </li>
  </ul>
      </p> 
         `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];

export const VENUE_ROOM_G = [
  {
    default: true,
    title: {
      cn: 'B1层',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `<p><img src="/images/venueroom/G/G.png" alt="" width="90%" /></p>
      <p><img src="/images/venueroom/G/G_icon.png" alt="" width="981" height="150" /></p>
      <p ><h2 style="font-size:40px;color: #343434;font-weight: 700;line-height: 1.4;text-align:center;">布局与容量</h2></p>
      <p>G层有四个大型无柱大厅，奢华大气，体现了独特的泰式建筑风格。 G层的设计灵感源自传统泰国Jong Kraben和卷起的缠腰布，其设计理念为Chut Thangkan Bab Thai Phrayook（正式泰式）。墙壁上饰有褶皱，打造出泰式装饰图案。一系列著名餐厅即使是最挑剔的食客，在这里也会找到满意的餐食。</p>
    
         `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];

export const VENUE_ROOM_G_END = [
  {
    default: true,
    title: {
      cn: 'G层',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `<p> <div class="t-venue-floor__info-floor-data-description-item">
      <strong>展厅</strong><br/>
      <ul class="a-list">
        <li>多功能厅</li>
        <li>5个下客区</li>
        <li>地板承重2,000 公斤/平方米</li>
        <li>装卸区26个装卸口</li>
        <li>服务电梯3台（W1.2米 x D2.7米 x H3米），1,350 公斤</li>
        <li>载货电梯2台（W3.5米 x D8米 x H3米），5,000 公斤</li>

      </ul>
    </div>
    <div class="t-venue-floor__info-floor-data-description-item">
      <strong>主门厅A</strong><br/>
      <ul class="a-list">
        <li>包括零售空间</li>
      </ul>
      <strong>主门厅B</strong><br/>
      <ul class="a-list">
        <li>包括零售空间</li>
      </ul>
    </div>
    </p>
         `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];

export const VENUE_ROOM_G_PHOTO = [
  {
    default: true,
    title: {
      cn: 'LG层',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `
      <p style="display:block;"><h2 style="font-size:40px;color: #343434;font-weight: 700;line-height: 1.4;text-align:center;">虚拟导览</h2></p>
      <div style="margin-bottom: 80px;position: relative;">
        <img src="/images/venueroom/G/Thumbnail_Level_G.jpg" style="width:100%">
        <a href="https://www.qsncc.com/vr/index.html/?floor=G&scene=Lakeside_Foyer_G_1" target="_block">
          <div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);font-size: 17px;background-color: #827800;color:#fffefe;padding: 17px 24px;font-weight: 600;border-radius: 20px 0 20px 0;">开始虚拟导览</div>
        </a>
      </div>


      <p ><h2 style="font-size:40px;color: #343434;font-weight: 700;line-height: 1.4;text-align:center;">图片库</h2></p>
      <div style="margin-bottom: 80px;">
      <ul>
        <li><img src="/images/venueroom/G/1.jpg" style="width:100%"></li><p></p>
        <li>
          <div style="display:flex">
            <div style="margin-right:20px">
              <img src="/images/venueroom/G/2.jpg" style="width: 48em;height: 29em;"><p></p>
            </div>
            <div>
              <img src="/images/venueroom/G/3.jpg" style="width:100%;height:14em;"><p></p>
              <img src="/images/venueroom/G/4.jpeg" style="width:100%; height:14em;"><p></p>
            </div>
          </div>
        </li>
        <li><img src="/images/venueroom/G/5.jpeg" style="width:100%"><p></p></li>
       
     
      </ul>
  </div>
         `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];

export const VENUE_ROOM_LG = [
  {
    default: true,
    title: {
      cn: 'LG层',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `<p><img src="/images/venueroom/LG/LG.png" alt="" width="90%" /></p>
      <p><img src="/images/venueroom/LG/LG_icon.png" alt="" width="959" height="152" /></p>
      <p ><h2 style="font-size:40px;color: #343434;font-weight: 700;line-height: 1.4;text-align:center;">布局与容量</h2></p>
      <p>LG层与MRT（地铁站）直接相连，有着可以满足所有生活方式需求的服务、商店，并摆放展示着泰国艺术大师的艺术品。装饰峰哥以Chut Thai Lamlong（休闲泰式）概念为基础，凸显轻松温馨的氛围，描绘了泰国当地服饰的魅力和独特图案，有着舒适的缠腰布、色彩缤纷的纱笼、褶皱布以及鳞片堆叠。</p>
     
         `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];

export const VENUE_ROOM_LG_PHOTO = [
  {
    default: true,
    title: {
      cn: 'LG层',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `
      <p style="display:block;"><h2 style="font-size:40px;color: #343434;font-weight: 700;line-height: 1.4;text-align:center;">虚拟导览</h2></p>
      <div style="margin-bottom: 80px;position: relative;">
      <img src="/images/venueroom/LG/Thumbnail_Level_LG.jpg" style="width:100%">
      <a href="https://www.qsncc.com/vr/index.html/?floor=LG&scene=Gallery_Walk_2" target="_block">
        <div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);font-size: 17px;background-color: #827800;color:#fffefe;padding: 17px 24px;font-weight: 600;border-radius: 20px 0 20px 0;">开始虚拟导览</div>
      </a>
     </div>
      <p ><h2 style="font-size:40px;color: #343434;font-weight: 700;line-height: 1.4;text-align:center;">图片库</h2></p>
      <div style="margin-bottom: 80px;">
      <ul>
        <li><img src="/images/venueroom/LG/1.jpg" style="width:100%"></li><p></p>
        <li>
          <div style="display:flex">
            <div style="margin-right:20px">
              <img src="/images/venueroom/LG/2.jpg" style="width: 48em;height: 29em;"><p></p>
            </div>
            <div>
              <img src="/images/venueroom/LG/3.jpg" style="width:100%;height:14em;"><p></p>
              <img src="/images/venueroom/LG/4.jpg" style="width:100%; height:14em;"><p></p>
            </div>
          </div>
        </li>
        <li><img src="/images/venueroom/LG/5.jpg" style="width:100%"><p></p></li>
       
        <li>
            <div style="display:flex">
              <div style="margin-right:20px"><img src="/images/venueroom/LG/6.jpeg" style=" width: 30em;height: 31em;"><p></p></div>
              <div><img src="/images/venueroom/LG/7.jpeg" style="width:100%;height: 31em;"><p></p></div>
            </div>
        </li>
        <li><img src="/images/venueroom/LG/8.jpg" style="width:100%"><p></p></li>
      </ul>
  </div>
         `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];

export const VENUE_ROOM_LG_END = [
  {
    default: true,
    title: {
      cn: 'LG层',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `<p> <div class="t-venue-floor__info-floor-data-description-item">
      <strong>展厅</strong><br/>
      <ul class="a-list">
        <li>立柱直径 =  1.7 米</li>
        <li>立柱间距 = 25 米</li>
        <li>地板承重1,500 公斤/平方米</li>
        <li>装卸区55个装卸口</li>
        <li>服务电梯3台（W1.2米 x D2.7米 x H3 米），1,350 公斤</li>
        <li>载货电梯2台（W3.5米 x D8米 x H3 米），5,000 公斤</li>

      </ul>
    </div>
    <div class="t-venue-floor__info-floor-data-description-item">
      <strong>LG 大厅 A</strong><br/>
      <ul class="a-list">
        <li>包括零售空间</li>
      </ul>
      <strong>LG 大厅 B</strong><br/>
      <ul class="a-list">
        <li>包括零售空间</li>
      </ul>
    </div>
    </p>
         `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];

export const VENUE_ROOM_1 = [
  {
    default: true,
    title: {
      cn: 'B1层',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `<p><img src="/images/venueroom/1/1.png" alt="" width="90%" /></p>
      <p><img src="/images/venueroom/1/1_icon.png" alt="" width="949" height="149" /></p>
      <p ><h2 style="font-size:40px;color: #343434;font-weight: 700;line-height: 1.4;text-align:center;">布局与容量</h2></p>
      <p>1层有四个宴会厅和四个大会堂。宴会厅的灵感来自Chut Chao Khao Thai或Thai hill tribe服饰风格，通过条纹和几何形状，描绘着自然。其中银色装饰品，正是山地部落人民佩戴的流行装饰品。大会堂的设计灵感来自泰王室服饰风格常用的Chut Thai Chakri或Phra Rajaniyom风格服饰。设计师放大了简化的泰国传统装饰图案“Pra Jam Yam”，并添加了Chut Thai Chakri连衣裙锦缎上的精美图案，增强了现代感和永恒感。 小型会议室俯瞰着湖泊和班佳齐蒂公园郁郁葱葱的绿荫。</p>
    
         `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];

export const VENUE_ROOM_1_END = [
  {
    default: true,
    title: {
      cn: 'LG层',
      th: 'นโยบายความเป็นส่วนตัว',
    },
    content: {
      cn: `<p> <div class="t-venue-floor__info-floor-data-description-item">
      <strong>大会堂</strong><br/>
      <ul class="a-list">
        <li>地板承重1,000公斤/平方米</li>
        <li>装卸区21装卸口</li>
        <li>载货电梯2台（W3.5米 x D8米 x H3 米），5,000 公斤</li>
        <li>服务电梯4台（W1.2米 x D2.7米 x H3 米），1,350 公斤</li>
      </ul>
      <strong>大会堂门厅</strong><br/>
      <ul class="a-list">
        <li>地板承重500公斤/平方米</li>
      </ul>
      <strong>会议室门厅 1A</strong><br/>
      <ul class="a-list">
        <li>地板承重500公斤/平方米</li>
      </ul>
    </div>
    <div class="t-venue-floor__info-floor-data-description-item">
      <strong>宴会厅</strong><br/>
      <ul class="a-list">
        <li>地板承重1,500公斤/平方米</li>
        <li>装卸区21个装卸口</li>
        <li>载货电梯2台（W3.5米 x D8米 x H3米），5,000公斤</li>
        <li>服务电梯4台（W1.2米 x D2.7米 x H3米），1.350公斤</li>
      </ul>
      <strong>宴会厅门厅</strong><br/>
      <ul class="a-list">
        <li>地板承重500公斤/平方米</li>
      </ul>
      <strong>会议室门厅 1B</strong><br/>
      <ul class="a-list">
        <li>地板承重500公斤/平方米</li>
      </ul>
    </div>
    </p>
         `,
      th: `<p>บริษัท เอ็น.ซี.ซี. แมนเนจเม้นท์ แอนด์ ดิเวลลอปเม้นท์ จำกัด (“บริษัทฯ”, “เรา” “พวกเรา” หรือ “ของเรา”) ให้ความสำคัญต่อการคุ้มครองข้อมูลส่วนบุคคลของท่าน เราทราบดีว่าท่านเป็นห่วงข้อมูลของท่านที่จะถูกเก็บรวบรวม ใช้ เปิดเผย และ ส่งหรือโอนไปยังต่างประเทศ ซึ่งเราและบริษัทในเครือ NCC Group จะนำข้อมูลที่ท่านให้กับเรานั้นไปใช้เพื่อจัดหาผลิตภัณฑ์และให้บริการให้ตรงกับความต้องการและความจำเป็นของท่านอย่างเหมาะสม บริษัทฯ ซาบซึ้งในความไว้วางใจของท่านและเราจะดูแลข้อมูลส่วนบุคคลของท่านด้วยความระมัดระวังและอย่างสมเหตุสมผล พร้อมมอบประสบการณ์และการให้บริการลูกค้าอย่างดีที่สุดจากเรา</p>
        <p>นโยบายความเป็นส่วนตัวฉบับนี้  อธิบายถึง การเก็บรวบรวม ใช้ เปิดเผย และโอนข้อมูลส่วนบุคคล (ตามคำนิยามด้านล่าง) และสิทธิในการคุ้มครองข้อมูลส่วนบุคคลของบุคคลภายนอกองค์กรของเราซึ่งเรามีปฏิสัมพันธ์ด้วย และข้อมูลส่วนบุคคลของผู้ที่เราดำเนินธุรกิจด้วยหรือผู้ที่เราเสนอผลิตภัณฑ์และบริการให้ รวมถึง (1) ลูกค้า (2) ผู้ติดต่อ, ลูกจ้าง, พนักงาน, ผู้รับมอบอำนาจ, ผู้มีอำนาจกระทำการแทน, ตัวแทน, กรรมการ, ผู้ถือหุ้น หรือบุคคลใดที่มีอำนาจในการดำเนินธุรกิจหรือมีส่วนร่วมในการดำเนินธุรกิจในนามของบริษัทลูกค้าและบริษัทในเครือของลูกค้า (3) ผู้ใช้หรือผู้เข้าเยี่ยมชมเว็บไซต์ของเรา (4) ผู้รับผลิตภัณฑ์หรือบริการของเรา และ (5) บุคคลอื่นใดที่เกี่ยวกับข้อมูลส่วนบุคคลที่เราได้รับมา (เรียกว่า “ท่าน” หรือ “ของท่าน”)  โดยนโยบายความเป็นส่วนตัวนี้ครอบคลุมถึง เว็บไซต์ แอปพลิเคชัน โซเชียลมีเดีย ช่องทางสื่อสารออนไลน์อื่นๆ การจัดงานอีเว้นท์และกิจกรรมของเรา ตลอดจนสถานที่อื่นๆ ที่ได้มีการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน อย่างไรก็ตาม กรุณาอ่านนโยบายความเป็นส่วนตัวฉบับนี้ควบคู่กับข้อตกลงและเงื่อนไขสำหรับการบริการเฉพาะที่ท่านใช้ (ซึ่งอาจมีกำหนดไว้แยกต่างหากตามประเภทของข้อมูลส่วนบุคคลที่เราเก็บจากท่าน)</p>
        <p>บริษัทฯ ขอสงวนสิทธิ์ในการแก้ไขนโยบายความเป็นส่วนตัวนี้เป็นครั้งคราว ท่านสามารถตรวจสอบได้ตลอดเวลาเพื่อดูว่านโยบายความเป็นส่วนตัวนี้ได้รับการแก้ไขครั้งล่าสุดเมื่อใด การแก้ไขเปลี่ยนแปลงใดๆ จะมีผลทันทีเมื่อเราเผยแพร่นโยบายความเป็นส่วนตัวที่แก้ไขดังกล่าวลงในเว็บไซต์  แอปพลิเคชัน หรือช่องทางสื่อสารอื่นใดของเรา เราจะแจ้งให้ท่านทราบหากมีการแก้ไขหรือปรับปรุงที่สำคัญ </p>`,
    },
  },
];

export const VENUE_ROOM_LG_FLOOR = [
  {
    icon: 'all-floor',
    label: '所有楼层平面图',
    tabLabel: '所有楼层平面图',
    image: {
      png: '/images/floors/details/level-LG-all.png',
      webp: '/images/floors/details/level-LG-all.webp',
      pngSp: '/images/floors/details/level-LG-all-sp.png',
      webpSp: '/images/floors/details/level-LG-all-sp.webp',
    },
    showFloor: true,
    showLayout: false,
    data: {
      description: `
      <div class="t-venue-floor__info-floor-data-description-item">
        <ul class="a-list">
          <li>立柱直径 = 1.7 m</li>
          <li>立柱间距 = 25 m</li>
          <li>楼面负荷 = 1,500 kg/m<sup>2</sup></li>
          <li>装卸区 = 55个</li>
          <li>员工电梯 = 3部（2.7 m x 1.2 m x 3 m）（长 x 宽 x 高），载重1,350 kg</li>
          <li>货梯 = 2部（8 m x 3.5 m x 3 m）（长 x 宽 x 高），载重5,000 kg</li>
        </ul>
      </div>
      `,
    },
  },
  {
    icon: 'number-5',
    label: '5号展厅',
    tabLabel: '展厅',
    key: 'lg-hall-5',
    image: {
      png: '/images/floors/details/level-LG-hall-5.png',
      webp: '/images/floors/details/level-LG-hall-5.webp',
      pngSp: '/images/floors/details/level-LG-hall-5-sp.png',
      webpSp: '/images/floors/details/level-LG-hall-5-sp.webp',
    },
    showFloor: true,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
            { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 51.74 },
            { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 7 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5588 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 60149 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5214 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 3564 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2880 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 5214 },
            { icon: 'booth', label: '展台', key: 'booth', value: 317 },
          ],
        },
      },
    },
  },
  {
    icon: 'number-6',
    label: '6号展厅',
    tabLabel: '展厅',
    key: 'lg-hall-6',
    image: {
      png: '/images/floors/details/level-LG-hall-6.png',
      webp: '/images/floors/details/level-LG-hall-6.webp',
      pngSp: '/images/floors/details/level-LG-hall-6-sp.png',
      webpSp: '/images/floors/details/level-LG-hall-6-sp.webp',
    },
    showFloor: true,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
            { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 54.28 },
            { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 7 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5863 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 63109 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5688 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 3888 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 3120 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 5688 },
            { icon: 'booth', label: '展台', key: 'booth', value: 350 },
          ],
        },
      },
    },
  },
  {
    icon: 'number-7',
    label: '7号展厅',
    tabLabel: '展厅',
    key: 'lg-hall-7',
    image: {
      png: '/images/floors/details/level-LG-hall-7.png',
      webp: '/images/floors/details/level-LG-hall-7.webp',
      pngSp: '/images/floors/details/level-LG-hall-7-sp.png',
      webpSp: '/images/floors/details/level-LG-hall-7-sp.webp',
    },
    showFloor: true,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
            { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 54.28 },
            { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 7 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5863 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 63109 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5688 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 3888 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 3120 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 5688 },
            { icon: 'booth', label: '展台', key: 'booth', value: 350 },
          ],
        },
      },
    },
  },
  {
    icon: 'number-8',
    label: '8号展厅',
    tabLabel: '展厅',
    key: 'lg-hall-8',
    image: {
      png: '/images/floors/details/level-LG-hall-8.png',
      webp: '/images/floors/details/level-LG-hall-8.webp',
      pngSp: '/images/floors/details/level-LG-hall-8-sp.png',
      webpSp: '/images/floors/details/level-LG-hall-8-sp.webp',
    },
    showFloor: true,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
            { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 50.33 },
            { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 7 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5436 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 58513 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5214 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 3564 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2640 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 5214 },
            { icon: 'booth', label: '展台', key: 'booth', value: 291 },
          ],
        },
      },
    },
  },
  {
    icon: 'number-8',
    label: '5-8号展厅',
    tabLabel: '展厅',
    key: 'lg-hall-8',
    image: {
      png: '/images/floors/details/level-LG-hall-8.png',
      webp: '/images/floors/details/level-LG-hall-8.webp',
      pngSp: '/images/floors/details/level-LG-hall-8-sp.png',
      webpSp: '/images/floors/details/level-LG-hall-8-sp.webp',
    },
    showFloor: true,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
            { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 210.65 },
            { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 7 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 22750 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 244879 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 21251 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 14628 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 11270 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 21252 },
            { icon: 'booth', label: '展台', key: 'booth', value: 1284 },
          ],
        },
      },
    },
  },
  {
    label: 'LG 大厅A',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 229.3 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 24 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 8.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 3350 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 36059 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 0 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 0 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 0 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 0 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: 'LG 大厅B',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 217 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 21 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 8.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 6650 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 71580 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 0 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 0 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 0 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 0 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
];

export const VENUE_ROOM_G_FLOOR = [
  {
    icon: 'number-1',
    label: '1号厅',
    tabLabel: '展厅',
    key: 'lg-hall-5',
    image: {
      png: '/images/floors/details/level-LG-hall-5.png',
      webp: '/images/floors/details/level-LG-hall-5.webp',
      pngSp: '/images/floors/details/level-LG-hall-5-sp.png',
      webpSp: '/images/floors/details/level-LG-hall-5-sp.webp',
    },
    showFloor: true,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
            { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 50.27 },
            { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 13.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5430 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 58448 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5688 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 3888 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2990 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 5688 },
            { icon: 'booth', label: '展台', key: 'booth', value: 324 },
          ],
        },
      },
    },
  },
  {
    icon: 'number-2',
    label: '2号厅',
    tabLabel: '展厅',
    key: 'lg-hall-6',
    image: {
      png: '/images/floors/details/level-LG-hall-6.png',
      webp: '/images/floors/details/level-LG-hall-6.webp',
      pngSp: '/images/floors/details/level-LG-hall-6-sp.png',
      webpSp: '/images/floors/details/level-LG-hall-6-sp.webp',
    },
    showFloor: true,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
            { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 53.7 },
            { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 13.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5800 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 62431 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5688 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 3888 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2990 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 5688 },
            { icon: 'booth', label: '展台', key: 'booth', value: 358 },
          ],
        },
      },
    },
  },
  {
    icon: 'number-3',
    label: '3号厅',
    tabLabel: '展厅',
    key: 'lg-hall-7',
    image: {
      png: '/images/floors/details/level-LG-hall-7.png',
      webp: '/images/floors/details/level-LG-hall-7.webp',
      pngSp: '/images/floors/details/level-LG-hall-7-sp.png',
      webpSp: '/images/floors/details/level-LG-hall-7-sp.webp',
    },
    showFloor: true,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
            { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 53.7 },
            { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 13.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5800 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 62431 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5688 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 3888 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2990 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 5688 },
            { icon: 'booth', label: '展台', key: 'booth', value: 356 },
          ],
        },
      },
    },
  },
  {
    icon: 'number-4',
    label: '4号厅',
    tabLabel: '展厅',
    key: 'lg-hall-8',
    image: {
      png: '/images/floors/details/level-LG-hall-8.png',
      webp: '/images/floors/details/level-LG-hall-8.webp',
      pngSp: '/images/floors/details/level-LG-hall-8-sp.png',
      webpSp: '/images/floors/details/level-LG-hall-8-sp.webp',
    },
    showFloor: true,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 108 },
            { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 49.12 },
            { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 13.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 5305 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 57102 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 5214 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 3564 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2760 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 5214 },
            { icon: 'booth', label: '展台', key: 'booth', value: 294 },
          ],
        },
      },
    },
  },
  {
    label: '1-4号厅',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 108 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 207 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 13.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 22335 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 240412 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 22494 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 15582 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 11730 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 22494 },
            { icon: 'booth', label: '展台', key: 'booth', value: 1305 },
          ],
        },
      },
    },
  },
  {
    label: '主门厅A',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 179 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 11.5 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 5.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 2500 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 26910 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 0 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 0 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 0 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 0 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '主门厅B',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 219 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 41 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 5.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 7500 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 80729 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 0 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 0 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 0 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 0 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
];

export const VENUE_ROOM_1_FLOOR = [
  {
    icon: 'number-1',
    label: '大会堂1',
    tabLabel: '展厅',
    key: 'lg-hall-5',
    image: {
      png: '/images/floors/details/level-LG-hall-5.png',
      webp: '/images/floors/details/level-LG-hall-5.webp',
      pngSp: '/images/floors/details/level-LG-hall-5-sp.png',
      webpSp: '/images/floors/details/level-LG-hall-5-sp.webp',
    },
    showFloor: true,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 42.5 },
            { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 23.3 },
            { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 9 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 990 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 10656 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 808 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 570 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 480 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 808 },
            { icon: 'booth', label: '展台', key: 'booth', value: 52 },
          ],
        },
      },
    },
  },
  {
    icon: 'number-2',
    label: '大会堂2',
    tabLabel: '展厅',
    key: 'lg-hall-6',
    image: {
      png: '/images/floors/details/level-LG-hall-6.png',
      webp: '/images/floors/details/level-LG-hall-6.webp',
      pngSp: '/images/floors/details/level-LG-hall-6-sp.png',
      webpSp: '/images/floors/details/level-LG-hall-6-sp.webp',
    },
    showFloor: true,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 42.5 },
            { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 26.7 },
            { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 9 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1135 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 12217 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 1076 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 684 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 560 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 1076 },
            { icon: 'booth', label: '展台', key: 'booth', value: 64 },
          ],
        },
      },
    },
  },
  {
    icon: 'number-3',
    label: '大会堂3',
    tabLabel: '展厅',
    key: 'lg-hall-7',
    image: {
      png: '/images/floors/details/level-LG-hall-7.png',
      webp: '/images/floors/details/level-LG-hall-7.webp',
      pngSp: '/images/floors/details/level-LG-hall-7-sp.png',
      webpSp: '/images/floors/details/level-LG-hall-7-sp.webp',
    },
    showFloor: true,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 42.5 },
            { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 27 },
            { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 9 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1150 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 12378 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 1076 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 684 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 560 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 1076 },
            { icon: 'booth', label: '展台', key: 'booth', value: 64 },
          ],
        },
      },
    },
  },
  {
    icon: 'number-4',
    label: '大会堂4',
    tabLabel: '展厅',
    key: 'lg-hall-8',
    image: {
      png: '/images/floors/details/level-LG-hall-8.png',
      webp: '/images/floors/details/level-LG-hall-8.webp',
      pngSp: '/images/floors/details/level-LG-hall-8-sp.png',
      webpSp: '/images/floors/details/level-LG-hall-8-sp.webp',
    },
    showFloor: true,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { image: '/images/floors/dimension-length.png', label: '长（米）', key: 'length', value: 14.5 },
            { image: '/images/floors/dimension-width.png', label: '宽（米）', key: 'width', value: 87.25 },
            { image: '/images/floors/dimension-height.png', label: '高（米）', key: 'height', value: 9 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1265 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 13616 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 813 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 540 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 450 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 813 },
            { icon: 'booth', label: '展台', key: 'booth', value: 40 },
          ],
        },
      },
    },
  },
  {
    label: '大会堂1-3',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 42.5 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 77.05 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 9 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 3275 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 35252 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 3260 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 2050 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 1680 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 3260 },
            { icon: 'booth', label: '展台', key: 'booth', value: 188 },
          ],
        },
      },
    },
  },
  {
    label: '大会堂1-4',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 57 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 77.05 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 9 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 4540 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 48868 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 3925 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 2700 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2200 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 3925 },
            { icon: 'booth', label: '展台', key: 'booth', value: 252 },
          ],
        },
      },
    },
  },
  {
    label: '大会堂门厅',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 33.9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 48.5 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 9 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1644 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 17697 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 0 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 0 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 0 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 0 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '宴会厅1',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 44.5 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 23.5 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 9.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1045 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 11248 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 870 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 600 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 520 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 870 },
            { icon: 'booth', label: '展台', key: 'booth', value: 57 },
          ],
        },
      },
    },
  },
  {
    label: '宴会厅2',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 44.5 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 26.83 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 9.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1194 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 12852 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 1044 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 720 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 600 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 1044 },
            { icon: 'booth', label: '展台', key: 'booth', value: 70 },
          ],
        },
      },
    },
  },
  {
    label: '宴会厅3',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 44.5 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 26.83 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 9.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1194 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 12852 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 1044 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 720 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 600 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 1044 },
            { icon: 'booth', label: '展台', key: 'booth', value: 70 },
          ],
        },
      },
    },
  },
  {
    label: '宴会厅4',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 44.5 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 26.5 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 9.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1180 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 12701 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 1044 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 720 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 600 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 1044 },
            { icon: 'booth', label: '展台', key: 'booth', value: 70 },
          ],
        },
      },
    },
  },
  {
    label: '宴会厅1-2',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 44.5 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 50.33 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 9.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 2239 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 24100 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 1850 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 1368 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 960 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 1851 },
            { icon: 'booth', label: '展台', key: 'booth', value: 127 },
          ],
        },
      },
    },
  },
  {
    label: '宴会厅3-4',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 44.5 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 53.33 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 9.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 2374 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 25553 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 2016 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 1482 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 960 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 2016 },
            { icon: 'booth', label: '展台', key: 'booth', value: 140 },
          ],
        },
      },
    },
  },
  {
    label: '宴会厅1-4',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 44.5 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 103.7 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 9.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 4615 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 49675 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 3750 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 2550 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 2000 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 3750 },
            { icon: 'booth', label: '展台', key: 'booth', value: 252 },
          ],
        },
      },
    },
  },
  {
    label: '宴会厅门厅',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 99.2 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 8.4 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 9.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 1125 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 12109 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 0 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 0 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 0 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 0 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室101',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 11.96 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 13.7 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 164 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1765 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 100 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 72 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 50 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 100 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室102',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 11.96 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 13.3 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 159 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1711 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 100 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 72 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 50 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 100 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室103',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 11.96 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 13.62 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 163 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1755 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 100 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 72 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 50 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 100 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室104',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 13 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 6.5 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 85 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 915 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 50 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 33 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 20 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 50 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室105',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 13 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 6.5 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 85 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 915 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 50 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 33 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 20 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 50 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室106',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 11.96 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 13.2 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 158 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1701 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 100 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 72 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 50 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 100 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室107A',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 11.96 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 6.6 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 79 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 850 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 40 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 30 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 20 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 40 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室107B',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 11.96 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 6.27 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 75 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 807 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 40 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 30 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 20 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 40 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室107A+107B',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 11.96 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 12.8 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 154 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1658 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 80 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 60 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 40 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 80 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室108',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 11.96 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 7.1 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 85 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 915 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 45 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 36 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 20 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 45 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室109A',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 12.9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 8.99 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 116 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1249 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 63 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 42 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 40 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 63 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室109B',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 12.9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 8.5 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 110 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1184 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 72 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 48 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 40 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 72 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室109C',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 12.9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 8.96 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 116 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1249 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 72 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 48 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 40 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 72 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室109D',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 12.9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 8.75 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 113 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1216 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 63 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 42 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 40 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 63 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室109E',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 13.52 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 9.3 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 127 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1367 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 66 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 54 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 40 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 66 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室109F',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 13.52 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 8.59 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 116 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1249 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 72 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 60 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 40 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 72 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室109G',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 13.52 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 8.79 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 119 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1281 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 72 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 60 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 40 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 72 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室109H',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 13.52 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 9.21 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 125 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1345 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 66 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 54 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 40 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 66 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室109A+109B',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 12.9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 17.49 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 226 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 2433 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 135 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 90 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 80 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 135 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室109C+109D',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 12.9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 17.71 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 229 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 2465 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 135 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 90 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 80 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 135 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室109B+109C',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 12.9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 17.46 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 225 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 2422 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 144 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 96 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 80 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 144 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室109E+109F',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 13.52 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 17.79 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 243 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 2616 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 138 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 114 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 80 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 138 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室109G+109H',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 13.52 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 18 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 243 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 2616 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 138 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 114 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 80 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 138 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室109BCFG',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 26.42 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 17.42 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 460 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 4951 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 360 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 240 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 200 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 360 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室109ABCDEFGH',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 26.4 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 35.2 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 942 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 10140 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 720 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 480 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 320 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 720 },
            { icon: 'booth', label: '展台', key: 'booth', value: 42 },
          ],
        },
      },
    },
  },
  {
    label: '会议室110A',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 12.9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 8.29 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 107 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1152 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 63 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 42 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 40 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 63 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室110B',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 12.89 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 9.3 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 121 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1302 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 72 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 48 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 40 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 72 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室110C',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 13.52 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 18.41 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 249 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 2680 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 144 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 114 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 80 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 144 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室110A+110B',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 12.9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 17.67 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 228 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 2454 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 135 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 90 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 80 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 135 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室110ABC',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 26.42 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 18.05 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 477 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 5134 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 360 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 264 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 200 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 360 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室111A',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 12.9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 9.14 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 118 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1270 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 72 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 48 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 40 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 72 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室111B',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 12.9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 8.29 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 107 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1152 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 63 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 42 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 40 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 63 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室111C',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 13.52 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 18.26 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 247 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 2659 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 144 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 114 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 80 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 144 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室111A+111B',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 12.9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 17.44 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 225 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 2422 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 135 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 90 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 80 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 135 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室111ABC',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 26.42 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 17.86 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 472 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 5081 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 360 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 264 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 200 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 360 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室110ABC+111ABC',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 26.42 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 35.91 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.05 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 949 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 10215 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 720 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 480 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 400 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 720 },
            { icon: 'booth', label: '展台', key: 'booth', value: 42 },
          ],
        },
      },
    },
  },
  {
    label: '会议室112',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 9.7 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 88 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 947 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 48 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 36 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 20 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 48 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室114',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 10.1 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 91 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 980 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 36 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 27 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 20 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 36 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室115',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 10.55 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 95 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1023 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 48 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 36 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 20 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 48 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室116',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 10.66 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 96 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1033 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 36 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 27 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 20 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 36 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室117',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 11.22 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 101 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1087 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 42 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 33 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 20 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 42 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室118',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 11.44 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 103 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1109 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 48 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 36 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 30 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 48 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室119',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 11.44 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 103 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1109 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 42 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 33 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 20 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 42 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室120',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 9 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 11.55 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 104 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 1119 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 48 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 36 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 20 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 48 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室门厅1A',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 5 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 129 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 3100 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 33368 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 0 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 0 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 0 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 0 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '会议室门厅1B',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 26 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 17 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 4200 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 45208 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 0 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 0 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 0 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 0 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '中心休息室C 101',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 5.5 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 45 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 4.2 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 248 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 2669 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 0 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 0 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 0 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 0 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
  {
    label: '中心休息室C 102',
    key: 'lg-foyer-a',
    showFloor: false,
    showLayout: true,
    data: {
      measurements: {
        dimension: {
          title: '尺寸（初步估算）',
          items: [
            { icon: 'all-floor', label: '长（米）', key: 'length', value: 7.87 },
            { icon: 'all-floor', label: '宽（米）', key: 'width', value: 47.5 },
            { icon: 'all-floor', label: '高（米）', key: 'height', value: 9.5 },
          ],
        },
        area: {
          title: '可使用总面积',
          items: [
            { icon: 'square', label: '（平方米）', key: 'area_sqm', value: 374 },
            { icon: 'square', label: '（平方英尺）', key: 'area_sqft', value: 4026 },
          ],
        },
        capacity: {
          title: '最大容量（大约）',
          items: [
            { icon: 'theatre', label: '剧院式', key: 'theatre', value: 0 },
            { icon: 'classroom', label: '课桌式', key: 'classroom', value: 0 },
            { icon: 'banquet', label: '宴会厅式', key: 'banquet', value: 0 },
            { icon: 'reception', label: '招待会', key: 'reception', value: 0 },
            { icon: 'booth', label: '展台', key: 'booth', value: 0 },
          ],
        },
      },
    },
  },
];
export const VIRTUALTOUR_LIST = [
  {
    title: {
      cn: '虚拟导览',
      th: 'ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม',
    },
    content: {
      cn: `
      <p style="font-size:40px;line-height: 1.3;letter-spacing: 8px;color: #827800;text-align: center;"><strong>虚拟导览</strong></p>
      <p style="text-align: center;font-size: 19px;padding-bottom: 2em;">探索QSNCC——世界一流，超凡卓越的会展活动平台。精细设计的300,000平方米空间中，有着各种各样的活动及服务，为您生活的方方面面增添无尽乐趣。</P>
        <div style="margin-bottom: 80px;position: relative;">
            <img src="/images/virtual/Thumbnail_Main.jpg" style="width:100%">
            <a href="https://www.qsncc.com/vr/index.html/?floor=G&scene=Entrance_View" target="_block">
              <div style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);font-size: 17px;background-color: #827800;color:#fffefe;padding: 17px 24px;font-weight: 600;border-radius: 20px 0 20px 0;">开始虚拟导览</div>
            </a>
          </div>

        
         `,
      th: `<p></p>`,
    },
  },
];
export const GETTING_HEAR_LIST = [
  {
    title: {
      cn: '乘车路线',
      th: 'ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม',
    },
    content: {
      cn: `
      <div style="display: flex;display: flex;align-items: center;">
        <div style="display: grid;grid-template-columns: 1fr 1fr;margin-right: 3em;">
          <p><img style="border-radius: 30px;width: 18em;margin-right: 1em;"  src="/images/bus-route/hear01.jpg" "></p>
          <p><img style="border-radius: 30px;width:18em;"  src="/images/bus-route/hear02.jpg" "></p>
          <p><img style="border-radius: 30px;width: 18em;margin-right: 1em;"  src="/images/bus-route/hear03.jpg" "></p>
          <p><img style="border-radius: 30px;width: 18em"  src="/images/bus-route/hear04.jpg" "></p>
        </div>
        <div>
          <p style="font-size: 23px;color: #000;padding-left: 20px;"><strong>多种交通方式都可以方便地到达QSNCC</strong></p>
          <p style="padding: 0 0 0 20px;line-height: 1.8em;font-size: 17px;">QSNCC直接联通QSNCC地铁站，与曼谷其他地区的纽带，方便快捷、畅通无阻。从素万那普机场乘坐BTS Skytrain或机场铁路，转乘到地铁站，然后通过连接通道可以步行到QSNCC。QSNCC场馆被四条主要道路包围，因此乘坐汽车、出租车和公共巴士也很方便。</p>
        </div>
      </div>
         `,
      th: `<p></p>`,
    },
  },
];
export const MRT_CONNECT_LIST = [
  {
    title: {
      cn: 'MRT换乘',
      th: 'ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม',
    },
    content: {
      cn: `
      
      <div>
        <p style="padding: 0 0 0 20px;text-indent: 32px;line-height: 1.8em;font-size: 17px;">地铁是前往QSNCC最方便、最划算、最低碳的方式。您可以在诗丽吉皇后国家会议中心站（3号出口）与地铁蓝线相连。该站与展厅直接连通，为参观QSNCC的游客提供无缝连接。这条线路将QSNCC连接到素坤逸线、机场铁路线以及非常有名的旅游景点：包括恰图恰周末市场、唐人街和大皇宫。</p>
      </div>
         `,
      th: `<p></p>`,
    },
  },
];
export const PARKING_LIST = [
  {
    title: {
      cn: '停车场',
      th: 'ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม',
    },
    content: {
      cn: `
      
      <div>
        <p style="letter-spacing: 8px;text-align:center;font-size: 40px;padding: 4% 0;color: #827800;"><strong>停车</strong></p>
        <p ><img src="/images/bus-route/direction-parking.jpg" width="100%"></p>
        <div style="display: flex;padding: 2em 8em;flex-wrap: wrap;">
          <div style="display:flex">
            <div style="width:100%;font-size: 30px;color:black;max-width: 9em;"><strong>停车</strong></div>
            <div>
                <div style="display: flex;justify-content: flex-start;align-items: center;">
                  <img src="/images/bus-route/time.png"  style="width: 5%;margin-right: 10px;"><strong style="margin-right: 20px;">05:00 - 24:00</strong>
                  <img src="/images/bus-route/level.png"  style="width: 5%;margin-right: 10px;"><strong>B1 层 / B2 层 / LM层</strong>
                </div>
                <p style="padding-top:10px;line-height: 1.8em;font-size: 17px;">QSNCC在5:00至24:00之间提供最多3000个室内停车位。（停车费优惠时段为07:00-21:00）停车场有直达活动楼层的电梯。无障碍停车场和优先停车场位于B1和B2层，电动汽车充电站和女士停车场位于B1层。摩托车停车场位于LM层。</p>
            </div>
          </div>
        </div>
        <div style="display: flex;padding: 2em 8em;flex-wrap: wrap;">
          <div style="display:flex;justify-content: center;align-items: stretch;">
            <div style="width:9em;font-size: 30px;color:black;"><strong>设施</strong></div>
                <div style="display: flex;justify-content: flex-start;align-items: center;">
                  <ul>
                    <li style="display: flex;justify-content: center;align-items: center;padding:0 7em 2em 0">
                      <img src="/images/bus-route/indoor.png"  style="margin-right: 10px;">
                      <span style="display:block;width:8em"><strong>室内停车</strong></span>
                    </li>
                    <li style="display: flex;justify-content: center;align-items: center;padding:0 7em 2em 0">
                      <img src="/images/bus-route/lady.png"  style="margin-right: 10px;">
                      <span style="display:block;width:8em"><strong>女士停车</strong></span>
                    </li>
                    <li style="display: flex;justify-content: center;align-items: center;padding:0 7em 2em 0">
                      <img src="/images/bus-route/evchar.png"  style="margin-right: 10px;">
                      <span style="display:block;width:8em"><strong>电动汽车充电桩</strong></span>
                    </li>
                  </ul>
                  <ul>
                    <li style="display: flex;justify-content: center;align-items: center;padding:0 7em 2em 0">
                      <img src="/images/bus-route/handi.png"  style="margin-right: 10px;">
                      <span style="display:block;width:8em"><strong>残疾人停车</strong></span>
                    </li>
                    <li style="display: flex;justify-content: center;align-items: center;padding:0 7em 2em 0">
                      <img src="/images/bus-route/motoback.png"  style="margin-right: 10px;">
                      <span style="display:block;width:8em"><strong>摩托车停车</strong></span>
                    </li>
                    <li style="display: flex;justify-content: center;align-items: center;padding:0 7em 2em 0">
                      <img src="/images/bus-route/bicycle.png"  style="margin-right: 10px;">
                      <span style="display:block;width:8em"><strong>自行车停车</strong></span>
                    </li>
                  </ul>
                </div>
            </div>
        </div>
        <div style="display: flex;padding: 2em 8em;flex-wrap: wrap;">
          <div style="display:flex;justify-content: center;align-items: stretch;">
            <div style="width:9em;font-size: 30px;color:black;"><strong>服务</strong></div>
                <div style="display: flex;justify-content: flex-start;align-items: flex-start;">
                  <ul>
                    <li style="display: flex;justify-content: center;align-items: center;padding:0 7em 2em 0">
                      <img src="/images/bus-route/valet.png"  style="margin-right: 10px;">
                      <span style="display:block;width:8em"><strong>代客泊车</strong></span>
                    </li>
                    <li style="display: flex;justify-content: center;align-items: center;padding:0 7em 2em 0">
                      <img src="/images/bus-route/limous.png"  style="margin-right: 10px;">
                      <span style="display:block;width:8em"><strong>豪华轿车</strong></span>
                    </li>
                  </ul>
                  <ul>
                    <li style="display: flex;justify-content: center;align-items: center;padding:0 7em 2em 0">
                      <img src="/images/bus-route/taxi.png"  style="margin-right: 10px;">
                      <span style="display:block;width:8em"><strong>出租车</strong></span>
                    </li>
                  </ul>
                </div>
            </div>
        </div>
      </div>
         `,
      th: `<p></p>`,
    },
  },
];
export const GETTING_LIST = [
  {
    title: {
      cn: 'What Personal Data we collect',
      th: 'ข้อมูลส่วนบุคคลประเภทใดบ้างที่เราเก็บรวบรวม',
    },
    content: {
      cn: `
        <div style="margin-bottom: 80px;">
          <p style="letter-spacing: 8px;text-align:center;font-size: 40px;padding: 4% 0;color: #827800;"><strong>“WELL”建筑标准</strong></p>
          <div style="display: flex;align-items: center;position: relative;">
            <div style="padding: 0 20px 0 0;">
                <div style="font-size: 23px;text-align:center;"><strong>美丽与用心的设计</strong></div><br>
                <ul>
                  <li style="list-style-type: square;line-height: 3em;font-size: 17px;">室内设计和装饰体现了泰国文化特色，体现了泰国公共艺术和历史</li>
                  <li style="list-style-type: square;line-height: 3em;font-size: 17px;">通过景观美化实现与 Benjakitti 公园的视觉联系</li>
                  <li style="list-style-type: square;line-height: 3em;font-size: 17px;">露天剧场打造优质公共聚会空间</li>
                </ul>
            </div>
            <p style="width:100%">
              <img style="border-radius: 50px 0 50px 0;" width="100%" height="60%" src="/images/home/gallery/covenient.jpg" >
            </p>
            <div style="display: flex;padding: 10px 0 3px 10px;position: absolute;bottom: 2%;left: 39em;background-color: #fff;border-radius:30px 0 0 0">
                <img src="/images/home/gallery/getting.jpg" width="35%" style="border-radius:30px 0 30px 0;padding-right: 10px;">
                <img src="/images/home/gallery/mrt2.jpg" width="35%" style="border-radius: 30px 0 30px 0;">
            </div>

          </div>
        </div>
        
        
         `,
      th: ``,
    },
  },
];
